import { GraphQLClient, RequestOptions } from 'graphql-request';
import { GraphQLError, print } from 'graphql'
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
type GraphQLClientRequestHeaders = RequestOptions['requestHeaders'];
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  CountryCode: { input: any; output: any; }
  CountryName: { input: any; output: any; }
  Currency: { input: any; output: any; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  EmailAddress: { input: any; output: any; }
  Int64: { input: any; output: any; }
  JSON: { input: any; output: any; }
  Long: { input: any; output: any; }
  Map: { input: any; output: any; }
  Upload: { input: any; output: any; }
  _FieldSet: { input: any; output: any; }
  federation__FieldSet: { input: any; output: any; }
  federation__Scope: { input: any; output: any; }
  link__Import: { input: any; output: any; }
  openfed__SubscriptionFilterValue: { input: any; output: any; }
};

export type AddressInput = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  postalCode: Scalars['String']['input'];
  region: Scalars['String']['input'];
  street1: Scalars['String']['input'];
  street2?: InputMaybe<Scalars['String']['input']>;
};

export type Attributes = {
  __typename?: 'Attributes';
  hba_status?: Maybe<HbaStatus>;
  maxRating?: Maybe<MaxRating>;
  mvpd?: Maybe<HbaStatus>;
  upstreamUserID?: Maybe<HbaStatus>;
  userID?: Maybe<HbaStatus>;
};

export type AuthenticatedPasswordChangeInput = {
  custId: Scalars['Int']['input'];
  password: Scalars['String']['input'];
  password1: Scalars['String']['input'];
  password2: Scalars['String']['input'];
};

export type AuthenticationDetails = {
  __typename?: 'AuthenticationDetails';
  cacheAt?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  dateFormat?: Maybe<Scalars['String']['output']>;
  encryptedPid?: Maybe<Scalars['String']['output']>;
  fantasyApiKey?: Maybe<Scalars['String']['output']>;
  hasSportsProfile?: Maybe<Scalars['Boolean']['output']>;
  isSportslineSubscriber: Scalars['Boolean']['output'];
  lastUnlockAt?: Maybe<Scalars['Date']['output']>;
  modifiedAt?: Maybe<Scalars['Date']['output']>;
  passwordChangeAt?: Maybe<Scalars['Date']['output']>;
  sequence?: Maybe<Scalars['Int']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  tpid?: Maybe<Scalars['String']['output']>;
  userDetails?: Maybe<UserDetails>;
};

export type AuthenticationResult = SapiResponse & {
  __typename?: 'AuthenticationResult';
  code: Scalars['Int']['output'];
  data?: Maybe<AuthenticationDetails>;
  message?: Maybe<Scalars['String']['output']>;
  sapiStatusCode?: Maybe<Scalars['Int']['output']>;
  success: Scalars['Boolean']['output'];
};

export type AuthenticationSessionResponse = {
  __typename?: 'AuthenticationSessionResponse';
  actionName?: Maybe<Scalars['String']['output']>;
  actionType?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  mvpd?: Maybe<Scalars['String']['output']>;
  notAfter?: Maybe<Scalars['String']['output']>;
  notBefore?: Maybe<Scalars['String']['output']>;
  reasonType?: Maybe<Scalars['String']['output']>;
  serviceProvider?: Maybe<Scalars['String']['output']>;
  sessionId?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type BadRequestError = {
  __typename?: 'BadRequestError';
  code: Scalars['Int']['output'];
  message: Scalars['String']['output'];
};

/**
 * GraphQL type definitions for player props projections, including queries and types for betting edges, projections, and connections.
 * refer to player_props_projection collection in MongoDB
 */
export type BasePlayerPropsProjection = {
  /** betting active flag, true if the player prop projection is active */
  active: Scalars['Boolean']['output'];
  /** betting side for the player prop projection, always two sides, like 'Over' and 'Under' */
  bettingSides: Array<BaseSimplePlayerPropsProjectionSide>;
  /** book state, like "NJ", "PA", etc. */
  bookState?: Maybe<Scalars['String']['output']>;
  /** cbs betting book id */
  cbsBookId: Scalars['ID']['output'];
  /** cbs betting market id */
  cbsMarket: BettingMarket;
  /** betting created at timestamp */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** betting game */
  game: Game;
  /** composite id for player props projection, include cbsMarketId and leagueId */
  id: Scalars['ID']['output'];
  /** isSubscriber flag, true because the player prop projection is for subscribers only */
  isSubscriber?: Maybe<Scalars['Boolean']['output']>;
  /** player jersey number, like 12, 23, etc. */
  jerseyNumber?: Maybe<Scalars['String']['output']>;
  /** betting player league, change to ! later */
  league: League;
  /** betting line for the player prop projection, like 50.5 for 'Over/Under 50.5 Receiving Yards' */
  line?: Maybe<Scalars['Float']['output']>;
  /** betting matchup score, a float value representing the strength of the matchup */
  matchupScore: Scalars['Float']['output'];
  /** betting model name */
  model: Scalars['String']['output'];
  /** betting Player */
  player: Player;
  /** betting team player associated with, change to ! later */
  playerTeam: Team;
  /** player position, like 'QB', 'RB', etc. */
  position?: Maybe<Scalars['String']['output']>;
  /** betting projection, a float value representing the projected value for the player prop */
  projection?: Maybe<Scalars['Float']['output']>;
  /** betting projection high, a float value representing the high end of the projection range */
  projectionHigh?: Maybe<Scalars['Float']['output']>;
  /** betting projection low, a float value representing the low end of the projection range */
  projectionLow?: Maybe<Scalars['Float']['output']>;
  /** betting rank, a float value representing the rank of the player prop projection */
  rank: Scalars['Float']['output'];
  /** Recommended betting side for Player Props Projection, like 'Over' or 'Under' */
  recommendedBettingSide?: Maybe<BasePlayerPropsProjectionSide>;
  /** betting source, like 'AI', 'CBS', 'SportsLine', etc. */
  src: Scalars['String']['output'];
  /** betting updated at timestamp */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** betting side value for player props projection */
export type BasePlayerPropsProjectionSide = {
  /** ai insights, a string value representing the AI insights for the player prop projection, come from player_insights table or betNarrative */
  aiInsights?: Maybe<Scalars['String']['output']>;
  /** is insights ai insights, true if the player prop projection is AI generated */
  isAiInsights?: Maybe<Scalars['Boolean']['output']>;
  /** betting odds, like -110 for 'Over -110' or 'Under -110' */
  odds?: Maybe<Scalars['String']['output']>;
  /** pickDisplay flag, true if the player prop projection should be displayed in the betting picks */
  pickDisplay?: Maybe<Scalars['Boolean']['output']>;
  /** betting probability, a int value representing the probability of the player prop projection */
  probInterval?: Maybe<Scalars['Int']['output']>;
  /** betting projection, a float value representing the projected value for the player prop */
  probSigmoid?: Maybe<Scalars['Float']['output']>;
  /** rank of betting side, a float value representing the rank of the player prop projection */
  rank?: Maybe<Scalars['Float']['output']>;
  /** betting rating star level, like 1 star, 2 stars, etc. */
  rating?: Maybe<Scalars['Float']['output']>;
  /** betting recommended side, true if the player prop projection is recommended to bet on that side */
  recommendedSide?: Maybe<Scalars['Boolean']['output']>;
  /** betting side, like 'Over' or 'Under' */
  side?: Maybe<Scalars['String']['output']>;
  /** betting edge value */
  value?: Maybe<Scalars['Float']['output']>;
};

/** simplified betting side which contains only necessary fields */
export type BaseSimplePlayerPropsProjectionSide = {
  /** betting odds, like -110 for 'Over -110' or 'Under -110' */
  odds: Scalars['String']['output'];
  /** betting side, like 'Over' or 'Under' */
  side: Scalars['String']['output'];
};

/** Represents the batting stats for a baseball player. */
export type BaseballBattingStats = {
  __typename?: 'BaseballBattingStats';
  /** The total number of at-bats by the player. */
  atBats?: Maybe<Scalars['Int']['output']>;
  /** The total number of base on balls by the player. */
  baseOnBalls?: Maybe<Scalars['Int']['output']>;
  /** The batting average of the player. */
  battingAverage?: Maybe<Scalars['Float']['output']>;
  /** The total number of times the player was caught stealing. */
  caughtStealing?: Maybe<Scalars['Int']['output']>;
  /** The total number of doubles hit by the player. */
  doubles?: Maybe<Scalars['Int']['output']>;
  /** The fantasy points scored by the player. */
  fantasyPoints?: Maybe<Scalars['Float']['output']>;
  /** The total number of times the player grounded into a double play. */
  groundedIntoDoublePlay?: Maybe<Scalars['Int']['output']>;
  /** The total number of times the player was hit by a pitch. */
  hitByPitch?: Maybe<Scalars['Int']['output']>;
  /** The total number of hits made by the player. */
  hits?: Maybe<Scalars['Int']['output']>;
  /** The total number of home runs hit by the player. */
  homeRuns?: Maybe<Scalars['Int']['output']>;
  /** The total number of runners left on base by the player. */
  leftOnBase?: Maybe<Scalars['Int']['output']>;
  /** The on-base percentage of the player. */
  onBasePercentage?: Maybe<Scalars['Float']['output']>;
  /** The on-base plus slugging percentage of the player. */
  onBasePlusSlugging?: Maybe<Scalars['Float']['output']>;
  /** The total number of runs batted in by the player. */
  rbis?: Maybe<Scalars['Int']['output']>;
  /** The total number of runs scored by the player. */
  runs?: Maybe<Scalars['Int']['output']>;
  /** The total number of sacrifice flies by the player. */
  sacrificeFlies?: Maybe<Scalars['Int']['output']>;
  /** The total number of sacrifice hits by the player. */
  sacrificeHits?: Maybe<Scalars['Int']['output']>;
  /** The total number of singles hit by the player. */
  singles?: Maybe<Scalars['Int']['output']>;
  /** The slugging percentage of the player. */
  sluggingPercentage?: Maybe<Scalars['Float']['output']>;
  /** The total number of stolen bases by the player. */
  stolenBases?: Maybe<Scalars['Int']['output']>;
  /** The total number of strikeouts by the player. */
  strikeouts?: Maybe<Scalars['Int']['output']>;
  /** The total number of team left on base by the player. */
  teamLob?: Maybe<Scalars['Int']['output']>;
  /** The total number of bases gained by the player. */
  totalBases?: Maybe<Scalars['Int']['output']>;
  /** The total number of triples hit by the player. */
  triples?: Maybe<Scalars['Int']['output']>;
};

/** Represents the pitching stats for a baseball player. */
export type BaseballPitchingStats = {
  __typename?: 'BaseballPitchingStats';
  /** The total number of base on balls allowed by the player. */
  baseOnBallsAllowed?: Maybe<Scalars['Int']['output']>;
  /** The total number of blown saves by the player. */
  blownSaves?: Maybe<Scalars['Int']['output']>;
  /** The total number of earned runs allowed by the player. */
  earnedRunsAllowed?: Maybe<Scalars['Int']['output']>;
  /** The earned run allowed (ERA) of the player. */
  era?: Maybe<Scalars['Float']['output']>;
  /** The fantasy points scored by the player. */
  fantasyPoints?: Maybe<Scalars['Float']['output']>;
  /** The total number of hits allowed by the player. */
  hitsAllowed?: Maybe<Scalars['Int']['output']>;
  /** The total number of holds by the player. */
  holds?: Maybe<Scalars['Int']['output']>;
  /** The total number of home runs allowed by the player. */
  homeRunsAllowed?: Maybe<Scalars['Int']['output']>;
  /** The total number of innings pitched by the player. */
  inningsPitched?: Maybe<Scalars['Float']['output']>;
  /** The total number of losses by the player. */
  losses?: Maybe<Scalars['Int']['output']>;
  /** The total number of pitches thrown by the player. */
  pitchesThrown?: Maybe<Scalars['Int']['output']>;
  /** The total number of runs allowed by the player. */
  runsAllowed?: Maybe<Scalars['Int']['output']>;
  /** The total number of saves by the player. */
  saves?: Maybe<Scalars['Int']['output']>;
  /** The total number of strikeouts allowed by the player. */
  strikeOutsThrown?: Maybe<Scalars['Int']['output']>;
  /** The total number of strikes thrown by the player. */
  strikesThrown?: Maybe<Scalars['Int']['output']>;
  /** The walks plus hits per inning pitched (WHIP) of the player. */
  whip?: Maybe<Scalars['Float']['output']>;
  /** The win-loss percentage of the player. */
  winLostPercentage?: Maybe<Scalars['Float']['output']>;
  /** The total number of wins by the player. */
  wins?: Maybe<Scalars['Int']['output']>;
};

/** Represents the player stats for baseball. */
export type BaseballPlayerStats = PlayerStats & {
  __typename?: 'BaseballPlayerStats';
  /** The batting stats for the player. */
  batting?: Maybe<BaseballBattingStats>;
  /** The first name of the player. */
  firstName?: Maybe<Scalars['String']['output']>;
  /** The initials for the player. */
  initials?: Maybe<Scalars['String']['output']>;
  /** The jersey number of the player. */
  jerseyNumber?: Maybe<Scalars['String']['output']>;
  /** The last name of the player. */
  lastName?: Maybe<Scalars['String']['output']>;
  /** The pitching stats for the player. */
  pitching?: Maybe<BaseballPitchingStats>;
  /** The unique identifier for the player. */
  playerId: Scalars['ID']['output'];
  /** The position of the player. */
  position?: Maybe<Scalars['String']['output']>;
  /** The sport type for the player. */
  sport?: Maybe<Scalars['String']['output']>;
};

/** Represents the player stats for basketball. */
export type BasketballPlayerStats = PlayerStats & {
  __typename?: 'BasketballPlayerStats';
  /** The first name of the player. */
  firstName?: Maybe<Scalars['String']['output']>;
  /** The initials for the player. */
  initials?: Maybe<Scalars['String']['output']>;
  /** The jersey number of the player. */
  jerseyNumber?: Maybe<Scalars['String']['output']>;
  /** The last name of the player. */
  lastName?: Maybe<Scalars['String']['output']>;
  /** The unique identifier for the player. */
  playerId: Scalars['ID']['output'];
  /** The position of the player. */
  position?: Maybe<Scalars['String']['output']>;
  /** The sport type for the player. */
  sport?: Maybe<Scalars['String']['output']>;
  /** The basketball stats for the player. */
  stat?: Maybe<BasketballStats>;
};

/** Represents the statistics of a player in basketball game. */
export type BasketballStats = {
  __typename?: 'BasketballStats';
  /** The number of assists made by the player. */
  assists?: Maybe<Scalars['Int']['output']>;
  /** The number of shots blocked by the player. */
  blocks?: Maybe<Scalars['Int']['output']>;
  /** The number of defensive rebounds grabbed by the player. */
  defensiveRebounds?: Maybe<Scalars['Int']['output']>;
  /** Indicates if the player was disqualified from the game. */
  disqualified?: Maybe<Scalars['String']['output']>;
  /** Indicates if the player was ejected from the game. */
  ejected?: Maybe<Scalars['String']['output']>;
  /** The fantasy points scored by the player. */
  fantasyPoints?: Maybe<Scalars['Float']['output']>;
  /** The number of field goals attempted by the player. */
  fieldGoalsAttempted?: Maybe<Scalars['Int']['output']>;
  /** The number of field goals made by the player. */
  fieldGoalsMade?: Maybe<Scalars['Int']['output']>;
  /** The number of flagrant fouls committed by the player. */
  flagrantFouls?: Maybe<Scalars['Int']['output']>;
  /** The number of personal fouls committed by the player. */
  fouls?: Maybe<Scalars['Int']['output']>;
  /** The number of free throws attempted by the player. */
  freeThrowsAttempted?: Maybe<Scalars['Int']['output']>;
  /** The number of free throws made by the player. */
  freeThrowsMade?: Maybe<Scalars['Int']['output']>;
  /** The number of minutes the player was on the court. */
  minutes?: Maybe<Scalars['Int']['output']>;
  /** The number of offensive rebounds grabbed by the player. */
  offensiveRebounds?: Maybe<Scalars['Int']['output']>;
  /** The plus-minus statistic of the player. */
  plusMinus?: Maybe<Scalars['Int']['output']>;
  /** The total points scored by the player. */
  points?: Maybe<Scalars['Int']['output']>;
  /** The number of steals made by the player. */
  steals?: Maybe<Scalars['Int']['output']>;
  /** The number of technical fouls committed by the player. */
  technicals?: Maybe<Scalars['Int']['output']>;
  /** The number of three-point shots attempted by the player. */
  threePointersAttempted?: Maybe<Scalars['Int']['output']>;
  /** The number of three-point shots made by the player. */
  threePointersMade?: Maybe<Scalars['Int']['output']>;
  /** The number of turnovers committed by the player. */
  turnovers?: Maybe<Scalars['Int']['output']>;
};

/** type definition for betting category, refer to category table */
export type BettingCategory = {
  __typename?: 'BettingCategory';
  /** create dt */
  createdAt: Scalars['DateTime']['output'];
  /** The unique identifier of the market category */
  id: Scalars['ID']['output'];
  /** The name of the betting category */
  name: BettingCategoryType;
  /** update dt */
  updatedAt: Scalars['DateTime']['output'];
};

/** category name for betting category, refer to category table */
export enum BettingCategoryType {
  /** player props projection */
  PlayerPropProjs = 'PLAYER_PROP_PROJS'
}

/** type definition for cbs market for props and odds, refer to market table */
export type BettingMarket = {
  __typename?: 'BettingMarket';
  /** The abbreviation of the cbs market */
  abbrev?: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the cbs market */
  id: Scalars['ID']['output'];
  /** The league passed from sportsline, used to filter the vendors associated with this market */
  league?: Maybe<League>;
  /**
   * live flag for the market, true meaning the market is changing when game is in progress
   *   false meaning the market is not changing
   */
  live: Scalars['Boolean']['output'];
  /** The name of the cbs market */
  name?: Maybe<Scalars['String']['output']>;
  /** The short name of the cbs market */
  shortName?: Maybe<Scalars['String']['output']>;
  /** The type of the cbs market (e.g., 'game', 'player', 'team') */
  type: BettingMarketType;
  /**
   * The vendors that are associated with this cbs market.
   *   *Constraints:`first` has a maximum limit of 500*
   */
  vendors?: Maybe<BettingMarketVendorConnection>;
};


/** type definition for cbs market for props and odds, refer to market table */
export type BettingMarketVendorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  vendorName?: InputMaybe<Scalars['String']['input']>;
};

/** type of cbs market, used for props and odds */
export enum BettingMarketType {
  Game = 'GAME',
  League = 'LEAGUE',
  Player = 'PLAYER',
  Team = 'TEAM'
}

/** connection between cbs market and vendor, refer to vendor_market_association table */
export type BettingMarketVendorConnection = {
  __typename?: 'BettingMarketVendorConnection';
  /** The edges of the cbs market vendor connection */
  edges: Array<BettingMarketVendorEdge>;
  /** The nodes of the cbs market vendor connection */
  nodes: Array<Vendor>;
  /** Pagination information for the cbs market vendor connection */
  pageInfo: PageInfo;
};

/** Edge for cbs market vendor connection */
export type BettingMarketVendorEdge = {
  __typename?: 'BettingMarketVendorEdge';
  /** The cursor for pagination */
  cursor: Scalars['String']['output'];
  /** The league associated with the vendor market */
  league?: Maybe<League>;
  /** The league ID associated with the vendor market */
  leagueId?: Maybe<Scalars['ID']['output']>;
  /** The vendor associated with the cbs market */
  node: Vendor;
  /** The vendor market ID */
  vendorMarketId: Scalars['String']['output'];
};

export type BillingInfoInput = {
  tokenId: Scalars['String']['input'];
};

/** Represents a connection of book selections with pagination info */
export type BookSelectionConnection = {
  __typename?: 'BookSelectionConnection';
  /** List of edges containing selections */
  edges: Array<BookSelectionEdge>;
  /** List of selection nodes */
  nodes: Array<SportsBookSelection>;
  /** Pagination information */
  pageInfo: PageInfo;
};

/** Represents an edge in a connection of book selections */
export type BookSelectionEdge = {
  __typename?: 'BookSelectionEdge';
  /** A cursor for pagination */
  cursor: Scalars['String']['output'];
  /** The selection at the end of the edge */
  node: SportsBookSelection;
};

export type BowlGame = {
  __typename?: 'BowlGame';
  date?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  matchup?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  prediction?: Maybe<Array<Maybe<BowlPredictionTeam>>>;
  time?: Maybe<Scalars['String']['output']>;
};

export type BowlPredictionData = {
  __typename?: 'BowlPredictionData';
  createDate?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  section?: Maybe<Array<Maybe<BowlPredictionSection>>>;
  updateDate?: Maybe<Scalars['String']['output']>;
};

export type BowlPredictionSection = {
  __typename?: 'BowlPredictionSection';
  bowl?: Maybe<Array<Maybe<BowlGame>>>;
  name?: Maybe<Scalars['String']['output']>;
};

export type BowlPredictionTeam = {
  __typename?: 'BowlPredictionTeam';
  teamAbbr?: Maybe<Scalars['String']['output']>;
  teamId?: Maybe<Scalars['Int']['output']>;
  teamName?: Maybe<Scalars['String']['output']>;
  teamSeo?: Maybe<Scalars['String']['output']>;
};

export type BracketTeamInput = {
  clinched?: InputMaybe<Scalars['Boolean']['input']>;
  firstFourOut?: InputMaybe<Scalars['Boolean']['input']>;
  firstFourOutRank?: InputMaybe<Scalars['Int']['input']>;
  lastFourIn?: InputMaybe<Scalars['Boolean']['input']>;
  lastFourInRank?: InputMaybe<Scalars['Int']['input']>;
  movement?: InputMaybe<Scalars['Int']['input']>;
  newOrNot?: InputMaybe<Scalars['Boolean']['input']>;
  onTheBubble?: InputMaybe<Scalars['Boolean']['input']>;
  playin?: InputMaybe<Scalars['Boolean']['input']>;
  projected?: InputMaybe<Scalars['Boolean']['input']>;
  quadrant?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  seed?: InputMaybe<Scalars['Int']['input']>;
  teamId?: InputMaybe<Scalars['Int']['input']>;
};

export type Bracketology = {
  __typename?: 'Bracketology';
  clinched?: Maybe<Scalars['Boolean']['output']>;
  createDate?: Maybe<Scalars['String']['output']>;
  createEpoch?: Maybe<Scalars['Int']['output']>;
  firstFourOut?: Maybe<Scalars['Boolean']['output']>;
  firstFourOutRank?: Maybe<Scalars['Int']['output']>;
  lastFourIn?: Maybe<Scalars['Boolean']['output']>;
  lastFourInRank?: Maybe<Scalars['Int']['output']>;
  movement?: Maybe<Scalars['Int']['output']>;
  newOrNot?: Maybe<Scalars['Boolean']['output']>;
  onTheBubble?: Maybe<Scalars['Boolean']['output']>;
  playin?: Maybe<Scalars['Boolean']['output']>;
  projected?: Maybe<Scalars['Boolean']['output']>;
  quadrant?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  seed?: Maybe<Scalars['Int']['output']>;
  team?: Maybe<Team>;
  teamId?: Maybe<Scalars['Int']['output']>;
  updateDate?: Maybe<Scalars['String']['output']>;
  updateEpoch?: Maybe<Scalars['Int']['output']>;
};

export type BracketologyDataInput = {
  bracketologyTeamList?: InputMaybe<Array<InputMaybe<BracketologyTeamItemInput>>>;
  pods?: InputMaybe<Array<InputMaybe<PodInput>>>;
};

export type BracketologyTeamData = {
  __typename?: 'BracketologyTeamData';
  bracketologyTeamList?: Maybe<Array<Maybe<BracketologyTeamItem>>>;
  pods?: Maybe<Array<Maybe<Pod>>>;
};

export type BracketologyTeamIdRemoved = {
  __typename?: 'BracketologyTeamIdRemoved';
  teamId?: Maybe<Scalars['Int']['output']>;
};

export type BracketologyTeamItem = {
  __typename?: 'BracketologyTeamItem';
  bracketology?: Maybe<Bracketology>;
  bubbleWatch?: Maybe<BubbleWatch>;
  strengthOfSchedule?: Maybe<StrengthOfSchedule>;
  teamStandings?: Maybe<TeamStandings>;
  tierWonLoss?: Maybe<TierWonLoss>;
};

export type BracketologyTeamItemInput = {
  bracketology?: InputMaybe<BracketTeamInput>;
  bubbleWatch?: InputMaybe<BubbleWatchInput>;
  strengthOfSchedule?: InputMaybe<StrengthOfScheduleInput>;
  tierWonLoss?: InputMaybe<TierWonLossInput>;
};

export type BubbleWatch = {
  __typename?: 'BubbleWatch';
  createDate?: Maybe<Scalars['String']['output']>;
  createEpoch?: Maybe<Scalars['Int']['output']>;
  outlook?: Maybe<Scalars['String']['output']>;
  sortId?: Maybe<Scalars['Int']['output']>;
  updateDate?: Maybe<Scalars['String']['output']>;
  updateEpoch?: Maybe<Scalars['Int']['output']>;
  workToDo?: Maybe<Scalars['Boolean']['output']>;
};

export type BubbleWatchInput = {
  outlook?: InputMaybe<Scalars['String']['input']>;
  sortId?: InputMaybe<Scalars['Int']['input']>;
  workToDo?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CbsSportsNewsLetter = {
  __typename?: 'CBSSportsNewsLetter';
  mCode: Scalars['String']['output'];
  masterProduct: MasterProduct;
};

export type CbsSportsNewsletterSubscription = {
  __typename?: 'CBSSportsNewsletterSubscription';
  custId: Scalars['Int']['output'];
  dateFormat: Scalars['String']['output'];
  isSubscribed: Scalars['Boolean']['output'];
  mCode: Scalars['String']['output'];
  masterProductId: Scalars['Int']['output'];
  newsLetter: CbsSportsNewsLetter;
  optInDate?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  subscriptionId?: Maybe<Scalars['Int']['output']>;
};

export type CmsArticle = CmsVersionableContentInterface & {
  __typename?: 'CMSArticle';
  body?: Maybe<Scalars['String']['output']>;
  businessUnit?: Maybe<CmsBusinessUnit>;
  cmsContentId?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dek?: Maybe<Scalars['String']['output']>;
  displayPublishedAt?: Maybe<Scalars['DateTime']['output']>;
  displayPublishedAtTimezone?: Maybe<Scalars['String']['output']>;
  displayUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  edition?: Maybe<CmsEdition>;
  editors?: Maybe<Array<CmsUser>>;
  graphicsCard?: Maybe<GraphicsCard>;
  headline?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<CmsImage>;
  primaryAuthor?: Maybe<CmsUser>;
  primaryCollection?: Maybe<CmsCollection>;
  primaryTopic?: Maybe<CmsTopic>;
  promoDek?: Maybe<Scalars['String']['output']>;
  promoHed?: Maybe<Scalars['String']['output']>;
  promoImage?: Maybe<CmsImage>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  publishedAtTimezone?: Maybe<Scalars['String']['output']>;
  relatedContent?: Maybe<Array<CmsRelatedContent>>;
  secondaryAuthors?: Maybe<Array<CmsUser>>;
  secondaryCollections?: Maybe<Array<CmsCollection>>;
  secondaryTopics?: Maybe<Array<CmsTopic>>;
  siteId: Scalars['Int']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  suppressAutoplay?: Maybe<Scalars['Boolean']['output']>;
  suppressBio?: Maybe<Scalars['Boolean']['output']>;
  tags?: Maybe<Array<CmsTag>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum CmsBusinessUnit {
  Cbss = 'CBSS',
  Spln = 'SPLN'
}

export type CmsCollection = {
  __typename?: 'CMSCollection';
  businessUnit?: Maybe<CmsBusinessUnit>;
  cmsContentId?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dek?: Maybe<Scalars['String']['output']>;
  displayPublishedAt?: Maybe<Scalars['DateTime']['output']>;
  displayTimezone?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  itemCount?: Maybe<Scalars['Int']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  publishedAtTimezone?: Maybe<Scalars['String']['output']>;
  siteId: Scalars['Int']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  social?: Maybe<Scalars['Boolean']['output']>;
  suppressBio?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CmsComponentInput = {
  id: Scalars['ID']['input'];
  tenant?: CmsTenant;
};

export type CmsComponentInterface = {
  cmsContentId?: Maybe<Scalars['ID']['output']>;
  componentLabel?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  function?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  internalName?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  siteId: Scalars['Int']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  view?: Maybe<Scalars['String']['output']>;
};

export type CmsComponentSlugInput = {
  slug: Scalars['String']['input'];
  tenant?: CmsTenant;
};

export type CmsContentIdEditionInput = {
  device?: CmsDevice;
  edition?: CmsEdition;
  id: Scalars['ID']['input'];
  tenant?: CmsTenant;
};

export type CmsContentIdInput = {
  device?: CmsDevice;
  id: Scalars['ID']['input'];
  tenant?: CmsTenant;
};

export type CmsContentIdOrSlugInput = {
  device?: CmsDevice;
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  tenant?: CmsTenant;
};

export type CmsContentSlugEditionInput = {
  device?: CmsDevice;
  edition?: CmsEdition;
  slug: Scalars['String']['input'];
  tenant?: CmsTenant;
};

export type CmsContentSlugInput = {
  device?: CmsDevice;
  slug: Scalars['String']['input'];
  tenant?: CmsTenant;
};

export type CmsCustomConfigComponent = CmsComponentInterface & {
  __typename?: 'CMSCustomConfigComponent';
  businessUnit?: Maybe<CmsBusinessUnit>;
  cmsContentId?: Maybe<Scalars['ID']['output']>;
  componentLabel?: Maybe<Scalars['String']['output']>;
  configSlug: Scalars['String']['output'];
  configuration?: Maybe<CmsCustomConfigConfiguration>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  function?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  internalName?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  siteId: Scalars['Int']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  view?: Maybe<Scalars['String']['output']>;
};

export type CmsCustomConfigConfiguration = {
  __typename?: 'CMSCustomConfigConfiguration';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  values: Scalars['JSON']['output'];
};

export enum CmsDevice {
  Desktop = 'DESKTOP',
  Mobile = 'MOBILE',
  Newsletter = 'NEWSLETTER',
  Tablet = 'TABLET'
}

export enum CmsEdition {
  Us = 'US'
}

export type CmsEditorialComponent = CmsComponentInterface & {
  __typename?: 'CMSEditorialComponent';
  businessUnit?: Maybe<CmsBusinessUnit>;
  cmsContentId?: Maybe<Scalars['ID']['output']>;
  componentLabel?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Array<CmsEditorialComponentContent>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  function?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  internalName?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  siteId: Scalars['Int']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  view?: Maybe<Scalars['String']['output']>;
};

export type CmsEditorialComponentContent = {
  __typename?: 'CMSEditorialComponentContent';
  author?: Maybe<Scalars['String']['output']>;
  body?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  image?: Maybe<CmsImage>;
  label?: Maybe<Scalars['String']['output']>;
  linkText?: Maybe<Scalars['String']['output']>;
  linkUrl?: Maybe<Scalars['String']['output']>;
  object?: Maybe<CmsObjectType>;
  origin?: Maybe<Scalars['String']['output']>;
  relatedItems?: Maybe<Array<CmsEditorialComponentContent>>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  view?: Maybe<Scalars['String']['output']>;
};

export type CmsFeature = {
  __typename?: 'CMSFeature';
  businessUnit?: Maybe<CmsBusinessUnit>;
  cmsContentId?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  edition: CmsEdition;
  id: Scalars['ID']['output'];
  layout?: Maybe<CmsPageLayout>;
  name: Scalars['String']['output'];
  siteId: Scalars['Int']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  viewType?: Maybe<Scalars['String']['output']>;
};

export type CmsImage = {
  __typename?: 'CMSImage';
  alt?: Maybe<Scalars['String']['output']>;
  businessUnit?: Maybe<CmsBusinessUnit>;
  caption?: Maybe<Scalars['String']['output']>;
  cmsContentId?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  credits?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  keywords?: Maybe<Scalars['String']['output']>;
  mimeType: Scalars['String']['output'];
  path: Scalars['String']['output'];
  primeColor?: Maybe<Scalars['String']['output']>;
  siteId: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url: Scalars['String']['output'];
  width?: Maybe<Scalars['Int']['output']>;
};

export type CmsListingComponent = CmsComponentInterface & {
  __typename?: 'CMSListingComponent';
  businessUnit?: Maybe<CmsBusinessUnit>;
  cmsContentId?: Maybe<Scalars['ID']['output']>;
  componentLabel?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  curated?: Maybe<CmsListingComponentContentItemConnection>;
  description?: Maybe<Scalars['String']['output']>;
  filters?: Maybe<Array<CmsListingComponentFilter>>;
  function?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  internalName?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Scalars['JSON']['output']>;
  siteId: Scalars['Int']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  view?: Maybe<Scalars['String']['output']>;
};


export type CmsListingComponentCuratedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type CmsListingComponentContentItem = {
  __typename?: 'CMSListingComponentContentItem';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<CmsImage>;
  isPinned?: Maybe<Scalars['Boolean']['output']>;
  object?: Maybe<CmsObjectType>;
  title?: Maybe<Scalars['String']['output']>;
};

export type CmsListingComponentContentItemConnection = {
  __typename?: 'CMSListingComponentContentItemConnection';
  /** A list of edges. */
  edges: Array<CmsListingComponentContentItemEdge>;
  /** A list of nodes. */
  nodes: Array<CmsListingComponentContentItem>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total count. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CmsListingComponentContentItemEdge = {
  __typename?: 'CMSListingComponentContentItemEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: CmsListingComponentContentItem;
};

export type CmsListingComponentFilter = {
  __typename?: 'CMSListingComponentFilter';
  content?: Maybe<CmsListingComponentContentItemConnection>;
  description?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  useLoadMore?: Maybe<Scalars['Boolean']['output']>;
  viewMoreText?: Maybe<Scalars['String']['output']>;
  viewMoreUrl?: Maybe<Scalars['String']['output']>;
};


export type CmsListingComponentFilterContentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type CmsLiveBlog = CmsVersionableContentInterface & {
  __typename?: 'CMSLiveBlog';
  businessUnit?: Maybe<CmsBusinessUnit>;
  callToAction?: Maybe<Scalars['String']['output']>;
  cmsContentId?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dek?: Maybe<Scalars['String']['output']>;
  displayPublishedAt?: Maybe<Scalars['DateTime']['output']>;
  displayPublishedAtTimezone?: Maybe<Scalars['String']['output']>;
  displayUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  edition?: Maybe<CmsEdition>;
  editors?: Maybe<Array<CmsUser>>;
  eventEnd?: Maybe<Scalars['DateTime']['output']>;
  eventStart?: Maybe<Scalars['DateTime']['output']>;
  eventTimezone?: Maybe<Scalars['String']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<CmsImage>;
  intro?: Maybe<Scalars['String']['output']>;
  items: CmsLiveBlogItemConnection;
  primaryAuthor?: Maybe<CmsUser>;
  primaryCollection?: Maybe<CmsCollection>;
  primaryTopic?: Maybe<CmsTopic>;
  promoDek?: Maybe<Scalars['String']['output']>;
  promoHed?: Maybe<Scalars['String']['output']>;
  promoImage?: Maybe<CmsImage>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  publishedAtTimezone?: Maybe<Scalars['String']['output']>;
  relatedContent?: Maybe<Array<CmsRelatedContent>>;
  secondaryAuthors?: Maybe<Array<CmsUser>>;
  secondaryCollections?: Maybe<Array<CmsCollection>>;
  secondaryTopics?: Maybe<Array<CmsTopic>>;
  siteId: Scalars['Int']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  suppressAutoplay?: Maybe<Scalars['Boolean']['output']>;
  suppressBio?: Maybe<Scalars['Boolean']['output']>;
  tags?: Maybe<Array<CmsTag>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CmsLiveBlogItemsArgs = {
  input?: CmsLiveBlogItemsInput;
};

export type CmsLiveBlogItem = {
  __typename?: 'CMSLiveBlogItem';
  body?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deleted: Scalars['Boolean']['output'];
  displayPublishedAt?: Maybe<Scalars['DateTime']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  important: Scalars['Boolean']['output'];
  pinned: Scalars['Boolean']['output'];
  pinnedSequence: Scalars['Int']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  scheduledAt?: Maybe<Scalars['DateTime']['output']>;
  sequence: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CmsLiveBlogItemConnection = {
  __typename?: 'CMSLiveBlogItemConnection';
  /** A list of edges. */
  edges: Array<CmsLiveBlogItemEdge>;
  /** A list of nodes. */
  nodes: Array<CmsLiveBlogItem>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total count. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CmsLiveBlogItemEdge = {
  __typename?: 'CMSLiveBlogItemEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: CmsLiveBlogItem;
};

export type CmsLiveBlogItemOrderBy = {
  /** Sort by `LiveBlogItem`'s sequence. */
  sequence?: InputMaybe<CmsOrderByDir>;
};

export type CmsLiveBlogItemsInput = {
  /** Should be base64 encoded to support offset and ID-based pagination. */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Defines the number of results to return. */
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CmsLiveBlogItemOrderBy>>;
};

export type CmsObjectType = CmsArticle | CmsCollection | CmsFeature | CmsImage | CmsLiveBlog | CmsLiveBlogItem | CmsPoll | CmsSportsObjectCoach | CmsSportsObjectRecruit | CmsSportsPodcastEpisode | CmsTag | CmsTemplate | CmsTemplateLayout | CmsUpdatingStory | CmsUser | CmsVideo | Conference | Division | Event | Game | League | Player | Sport | Team;

export enum CmsOrderByDir {
  /** Sort by ascending order. */
  Asc = 'ASC',
  /** Sort by descending order. */
  Desc = 'DESC'
}

export type CmsPageLayout = {
  __typename?: 'CMSPageLayout';
  children: Array<CmsPageLayout>;
  colspan: Scalars['Int']['output'];
  components: Array<CmsComponentInterface>;
  label?: Maybe<Scalars['String']['output']>;
};

export type CmsPoll = {
  __typename?: 'CMSPoll';
  answers: Array<CmsPollAnswer>;
  businessUnit?: Maybe<CmsBusinessUnit>;
  cmsContentId?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  displayPublishedAt?: Maybe<Scalars['DateTime']['output']>;
  displayPublishedAtTimezone?: Maybe<Scalars['String']['output']>;
  displayUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  edition?: Maybe<CmsEdition>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  headline: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  maxVotes: Scalars['Int']['output'];
  postBallotComponent?: Maybe<Scalars['String']['output']>;
  publishable: Scalars['Boolean']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  publishedAtTimezone?: Maybe<Scalars['String']['output']>;
  question?: Maybe<Scalars['String']['output']>;
  requireLogin: Scalars['Boolean']['output'];
  resultsPage?: Maybe<Scalars['String']['output']>;
  showVoteCount: Scalars['Boolean']['output'];
  siteId: Scalars['Int']['output'];
  startDate?: Maybe<Scalars['DateTime']['output']>;
  subHeading?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  voteButtonText?: Maybe<Scalars['String']['output']>;
  /** Checks if the current user has voted on the Poll. */
  voteStatus?: Maybe<CmsPollVoteStatus>;
};

export type CmsPollAccessToken = {
  __typename?: 'CMSPollAccessToken';
  token: Scalars['String']['output'];
};

export type CmsPollAnswer = {
  __typename?: 'CMSPollAnswer';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deleted: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<CmsImage>;
  sequence: Scalars['Int']['output'];
  text: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Checks if the current user has voted on the current answer. */
  voteStatus?: Maybe<CmsPollVoteStatus>;
  votes: Scalars['Int']['output'];
};

export type CmsPollCastVoteInput = {
  allowAlterVote?: InputMaybe<Scalars['Boolean']['input']>;
  pollAnswerId: Scalars['ID']['input'];
  pollId: Scalars['ID']['input'];
  tenant?: CmsTenant;
  token: Scalars['String']['input'];
  userIdentifier: Scalars['String']['input'];
};

export type CmsPollCastVotesInput = {
  allowAlterVote?: InputMaybe<Scalars['Boolean']['input']>;
  pollAnswerIds: Array<Scalars['ID']['input']>;
  pollId: Scalars['ID']['input'];
  tenant?: CmsTenant;
  token: Scalars['String']['input'];
  userIdentifier: Scalars['String']['input'];
};

/** Conditions to filter Poll listings by. */
export type CmsPollCondition = {
  /** Editions. */
  editionsIn?: Array<CmsEdition>;
  /** IDs in. */
  idsIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  relatedContentIn?: InputMaybe<CmsRelatedContentInInput>;
  /** Slugs. */
  slugsIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** tenants. */
  tenantsIn?: Array<CmsTenant>;
};

export type CmsPollConnection = {
  __typename?: 'CMSPollConnection';
  /** A list of edges. */
  edges: Array<CmsPollEdge>;
  /** A list of nodes. */
  nodes: Array<CmsPoll>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total count. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CmsPollEdge = {
  __typename?: 'CMSPollEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: CmsPoll;
};

export type CmsPollInput = {
  device?: CmsDevice;
  edition?: CmsEdition;
  id: Scalars['ID']['input'];
  tenant?: CmsTenant;
  /** The user identifier to use against checking of polls. */
  userIdentifier?: InputMaybe<Scalars['String']['input']>;
};

export type CmsPollOrderBy = {
  /** Sort by `Poll`'s created_at. */
  createdAt?: InputMaybe<CmsOrderByDir>;
  /** Sort by `Poll`'s published_at. */
  publishedAt?: InputMaybe<CmsOrderByDir>;
  /** Sort by `Poll`'s updated_at. */
  updatedAt?: InputMaybe<CmsOrderByDir>;
};

export type CmsPollVoteAccessTokenInput = {
  pollAnswerId: Scalars['ID']['input'];
  pollId: Scalars['ID']['input'];
  tenant?: CmsTenant;
  userIdentifier: Scalars['String']['input'];
};

export type CmsPollVoteForbiddenError = Error & {
  __typename?: 'CMSPollVoteForbiddenError';
  message: Scalars['String']['output'];
};

export type CmsPollVoteInvalidTokenError = Error & {
  __typename?: 'CMSPollVoteInvalidTokenError';
  message: Scalars['String']['output'];
};

export type CmsPollVoteResult = BadRequestError | CmsPollVoteForbiddenError | CmsPollVoteInvalidTokenError | CmsPollVoteUserAlreadyVotedError | InternalServerError | SuccessResult;

export enum CmsPollVoteStatus {
  NotVoted = 'NOT_VOTED',
  Voted = 'VOTED',
  VotePending = 'VOTE_PENDING'
}

export type CmsPollVoteUserAlreadyVotedError = Error & {
  __typename?: 'CMSPollVoteUserAlreadyVotedError';
  message: Scalars['String']['output'];
};

export type CmsPollVotesAccessTokenInput = {
  pollAnswerIds: Array<Scalars['ID']['input']>;
  pollId: Scalars['ID']['input'];
  tenant?: CmsTenant;
  userIdentifier: Scalars['String']['input'];
};

export type CmsPollsInput = {
  /** Should be base64 encoded to support offset and ID-based pagination. */
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: CmsPollCondition;
  /** Defines the number of results to return. */
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CmsPollOrderBy>>;
  /** The user identifier to use against checking of polls. */
  userIdentifier?: InputMaybe<Scalars['String']['input']>;
};

export type CmsRecommendedContent = CmsArticle | CmsLiveBlog | CmsVideo | GraphicsCard | XTweet;

export type CmsRecommendedContentIdInput = {
  contentType: CmsRecommendedContentType;
  id: Scalars['ID']['input'];
};

export enum CmsRecommendedContentType {
  CmsArticle = 'CMS_ARTICLE',
  CmsLiveBlog = 'CMS_LIVE_BLOG',
  CmsVideo = 'CMS_VIDEO',
  GraphicsCard = 'GRAPHICS_CARD',
  XTweet = 'X_TWEET'
}

export type CmsRelatedContent = {
  __typename?: 'CMSRelatedContent';
  category?: Maybe<Scalars['String']['output']>;
  object?: Maybe<CmsObjectType>;
};

export type CmsRelatedContentAbbreviationsInput = {
  sportsObjectGame?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CmsRelatedContentFiltersInput = {
  /** Editions. */
  editionsIn?: Array<CmsEdition>;
  tenantsIn?: Array<CmsTenant>;
};

export type CmsRelatedContentIDsInput = {
  contentArticle?: InputMaybe<Array<Scalars['ID']['input']>>;
  contentCollection?: InputMaybe<Array<Scalars['ID']['input']>>;
  contentFeature?: InputMaybe<Array<Scalars['ID']['input']>>;
  contentImage?: InputMaybe<Array<Scalars['ID']['input']>>;
  contentLiveBlog?: InputMaybe<Array<Scalars['ID']['input']>>;
  contentLiveBlogItem?: InputMaybe<Array<Scalars['ID']['input']>>;
  contentPoll?: InputMaybe<Array<Scalars['ID']['input']>>;
  contentTag?: InputMaybe<Array<Scalars['ID']['input']>>;
  contentTemplate?: InputMaybe<Array<Scalars['ID']['input']>>;
  contentTemplateLayout?: InputMaybe<Array<Scalars['ID']['input']>>;
  contentUpdatingStory?: InputMaybe<Array<Scalars['ID']['input']>>;
  contentVideo?: InputMaybe<Array<Scalars['ID']['input']>>;
  coreUser?: InputMaybe<Array<Scalars['ID']['input']>>;
  sportsObjectCoach?: InputMaybe<Array<Scalars['ID']['input']>>;
  sportsObjectConference?: InputMaybe<Array<Scalars['ID']['input']>>;
  sportsObjectDivision?: InputMaybe<Array<Scalars['ID']['input']>>;
  sportsObjectEvent?: InputMaybe<Array<Scalars['ID']['input']>>;
  sportsObjectGame?: InputMaybe<Array<Scalars['ID']['input']>>;
  sportsObjectLeague?: InputMaybe<Array<Scalars['ID']['input']>>;
  sportsObjectPlayer?: InputMaybe<Array<Scalars['ID']['input']>>;
  sportsObjectRecruit?: InputMaybe<Array<Scalars['ID']['input']>>;
  sportsObjectSport?: InputMaybe<Array<Scalars['ID']['input']>>;
  sportsObjectTeam?: InputMaybe<Array<Scalars['ID']['input']>>;
  sportsPodcastEpisode?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type CmsRelatedContentInInput = {
  abbrevsIn?: InputMaybe<CmsRelatedContentAbbreviationsInput>;
  idsIn?: InputMaybe<CmsRelatedContentIDsInput>;
};

export type CmsSportsObjectCoach = {
  __typename?: 'CMSSportsObjectCoach';
  id: Scalars['ID']['output'];
  player?: Maybe<Player>;
};

export type CmsSportsObjectEvent = {
  __typename?: 'CMSSportsObjectEvent';
  awayTeamName?: Maybe<Scalars['String']['output']>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  contactPhone?: Maybe<Scalars['String']['output']>;
  contactSms?: Maybe<Scalars['String']['output']>;
  couplerPhone?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  eventName?: Maybe<Scalars['String']['output']>;
  eventPeriod?: Maybe<Scalars['Int']['output']>;
  eventStatus?: Maybe<Scalars['String']['output']>;
  eventType?: Maybe<Scalars['String']['output']>;
  externalUrl?: Maybe<Scalars['String']['output']>;
  homeTeamName?: Maybe<Scalars['String']['output']>;
  leagueAbbreviation?: Maybe<Scalars['String']['output']>;
  oracleId?: Maybe<Scalars['Int']['output']>;
  scheduledEndDate?: Maybe<Scalars['DateTime']['output']>;
  scheduledStartDate?: Maybe<Scalars['DateTime']['output']>;
  scheduledTimezone?: Maybe<Scalars['String']['output']>;
  seasonYear?: Maybe<Scalars['Int']['output']>;
  syncedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  venue?: Maybe<Scalars['String']['output']>;
};

/** Conditions to filter SportsObjectEvent listings by. */
export type CmsSportsObjectEventCondition = {
  /** IDs in. */
  idsIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Perform a keyword search. */
  keywordSearch?: InputMaybe<Scalars['String']['input']>;
  leagueAbbreviation?: InputMaybe<Scalars['String']['input']>;
};

export type CmsSportsObjectEventConnection = {
  __typename?: 'CMSSportsObjectEventConnection';
  /** A list of edges. */
  edges: Array<CmsSportsObjectEventEdge>;
  /** A list of nodes. */
  nodes: Array<CmsSportsObjectEvent>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total count. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CmsSportsObjectEventEdge = {
  __typename?: 'CMSSportsObjectEventEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: CmsSportsObjectEvent;
};

export type CmsSportsObjectEventOrderBy = {
  /** Sort by `SportsObjectEvent`'s created_at. */
  createdAt?: InputMaybe<CmsOrderByDir>;
  /** Sort by score. */
  score?: InputMaybe<CmsOrderByDir>;
  /** Sort by `SportsObjectEvent`'s updated_at. */
  updatedAt?: InputMaybe<CmsOrderByDir>;
};

export type CmsSportsObjectEventsInput = {
  /** Should be base64 encoded to support offset and ID-based pagination. */
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: CmsSportsObjectEventCondition;
  /** Defines the number of results to return. */
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CmsSportsObjectEventOrderBy>>;
};

export type CmsSportsObjectGame = {
  __typename?: 'CMSSportsObjectGame';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  gameAbbreviation?: Maybe<Scalars['String']['output']>;
  gameDate?: Maybe<Scalars['DateTime']['output']>;
  leagueAbbreviation?: Maybe<Scalars['String']['output']>;
  oracleId?: Maybe<Scalars['Int']['output']>;
  syncedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Conditions to filter SportsObjectGame listings by. */
export type CmsSportsObjectGameCondition = {
  /** IDs in. */
  idsIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Perform a keyword search. */
  keywordSearch?: InputMaybe<Scalars['String']['input']>;
  leagueAbbreviation?: InputMaybe<Scalars['String']['input']>;
};

export type CmsSportsObjectGameConnection = {
  __typename?: 'CMSSportsObjectGameConnection';
  /** A list of edges. */
  edges: Array<CmsSportsObjectGameEdge>;
  /** A list of nodes. */
  nodes: Array<CmsSportsObjectGame>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total count. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CmsSportsObjectGameEdge = {
  __typename?: 'CMSSportsObjectGameEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: CmsSportsObjectGame;
};

export type CmsSportsObjectGameOrderBy = {
  /** Sort by `SportsObjectGame`'s created_at. */
  createdAt?: InputMaybe<CmsOrderByDir>;
  /** Sort by score. */
  score?: InputMaybe<CmsOrderByDir>;
  /** Sort by `SportsObjectGame`'s updated_at. */
  updatedAt?: InputMaybe<CmsOrderByDir>;
};

export type CmsSportsObjectGamesInput = {
  /** Should be base64 encoded to support offset and ID-based pagination. */
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: CmsSportsObjectGameCondition;
  /** Defines the number of results to return. */
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CmsSportsObjectGameOrderBy>>;
};

export type CmsSportsObjectLeague = {
  __typename?: 'CMSSportsObjectLeague';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  leagueAbbreviation?: Maybe<Scalars['String']['output']>;
  leagueName?: Maybe<Scalars['String']['output']>;
  leagueSortOrder?: Maybe<Scalars['String']['output']>;
  leagueType?: Maybe<Scalars['String']['output']>;
  oracleId?: Maybe<Scalars['Int']['output']>;
  sportName?: Maybe<Scalars['String']['output']>;
  syncedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Conditions to filter SportsObjectLeague listings by. */
export type CmsSportsObjectLeagueCondition = {
  /** IDs in. */
  idsIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Perform a keyword search. */
  keywordSearch?: InputMaybe<Scalars['String']['input']>;
};

export type CmsSportsObjectLeagueConnection = {
  __typename?: 'CMSSportsObjectLeagueConnection';
  /** A list of edges. */
  edges: Array<CmsSportsObjectLeagueEdge>;
  /** A list of nodes. */
  nodes: Array<CmsSportsObjectLeague>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total count. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CmsSportsObjectLeagueEdge = {
  __typename?: 'CMSSportsObjectLeagueEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: CmsSportsObjectLeague;
};

export type CmsSportsObjectLeagueOrderBy = {
  /** Sort by `SportsObjectLeague`'s created_at. */
  createdAt?: InputMaybe<CmsOrderByDir>;
  /** Sort by `SportsObjectLeague`'s league_name. */
  name?: InputMaybe<CmsOrderByDir>;
  /** Sort by score. */
  score?: InputMaybe<CmsOrderByDir>;
  /** Sort by `SportsObjectLeague`'s updated_at. */
  updatedAt?: InputMaybe<CmsOrderByDir>;
};

export type CmsSportsObjectLeaguesInput = {
  /** Should be base64 encoded to support offset and ID-based pagination. */
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: CmsSportsObjectLeagueCondition;
  /** Defines the number of results to return. */
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CmsSportsObjectLeagueOrderBy>>;
};

export type CmsSportsObjectPlayer = {
  __typename?: 'CMSSportsObjectPlayer';
  birthDate?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  debutDate?: Maybe<Scalars['DateTime']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  experience?: Maybe<Scalars['Int']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  headshotImage?: Maybe<CmsImage>;
  height?: Maybe<Scalars['String']['output']>;
  hometown?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  lockExpires?: Maybe<Scalars['DateTime']['output']>;
  marqueeImage?: Maybe<CmsImage>;
  nickName?: Maybe<Scalars['String']['output']>;
  oracleId?: Maybe<Scalars['Int']['output']>;
  resolvedMarquee?: Maybe<Scalars['Boolean']['output']>;
  school?: Maybe<Scalars['String']['output']>;
  syncedAt?: Maybe<Scalars['DateTime']['output']>;
  titleName?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  weight?: Maybe<Scalars['String']['output']>;
};

/** Conditions to filter SportsObjectPlayer listings by. */
export type CmsSportsObjectPlayerCondition = {
  /** IDs in. */
  idsIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Perform a keyword search. */
  keywordSearch?: InputMaybe<Scalars['String']['input']>;
};

export type CmsSportsObjectPlayerConnection = {
  __typename?: 'CMSSportsObjectPlayerConnection';
  /** A list of edges. */
  edges: Array<CmsSportsObjectPlayerEdge>;
  /** A list of nodes. */
  nodes: Array<CmsSportsObjectPlayer>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total count. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CmsSportsObjectPlayerEdge = {
  __typename?: 'CMSSportsObjectPlayerEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: CmsSportsObjectPlayer;
};

export type CmsSportsObjectPlayerOrderBy = {
  /** Sort by `SportsObjectPlayer`'s created_at. */
  createdAt?: InputMaybe<CmsOrderByDir>;
  /** Sort by score. */
  score?: InputMaybe<CmsOrderByDir>;
  /** Sort by `SportsObjectPlayer`'s updated_at. */
  updatedAt?: InputMaybe<CmsOrderByDir>;
};

export type CmsSportsObjectPlayersInput = {
  /** Should be base64 encoded to support offset and ID-based pagination. */
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: CmsSportsObjectPlayerCondition;
  /** Defines the number of results to return. */
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CmsSportsObjectPlayerOrderBy>>;
};

export type CmsSportsObjectRecruit = {
  __typename?: 'CMSSportsObjectRecruit';
  id: Scalars['ID']['output'];
  player?: Maybe<Player>;
};

export type CmsSportsObjectSport = {
  __typename?: 'CMSSportsObjectSport';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  oracleId?: Maybe<Scalars['Int']['output']>;
  sportAbbreviation?: Maybe<Scalars['String']['output']>;
  sportName?: Maybe<Scalars['String']['output']>;
  sportShortname?: Maybe<Scalars['String']['output']>;
  syncedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Conditions to filter SportsObjectSport listings by. */
export type CmsSportsObjectSportCondition = {
  /** IDs in. */
  idsIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Perform a keyword search. */
  keywordSearch?: InputMaybe<Scalars['String']['input']>;
};

export type CmsSportsObjectSportConnection = {
  __typename?: 'CMSSportsObjectSportConnection';
  /** A list of edges. */
  edges: Array<CmsSportsObjectSportEdge>;
  /** A list of nodes. */
  nodes: Array<CmsSportsObjectSport>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total count. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CmsSportsObjectSportEdge = {
  __typename?: 'CMSSportsObjectSportEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: CmsSportsObjectSport;
};

export type CmsSportsObjectSportOrderBy = {
  /** Sort by `SportsObjectSport`'s created_at. */
  createdAt?: InputMaybe<CmsOrderByDir>;
  /** Sort by `SportsObjectSport`'s league_name. */
  name?: InputMaybe<CmsOrderByDir>;
  /** Sort by score. */
  score?: InputMaybe<CmsOrderByDir>;
  /** Sort by `SportsObjectSport`'s updated_at. */
  updatedAt?: InputMaybe<CmsOrderByDir>;
};

export type CmsSportsObjectSportsInput = {
  /** Should be base64 encoded to support offset and ID-based pagination. */
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: CmsSportsObjectSportCondition;
  /** Defines the number of results to return. */
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CmsSportsObjectSportOrderBy>>;
};

export type CmsSportsObjectTeam = {
  __typename?: 'CMSSportsObjectTeam';
  colorHexDex?: Maybe<Scalars['String']['output']>;
  colorPrimaryHex?: Maybe<Scalars['String']['output']>;
  colorSecondaryHex?: Maybe<Scalars['String']['output']>;
  conferenceAbbreviation?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  divisionAbbreviation?: Maybe<Scalars['String']['output']>;
  image?: Maybe<CmsImage>;
  leagueAbbreviation?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  lockExpires?: Maybe<Scalars['DateTime']['output']>;
  mediumName?: Maybe<Scalars['String']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  oracleId?: Maybe<Scalars['Int']['output']>;
  shortName?: Maybe<Scalars['String']['output']>;
  syncedAt?: Maybe<Scalars['DateTime']['output']>;
  teamAbbreviation?: Maybe<Scalars['String']['output']>;
  teamStatus?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  venueId?: Maybe<Scalars['Int']['output']>;
};

/** Conditions to filter SportsObjectTeam listings by. */
export type CmsSportsObjectTeamCondition = {
  /** IDs in. */
  idsIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Perform a keyword search. */
  keywordSearch?: InputMaybe<Scalars['String']['input']>;
  leagueAbbreviation?: InputMaybe<Scalars['String']['input']>;
};

export type CmsSportsObjectTeamConnection = {
  __typename?: 'CMSSportsObjectTeamConnection';
  /** A list of edges. */
  edges: Array<CmsSportsObjectTeamEdge>;
  /** A list of nodes. */
  nodes: Array<CmsSportsObjectTeam>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total count. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CmsSportsObjectTeamEdge = {
  __typename?: 'CMSSportsObjectTeamEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: CmsSportsObjectTeam;
};

export type CmsSportsObjectTeamOrderBy = {
  /** Sort by `SportsObjectTeam`'s created_at. */
  createdAt?: InputMaybe<CmsOrderByDir>;
  /** Sort by score. */
  score?: InputMaybe<CmsOrderByDir>;
  /** Sort by `SportsObjectTeam`'s updated_at. */
  updatedAt?: InputMaybe<CmsOrderByDir>;
};

export type CmsSportsObjectTeamsInput = {
  /** Should be base64 encoded to support offset and ID-based pagination. */
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: CmsSportsObjectTeamCondition;
  /** Defines the number of results to return. */
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CmsSportsObjectTeamOrderBy>>;
};

export type CmsSportsPodcastEpisode = {
  __typename?: 'CMSSportsPodcastEpisode';
  businessUnit?: Maybe<CmsBusinessUnit>;
  channel?: Maybe<Scalars['String']['output']>;
  cmsContentId?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  explicit?: Maybe<Scalars['Boolean']['output']>;
  featured?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  keywords?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  publishedAtTimezone: Scalars['String']['output'];
  siteId: Scalars['Int']['output'];
  size?: Maybe<Scalars['Int']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CmsStaticComponent = CmsComponentInterface & {
  __typename?: 'CMSStaticComponent';
  businessUnit?: Maybe<CmsBusinessUnit>;
  cmsContentId?: Maybe<Scalars['ID']['output']>;
  componentLabel?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  function?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  internalName?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  siteId: Scalars['Int']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  view?: Maybe<Scalars['String']['output']>;
};

export type CmsTag = {
  __typename?: 'CMSTag';
  businessUnit?: Maybe<CmsBusinessUnit>;
  cmsContentId?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  siteId: Scalars['Int']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CmsTemplate = {
  __typename?: 'CMSTemplate';
  businessUnit?: Maybe<CmsBusinessUnit>;
  cmsContentId?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  deviceType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  layoutId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  siteId: Scalars['Int']['output'];
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CmsTemplateLayout = {
  __typename?: 'CMSTemplateLayout';
  businessUnit?: Maybe<CmsBusinessUnit>;
  cmsContentId?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  deviceType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isG960: Scalars['Boolean']['output'];
  layoutWidth: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  siteId: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CmsTenant = {
  businessUnit?: CmsBusinessUnit;
  siteId?: Scalars['Int']['input'];
};

export type CmsTextComponent = CmsComponentInterface & {
  __typename?: 'CMSTextComponent';
  body?: Maybe<Scalars['String']['output']>;
  businessUnit?: Maybe<CmsBusinessUnit>;
  cmsContentId?: Maybe<Scalars['ID']['output']>;
  componentLabel?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  function?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  internalName?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  siteId: Scalars['Int']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  view?: Maybe<Scalars['String']['output']>;
};

export type CmsTopic = {
  __typename?: 'CMSTopic';
  businessUnit?: Maybe<CmsBusinessUnit>;
  cmsContentId?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  siteId: Scalars['Int']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CmsUpdatingStory = CmsVersionableContentInterface & {
  __typename?: 'CMSUpdatingStory';
  businessUnit?: Maybe<CmsBusinessUnit>;
  callToAction?: Maybe<Scalars['String']['output']>;
  cmsContentId?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dek?: Maybe<Scalars['String']['output']>;
  displayPublishedAt?: Maybe<Scalars['DateTime']['output']>;
  displayPublishedAtTimezone?: Maybe<Scalars['String']['output']>;
  displayUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  edition?: Maybe<CmsEdition>;
  editors?: Maybe<Array<CmsUser>>;
  eventEnd?: Maybe<Scalars['DateTime']['output']>;
  eventStart?: Maybe<Scalars['DateTime']['output']>;
  eventTimezone?: Maybe<Scalars['String']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<CmsImage>;
  intro?: Maybe<Scalars['String']['output']>;
  primaryAuthor?: Maybe<CmsUser>;
  primaryCollection?: Maybe<CmsCollection>;
  primaryTopic?: Maybe<CmsTopic>;
  promoDek?: Maybe<Scalars['String']['output']>;
  promoHed?: Maybe<Scalars['String']['output']>;
  promoImage?: Maybe<CmsImage>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  publishedAtTimezone?: Maybe<Scalars['String']['output']>;
  relatedContent?: Maybe<Array<CmsRelatedContent>>;
  secondaryAuthors?: Maybe<Array<CmsUser>>;
  secondaryCollections?: Maybe<Array<CmsCollection>>;
  secondaryTopics?: Maybe<Array<CmsTopic>>;
  siteId: Scalars['Int']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  suppressAutoplay?: Maybe<Scalars['Boolean']['output']>;
  suppressBio?: Maybe<Scalars['Boolean']['output']>;
  tags?: Maybe<Array<CmsTag>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CmsUser = {
  __typename?: 'CMSUser';
  businessUnit?: Maybe<CmsBusinessUnit>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<CmsImage>;
  lastName?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  username: Scalars['String']['output'];
};

export type CmsVersionableContentInterface = {
  cmsContentId?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dek?: Maybe<Scalars['String']['output']>;
  displayPublishedAt?: Maybe<Scalars['DateTime']['output']>;
  displayPublishedAtTimezone?: Maybe<Scalars['String']['output']>;
  displayUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  edition?: Maybe<CmsEdition>;
  editors?: Maybe<Array<CmsUser>>;
  headline?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<CmsImage>;
  primaryAuthor?: Maybe<CmsUser>;
  primaryTopic?: Maybe<CmsTopic>;
  promoDek?: Maybe<Scalars['String']['output']>;
  promoHed?: Maybe<Scalars['String']['output']>;
  promoImage?: Maybe<CmsImage>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  publishedAtTimezone?: Maybe<Scalars['String']['output']>;
  relatedContent?: Maybe<Array<CmsRelatedContent>>;
  secondaryAuthors?: Maybe<Array<CmsUser>>;
  secondaryTopics?: Maybe<Array<CmsTopic>>;
  siteId: Scalars['Int']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  suppressBio?: Maybe<Scalars['Boolean']['output']>;
  tags?: Maybe<Array<CmsTag>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CmsVideo = CmsVersionableContentInterface & {
  __typename?: 'CMSVideo';
  businessUnit?: Maybe<CmsBusinessUnit>;
  casts?: Maybe<Array<CmsVideoCast>>;
  chapters?: Maybe<Array<CmsVideoChapter>>;
  cmsContentId?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dek?: Maybe<Scalars['String']['output']>;
  displayPublishedAt?: Maybe<Scalars['DateTime']['output']>;
  displayPublishedAtTimezone?: Maybe<Scalars['String']['output']>;
  displayUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  duration?: Maybe<Scalars['Float']['output']>;
  edition?: Maybe<CmsEdition>;
  editors?: Maybe<Array<CmsUser>>;
  files?: Maybe<Array<CmsVideoFile>>;
  headline?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<CmsImage>;
  orientation: CmsVideoOrientation;
  primaryAuthor?: Maybe<CmsUser>;
  primaryCollection?: Maybe<CmsCollection>;
  primaryTopic?: Maybe<CmsTopic>;
  promoDek?: Maybe<Scalars['String']['output']>;
  promoHed?: Maybe<Scalars['String']['output']>;
  promoImage?: Maybe<CmsImage>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  publishedAtTimezone?: Maybe<Scalars['String']['output']>;
  relatedContent?: Maybe<Array<CmsRelatedContent>>;
  secondaryAuthors?: Maybe<Array<CmsUser>>;
  secondaryCollections?: Maybe<Array<CmsCollection>>;
  secondaryTopics?: Maybe<Array<CmsTopic>>;
  siteId: Scalars['Int']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  suppressBio?: Maybe<Scalars['Boolean']['output']>;
  tags?: Maybe<Array<CmsTag>>;
  trackingID?: Maybe<Scalars['String']['output']>;
  transcripts?: Maybe<Array<CmsVideoTranscript>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  vendors?: Maybe<Array<CmsVideoVendor>>;
};

export type CmsVideoCast = {
  __typename?: 'CMSVideoCast';
  name?: Maybe<Scalars['String']['output']>;
};

export type CmsVideoChapter = {
  __typename?: 'CMSVideoChapter';
  category?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  time?: Maybe<Scalars['Int']['output']>;
};

export type CmsVideoComponent = CmsComponentInterface & {
  __typename?: 'CMSVideoComponent';
  businessUnit?: Maybe<CmsBusinessUnit>;
  cmsContentId?: Maybe<Scalars['ID']['output']>;
  componentLabel?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  function?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  internalName?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  siteId: Scalars['Int']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  video?: Maybe<CmsVideo>;
  view?: Maybe<Scalars['String']['output']>;
};

export type CmsVideoFile = {
  __typename?: 'CMSVideoFile';
  audioBitrate?: Maybe<Scalars['Int']['output']>;
  audioChannels?: Maybe<Scalars['Float']['output']>;
  audioCodec?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  downloadUrl?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Float']['output']>;
  frameRate?: Maybe<Scalars['Float']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  sourceUrl?: Maybe<Scalars['String']['output']>;
  streamingUrl?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  vendors?: Maybe<Array<CmsVideoFileVendor>>;
  videoBitrate?: Maybe<Scalars['Int']['output']>;
  videoCodec?: Maybe<Scalars['String']['output']>;
  videoFormat?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type CmsVideoFileVendor = {
  __typename?: 'CMSVideoFileVendor';
  data?: Maybe<Scalars['JSON']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  vendorId?: Maybe<Scalars['String']['output']>;
  vendorName: Scalars['String']['output'];
};

export enum CmsVideoOrientation {
  Landscape = 'LANDSCAPE',
  Portrait = 'PORTRAIT'
}

export type CmsVideoTranscript = {
  __typename?: 'CMSVideoTranscript';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  data?: Maybe<Scalars['String']['output']>;
  format?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  process?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CmsVideoVendor = {
  __typename?: 'CMSVideoVendor';
  data?: Maybe<Scalars['JSON']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  vendorId?: Maybe<Scalars['String']['output']>;
  vendorName: Scalars['String']['output'];
};

/** Cache control scope enumeration */
export enum CacheControlScope {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type ClientTokenResponse = {
  __typename?: 'ClientTokenResponse';
  access_token?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['Int']['output']>;
  expires_in?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  token_type?: Maybe<Scalars['String']['output']>;
};

export type CodeProfilesInput = {
  code: Scalars['String']['input'];
  serviceProvider?: InputMaybe<Scalars['String']['input']>;
};

export type CodeProfilesResponse = {
  __typename?: 'CodeProfilesResponse';
  profiles?: Maybe<Array<Maybe<ProviderProfile>>>;
};

/** Represents a college football subdivision enum value. */
export enum CollegeFootballSubdivision {
  /** NCAA Division I Football Bowl Subdivision */
  Fbs = 'FBS',
  /** NCAA Division I Football Championship Subdivision */
  Fcs = 'FCS'
}

/** tennis competition, refer to competition table in SQL DB */
export type Competition = {
  __typename?: 'Competition';
  /** The timestamp when the competition was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** gender of the competition */
  gender?: Maybe<CompetitionGender>;
  /** The unique identifier for the competition */
  id: Scalars['ID']['output'];
  /** league of the competition, such as ATP, WTA, ITF */
  league?: Maybe<League>;
  /** The level of the competition, such as grand_slam, wta_250, wta_international. */
  level?: Maybe<CompetitionLevel>;
  /**
   * The matches associated with the competition, with optional filtering by scheduled time and sorting.
   *   If `sort` is provided, it will be applied in the order given.
   *   If the `sort` is not added, the default sorting is by scheduled time in ascending order.
   */
  matches?: Maybe<CompetitionMatchConnection>;
  /** The name of the competition */
  name: Scalars['String']['output'];
  /** parent of the competition, if any */
  parentId?: Maybe<Scalars['ID']['output']>;
  /**
   * The competition seasons associated with the competition.
   *   If activeSince and activeUntil are provided, seasons that overlap with the range will be returned.
   */
  season?: Maybe<CompetitionSeasonsConnection>;
  /** The type of the competition (e.g., singles, doubles) */
  type?: Maybe<CompetitionType>;
  /** The timestamp when the competition was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


/** tennis competition, refer to competition table in SQL DB */
export type CompetitionMatchesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  scheduledSince?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledUntil?: InputMaybe<Scalars['DateTime']['input']>;
  sort?: InputMaybe<Array<MatchSortInput>>;
};


/** tennis competition, refer to competition table in SQL DB */
export type CompetitionSeasonArgs = {
  activeSince?: InputMaybe<Scalars['Date']['input']>;
  activeUntil?: InputMaybe<Scalars['Date']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  seasonId?: InputMaybe<Scalars['ID']['input']>;
};

/** competition gender */
export enum CompetitionGender {
  Men = 'MEN',
  Mixed = 'MIXED',
  Women = 'WOMEN'
}

/** Competition levels */
export enum CompetitionLevel {
  Atp_250 = 'ATP_250',
  Atp_500 = 'ATP_500',
  Atp_1000 = 'ATP_1000',
  AtpNextGeneration = 'ATP_NEXT_GENERATION',
  AtpWorldTourFinals = 'ATP_WORLD_TOUR_FINALS',
  GrandSlam = 'GRAND_SLAM',
  National = 'NATIONAL',
  Wta_125 = 'WTA_125',
  Wta_250 = 'WTA_250',
  Wta_500 = 'WTA_500',
  Wta_1000 = 'WTA_1000',
  WtaChampionships = 'WTA_CHAMPIONSHIPS',
  WtaEliteTrophy = 'WTA_ELITE_TROPHY',
  WtaInternational = 'WTA_INTERNATIONAL',
  WtaMaster = 'WTA_MASTER',
  WtaPremier = 'WTA_PREMIER'
}

/** Define a connection between a competition and its list of matches. */
export type CompetitionMatchConnection = {
  __typename?: 'CompetitionMatchConnection';
  edges?: Maybe<Array<Maybe<CompetitionMatchEdge>>>;
  nodes?: Maybe<Array<Maybe<Match>>>;
  pageInfo: PageInfo;
};

export type CompetitionMatchEdge = {
  __typename?: 'CompetitionMatchEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<Match>;
};

/** Represents a parent tournament that can have child tournaments. */
export type CompetitionParent = {
  __typename?: 'CompetitionParent';
  /** The alternate name for the parent competition, if any */
  alternateName?: Maybe<Scalars['String']['output']>;
  /** The child tournaments associated with this parent tournament. Note that when using tennisTournaments query with types, levels, or leagueAbbrevs filters, both parent and child competitions will be filtered using those parameters. */
  childTournaments?: Maybe<Array<Competition>>;
  /** The unique identifier for the parent competition */
  id: Scalars['ID']['output'];
  /** The name of the parent competition */
  name: Scalars['String']['output'];
  /**
   * The competition seasons associated with the competition.
   *   If activeSince and activeUntil are provided, seasons that overlap with the range will be returned.
   */
  season?: Maybe<CompetitionSeasonsConnection>;
};


/** Represents a parent tournament that can have child tournaments. */
export type CompetitionParentChildTournamentsArgs = {
  leagueAbbrevs?: InputMaybe<Array<Scalars['String']['input']>>;
  levels?: InputMaybe<Array<CompetitionLevel>>;
  types?: InputMaybe<Array<CompetitionType>>;
};


/** Represents a parent tournament that can have child tournaments. */
export type CompetitionParentSeasonArgs = {
  activeSince?: InputMaybe<Scalars['Date']['input']>;
  activeUntil?: InputMaybe<Scalars['Date']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  seasonId?: InputMaybe<Scalars['ID']['input']>;
};

/** Connection type for fetching parent competitions with pagination. */
export type CompetitionParentConnection = {
  __typename?: 'CompetitionParentConnection';
  edges: Array<CompetitionParentEdge>;
  nodes: Array<CompetitionParent>;
  pageInfo: PageInfo;
};

/** Edge type for parent competitions, used in pagination. */
export type CompetitionParentEdge = {
  __typename?: 'CompetitionParentEdge';
  cursor: Scalars['String']['output'];
  node: CompetitionParent;
};

/** association between tennis competition and season */
export type CompetitionSeason = {
  __typename?: 'CompetitionSeason';
  /** The unique identifier for the competition */
  competitionId: Scalars['ID']['output'];
  /** The complex/venue associated with the competition season */
  complex?: Maybe<Complex>;
  /** The timestamp when the competition season was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Whether the tournament season is active. It only applies to child competition seasons. */
  isActive?: Maybe<Scalars['Boolean']['output']>;
  matches?: Maybe<CompetitionSeasonMatchConnection>;
  /** The unique identifier for the season */
  seasonId: Scalars['ID']['output'];
  /** The surface type for the competition season */
  surface?: Maybe<Scalars['String']['output']>;
  /** The end date of the tournament */
  tournamentEndDt?: Maybe<Scalars['Date']['output']>;
  /** The start date of the tournament */
  tournamentStartDt?: Maybe<Scalars['Date']['output']>;
  /** The year of the tournament */
  tournamentYear?: Maybe<Scalars['Int']['output']>;
  /** The timestamp when the competition season was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


/** association between tennis competition and season */
export type CompetitionSeasonMatchesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  scheduledSince?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledUntil?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Connection between competition season and matches */
export type CompetitionSeasonMatchConnection = {
  __typename?: 'CompetitionSeasonMatchConnection';
  edges: Array<Maybe<CompetitionSeasonMatchEdge>>;
  nodes: Array<Maybe<Match>>;
  pageInfo: PageInfo;
};

/** Edge for competition season and match connection */
export type CompetitionSeasonMatchEdge = {
  __typename?: 'CompetitionSeasonMatchEdge';
  cursor: Scalars['String']['output'];
  node: Match;
};

/** connection between competition and season */
export type CompetitionSeasonsConnection = {
  __typename?: 'CompetitionSeasonsConnection';
  edges: Array<Maybe<CompetitionSeasonsEdge>>;
  nodes: Array<Maybe<CompetitionSeason>>;
  pageInfo: PageInfo;
};

/** Edge for competition and season connection */
export type CompetitionSeasonsEdge = {
  __typename?: 'CompetitionSeasonsEdge';
  cursor: Scalars['String']['output'];
  node: CompetitionSeason;
};

/** type of competition */
export enum CompetitionType {
  Doubles = 'DOUBLES',
  MixedDoubles = 'MIXED_DOUBLES',
  Singles = 'SINGLES'
}

export type Complex = {
  __typename?: 'Complex';
  /** Cbs name for the complex */
  cbsOverwriteName?: Maybe<Scalars['String']['output']>;
  /** City where the complex is located */
  city?: Maybe<Scalars['String']['output']>;
  /** Country where the complex is located */
  countryName?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the game */
  id: Scalars['ID']['output'];
  /** Name for the complex */
  name: Scalars['String']['output'];
  /** State where the complex is located */
  state?: Maybe<Scalars['String']['output']>;
};

/** Represents a conference in the sports GraphQL schema. */
export type Conference = {
  __typename?: 'Conference';
  /** The abbreviation of the conference. */
  abbrev: Scalars['String']['output'];
  /** The date and time that the conference was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** The unique identifier for the conference. */
  id: Scalars['ID']['output'];
  /** The name of the conference. */
  name?: Maybe<Scalars['String']['output']>;
  /** The date and time that the conference was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/**
 * Country type definition, refer to country table
 * @cacheControl(maxAge: 2592000) sets the cache TTL to 30 days (2592000 seconds)
 */
export type Country = {
  __typename?: 'Country';
  /** ISO 3166-1 alpha-2 code for the country */
  alpha2code: Scalars['String']['output'];
  /** ISO 3166-1 alpha-3 code for the country */
  alpha3code: Scalars['String']['output'];
  /** Name of the country */
  countryName: Scalars['String']['output'];
  /** Unique identifier for the country */
  id: Scalars['ID']['output'];
  /** Top-level domain for the country */
  topLevelDomain: Scalars['String']['output'];
};

export type CreateAuthenticationSessionInput = {
  domainName: Scalars['String']['input'];
  mvpd: Scalars['String']['input'];
  redirectUrl: Scalars['String']['input'];
  serviceProvider?: InputMaybe<Scalars['String']['input']>;
};

export type CreateGraphicExportInput = {
  automated?: InputMaybe<Scalars['Boolean']['input']>;
  config: Scalars['JSON']['input'];
  createdBy?: InputMaybe<Scalars['String']['input']>;
  dataEndpoint?: InputMaybe<Scalars['String']['input']>;
  graphicId: Scalars['String']['input'];
  leagueAbbr: Scalars['String']['input'];
  name: Scalars['String']['input'];
  s3Bucket?: InputMaybe<Scalars['String']['input']>;
  s3Path?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type CreateGraphicInput = {
  apiId: Scalars['String']['input'];
  config: Scalars['JSON']['input'];
  createdBy?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  leagueAbbr?: InputMaybe<Scalars['String']['input']>;
  leagueId?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
};

export type CreateGraphicScheduleTaskInput = {
  active: Scalars['Boolean']['input'];
  createdBy?: InputMaybe<Scalars['String']['input']>;
  graphicId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  nextRun?: InputMaybe<Scalars['DateTime']['input']>;
  params: Scalars['JSON']['input'];
  schedule: Scalars['String']['input'];
};

export type CreateGraphicsUserInput = {
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  username: Scalars['String']['input'];
};

export type CreateOneTimePurchaseInput = {
  accountCode?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<Scalars['Int']['input']>;
  couponCode?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  custId: Scalars['String']['input'];
  discountAmount?: InputMaybe<Scalars['Int']['input']>;
  discountAmountCents?: InputMaybe<Scalars['Int']['input']>;
  domainId: Scalars['String']['input'];
  fTag?: InputMaybe<Scalars['String']['input']>;
  invoiceNum?: InputMaybe<Scalars['String']['input']>;
  masterProductId: Scalars['String']['input'];
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  paymentVendor?: InputMaybe<Scalars['String']['input']>;
  planCode?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  tTag?: InputMaybe<Scalars['String']['input']>;
  taxAmountCents?: InputMaybe<Scalars['Int']['input']>;
  totalPaidAmountCents?: InputMaybe<Scalars['Int']['input']>;
  transStatus?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOneTimePurchaseResponse = {
  __typename?: 'CreateOneTimePurchaseResponse';
  accountCode?: Maybe<Scalars['String']['output']>;
  amount?: Maybe<Scalars['Int']['output']>;
  couponCode?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  custId?: Maybe<Scalars['Int']['output']>;
  dateFormat?: Maybe<Scalars['String']['output']>;
  discountAmount?: Maybe<Scalars['Int']['output']>;
  domainId?: Maybe<Scalars['Int']['output']>;
  fTag?: Maybe<Scalars['String']['output']>;
  invoiceNum?: Maybe<Scalars['String']['output']>;
  masterProductId?: Maybe<Scalars['Int']['output']>;
  paymentMethod?: Maybe<Scalars['String']['output']>;
  paymentPeriodType?: Maybe<Scalars['String']['output']>;
  paymentType?: Maybe<Scalars['String']['output']>;
  paymentVendor?: Maybe<Scalars['String']['output']>;
  planCode?: Maybe<Scalars['String']['output']>;
  prodBillingType?: Maybe<Scalars['String']['output']>;
  prodPaymentId?: Maybe<Scalars['Int']['output']>;
  referral?: Maybe<Scalars['String']['output']>;
  statusId?: Maybe<Scalars['Int']['output']>;
  subId?: Maybe<Scalars['Int']['output']>;
  taxAmount?: Maybe<Scalars['Int']['output']>;
  transStatus?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type CreateOpenWebUserInput = {
  disclosure_id: Scalars['Int']['input'];
  email: Scalars['String']['input'];
  primary_key: Scalars['String']['input'];
  spot_id: Scalars['String']['input'];
  user_name: Scalars['String']['input'];
};

export type CreatePurchaseInput = {
  account: RecurlyPurchaseAccountInput;
  couponCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  currency: Scalars['Currency']['input'];
  lineItems: Array<RecurlyPurchaseLineItemInput>;
};

export type CreateRecurlySubscriptionChangeInput = {
  couponCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  planCode: Scalars['String']['input'];
  prorationSettings?: InputMaybe<RecurlySubscriptionChangeProrationSetting>;
  subscriptionId: Scalars['String']['input'];
  timeframe: RecurlySubscriptionChangeTimeframe;
};

export type CreateRecurlySubscriptionInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['CountryCode']['input']>;
  currency: Scalars['String']['input'];
  custId: Scalars['Int']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  planCode: Scalars['String']['input'];
  postalCode?: InputMaybe<Scalars['String']['input']>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
  recurlyToken: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSubscriptionInput = {
  custId?: InputMaybe<Scalars['String']['input']>;
  disclosures: Array<Scalars['Int']['input']>;
  emailAddress?: InputMaybe<Scalars['EmailAddress']['input']>;
  mCode: Array<Scalars['String']['input']>;
  masterProductId: Scalars['String']['input'];
  pid?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};

export type CreateUser = {
  __typename?: 'CreateUser';
  custId?: Maybe<Scalars['Int']['output']>;
  details?: Maybe<UserDetails>;
  metaData?: Maybe<MetaData>;
};

export type CreateUserProfileInput = {
  custId?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateUserResult = SapiResponse & {
  __typename?: 'CreateUserResult';
  code: Scalars['Int']['output'];
  data?: Maybe<CreateUser>;
  message?: Maybe<Scalars['String']['output']>;
  sapiStatusCode?: Maybe<Scalars['Int']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CreateUserSubscriptionInput = {
  accountCode?: InputMaybe<Scalars['String']['input']>;
  activatedAt: Scalars['DateTime']['input'];
  amount: Scalars['Float']['input'];
  appId: Scalars['String']['input'];
  canceledAt?: InputMaybe<Scalars['DateTime']['input']>;
  curPeriodEndAt?: InputMaybe<Scalars['DateTime']['input']>;
  curPeriodStartAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  custId: Scalars['Int']['input'];
  domainId: Scalars['Int']['input'];
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  initialReferrer?: InputMaybe<Scalars['String']['input']>;
  invoiceNumber?: InputMaybe<Scalars['String']['input']>;
  masterProductId: Scalars['Int']['input'];
  masterProductName?: InputMaybe<Scalars['String']['input']>;
  orderSource?: InputMaybe<Scalars['String']['input']>;
  partner?: InputMaybe<Scalars['String']['input']>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  paymentVendor?: InputMaybe<Scalars['String']['input']>;
  planCode: Scalars['String']['input'];
  planName: Scalars['String']['input'];
  platform: Scalars['String']['input'];
  subscriptionId: Scalars['String']['input'];
  subscriptionState?: InputMaybe<Scalars['String']['input']>;
  trialEndAt?: InputMaybe<Scalars['DateTime']['input']>;
  trialStartAt?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
  vendorSubscriptionId?: InputMaybe<Scalars['String']['input']>;
};

export type CustomFields = {
  __typename?: 'CustomFields';
  name?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type DataEngIdentifier = {
  /** Internal unique identifier */
  internalId?: InputMaybe<Scalars['ID']['input']>;
  /** Vendor's unique identifier for the entity */
  vendorEntityId?: InputMaybe<Scalars['ID']['input']>;
  /** Unique identifier of the vendor providing the data */
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * This type represents a deep link to a specific platform or service,
 * allowing users to navigate directly to the expert's profile or content.
 * The deep link may vary based on the platform or context in which it is used.
 * For example, it could point to a specific page on SportsLine or another
 * service where the expert's content is hosted.
 * The deep link is typically used in conjunction with the expert's
 */
export type DeepLink = {
  __typename?: 'DeepLink';
  /**
   * A URL that directs users to the expert's profile on SportsLine,
   *   providing access to their picks, analysis, and other relevant content.
   */
  sportsline?: Maybe<Scalars['String']['output']>;
};

export type DeleteOpenWebUserInput = {
  primary_key: Scalars['String']['input'];
  spot_id?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteOpenWebUserResponse = {
  __typename?: 'DeleteOpenWebUserResponse';
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** The Salary interface represents the salary information for a player or a team in a DFS contest. */
export type DfsSalary = {
  /** Creation timestamp of the salary entry. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** DraftKings specific draftable ID. */
  draftKingsDraftableId?: Maybe<Scalars['Int']['output']>;
  /** DraftKings specific player ID. */
  draftKingsPlayerId?: Maybe<Scalars['Int']['output']>;
  /** FanDuel specific player ID. */
  fanDuelPlayerId?: Maybe<Scalars['Int']['output']>;
  /** FanDuel specific stats ID. */
  fanDuelStatsId?: Maybe<Scalars['Int']['output']>;
  /** The game associated with this salary. */
  game: Game;
  /** Type of DFS contest. */
  gameType?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the salary entry. */
  id: Scalars['ID']['output'];
  /** Positions eligible for the salary. */
  positions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Provider of the salary information. */
  provider: Scalars['String']['output'];
  /** The salary amount. */
  salary: Scalars['Int']['output'];
  /** The date when the salary is applicable. */
  salaryDate?: Maybe<Scalars['Date']['output']>;
  /** End time of the slate. */
  slateEnd?: Maybe<Scalars['DateTime']['output']>;
  /** Unique identifier for the slate. */
  slateId: Scalars['Int']['output'];
  /** Start time of the slate. */
  slateStart?: Maybe<Scalars['DateTime']['output']>;
  /** Type of slate for the game(s). */
  slateType?: Maybe<Scalars['String']['output']>;
  /** Tier of the salary. */
  tier?: Maybe<Scalars['String']['output']>;
  /** Last update timestamp of the salary entry. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type DisclosureInput = {
  disclosureId?: InputMaybe<Scalars['Int']['input']>;
  disclosureText?: InputMaybe<Scalars['String']['input']>;
};

export type DisclosureList = {
  __typename?: 'DisclosureList';
  disclosureId: Scalars['Int']['output'];
  disclosureText?: Maybe<Scalars['String']['output']>;
  displayOrderNum: Scalars['Int']['output'];
  requiredInd: Scalars['Int']['output'];
};

/** Represents a division in the sports league. */
export type Division = {
  __typename?: 'Division';
  /** The abbreviation for the division. */
  abbrev?: Maybe<Scalars['String']['output']>;
  /** The date and time the division was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** The unique identifier for the division. */
  id: Scalars['ID']['output'];
  /** The name of the division. */
  name?: Maybe<Scalars['String']['output']>;
  /** The date and time the division was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type Domain = {
  __typename?: 'Domain';
  mvpdInitiated?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/**
 * Defines an Error interface to be used as a part of a response Union type.
 *
 * This allows for clients as needed to better detect errors as part of the schema,
 * rather than the standard GraphQL error throwing mechanism where the pertinent concise
 * error code may be embedded in the 'extensions' portion of the errors.
 */
export type Error = {
  message: Scalars['String']['output'];
};

/** event type definition, refer to event table */
export type Event = {
  __typename?: 'Event';
  abbrev?: Maybe<Scalars['String']['output']>;
  cmsPolls: CmsPollConnection;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  /**
   * The players associated with the event.
   *   *Constraints:`first` has a maximum limit of 500*
   */
  eventPlayers?: Maybe<EventPlayersConnection>;
  externalUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  number?: Maybe<Scalars['Int']['output']>;
  period?: Maybe<Scalars['Int']['output']>;
  priorWinningId?: Maybe<Scalars['String']['output']>;
  prizeMoney?: Maybe<Scalars['String']['output']>;
  scheduledEndTime?: Maybe<Scalars['DateTime']['output']>;
  scheduledTime?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  supportedInd?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The vendors that are associated with the player.
   *   *Constraints:`first` has a maximum limit of 500*
   */
  vendorPlayers?: Maybe<VendorPlayersConnection>;
  winningId?: Maybe<Scalars['String']['output']>;
};


/** event type definition, refer to event table */
export type EventCmsPollsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filters: CmsRelatedContentFiltersInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CmsPollOrderBy>>;
  userIdentifier?: InputMaybe<Scalars['String']['input']>;
};


/** event type definition, refer to event table */
export type EventEventPlayersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
};


/** event type definition, refer to event table */
export type EventVendorPlayersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  vendorId: Scalars['Int']['input'];
};

export type EventConnection = {
  __typename?: 'EventConnection';
  /** A list of edges. */
  edges: Array<EventEdge>;
  /** A list of nodes. */
  nodes: Array<Event>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total count. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type EventEdge = {
  __typename?: 'EventEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Event;
};

export type EventPlayer = {
  __typename?: 'EventPlayer';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  eventId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  player?: Maybe<Player>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** connection between event and player, refer to event_player_association table */
export type EventPlayersConnection = {
  __typename?: 'EventPlayersConnection';
  edges: Array<Maybe<EventPlayersEdge>>;
  nodes: Array<Maybe<EventPlayer>>;
  pageInfo: PageInfo;
};

/** Edge for event player connection */
export type EventPlayersEdge = {
  __typename?: 'EventPlayersEdge';
  cursor: Scalars['String']['output'];
  node: EventPlayer;
};

/**
 * Represents a record of an expert's performance in a specific league,
 * including their streaks.
 */
export type ExpertLeagueRecord = {
  __typename?: 'ExpertLeagueRecord';
  /** The expert's unique identifier, used to reference the expert */
  expertId: Scalars['String']['output'];
  /** The league associated with this expert's streaks (e.g., 'NFL', 'NBA'). */
  league: League;
  /**
   * The streaks associated with this expert's performance in the league and
   *   limiting the number of streaks returned to the specified limit.
   */
  streaks?: Maybe<Array<ExpertStreak>>;
};


/**
 * Represents a record of an expert's performance in a specific league,
 * including their streaks.
 */
export type ExpertLeagueRecordStreaksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Represents a single expert pick, including its status, expert information,
 * and any associated game or selection details.
 */
export type ExpertPick = {
  __typename?: 'ExpertPick';
  /** The date and time the pick was created, in ISO 8601 format. */
  createdAt: Scalars['DateTime']['output'];
  /**
   * Basic expert information, such as name, bio, and social handles.
   *   Useful for displaying the pick's source.
   */
  expert?: Maybe<SportslineExpert>;
  /**
   * The identifier for the expert who made this pick. Used to join
   *   or look up additional information about the expert.
   */
  expertId: Scalars['ID']['output'];
  /**
   * A list of the expert's current or relevant streaks related to this league,
   *   homeTeamId, or awayTeamId. Useful for showing how 'hot' or consistent
   *   the expert has been in similar picks.
   */
  expertStreaks?: Maybe<Array<ExpertStreak>>;
  /**
   * Information about the specific game associated with this pick,
   *   as provided by Primpy or another data source.
   */
  game?: Maybe<Game>;
  /**
   * Unique identifier of the pick, used to correlate data across systems
   *   or track the pick within the API.
   */
  id: Scalars['ID']['output'];
  /**
   * Boolean indicator used to pin expert picks at the top of lists on
   *   the SportsLine website. After the pick is graded (result is finalized),
   *   this value is typically set to false.
   */
  isFeatured: Scalars['Boolean']['output'];
  /**
   * Returns true if the user making the query is a SportsLine subscriber;
   *   false otherwise.
   */
  isSubscriber?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The league (e.g., NFL, MLB) related to the pick's game,
   *   as provided by Primpy or another data source.
   */
  league?: Maybe<League>;
  /**
   * Indicates whether the pick is locked for the user. Typically:
   *   • 'true' if the user is not a subscriber and the pick is still PENDING
   *   • 'false' otherwise
   */
  locked: Scalars['Boolean']['output'];
  /**
   * The result status of the pick:
   *   - 'PENDING' if the game is not finished or the pick hasn't been settled.
   *   - 'WIN', 'LOSS', or 'PUSH' once the grading process completes.
   *   - 'UNKNOWN' or 'ERROR' might be used internally if there's an
   *   unexpected issue in grading (not shown in this schema).
   */
  resultStatus?: Maybe<Scalars['String']['output']>;
  /**
   * The selection detail made by the expert, which can be one of the following types:
   *   - ExpertPickSelectionStandard
   *   - ExpertPickSelectionPlayerProps
   *   - ExpertPickSelectionTeamProps
   *   - ExpertPickSelectionGameProps
   */
  selection: ExpertPickSelection;
  /**
   * The identifier of the sportsbook where the pick was made. May reflect
   *   either an older ID (e.g., 'sr:book:32219') or a newer ID (e.g., '33').
   */
  sportsbookId?: Maybe<Scalars['ID']['output']>;
  /**
   * The name of the sportsbook where the pick was made (e.g., 'Caesars',
   *   'FanDuel'). Useful for displaying or comparing lines from different books.
   */
  sportsbookName?: Maybe<Scalars['String']['output']>;
  /**
   * A float number used to calculate or denote the 'stake' for the pick,
   *   influencing profit/loss calculations. Common values include:
   *   0.5, 1.0, 1.5, 1.75, and 2. Defaults to 1.0.
   */
  unit: Scalars['Float']['output'];
  /** The last time any information about the pick was updated, in ISO 8601 format. */
  updatedAt: Scalars['DateTime']['output'];
  /**
   * Provides written analysis or explanation for the pick. If the pick is
   *   pending and the user is not a subscriber, this returns the upsell message
   *   (writeupUpsell) or is hidden entirely.
   */
  writeup?: Maybe<Scalars['String']['output']>;
};

/**
 * Input parameters used to filter expert picks (e.g., by game IDs, leagues,
 * or market types).
 */
export type ExpertPickFilterInput = {
  /**
   * Filter picks by CBS Expert ID if your system uses a separate ID for CBS-provided
   *   experts.
   */
  cbsExpertId?: InputMaybe<Array<Scalars['Int']['input']>>;
  /**
   * Filter picks by expert ID (often corresponds to an internal or universal
   *   user/expert identifier).
   */
  expertId?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Filter picks by one or more game abbreviations (e.g., team aliases or
   *   short codes used for the matchup).
   */
  gameAbbreviations?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter picks by specific game IDs. */
  gameIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filter by specific pick IDs (useful for retrieving a known subset of picks). */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter picks to only include certain leagues (e.g., 'NFL', 'NBA'). */
  leagues?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter picks by market type (e.g., MONEY_LINE, POINT_SPREAD, OVER_UNDER, PROP). */
  marketType?: InputMaybe<Array<ExpertPickMarketType>>;
  /** Filter picks by their result status (PENDING, WIN, LOSS, PUSH). */
  resultStatus?: InputMaybe<Array<ExpertPickResultStatus>>;
  /** Filter picks by their state (UPCOMING or PAST). */
  state?: InputMaybe<ExpertPickState>;
};

/**
 * The market category for an Expert Pick.
 * Used to classify the nature of the bet.
 */
export enum ExpertPickMarketType {
  /**
   * A bet on which team or participant wins the match or event outright,
   *   without point spreads or other adjustments.
   */
  MoneyLine = 'MONEY_LINE',
  /**
   * A bet on whether the combined score (points, runs, or goals) in a game
   *   will exceed (Over) or remain under (Under) a predetermined total.
   */
  OverUnder = 'OVER_UNDER',
  /**
   * A bet on the margin of victory. The favored team must win by more
   *   than the set "spread" for the bet to pay out; the underdog can win
   *   outright or lose by fewer points than the spread.
   */
  PointSpread = 'POINT_SPREAD',
  /**
   * A proposition bet, often focusing on a specific statistical outcome
   *   or in-game event (e.g., a player's number of touchdowns, or total rebounds).
   */
  Prop = 'PROP'
}

/**
 * The pick's status relative to the grading (settlement) process.
 *
 * - Before the grading process: PENDING
 * - After the grading process: WIN, LOSS, or PUSH
 * - If an unexpected error occurs, the pick could end up in an ERROR state (not shown in this schema).
 */
export enum ExpertPickResultStatus {
  /** The pick was unsuccessful and resulted in a loss. */
  Loss = 'LOSS',
  /** The related event is not finished or hasn't been settled. */
  Pending = 'PENDING',
  /**
   * The outcome is neither a win nor a loss, commonly due to a tie
   *   or event being voided (e.g., 'no action' scenario).
   */
  Push = 'PUSH',
  /** The pick was successful and resulted in a win. */
  Win = 'WIN'
}

/**
 * Shared fields for all Expert Pick selections, providing baseline context
 * such as odds, side, and descriptive labels.
 */
export type ExpertPickSelection = {
  /**
   * A unique identifier for the betting market, provided by the external
   *   data source (e.g., CBS). Used for cross-referencing this particular
   *   market or bet in external APIs and data integrations.
   */
  cbsMarketId?: Maybe<Scalars['Int']['output']>;
  /**
   * A unique identifier for the pick selection, used to create a GraphQL fragment
   *   and reference the selection in the Apollo cache. This ensures that updates
   *   are properly tracked and displayed in the user interface.
   */
  id: Scalars['ID']['output'];
  /**
   * A descriptive summary of the expert's selection. For example: "Baltimore -124".
   *
   *   - For non-subscribers (if the pick is still pending), this may display a
   *   promotional or upsell message (e.g., "Pick available to subscribers only")
   *   instead of the actual pick details.
   *   - Once the pick is no longer pending (e.g., the game has started or completed),
   *   the full description is revealed to everyone.
   */
  label: Scalars['String']['output'];
  /** The market of the expert pick, which provides context about the type of bet. */
  market?: Maybe<BettingMarket>;
  /**
   * The type of market this bet falls under. Examples:
   *   - MONEY_LINE, OVER_UNDER, POINT_SPREAD (for typical standard picks)
   *   - PROP (for player, team, or game prop bets)
   *
   *   This helps users quickly identify the bet's nature.
   */
  marketType?: Maybe<Scalars['String']['output']>;
  /**
   * A user-friendly label describing the market type. For example:
   *   - 'Money Line' for MONEY_LINE
   *   - 'Over/Under' for OVER_UNDER
   *   - 'Point Spread' for POINT_SPREAD
   *   - 'Prop' for PROP
   *
   *   If the pick is pending and the user is not subscribed, this may be null.
   *   Otherwise, it displays a descriptive value drawn from the dataset.
   */
  marketTypeLabel?: Maybe<Scalars['String']['output']>;
  /**
   * The odds (or payout indicator) assigned to this pick. These values may be in
   *   American (e.g., -110), decimal (e.g., 1.91), or fractional (e.g., 10/11) format,
   *   depending on your system. The odds reflect the potential return if the pick wins.
   */
  odds?: Maybe<Scalars['Float']['output']>;
  /**
   * The side or outcome you are choosing. Typical values may include:
   *   - 'OVER': betting on a result exceeding a certain threshold
   *   - 'UNDER': betting on a result falling below a certain threshold
   *   - 'YES'/'NO': for prop bets on whether something specific will happen
   *   - 'UNKNOWN': a placeholder when the side isn't yet determined
   */
  side?: Maybe<Scalars['String']['output']>;
  /**
   * A secondary label or subheading providing additional context. Examples:
   *   - For subscribers: the market name or category.
   *   - For non-subscribers: a generic placeholder (e.g., "{Author Name}'s Picks").
   *
   *   This is useful for distinguishing multiple picks in the UI and highlighting
   *   the source or type of the pick.
   */
  subLabel: Scalars['String']['output'];
  /**
   * Represents the 'unit' or confidence level the expert is placing on this pick.
   *   Common values might be 0.5, 1.0, 1.5, etc., where a higher number indicates
   *   greater confidence and a larger suggested stake.
   */
  unit?: Maybe<Scalars['Float']['output']>;
};

/**
 * Specific selection type for a Game Prop pick, focusing on an event or
 * statistic at the entire game level (e.g., Over/Under for combined points).
 */
export type ExpertPickSelectionGameProps = ExpertPickSelection & {
  __typename?: 'ExpertPickSelectionGameProps';
  /**
   * A unique identifier provided by an external source (e.g., CBS) for this
   *   specific game prop market. Useful for syncing or cross-referencing
   *   data across multiple systems.
   */
  cbsMarketId?: Maybe<Scalars['Int']['output']>;
  /**
   * A unique identifier for this game prop selection, used to create
   *   a GraphQL fragment and manage references within the Apollo cache.
   *   This ensures that any updates to the selection are accurately tracked.
   */
  id: Scalars['ID']['output'];
  /**
   * A concise description of the pick. For example: 'Over 210.5'.
   *   The formatOdds argument (Boolean) can be used to include or format
   *   the odds within this label if the UI supports it. This label may differ
   *   for non-subscribers if the pick is still pending, often showing a
   *   generic or upsell message.
   *   The argumen variant specifies the label variant (SHORT, MEDIUM, LONG).
   */
  label: Scalars['String']['output'];
  /** The market of the expert pick, which provides context about the type of bet. */
  market?: Maybe<BettingMarket>;
  /**
   * Identifies the type of market for this selection. Typically 'PROP'
   *   indicates it's a prop bet at the game level. Logging is recommended if
   *   this value is missing, to aid in debugging and data integrity checks.
   */
  marketType?: Maybe<Scalars['String']['output']>;
  /**
   * A human-readable label indicating the market type.
   *   For instance, 'Game Prop'. Displayed in the UI to help users recognize
   *   the selection type quickly. Logging is recommended if missing.
   */
  marketTypeLabel?: Maybe<Scalars['String']['output']>;
  /**
   * The odds associated with the selection, which represent the potential payout
   *   if the bet is successful. These may be displayed in different formats (e.g.,
   *   American, decimal, fractional) depending on your system configuration.
   */
  odds?: Maybe<Scalars['Float']['output']>;
  /**
   * Indicates which outcome or side the bet is placed on:
   *   • OVER/UNDER for total-based bets
   *   • AWAY/HOME for bets tied to a specific team's performance
   *   • In 3-way markets (like soccer), it could be AWAY, HOME, or DRAW
   */
  side?: Maybe<Scalars['String']['output']>;
  /**
   * A secondary descriptive label providing additional context about the pick.
   *   For subscribed users, this might show the specific Market Name or Type
   *   (e.g., 'Game Total Points'). For non-subscribers, if the pick is pending,
   *   it could display something like '{Author Name}'s Pick' (e.g., 'Brad's Pick').
   */
  subLabel: Scalars['String']['output'];
  /**
   * Holds the team object for markets that involve a specific team,
   *   such as Money Line or Spread bets. For totals or markets not tied
   *   to one team (like Over/Under for the entire game), this field will be null.
   */
  team?: Maybe<Team>;
  /**
   * Reflects the 'unit size' or confidence level the expert assigns
   *   to the pick. Common examples: 0.5, 1.0, 1.5, 1.75, or 2.
   *   Larger units typically indicate a higher level of confidence
   *   or a recommended larger stake.
   */
  unit?: Maybe<Scalars['Float']['output']>;
  /**
   * Represents the numerical threshold (the 'line') set by oddsmakers.
   *   Examples include:
   *   • Over/Under (Totals): The 'line' is the total number of points/goals
   *   set for the game. Bettors choose OVER or UNDER this number.
   *   • Spread: The 'line' is the point margin one team must cover.
   *   If the 'line' is 3.5, the favored team must win by more than 3.5 points
   *   to cover; the underdog must lose by fewer than 4 points (or win outright)
   *   to cover.
   *   For Money Line wagers, where betting is purely on which team wins,
   *   no line value is needed and this could be null.
   */
  value?: Maybe<Scalars['Float']['output']>;
};


/**
 * Specific selection type for a Game Prop pick, focusing on an event or
 * statistic at the entire game level (e.g., Over/Under for combined points).
 */
export type ExpertPickSelectionGamePropsLabelArgs = {
  formatOdds?: InputMaybe<Scalars['Boolean']['input']>;
  variant?: InputMaybe<ExpertPickSelectionLabelVariant>;
};

/**
 * Enum representing the different label variants for an expert pick selection.
 *
 * - SHORT: Represents a short label variant.
 * - MEDIUM: Represents a medium label variant.
 * - LONG: Represents a long label variant.
 */
export enum ExpertPickSelectionLabelVariant {
  /**
   * Represents a long label variant.
   *   Standard Markets Examples:
   *   - MoneyLine: 'Arkansas +1.5'
   *   - Spread: 'Arkansas -16.5 (-110)'
   *   - Total: 'Over 48.5 (-110)'
   *   Prop Markets Examples:
   *   - Game:
   *   - MoneyLine: 'Rec Yds Arkansas +1.5'
   *   - Spread: 'Rec Yds Arkansas -16.5 (-110)'
   *   - Total: 'Rec Yds Under 48.5 (-110)'
   *   - Player:
   *   - Player Name Under Total Receiving Yards (-110)
   *   - Team:
   *   - Team Name Over 50.5 Rec Yds (-110)
   *   - Rec Yds Team Name (-110)
   */
  Long = 'LONG',
  /**
   * Represents a medium label variant.
   *   Standard Markets Examples:
   *   - MoneyLine: 'Arkansas'
   *   - Spread: 'Arkansas -16.5'
   *   - Total: 'OVER 48.5'
   *   Prop Markets Examples:
   *   - Game:
   *   - MoneyLine: 'Arkansas'
   *   - Spread: 'Arkansas -16.5'
   *   - Total: 'UNDER 48.5'
   *   - Player:
   *   - UNDER 63.5
   *   - Team:
   *   - OVER 63.5
   */
  Medium = 'MEDIUM',
  /**
   * Represents a short label variant.
   *   Standard Markets Examples:
   *   - MoneyLine: 'BAL'
   *   - Spread: 'BAL -7'
   *   - Total: 'OVER 48.5'
   *   Prop Markets Examples:
   *   - Game:
   *   - MoneyLine: 'BAL'
   *   - Spread: 'BAL -7'
   *   - Total: 'UNDER 48.5'
   *   - Player:
   *   - UNDER 63.5
   *   - Team:
   *   - OVER 63.5
   */
  Short = 'SHORT'
}

/**
 * Specific selection type for a Player Prop pick, where the bet focuses
 * on an individual player's performance or stats.
 */
export type ExpertPickSelectionPlayerProps = ExpertPickSelection & {
  __typename?: 'ExpertPickSelectionPlayerProps';
  /**
   * A unique identifier for the betting market, provided by the external
   *   data source (e.g., CBS). Used for cross-referencing this particular
   *   market or bet in external APIs and data integrations.
   */
  cbsMarketId?: Maybe<Scalars['Int']['output']>;
  /**
   * A unique identifier for the selection, used to create a GraphQL fragment
   *   and reference the selection within the Apollo cache. Ensures any updates
   *   or references to the selection can be accurately tracked.
   */
  id: Scalars['ID']['output'];
  /**
   * A descriptive label of the pick for subscribed users. This can summarize
   *   key information (e.g., the bet type, relevant stats, or matchup details).
   *   The arguments:
   *   - abbreviated: if true, outputs a shortened label (useful in tight UI spaces).
   *   - formatOdds: if true, includes or formats the betting odds in the label.
   *   - variant: specifies the label variant (SHORT, MEDIUM, LONG).
   */
  label: Scalars['String']['output'];
  /** The market of the expert pick, which provides context about the type of bet. */
  market?: Maybe<BettingMarket>;
  /**
   * Indicates the category of the bet (e.g., 'PROP', 'SPREAD', 'MONEY_LINE').
   *   This is crucial for differentiating various types of wagers in sports betting.
   */
  marketType?: Maybe<Scalars['String']['output']>;
  /**
   * A user-facing label derived from the marketType. This is typically
   *   displayed in the UI to help users easily recognize the type of bet,
   *   such as 'Prop Bet' or 'Player Prop'.
   */
  marketTypeLabel?: Maybe<Scalars['String']['output']>;
  /**
   * The odds assigned to this selection, typically reflecting the payout
   *   potential if the pick is correct. Can be in decimal (e.g., 1.90),
   *   fractional (e.g., 9/10), or American format (e.g., -110).
   */
  odds?: Maybe<Scalars['Float']['output']>;
  /**
   * Information about the player associated with this selection, including
   *   attributes such as the player's name, position, and stats. Commonly
   *   used in player-specific prop bets.
   */
  player?: Maybe<Player>;
  /**
   * Information about the team the selected player belongs to. Useful for
   *   displaying matchup details or team-specific stats that might influence
   *   the pick (e.g., offensive style, injuries, team trends).
   */
  playerTeam?: Maybe<Team>;
  /**
   * The side or outcome you are betting on. For example:
   *   - OVER: picking a result above a certain threshold
   *   - UNDER: picking a result below a certain threshold
   *   - YES/NO: indicating whether something will or will not happen
   *   - UNKNOWN: a placeholder if the side isn't set yet
   */
  side?: Maybe<Scalars['String']['output']>;
  /**
   * An additional label or subheading for the pick. For subscribed users, this
   *   might include the Market Name. For non-subscribers, it could default to
   *   something like '{Author Name}'s Picks' to give context about who made the pick.
   */
  subLabel: Scalars['String']['output'];
  /**
   * Reflects the level of confidence or 'stake' an expert places on this pick.
   *   Common values might include 0.5, 1.0, 1.5, 1.75, or 2.0 units. Higher values
   *   indicate a stronger recommendation or larger suggested wager.
   */
  unit?: Maybe<Scalars['Float']['output']>;
  /**
   * Represents the reference number or threshold applicable to certain prop bets
   *   (e.g., Over 3.5 Goals or Under 4.5 Rebounds). Not all picks require a value,
   *   so this may be null or omitted for picks where no threshold applies.
   */
  value?: Maybe<Scalars['Float']['output']>;
};


/**
 * Specific selection type for a Player Prop pick, where the bet focuses
 * on an individual player's performance or stats.
 */
export type ExpertPickSelectionPlayerPropsLabelArgs = {
  abbreviated?: InputMaybe<Scalars['Boolean']['input']>;
  formatOdds?: InputMaybe<Scalars['Boolean']['input']>;
  variant?: InputMaybe<ExpertPickSelectionLabelVariant>;
};

/**
 * A standard selection type for typical markets such as Money Line, Point Spread,
 * or Over/Under—often referred to as "standard" bets in sports wagering.
 */
export type ExpertPickSelectionStandard = ExpertPickSelection & {
  __typename?: 'ExpertPickSelectionStandard';
  /**
   * A unique identifier for the betting market, provided by the external
   *   data source (e.g., CBS). Used for cross-referencing this particular
   *   market or bet in external APIs and data integrations.
   */
  cbsMarketId?: Maybe<Scalars['Int']['output']>;
  /**
   * A unique identifier for this standard pick selection, used to create
   *   a GraphQL fragment and reference it within the Apollo cache. This
   *   ensures that changes to the selection are properly tracked and
   *   displayed.
   */
  id: Scalars['ID']['output'];
  /**
   * A descriptive label of the selection. Examples:
   *   • For MONEY_LINE: 'Baltimore -124'
   *   • For POINT_SPREAD: 'Baltimore -7'
   *
   *   - If the user is subscribed and the pick is still pending, they see
   *   the full description (e.g., 'Baltimore -124').
   *   - If the user is non-subscribed and the pick is pending:
   *   -- The label will show a pickUpsell value if provided,
   *   -- Otherwise, it defaults to 'Subscribers Only'.
   *
   *   The argument 'formatOdds' can be used to include or format the odds
   *   in the label if your UI allows it.
   *   The argumen variant specifies the label variant (SHORT, MEDIUM, LONG).
   */
  label: Scalars['String']['output'];
  /** The market of the expert pick, which provides context about the type of bet. */
  market?: Maybe<BettingMarket>;
  /**
   * Identifies the type of market for this standard pick. Typically,
   *   one of the following:
   *   • MONEY_LINE
   *   • OVER_UNDER
   *   • POINT_SPREAD
   *   Logging is recommended if this value is missing for diagnosis and
   *   data consistency purposes.
   */
  marketType?: Maybe<Scalars['String']['output']>;
  /**
   * A user-friendly label derived from marketType, often displayed in the UI.
   *   For example:
   *   • 'Money Line'
   *   • 'Over/Under'
   *   • 'Point Spread'
   *   Logging is recommended if this value is missing for diagnosis and
   *   data consistency purposes.
   */
  marketTypeLabel?: Maybe<Scalars['String']['output']>;
  /**
   * Reflects the odds (potential payout) for this selection. The format
   *   (e.g., American, decimal, fractional) may vary depending on your
   *   system's settings.
   */
  odds?: Maybe<Scalars['Float']['output']>;
  /**
   * Indicates which side of the selection is being chosen. Examples:
   *   • HOME or AWAY for a game outcome
   *   • OVER or UNDER for a totals/points-based bet
   *   This field's meaning can vary based on the marketType.
   */
  side?: Maybe<Scalars['String']['output']>;
  /**
   * A secondary label or subheading for the selection. Typically:
   *   • For subscribed users: the specific Market Type (e.g., 'Money Line').
   *   • For non-subscribers (if the pick is pending): the author's name
   *   or a default placeholder, such as 'Brad's Pick'.
   */
  subLabel: Scalars['String']['output'];
  /**
   * Information about the team associated with this pick, if applicable.
   *   For markets that don't involve a specific team (e.g., certain
   *   Over/Under bets), this field may be null. Otherwise, it can
   *   represent the HOME or AWAY team for a given matchup.
   */
  team?: Maybe<Team>;
  /**
   * Signifies the unit size or confidence level assigned by the expert.
   *   Common values are 0.5, 1.0, 1.5, 1.75, or 2. A higher number indicates
   *   more confidence or a larger recommended stake.
   */
  unit?: Maybe<Scalars['Float']['output']>;
  /**
   * Represents the numerical threshold or line associated with the bet,
   *   if relevant. For example:
   *   • POINT_SPREAD might have a value (e.g., 7.5),
   *   • OVER_UNDER might have a value (e.g., 48.5).
   *
   *   MONEY_LINE bets typically won't have a 'value' because the bet is on
   *   a team to win outright rather than a points-based threshold.
   */
  value?: Maybe<Scalars['Float']['output']>;
};


/**
 * A standard selection type for typical markets such as Money Line, Point Spread,
 * or Over/Under—often referred to as "standard" bets in sports wagering.
 */
export type ExpertPickSelectionStandardLabelArgs = {
  formatOdds?: InputMaybe<Scalars['Boolean']['input']>;
  variant?: InputMaybe<ExpertPickSelectionLabelVariant>;
};

/**
 * Specific selection type for a Team Prop pick, where the bet focuses on
 * a particular team's performance (e.g., team total points).
 */
export type ExpertPickSelectionTeamProps = ExpertPickSelection & {
  __typename?: 'ExpertPickSelectionTeamProps';
  /**
   * A unique identifier provided by an external data source (e.g., CBS) to reference
   *   this specific market. Useful for cross-checking or syncing data between systems.
   */
  cbsMarketId?: Maybe<Scalars['Int']['output']>;
  /**
   * A unique identifier for this team prop selection, used to create
   *   a GraphQL fragment and manage references within the Apollo cache.
   *   Ensures any updates or references to the selection are accurately tracked.
   */
  id: Scalars['ID']['output'];
  /**
   * A short descriptive label summarizing the pick. For example: 'Lakers Over 105.5'.
   *   The argument formatOdds (Boolean) can be used to include or format the odds within
   *   the label if desired. This label might vary for subscribers vs. non-subscribers if
   *   the pick is still pending.
   *   The argument variant (ExpertPickSelectionLabelVariant) specifies the label variant.
   */
  label: Scalars['String']['output'];
  /** The market of the expert pick, which provides context about the type of bet. */
  market?: Maybe<BettingMarket>;
  /**
   * Specifies the bet's market category. In this case, it typically indicates a
   *   'PROP' market. Logging is recommended if this value is missing for debugging
   *   and data quality purposes.
   */
  marketType?: Maybe<Scalars['String']['output']>;
  /**
   * A human-readable label corresponding to the marketType. This is commonly
   *   displayed in the UI to help users quickly identify that this pick is a prop bet.
   *   For example, 'Team Prop'. Logging is recommended if this value is missing.
   */
  marketTypeLabel?: Maybe<Scalars['String']['output']>;
  /**
   * The odds associated with this team prop selection. Could be displayed in various
   *   formats (American, decimal, fractional), depending on the application's settings.
   *   Indicates the potential payout if the pick is correct.
   */
  odds?: Maybe<Scalars['Float']['output']>;
  /**
   * The side of the selection, typically 'OVER' or 'UNDER' for team props.
   *   This indicates whether the expert is predicting a result above or below the
   *   specified threshold (value).
   */
  side?: Maybe<Scalars['String']['output']>;
  /**
   * A secondary label or heading providing additional context about the pick.
   *   For subscribers, this could display specific market details (e.g., 'Team
   *   Total Points'). For non-subscribers (if the pick is pending), it might
   *   display a generic message or the author's name (e.g., 'Brad's Pick').
   */
  subLabel: Scalars['String']['output'];
  /**
   * The team associated with this prop bet. This typically includes information such
   *   as team name, location, or league details and is essential for displaying which
   *   team the pick is related to.
   */
  team?: Maybe<Team>;
  /**
   * Indicates the 'unit' or staking level the expert suggests for this pick.
   *   Common values include 0.5, 1.0, 1.5, 1.75, and 2. A higher unit implies
   *   greater confidence or a recommended higher stake.
   */
  unit?: Maybe<Scalars['Float']['output']>;
  /**
   * Represents the reference threshold or numeric value applicable to this prop.
   *   For example, 29.5 (Team Over/Under Points), 105.5 (Team Over/Under Points),
   *   etc. Not all props require a value, but for many team props, this is a key metric.
   */
  value?: Maybe<Scalars['Float']['output']>;
};


/**
 * Specific selection type for a Team Prop pick, where the bet focuses on
 * a particular team's performance (e.g., team total points).
 */
export type ExpertPickSelectionTeamPropsLabelArgs = {
  formatOdds?: InputMaybe<Scalars['Boolean']['input']>;
  variant?: InputMaybe<ExpertPickSelectionLabelVariant>;
};

/**
 * Defines which fields can be used to sort the returned picks and in what order
 * (ascending or descending).
 */
export enum ExpertPickSortByField {
  /** Sort by the date the pick was created, often to show the newest or oldest picks first. */
  Created = 'CREATED',
  /** Sort by the 'featured' status first, so featured picks appear at the top. */
  Featured = 'FEATURED',
  /**
   * Sort by the scheduled start date/time of the game, allowing picks to be
   *   viewed chronologically around the game schedule.
   */
  GameScheduledDateTime = 'GAME_SCHEDULED_DATE_TIME'
}

/**
 * Specifies the sorting criteria for expert picks, including which field to
 * sort by and whether the sorting is ascending or descending.
 */
export type ExpertPickSortByInput = {
  /** The field by which to sort (e.g., FEATURED, CREATED, GAME_SCHEDULED_DATE_TIME). */
  field: ExpertPickSortByField;
  /** Determines whether to sort results in ascending (ASC) or descending (DESC) order. */
  order: SortOrder;
};

/**
 * Represents whether a pick is upcoming (still pending) or in the past (already decided).
 * - UPCOMING for picks with PENDING result status
 * - PAST for picks with WIN, LOSS, or PUSH
 */
export enum ExpertPickState {
  /** Indicates the pick has been graded, typically resulting in a WIN, LOSS, or PUSH. */
  Past = 'PAST',
  /**
   * Indicates the pick is still open and the related event is
   *   either yet to start or in progress, so the result hasn't been settled.
   */
  Upcoming = 'UPCOMING'
}

/**
 * Defines a connection object for a paginated list of Expert Picks, including
 * metadata like totalCount and pageInfo, as well as the list of edges.
 */
export type ExpertPicksConnection = {
  __typename?: 'ExpertPicksConnection';
  /** The list of edges, each containing a single ExpertPick and a pagination cursor. */
  edges?: Maybe<Array<ExpertPicksEdge>>;
  /** An object containing pagination metadata, such as whether more pages are available. */
  pageInfo: PageInfo;
  /** The total number of picks matching the filters (before pagination). */
  totalCount: Scalars['Int']['output'];
};

/**
 * Represents a single edge in a paginated list of expert picks, containing
 * a cursor for pagination and the pick itself.
 */
export type ExpertPicksEdge = {
  __typename?: 'ExpertPicksEdge';
  /** A cursor used for pagination in a Relay-style GraphQL connection. */
  cursor: Scalars['String']['output'];
  /** The actual ExpertPick node (record) for this position in the list. */
  node: ExpertPick;
};

/**
 * Represents a historical or ongoing streak of picks from an expert,
 * including details about wins, losses, pushes, profit, and related
 * league/team information.
 */
export type ExpertStreak = {
  __typename?: 'ExpertStreak';
  /**
   * Indicates if the streak is classified as 'hot' for a given league or
   *   time period, often used to display a special badge or highlight in the UI.
   */
  hot?: Maybe<Scalars['Boolean']['output']>;
  /**
   * A unique identifier for the streak. Used to manage references within
   *   the system or Apollo cache.
   */
  id: Scalars['ID']['output'];
  /**
   * Flags whether this streak is considered the 'best' or top-tier among
   *   multiple streaks in a league. Can be used to apply special styling or
   *   rankings in the UI.
   */
  isBest?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Label describing the streak.
   *   On the sportsline.com website, the label is built using the records, the amount of picks, the league or the team and the type of picks.
   *   e.g. 55-43-2 in Last 100 MLB Picks, 85-65 in Last 150 NBA O/U Picks, 12-5 in Last 17 IND O/U Picks
   *   The mobile apps use a short version of the label with the amount of picks, the league and an abbreviation of the market type.
   *   e.g. Last 100 MLB, Last 100 MLB ML, Last 101 NFL Props, Last 45 NBA ATS
   */
  label?: Maybe<Scalars['String']['output']>;
  /**
   * The league associated with this streak, such as NFL, NBA, or MLB.
   *   Helps contextualize the picks (e.g., "Last 100 MLB Picks").
   */
  league?: Maybe<League>;
  /** The total count of picks classified as a LOSS within this streak. */
  lost?: Maybe<Scalars['Int']['output']>;
  /**
   * Indicates the category or market of the streak (e.g., Money Line,
   *   Over/Under, Point Spread, Props). Useful for segmenting
   *   performance across different bet types.
   */
  marketType?: Maybe<ExpertStreakMarketType>;
  /**
   * The net profit or loss accumulated over the course of the streak,
   *   expressed as a numerical value. Positive values (e.g., 610) indicate
   *   net winnings; negative values (e.g., -200) indicate net losses.
   */
  profit?: Maybe<Scalars['Float']['output']>;
  /**
   * The total count of picks classified as a PUSH (i.e., a tie or
   *   no-action scenario) within this streak.
   */
  pushed?: Maybe<Scalars['Int']['output']>;
  /**
   * The rank of the streak if displayed among other top streaks
   *   (e.g., 1 for the best, 2 for the second-best).
   */
  rank?: Maybe<Scalars['Int']['output']>;
  /**
   * The team associated with this streak, if applicable. For example,
   *   if the streak focuses on a particular team's games or picks
   *   (e.g., "Last 17 IND O/U Picks"), this field provides
   *   the team context.
   */
  team?: Maybe<Team>;
  /**
   * The percentage of picks won in this streak, calculated as
   *   (won / total picks) * 100. Useful for quickly assessing
   *   the expert's overall performance.
   */
  winPercentage?: Maybe<Scalars['Float']['output']>;
  /** The total count of picks classified as a WIN within this streak. */
  won?: Maybe<Scalars['Int']['output']>;
};


/**
 * Represents a historical or ongoing streak of picks from an expert,
 * including details about wins, losses, pushes, profit, and related
 * league/team information.
 */
export type ExpertStreakLabelArgs = {
  short?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Represents the market type or category of the expert streak
 * (e.g., Money Line, Point Spread, Over/Under).
 */
export type ExpertStreakMarketType = {
  __typename?: 'ExpertStreakMarketType';
  /**
   * An abbreviated label for the market type, commonly used where
   *   space is limited. Examples: OVR, ATS, ML, O/U, SD, PROP.
   */
  abbr?: Maybe<Scalars['String']['output']>;
  /**
   * A human-readable label describing the market type. Examples:
   *   • "Money Line"
   *   • "Point Spread"
   *   • "Over/Under"
   *   • "Sides"
   *   • "Picks"
   *   Corresponds to the naming conventions used in SportsLine Web.
   */
  label?: Maybe<Scalars['String']['output']>;
  /**
   * A string representing the streak's market type as defined by
   *   an internal enum. Useful for internal logic or filtering
   *   across multiple services or subgraphs.
   */
  type?: Maybe<Scalars['String']['output']>;
};

export type FavoriteTeams = {
  __typename?: 'FavoriteTeams';
  mlb?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  nba?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ncaab?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ncaaf?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  nfl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  nhl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type FavoriteTeamsInput = {
  mlb?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nba?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ncaab?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ncaaf?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nfl?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nhl?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** Represents the defensive stats for a football player. */
export type FootballDefensiveStats = {
  __typename?: 'FootballDefensiveStats';
  /** The total number of assists made by the player. */
  assists?: Maybe<Scalars['Int']['output']>;
  /** The total number of touchdowns from blocked punts. */
  blockedPuntsTouchdowns?: Maybe<Scalars['Int']['output']>;
  /** The total number of touchdowns from blocked field goals. */
  blockedfieldGoalsTouchdowns?: Maybe<Scalars['Int']['output']>;
  /** The total number of forced fumbles by the player. */
  forcedFumbles?: Maybe<Scalars['Int']['output']>;
  /** The total number of touchdowns from fumble returns. */
  fumbleReturnTouchdowns?: Maybe<Scalars['Int']['output']>;
  /** The total number of yards gained from fumble returns. */
  fumbleReturnYards?: Maybe<Scalars['Int']['output']>;
  /** The total number of fumble recoveries by the player. */
  fumblesRecovered?: Maybe<Scalars['Int']['output']>;
  /** The total number of touchdowns from interception returns. */
  interceptionTouchdowns?: Maybe<Scalars['Int']['output']>;
  /** The total number of yards gained from interception returns. */
  interceptionYards?: Maybe<Scalars['Int']['output']>;
  /** The total number of interceptions made by the player. */
  interceptions?: Maybe<Scalars['Int']['output']>;
  /** The total number of one-point safeties made by the player. */
  onepointSafeties?: Maybe<Scalars['Int']['output']>;
  /** The total number of passes defended by the player. */
  passesDefended?: Maybe<Scalars['Int']['output']>;
  /** The total number of sacks made by the player. */
  sacks?: Maybe<Scalars['Float']['output']>;
  /** The total number of yards lost due to sacks made by the player. */
  sacksYards?: Maybe<Scalars['Float']['output']>;
  /** The total number of safeties made by the player. */
  safeties?: Maybe<Scalars['Int']['output']>;
  /** The total number of tackles made by the player. */
  tackles?: Maybe<Scalars['Int']['output']>;
  /** The total number of tackles for loss made by the player. */
  tacklesForLoss?: Maybe<Scalars['Int']['output']>;
  /** The total number of two-point conversion attempts by the player. */
  twopointConversionAttempts?: Maybe<Scalars['Int']['output']>;
  /** The total number of two-point conversions made by the player. */
  twopointConversionsMade?: Maybe<Scalars['Int']['output']>;
};

/** Represents the fantasy stats for a football player. */
export type FootballFantasyStats = {
  __typename?: 'FootballFantasyStats';
  /** The total number of fantasy points scored by the player. */
  points?: Maybe<Scalars['Int']['output']>;
};

/** Represents the fumble stats for a football player. */
export type FootballFumblesStats = {
  __typename?: 'FootballFumblesStats';
  /** The total number of fumbles */
  fumbles?: Maybe<Scalars['Int']['output']>;
  /** The total number of fumbles lost by the player */
  fumblesLost?: Maybe<Scalars['Int']['output']>;
  /** The number of touchdowns scored from opponent fumble recoveries */
  opponentFumbleRecoveredTouchdowns?: Maybe<Scalars['Int']['output']>;
  /** The total yards gained from opponent fumble recoveries */
  opponentFumbleRecoveredYards?: Maybe<Scalars['Int']['output']>;
  /** The total number of fumbles recovered by the opponent */
  opponentFumblesRecovered?: Maybe<Scalars['Int']['output']>;
  /** The number of touchdowns scored from own fumble recoveries */
  ownFumbleRecoveredTouchdowns?: Maybe<Scalars['Int']['output']>;
  /** The total number of fumbles recovered by the player */
  ownFumblesRecovered?: Maybe<Scalars['Int']['output']>;
  /** The number of yards scored from own fumble recoveries */
  ownFumblesRecoveredYards?: Maybe<Scalars['Int']['output']>;
};

/** Represents the kick return stats for a football player. */
export type FootballKickingReturnStats = {
  __typename?: 'FootballKickingReturnStats';
  /** The average number of yards per kick return. */
  kickReturnAverage?: Maybe<Scalars['Float']['output']>;
  /** The longest kick return made by the player. */
  kickReturnLong?: Maybe<Scalars['Int']['output']>;
  /** The total number of touchdowns from kick returns. */
  kickReturnTouchdowns?: Maybe<Scalars['Int']['output']>;
  /** The total number of yards gained from kick returns. */
  kickReturnYards?: Maybe<Scalars['Int']['output']>;
  /** The total number of kick returns made by the player. */
  kickReturns?: Maybe<Scalars['Int']['output']>;
};

/** Represents the kicking stats for a football player. */
export type FootballKickingStats = {
  __typename?: 'FootballKickingStats';
  /** The total number of extra points blocked. */
  extraPointBlocked?: Maybe<Scalars['Int']['output']>;
  /** The total number of extra points attempted by the player. */
  extraPointsAttempted?: Maybe<Scalars['Int']['output']>;
  /** The total number of extra points made by the player. */
  extraPointsMade?: Maybe<Scalars['Int']['output']>;
  /** The total number of field goals blocked. */
  fieldGoalBlocked?: Maybe<Scalars['Int']['output']>;
  /** The longest field goal made by the player. */
  fieldGoalLong?: Maybe<Scalars['Int']['output']>;
  /** The total number of field goals attempted by the player. */
  fieldGoalsAttempted?: Maybe<Scalars['Int']['output']>;
  /** The total number of field goals made by the player. */
  fieldGoalsMade?: Maybe<Scalars['Int']['output']>;
};

/** Represents the passing stats for a football player. */
export type FootballPassingStats = {
  __typename?: 'FootballPassingStats';
  /** The total number of pass attempts made by the player. */
  passAttempts?: Maybe<Scalars['Int']['output']>;
  /** The total number of pass completions made by the player. */
  passCompletions?: Maybe<Scalars['Int']['output']>;
  /** The total number of interceptions thrown by the player. */
  passInterceptions?: Maybe<Scalars['Int']['output']>;
  /** The longest pass made by the player. */
  passLong?: Maybe<Scalars['Int']['output']>;
  /** The passer rating of the player. */
  passRating?: Maybe<Scalars['Float']['output']>;
  /** The total number of yards lost due to sacks. */
  passSackYards?: Maybe<Scalars['Int']['output']>;
  /** The total number of times the player was sacked. */
  passSacked?: Maybe<Scalars['Int']['output']>;
  /** The total number of pass touchdowns made by the player. */
  passTouchdowns?: Maybe<Scalars['Int']['output']>;
  /** The total number of passing yards gained by the player. */
  passYards?: Maybe<Scalars['Int']['output']>;
};

/** Represents the statistics of a football player in a game. */
export type FootballPlayerStats = PlayerStats & {
  __typename?: 'FootballPlayerStats';
  /** The defensive stats for the player. */
  defensive?: Maybe<FootballDefensiveStats>;
  /** The fantasy stats for the player. */
  fantasy?: Maybe<FootballFantasyStats>;
  /** The first name of the player. */
  firstName?: Maybe<Scalars['String']['output']>;
  /** The fumble stats for the player. */
  fumbles?: Maybe<FootballFumblesStats>;
  /** The initials for the player. */
  initials?: Maybe<Scalars['String']['output']>;
  /** The jersey number of the player. */
  jerseyNumber?: Maybe<Scalars['String']['output']>;
  /** The kick return stats for the player. */
  kickReturn?: Maybe<FootballKickingReturnStats>;
  /** The kicking stats for the player. */
  kicking?: Maybe<FootballKickingStats>;
  /** The last name of the player. */
  lastName?: Maybe<Scalars['String']['output']>;
  /** The passing stats for the player. */
  passing?: Maybe<FootballPassingStats>;
  /** The unique identifier for the player. */
  playerId: Scalars['ID']['output'];
  /** The position of the player. */
  position?: Maybe<Scalars['String']['output']>;
  /** The punt return stats for the player. */
  puntReturn?: Maybe<FootballPuntingReturnStats>;
  /** The punting stats for the player. */
  punting?: Maybe<FootballPuntingStats>;
  /** The receiving stats for the player. */
  receiving?: Maybe<FootballReceivingStats>;
  /** The rushing stats for the player. */
  rushing?: Maybe<FootballRushingStats>;
  /** The sport type for the player. */
  sport?: Maybe<Scalars['String']['output']>;
};

/** Represents the punt return stats for a football player. */
export type FootballPuntingReturnStats = {
  __typename?: 'FootballPuntingReturnStats';
  /** The average number of yards per punt return. */
  puntReturnAverage?: Maybe<Scalars['Float']['output']>;
  /** The total number of fair catches from punt returns. */
  puntReturnFairCatches?: Maybe<Scalars['Int']['output']>;
  /** The longest punt return made by the player. */
  puntReturnLong?: Maybe<Scalars['Int']['output']>;
  /** The total number of touchdowns from punt returns. */
  puntReturnTouchdowns?: Maybe<Scalars['Int']['output']>;
  /** The total number of yards gained from punt returns. */
  puntReturnYards?: Maybe<Scalars['Int']['output']>;
  /** The total number of punt returns made by the player. */
  puntReturns?: Maybe<Scalars['Int']['output']>;
};

/** Represents the punting stats for a football player. */
export type FootballPuntingStats = {
  __typename?: 'FootballPuntingStats';
  /** The average number of yards per punt. */
  puntAverage?: Maybe<Scalars['Float']['output']>;
  /** The total number of punts blocked. */
  puntBlocked?: Maybe<Scalars['Int']['output']>;
  /** The total number of punts inside the 20-yard line. */
  puntInside20?: Maybe<Scalars['Int']['output']>;
  /** The longest punt made by the player. */
  puntLong?: Maybe<Scalars['Int']['output']>;
  /** The total number of touchbacks from punts. */
  puntTouchbacks?: Maybe<Scalars['Int']['output']>;
  /** The total number of yards gained from punts. */
  puntYards?: Maybe<Scalars['Int']['output']>;
  /** The total number of punts made by the player. */
  punts?: Maybe<Scalars['Int']['output']>;
};

/** Represents the receiving stats for a football player. */
export type FootballReceivingStats = {
  __typename?: 'FootballReceivingStats';
  /** The longest reception made by the player. */
  receptionLong?: Maybe<Scalars['Int']['output']>;
  /** The total number of times the player was targeted for a reception. */
  receptionTargeted?: Maybe<Scalars['Int']['output']>;
  /** The total number of touchdowns from receptions. */
  receptionTouchdowns?: Maybe<Scalars['Int']['output']>;
  /** The total number of yards gained from receptions. */
  receptionYards?: Maybe<Scalars['Int']['output']>;
  /** The total number of receptions made by the player. */
  receptions?: Maybe<Scalars['Int']['output']>;
  /** The total number of yards gained after the catch. */
  yardsAfterCatch?: Maybe<Scalars['Int']['output']>;
};

/** Represents the rushing stats for a football player. */
export type FootballRushingStats = {
  __typename?: 'FootballRushingStats';
  /** The total number of red zone attempts made by the player. */
  redzoneAttempts?: Maybe<Scalars['Int']['output']>;
  /** The longest rush made by the player. */
  rushLong?: Maybe<Scalars['Int']['output']>;
  /** The total number of rushing touchdowns made by the player. */
  rushTouchdowns?: Maybe<Scalars['Int']['output']>;
  /** The total number of rushing yards gained by the player. */
  rushYards?: Maybe<Scalars['Int']['output']>;
  /** The total number of rushes made by the player. */
  rushes?: Maybe<Scalars['Int']['output']>;
};

export type ForgotPassword = SapiResponse & {
  __typename?: 'ForgotPassword';
  code: Scalars['Int']['output'];
  message?: Maybe<Scalars['String']['output']>;
  sapiStatusCode?: Maybe<Scalars['Int']['output']>;
  success: Scalars['Boolean']['output'];
  xurl?: Maybe<Scalars['String']['output']>;
};

export type ForgotPasswordInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  clientName?: InputMaybe<Scalars['String']['input']>;
  emailAddress: Scalars['EmailAddress']['input'];
  messageProperties?: InputMaybe<ForgotPasswordMessageProperties>;
  xurl?: InputMaybe<Scalars['String']['input']>;
};

export type ForgotPasswordMessageProperties = {
  url?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Represents a sports game or matchup entity. This entity is federated across multiple
 * services to allow data composition from different subgraphs. A 'Game' may include
 * details such as participating teams, scheduled time, league context, and more.
 */
export type Game = {
  __typename?: 'Game';
  /** Abbreviation for the game */
  abbrev?: Maybe<Scalars['String']['output']>;
  /** Information about the away team */
  awayTeam?: Maybe<GameTeam>;
  /** Score of the away team */
  awayTeamScore?: Maybe<Scalars['Int']['output']>;
  /** Number of shootout goals scored by the away team (NHL only) */
  awayTeamShootoutGoals?: Maybe<Scalars['Int']['output']>;
  /** Outcome of the shootout for the away team (NHL only) */
  awayTeamShootoutOutcome?: Maybe<ShootoutOutcome>;
  /**
   * player props projections for this game, suggest passing in leagueId to get only future projections
   *   *Constraints: `first` has a maximum limit of 500*
   */
  bettingPlayerPropsProjections?: Maybe<PlayerPropsProjectionConnection>;
  cbsWeekNumber?: Maybe<Scalars['Int']['output']>;
  cmsPolls: CmsPollConnection;
  /** Timestamp when the game was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Retrieves a paginated list of expert picks associated with this game,
   *   allowing you to view, filter, or sort picks based on various criteria.
   *
   *   Arguments:
   *   - filter (ExpertPickFilterInput): Lets you narrow down picks by
   *   parameters such as leagues, market types, or result statuses.
   *   - sortBy ([ExpertPickSortByInput!]!): Allows you to order picks
   *   by fields like creation date or featured status.
   *   - first, after, last, before: Provide Relay-style pagination controls,
   *   enabling you to fetch a specific page of results.
   *
   *   Returns:
   *   An ExpertPicksConnection object, which includes the totalCount,
   *   pagination info, and a list of expert picks (edges) for this game.
   *
   *   Typical Use Cases:
   *   - Displaying all upcoming or recent picks made by experts for
   *   this specific game on a page or within an app.
   *   - Filtering picks by subscription status, result outcome, or
   *   market type (e.g., MONEY_LINE, OVER_UNDER).
   *   - Sorting picks by date to show the newest or oldest picks first,
   *   or by featured status to highlight marquee picks.
   */
  expertPicks?: Maybe<ExpertPicksConnection>;
  /** Extra time add to 90 minutes in soccer match */
  extraTime?: Maybe<Scalars['String']['output']>;
  /** Number assigned to the game */
  gameNumber?: Maybe<Scalars['Int']['output']>;
  /** Information about the home team */
  homeTeam?: Maybe<GameTeam>;
  /** Score of the home team */
  homeTeamScore?: Maybe<Scalars['Int']['output']>;
  /** Number of shootout goals scored by the home team (NHL only) */
  homeTeamShootoutGoals?: Maybe<Scalars['Int']['output']>;
  /** Outcome of the shootout for the home team (NHL only) */
  homeTeamShootoutOutcome?: Maybe<ShootoutOutcome>;
  /**
   * A unique identifier for this game. Used to correlate or retrieve
   *   additional information from other subgraphs or services.
   */
  id: Scalars['ID']['output'];
  /** Indicates if the game is locked */
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates if the game is played at a neutral venue */
  isNeutral?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the soccer game is in penalty shootout */
  isShootout?: Maybe<Scalars['Boolean']['output']>;
  /** League to which the game belongs */
  league: League;
  /** Minutes elapsed in soccer match */
  minute?: Maybe<Scalars['String']['output']>;
  /** Period of the game (as is from Atlas.Game.period table) */
  period?: Maybe<Scalars['Int']['output']>;
  /** player stats for game */
  playerStats?: Maybe<GamePlayerStats>;
  /**
   * Connection to the salaries for the game
   *   *Constraints:`first` has a maximum limit of 500*
   */
  salaries?: Maybe<GameDfsSalaryConnection>;
  /** Schedule metadata for the game */
  scheduleMetaData?: Maybe<ScheduleMetaData>;
  /** Scheduled start time of the game */
  scheduledTime?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Scheduled start time of the game as the number of seconds since the Unix epoch (January 1, 1970 UTC).
   *   This is useful for clients that require a numeric timestamp for date/time calculations.
   */
  scheduledTimeEpoch?: Maybe<Scalars['Int']['output']>;
  /** Scoreboard information for the game */
  scoreboard?: Maybe<Scoreboard>;
  /** Season during which the game is played */
  season?: Maybe<Season>;
  /** The season splits for the game. */
  seasonSplits: Array<Maybe<MarketSeasonSplit>>;
  /** Connection to the standard odds for the game */
  standardOdds?: Maybe<GameOddsConnection>;
  /** Status of the game */
  status?: Maybe<GameStatus>;
  /** Time remaining in the period */
  timeRemaining?: Maybe<Scalars['String']['output']>;
  /** game tv channel info from game_television_association table */
  tvChannels?: Maybe<Array<GameTelevision>>;
  /** Type of the game (from game_schedule_metadata.gameType) */
  type?: Maybe<Scalars['String']['output']>;
  /** Description of the game type (from game_schedule_metadata.gameTypeDescription) */
  typeDescription?: Maybe<Scalars['String']['output']>;
  /** Detailed type of the game (from game_schedule_metadata.gameTypeDetail) */
  typeDetail?: Maybe<Scalars['String']['output']>;
  /** Timestamp when the game was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The vendors that are associated with this game.
   *   *Constraints: `first` has a maximum limit of 500*
   */
  vendors?: Maybe<GameVendorConnection>;
  /** Venue where the game is played */
  venue?: Maybe<Venue>;
  weekNumber?: Maybe<Scalars['Int']['output']>;
  /** Team that won the game */
  winningTeam?: Maybe<Team>;
};


/**
 * Represents a sports game or matchup entity. This entity is federated across multiple
 * services to allow data composition from different subgraphs. A 'Game' may include
 * details such as participating teams, scheduled time, league context, and more.
 */
export type GameBettingPlayerPropsProjectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<PlayerPropsProjectionFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Array<PlayerPropsProjectionSortInput>>;
};


/**
 * Represents a sports game or matchup entity. This entity is federated across multiple
 * services to allow data composition from different subgraphs. A 'Game' may include
 * details such as participating teams, scheduled time, league context, and more.
 */
export type GameCmsPollsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filters: CmsRelatedContentFiltersInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CmsPollOrderBy>>;
  userIdentifier?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Represents a sports game or matchup entity. This entity is federated across multiple
 * services to allow data composition from different subgraphs. A 'Game' may include
 * details such as participating teams, scheduled time, league context, and more.
 */
export type GameExpertPicksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ExpertPickFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Array<ExpertPickSortByInput>>;
};


/**
 * Represents a sports game or matchup entity. This entity is federated across multiple
 * services to allow data composition from different subgraphs. A 'Game' may include
 * details such as participating teams, scheduled time, league context, and more.
 */
export type GameSalariesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Represents a sports game or matchup entity. This entity is federated across multiple
 * services to allow data composition from different subgraphs. A 'Game' may include
 * details such as participating teams, scheduled time, league context, and more.
 */
export type GameStandardOddsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  cbsMarketIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sportsBookIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


/**
 * Represents a sports game or matchup entity. This entity is federated across multiple
 * services to allow data composition from different subgraphs. A 'Game' may include
 * details such as participating teams, scheduled time, league context, and more.
 */
export type GameVendorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  vendorName?: InputMaybe<Scalars['String']['input']>;
};

export type GameConnection = {
  __typename?: 'GameConnection';
  /** A list of edges. */
  edges: Array<GameEdge>;
  /** A list of nodes. */
  nodes: Array<Game>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total count. */
  totalCount: Scalars['Int']['output'];
};

/** definition for game salary connection */
export type GameDfsSalaryConnection = {
  __typename?: 'GameDfsSalaryConnection';
  edges: Array<GameDfsSalaryEdge>;
  nodes: Array<DfsSalary>;
  pageInfo: PageInfo;
};

/**
 * The GameDfsSalaryEdge type represents the edge in a connection between a game and its associated DFS salaries.
 * The cache control directive is used to set the max age of the cache to 60 seconds.
 */
export type GameDfsSalaryEdge = {
  __typename?: 'GameDfsSalaryEdge';
  /** Cursor for pagination in the connection. */
  cursor: Scalars['String']['output'];
  /** The salary node in the connection. */
  node: DfsSalary;
};

/** An edge in a connection. */
export type GameEdge = {
  __typename?: 'GameEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Game;
};

/** Represents a game leg of a parlay where betType='game' */
export type GameLeg = {
  /** The type of bet being placed. */
  betType: Scalars['String']['output'];
  /** The CBS book identifier. */
  cbsBookId: Scalars['Int']['output'];
  /** cbsMarketAbbrev */
  cbsMarketAbbrev?: Maybe<Scalars['String']['output']>;
  /** The CBS market identifier. */
  cbsMarketId?: Maybe<Scalars['Int']['output']>;
  /** The name of the CBS market. */
  cbsMarketName?: Maybe<Scalars['String']['output']>;
  /** The bettor's edge for the bet. */
  edge: Scalars['Float']['output'];
  /** Represents a game in the parlay. */
  game: Game;
  /** The id of the Leg */
  id: Scalars['ID']['output'];
  /** Additional insight or information about the bet. */
  insight?: Maybe<Scalars['String']['output']>;
  /** The american odds for the bet. */
  odds?: Maybe<Scalars['Float']['output']>;
  /** The projected score used for the parlay */
  parlayProjectedScore?: Maybe<ParlayProjectedScore>;
  /** The side of the bet. */
  side?: Maybe<Scalars['String']['output']>;
};

/** definition for game odds connection */
export type GameOddsConnection = {
  __typename?: 'GameOddsConnection';
  edges: Array<GameOddsEdge>;
  nodes: Array<OddsBettingMarket>;
  pageInfo: PageInfo;
};

/** Edge for game odds connection */
export type GameOddsEdge = {
  __typename?: 'GameOddsEdge';
  cursor: Scalars['String']['output'];
  node: OddsBettingMarket;
};

/** Represents the player stats for a game. */
export type GamePlayerStats = {
  __typename?: 'GamePlayerStats';
  /** The unique identifier for the game player stats is game id. */
  _id: Scalars['ID']['output'];
  /** The sport type for the game, such as basketball, baseball, football, hockey, or soccer. */
  sport?: Maybe<Scalars['String']['output']>;
  /** The team player stats for the game. */
  teamPlayerStats?: Maybe<Array<Maybe<TeamPlayerStats>>>;
};

export type GameScore = {
  __typename?: 'GameScore';
  /** The away score for the game. */
  away?: Maybe<Scalars['Int']['output']>;
  /** The home score for the game. */
  home?: Maybe<Scalars['Int']['output']>;
};

export type GameSeasonSplit = {
  __typename?: 'GameSeasonSplit';
  /** The unique identifier for the game split. */
  _id: Scalars['ID']['output'];
  /** The date and time when this game split was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** The market season splits for this game. */
  markets: Array<MarketSeasonSplit>;
  /** The date and time when this game split was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** The status of a game */
export enum GameStatus {
  Canceled = 'CANCELED',
  Delayed = 'DELAYED',
  Final = 'FINAL',
  Halftime = 'HALFTIME',
  InProgress = 'IN_PROGRESS',
  Postponed = 'POSTPONED',
  Rescheduled = 'RESCHEDULED',
  Scheduled = 'SCHEDULED',
  Suspended = 'SUSPENDED',
  Tba = 'TBA'
}

/** team type used in game type, GameTeam will always be a child of a Game */
export type GameTeam = TeamBase & {
  __typename?: 'GameTeam';
  /** The abbreviated name of the team. */
  abbrev?: Maybe<Scalars['String']['output']>;
  /** The color of the team in hex format. */
  colorHexDex?: Maybe<Scalars['String']['output']>;
  /** The primary color of the team in hex format. */
  colorPrimaryHex?: Maybe<Scalars['String']['output']>;
  /** The secondary color of the team in hex format. */
  colorSecondaryHex?: Maybe<Scalars['String']['output']>;
  /** The date and time the team was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Return the game’s season standings record or, if none exists, the current regular season record. */
  currentStandings?: Maybe<TeamSeasonStanding>;
  /** The home venue of the team */
  homeVenue?: Maybe<Venue>;
  /** The unique identifier for the team. */
  id: Scalars['ID']['output'];
  /** The location of the team */
  location?: Maybe<Scalars['String']['output']>;
  /** The medium name of the team */
  mediumName?: Maybe<Scalars['String']['output']>;
  /** The nickname of the team */
  nickname?: Maybe<Scalars['String']['output']>;
  /**
   * The players that are associated with this team.
   *   *Constraints: `first` has a maximum limit of 500*
   */
  players?: Maybe<TeamPlayerConnection>;
  /**
   * The GameTeam's season will come from the parent Game - GameTeam will always be a child of a Game
   *   *Constraints: `first` has a maximum limit of 500*
   */
  seasons?: Maybe<TeamSeasonConnection>;
  /** The short name of the team */
  shortName?: Maybe<Scalars['String']['output']>;
  /** The date and time the team was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The vendors that are associated with this team.
   *   *Constraints: `first` has a maximum limit of 500*
   */
  vendors?: Maybe<TeamVendorConnection>;
};


/** team type used in game type, GameTeam will always be a child of a Game */
export type GameTeamPlayersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


/** team type used in game type, GameTeam will always be a child of a Game */
export type GameTeamSeasonsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


/** team type used in game type, GameTeam will always be a child of a Game */
export type GameTeamVendorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  vendorName?: InputMaybe<Scalars['String']['input']>;
};

/** game television information, refer to game_television_association table in Atlas */
export type GameTelevision = {
  __typename?: 'GameTelevision';
  /** Unique identifier for the television network */
  callLetters: Scalars['String']['output'];
  /** country identifier for the television network */
  countryId?: Maybe<Scalars['Int']['output']>;
  /** country name for the television network */
  countryName?: Maybe<Scalars['String']['output']>;
  /** Timestamp when the game television was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Unique identifier for the game */
  gameId: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  /** Television network display name */
  name: Scalars['String']['output'];
  /** team identifier for the television network */
  teamId?: Maybe<Scalars['Int']['output']>;
  /** television type id, refer to television_type table */
  typeId?: Maybe<Scalars['Int']['output']>;
  /** television type name, such as 'National', 'Local', 'Spanish', etc. */
  typeName?: Maybe<Scalars['String']['output']>;
  /** Timestamp when the game television was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Defines a connection between a game and its vendor game association. */
export type GameVendorConnection = {
  __typename?: 'GameVendorConnection';
  edges: Array<GameVendorEdge>;
  nodes: Array<Vendor>;
  pageInfo: PageInfo;
};

/** Represents an edge in a connection between Games => Vendor. */
export type GameVendorEdge = {
  __typename?: 'GameVendorEdge';
  /** The date and time the vendor game association was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The node of the edge. */
  node: Vendor;
  /** The date and time the vendor game association was updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The vendor game id associated with this cbs game. */
  vendorGameId?: Maybe<Scalars['String']['output']>;
};

export type GenerateSportsEntityIdInput = {
  abbrev: Scalars['String']['input'];
  entity: Scalars['String']['input'];
};

export type GenerateSportsEntityIdOutput = {
  __typename?: 'GenerateSportsEntityIdOutput';
  abbrev: Scalars['String']['output'];
  create_dt: Scalars['Date']['output'];
  id: Scalars['Int']['output'];
};

export type GetBowlPredictionDataResponse = {
  __typename?: 'GetBowlPredictionDataResponse';
  code?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<BowlPredictionData>;
};

export type GetBracketologyDataByTeamIdResponse = {
  __typename?: 'GetBracketologyDataByTeamIdResponse';
  code?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<BracketologyTeamItem>;
};

export type GetBracketologyDataResponse = {
  __typename?: 'GetBracketologyDataResponse';
  code?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<BracketologyTeamData>;
};

export type GetUserNewslettersSubscriptionInput = {
  clientName?: InputMaybe<Scalars['String']['input']>;
  pid: Scalars['String']['input'];
};

export type GetUserSubscriptionsInput = {
  clientName?: InputMaybe<Scalars['String']['input']>;
  custId: Scalars['Int']['input'];
};

/** Google Sign On User Profile */
export type GoogleUserProfile = {
  __typename?: 'GoogleUserProfile';
  email?: Maybe<Scalars['String']['output']>;
  emailVerified?: Maybe<Scalars['Boolean']['output']>;
  /** The user's last name */
  familyName?: Maybe<Scalars['String']['output']>;
  /** The user's first name */
  givenName?: Maybe<Scalars['String']['output']>;
  /** The hosted domain */
  hd?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  /** The user's full name */
  name?: Maybe<Scalars['String']['output']>;
  /** The user's profile picture */
  picture?: Maybe<Scalars['String']['output']>;
  /** The user's unique ID */
  sub?: Maybe<Scalars['String']['output']>;
};

export type GoogleUserProfileInput = {
  accessToken: Scalars['String']['input'];
};

export type Graphic = {
  __typename?: 'Graphic';
  apiId: Scalars['String']['output'];
  cmsId?: Maybe<Scalars['String']['output']>;
  config: Scalars['JSON']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  creator?: Maybe<GraphicsUser>;
  description?: Maybe<Scalars['String']['output']>;
  exports?: Maybe<Array<GraphicExport>>;
  graphicsCard?: Maybe<GraphicsCard>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  scheduleTasks?: Maybe<Array<GraphicScheduleTask>>;
  tags?: Maybe<Array<GraphicTag>>;
  updated?: Maybe<GraphicsUser>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
  version: Scalars['Int']['output'];
};


export type GraphicExportsArgs = {
  latest?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GraphicDeleteManyResponse = {
  __typename?: 'GraphicDeleteManyResponse';
  id: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type GraphicExport = {
  __typename?: 'GraphicExport';
  automated?: Maybe<Scalars['Boolean']['output']>;
  config: Scalars['JSON']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  creator?: Maybe<GraphicsUser>;
  dataEndpoint?: Maybe<Scalars['String']['output']>;
  graphic?: Maybe<Graphic>;
  graphicId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  leagueAbbr: Scalars['String']['output'];
  leagueId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  s3Bucket?: Maybe<Scalars['String']['output']>;
  s3Path?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type GraphicExportFilterInput = {
  automated?: InputMaybe<Scalars['Boolean']['input']>;
  graphicApiId?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<GraphicExportSortField>;
  sortDirection?: InputMaybe<SortDirection>;
};

export type GraphicExportFiltersInput = {
  automated?: InputMaybe<Scalars['Boolean']['input']>;
  createdAfter?: InputMaybe<Scalars['DateTime']['input']>;
  createdBefore?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  graphicApiId?: InputMaybe<Scalars['String']['input']>;
  leagueAbbr?: InputMaybe<Scalars['String']['input']>;
  leagueId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<GraphicExportSortField>;
  sortDirection?: InputMaybe<SortDirection>;
  updatedAfter?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBefore?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export enum GraphicExportSortField {
  CreatedAt = 'CREATED_AT',
  UpdatedAt = 'UPDATED_AT'
}

export type GraphicFiltersInput = {
  apiId?: InputMaybe<Scalars['String']['input']>;
  createdAfter?: InputMaybe<Scalars['DateTime']['input']>;
  createdBefore?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  hasExports?: InputMaybe<Scalars['Boolean']['input']>;
  hasTasks?: InputMaybe<Scalars['Boolean']['input']>;
  leagueAbbr?: InputMaybe<Scalars['String']['input']>;
  leagueId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedAfter?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBefore?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type GraphicScheduleTask = {
  __typename?: 'GraphicScheduleTask';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  creator?: Maybe<GraphicsUser>;
  graphic?: Maybe<Graphic>;
  graphicId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  nextRun?: Maybe<Scalars['DateTime']['output']>;
  schedule: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type GraphicScheduleTaskDeleteManyResponse = {
  __typename?: 'GraphicScheduleTaskDeleteManyResponse';
  id: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type GraphicScheduleTaskFiltersInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  createdAfter?: InputMaybe<Scalars['DateTime']['input']>;
  createdBefore?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  graphicApiId?: InputMaybe<Scalars['String']['input']>;
  graphicId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nextRunAfter?: InputMaybe<Scalars['DateTime']['input']>;
  nextRunBefore?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAfter?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBefore?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type GraphicTag = {
  __typename?: 'GraphicTag';
  createdAt: Scalars['DateTime']['output'];
  graphics?: Maybe<Array<Graphic>>;
  id: Scalars['String']['output'];
};

/** Represents a Graphics Card. */
export type GraphicsCard = {
  __typename?: 'GraphicsCard';
  associations?: Maybe<Array<GraphicsCardAssociation>>;
  businessUnit: CmsBusinessUnit;
  clickThroughURL?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  dataSource?: Maybe<GraphicsCardCmsContentDataSource>;
  disabled: Scalars['Boolean']['output'];
  externalID?: Maybe<Scalars['ID']['output']>;
  height: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  metadata: Scalars['Map']['output'];
  siteID: Scalars['Int']['output'];
  subTitle: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  type: GraphicsCardType;
  updatedAt: Scalars['DateTime']['output'];
  url: Scalars['String']['output'];
  width: Scalars['Int']['output'];
};

/** Represents the available Graphics Card associations. */
export type GraphicsCardAssociation = Event | Game | League | Player | Sport | Team;

export type GraphicsCardAssociationInput = {
  id: Scalars['ID']['input'];
  type: GraphicsCardAssociationType;
};

/** Represents the available Graphics Card association types. */
export enum GraphicsCardAssociationType {
  Event = 'EVENT',
  Game = 'GAME',
  League = 'LEAGUE',
  Player = 'PLAYER',
  Sport = 'SPORT',
  Team = 'TEAM'
}

/** Represents the available CMS content types associated to a Graphics Card. */
export type GraphicsCardCmsContentDataSource = CmsArticle;

export type GraphicsCardCmsContentDataSourceInput = {
  id: Scalars['ID']['input'];
  type: GraphicsCardCmsContentDataSourceType;
};

/** Represents the available Graphics Card CMS content data source types. */
export enum GraphicsCardCmsContentDataSourceType {
  Article = 'ARTICLE'
}

export type GraphicsCardConnection = {
  __typename?: 'GraphicsCardConnection';
  /** A list of edges. */
  edges: Array<GraphicsCardEdge>;
  /** A list of nodes. */
  nodes: Array<GraphicsCard>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total count. */
  totalCount: Scalars['Int']['output'];
};

export type GraphicsCardCreate = {
  associations?: InputMaybe<Array<GraphicsCardAssociationInput>>;
  businessUnit?: InputMaybe<CmsBusinessUnit>;
  clickThroughUrl?: InputMaybe<Scalars['String']['input']>;
  createUserID: Scalars['ID']['input'];
  dataSource?: InputMaybe<GraphicsCardCmsContentDataSourceInput>;
  dataSourceURL?: InputMaybe<Scalars['String']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  externalID?: InputMaybe<Scalars['ID']['input']>;
  files: GraphicsCardFiles;
  metadata: Scalars['Map']['input'];
  siteID?: InputMaybe<Scalars['Int']['input']>;
  subTitle?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  type: GraphicsCardType;
};

export type GraphicsCardEdge = {
  __typename?: 'GraphicsCardEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: GraphicsCard;
};

export type GraphicsCardFiles = {
  pngFile: Scalars['Upload']['input'];
  svgFile: Scalars['Upload']['input'];
};

export type GraphicsCardOrderBy = {
  createdAt?: InputMaybe<OrderByDir>;
  id?: InputMaybe<OrderByDir>;
  updatedAt?: InputMaybe<OrderByDir>;
};

/** Represents the available Graphics Card types. */
export enum GraphicsCardType {
  FantasyProjections = 'FANTASY_PROJECTIONS',
  FantasyRankings = 'FANTASY_RANKINGS',
  FantasyStats = 'FANTASY_STATS',
  LeagueStatsLeaders = 'LEAGUE_STATS_LEADERS',
  PowerRanking = 'POWER_RANKING'
}

export type GraphicsCardUpdate = {
  associations?: InputMaybe<Array<GraphicsCardAssociationInput>>;
  clickThroughUrl?: InputMaybe<Scalars['String']['input']>;
  dataSource?: InputMaybe<GraphicsCardCmsContentDataSourceInput>;
  dataSourceURL?: InputMaybe<Scalars['String']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  files?: InputMaybe<GraphicsCardFiles>;
  id: Scalars['ID']['input'];
  metadata?: InputMaybe<Scalars['Map']['input']>;
  subTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<GraphicsCardType>;
  updateUserID: Scalars['ID']['input'];
};

export type GraphicsCardsCondition = {
  associationsIn?: InputMaybe<Array<GraphicsCardAssociationInput>>;
  dataSourcesIn?: InputMaybe<Array<GraphicsCardCmsContentDataSourceInput>>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  externalIdsIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idsIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Represents the inputs for graphics cards resolver. */
export type GraphicsCardsInput = {
  /** Should be base64 encoded to support offset and ID-based pagination. */
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<GraphicsCardsCondition>;
  /** Defines the number of results to return. */
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GraphicsCardOrderBy>>;
};

export type GraphicsUser = {
  __typename?: 'GraphicsUser';
  createdAt: Scalars['DateTime']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  username: Scalars['String']['output'];
};

export type HbaStatus = {
  __typename?: 'HBAStatus';
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** Represents the player stats for hockey. */
export type HockeyPlayerStats = PlayerStats & {
  __typename?: 'HockeyPlayerStats';
  /** The first name of the player. */
  firstName?: Maybe<Scalars['String']['output']>;
  /** The initials for the player. */
  initials?: Maybe<Scalars['String']['output']>;
  /** The jersey number of the player. */
  jerseyNumber?: Maybe<Scalars['String']['output']>;
  /** The last name of the player. */
  lastName?: Maybe<Scalars['String']['output']>;
  /** The unique identifier for the player. */
  playerId: Scalars['ID']['output'];
  /** The position of the player. */
  position?: Maybe<Scalars['String']['output']>;
  /** The shots per period for the player. */
  shotsPerPeriod?: Maybe<Array<Maybe<HockeyShotsPerPeriod>>>;
  /** The sport type for the player. */
  sport?: Maybe<Scalars['String']['output']>;
  /** The hockey stats for the player. */
  stat?: Maybe<HockeyStats>;
};

/** Represents the shots per period for a hockey player. */
export type HockeyShotsPerPeriod = {
  __typename?: 'HockeyShotsPerPeriod';
  /** The period number. */
  period?: Maybe<Scalars['Int']['output']>;
  /** The total number of shots made by the player in the period. */
  shots?: Maybe<Scalars['Int']['output']>;
};

/** Represents the statistics of a player in a hockey game. */
export type HockeyStats = {
  __typename?: 'HockeyStats';
  /** The total number of assists made by the player. */
  assists?: Maybe<Scalars['Int']['output']>;
  /** The total number of blocks made by the player. */
  blocks?: Maybe<Scalars['Int']['output']>;
  /** The total even strength time on ice for the player. */
  evenTimeOnIce?: Maybe<Scalars['String']['output']>;
  /** The total number of faceoff losses by the player. */
  faceOffLosses?: Maybe<Scalars['Int']['output']>;
  /** The total number of faceoff wins by the player. */
  faceOffWins?: Maybe<Scalars['Int']['output']>;
  /** The faceoff win percentage of the player. */
  faceoffWinPercentage?: Maybe<Scalars['Float']['output']>;
  /** The total number of game misconducts by the player. */
  gameMisconducts?: Maybe<Scalars['Int']['output']>;
  /** The total number of giveaways by the player. */
  giveaways?: Maybe<Scalars['Int']['output']>;
  /** The total number of goals scored by the player. */
  goals?: Maybe<Scalars['Int']['output']>;
  /** The total number of goals against the player. */
  goalsAgainst?: Maybe<Scalars['Int']['output']>;
  /** The total number of hits made by the player. */
  hits?: Maybe<Scalars['Int']['output']>;
  /** The total number of major penalties committed by the player. */
  majorPenalties?: Maybe<Scalars['Int']['output']>;
  /** The total number of minor penalties committed by the player. */
  minorPenalties?: Maybe<Scalars['Int']['output']>;
  /** The total number of missed shots by the player. */
  missedShots?: Maybe<Scalars['Int']['output']>;
  /** The total number of penalties committed by the player. */
  penalties?: Maybe<Scalars['Int']['output']>;
  /** The total number of penalty minutes for the player. */
  penaltyMinutes?: Maybe<Scalars['Int']['output']>;
  /** The plus-minus statistic of the player. */
  plusMinus?: Maybe<Scalars['Int']['output']>;
  /** The total number of points scored by the player. */
  points?: Maybe<Scalars['Int']['output']>;
  /** The total number of power play goals scored by the player. */
  powerPlayGoals?: Maybe<Scalars['Int']['output']>;
  /** The total power play time on ice for the player. */
  powerPlayTimeOnIce?: Maybe<Scalars['String']['output']>;
  /** The save percentage of the player. */
  savePercentage?: Maybe<Scalars['Float']['output']>;
  /** The total number of saves made by the player. */
  saves?: Maybe<Scalars['Int']['output']>;
  /** The total number of shifts by the player. */
  shifts?: Maybe<Scalars['Int']['output']>;
  /** The total number of shootout shots by the player. */
  shootoutShots?: Maybe<Scalars['Int']['output']>;
  /** The total short-handed time on ice for the player. */
  shortHandedTimeOnIce?: Maybe<Scalars['String']['output']>;
  /** The total number of shots against the player. */
  shotsAgainst?: Maybe<Scalars['Int']['output']>;
  /** The total number of shots on goal by the player. */
  shotsOnGoal?: Maybe<Scalars['Int']['output']>;
  /** The total number of takeaways by the player. */
  takeaways?: Maybe<Scalars['Int']['output']>;
  /** The total time on ice for the player. */
  timeOnIce?: Maybe<Scalars['String']['output']>;
};

/**
 * Encapsulates the response structure for hottest experts queries, including
 * the league, the season year, and the expert data.
 */
export type HottestExpertResponse = {
  __typename?: 'HottestExpertResponse';
  /**
   * A list of the current hottest experts, often limited by a
   *   specified number (e.g., top 5, top 10). Each expert includes
   *   additional streak information, ranking, and performance metrics.
   */
  experts?: Maybe<Array<SportslineHottestExpert>>;
  /**
   * The league for which the hottest experts are being retrieved.
   *   Ties back to a League entity for further context (e.g.,
   *   league name, abbreviation).
   */
  league: League;
  /**
   * The season year used to determine the hottest experts. Derived either
   *   from the input 'year' parameter or defaulted from SportsLine's
   *   configuration if no year is specified.
   */
  seasonYear: Scalars['Int']['output'];
};


/**
 * Encapsulates the response structure for hottest experts queries, including
 * the league, the season year, and the expert data.
 */
export type HottestExpertResponseExpertsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type InitiateMvpdLogoutInput = {
  mvpd: Scalars['String']['input'];
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
  serviceProvider?: InputMaybe<Scalars['String']['input']>;
};

export type InternalServerError = {
  __typename?: 'InternalServerError';
  code: Scalars['Int']['output'];
  message: Scalars['String']['output'];
};

export type ItblInternal = {
  __typename?: 'ItblInternal';
  documentCreatedAt: Scalars['String']['output'];
  documentUpdatedAt: Scalars['String']['output'];
  emailDomain: Scalars['String']['output'];
};

export type IterableChannel = {
  __typename?: 'IterableChannel';
  channelType: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  messageMedium: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type IterableMessageType = {
  __typename?: 'IterableMessageType';
  channelId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  subscriptionPolicy?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Float']['output']>;
};

export type IterableUserByEmailResponse = {
  __typename?: 'IterableUserByEmailResponse';
  user?: Maybe<IterableUserDetails>;
};

export type IterableUserDetails = {
  __typename?: 'IterableUserDetails';
  dataFields?: Maybe<IterableUserDetailsDataFields>;
  email: Scalars['String']['output'];
  userId?: Maybe<Scalars['String']['output']>;
};

export type IterableUserDetailsDataFields = {
  __typename?: 'IterableUserDetailsDataFields';
  itblInternal?: Maybe<ItblInternal>;
  itblUserId: Scalars['String']['output'];
  profileUpdatedAt: Scalars['String']['output'];
  signupDate: Scalars['String']['output'];
  signupSource: Scalars['String']['output'];
  subscribedMessageTypeIds: Array<Scalars['Int']['output']>;
  unsubscribedChannelIds: Array<Scalars['Int']['output']>;
  unsubscribedMessageTypeIds: Array<Scalars['Int']['output']>;
  userListIds: Array<Scalars['Int']['output']>;
};

/**
 * Represents a sports league (e.g., NFL, NBA, MLB). This entity is federated
 * across multiple services, allowing you to query or mutate league data from
 * different subgraphs.
 */
export type League = {
  __typename?: 'League';
  /**
   * The standard abbreviation for the league (e.g., "NFL" for National Football League).
   *   Marked as @external because it is defined and resolved in another subgraph.
   */
  abbrev: Scalars['String']['output'];
  /**
   * player props projections for this league, suggest passing in leagueId to get only future projections
   *   *Constraints: `first` has a maximum limit of 500*
   */
  bettingPlayerPropsProjections?: Maybe<PlayerPropsProjectionConnection>;
  /**
   * top free player props projections for the league
   *   *Constraints: `first` has a maximum limit of 500*
   */
  bettingTopFreePlayerPropsProjections?: Maybe<PlayerPropsProjectionFpConnection>;
  /**
   * Indicates the current regular season associated with this league. This
   *   could represent the currently active season, or the one most relevant
   *   to ongoing or upcoming games. Marked as @external because it is defined
   *   and resolved in another subgraph.
   */
  currentRegularSeason?: Maybe<Season>;
  /**
   * Paginated list of sports events (matches, fights, tournaments, etc.) under this league filtered
   *   by scheduled start time. Results are ordered ascending by scheduledTime unless otherwise noted.
   *   *Constraints: `first` has a maximum limit of 100*
   */
  events?: Maybe<LeagueEventsConnection>;
  /**
   * Fetches the expert picks for this league.
   *   This field allows you to filter, sort, and paginate through expert picks.
   *   - filter (ExpertPickFilterInput): Optional input to filter expert picks
   *   based on various criteria such as game IDs, expert IDs, or date ranges.
   *   - sortBy ([ExpertPickSortByInput!]): Optional input to specify how to sort
   *   the expert picks, such as by date or expert name.
   *   - first (Int): Optional argument to limit the number of expert picks returned.
   *   - after (String): Optional cursor for pagination, indicating the point
   *   after which to return results.
   *   - last (Int): Optional argument to limit the number of expert picks returned
   *   in reverse order.
   *   - before (String): Optional cursor for pagination, indicating the point
   *   before which to return results.
   *   This field is marked with @cacheControl(scope: PRIVATE) to indicate that
   *   the results are specific to the user and should not be cached publicly.
   *   This allows for personalized data retrieval while maintaining privacy.
   */
  expertPicks?: Maybe<ExpertPicksConnection>;
  /**
   * The games that are associated with this league.
   *   *Constraints: `first` has a maximum limit of 500*"
   */
  games?: Maybe<LeagueGamesConnection>;
  /**
   * Fetches the 'hottest experts' for this league in a given year. Experts
   *   are typically individuals who provide picks or analysis within SportsLine.
   *   This field uses the @requires directive to ensure it has access to
   *   'abbrev' and the 'year' property from currentRegularSeason.
   *   - year (Int): Optionally specify a particular season year to retrieve
   *   the hottest experts for. If omitted, defaults might be based on
   *   currentRegularSeason's year or other logic in your resolvers.
   */
  hottestExperts?: Maybe<HottestExpertResponse>;
  /**
   * A unique identifier for the league within this federated schema.
   *   Typically references an internal or external ID used to fetch league data
   *   across services.
   */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /**
   * The parlays that are associated with this league.
   *   *Constraints: `first` has a maximum limit of 500*
   */
  parlays?: Maybe<LeagueParlayConnection>;
  /**
   * The player news that are associated with this league.
   *   *Constraints: `first` has a maximum limit of 500*
   */
  playerNews?: Maybe<LeaguePlayerNewsConnection>;
  /** projection market list for the league and category name */
  projectionMarkets?: Maybe<Array<MarketCategory>>;
  sport: Sport;
  /** The tennis tournaments that are associated with this league. */
  tournaments?: Maybe<LeagueCompetitionConnection>;
  type?: Maybe<Scalars['String']['output']>;
  /**
   * The vendor events that are associated with this league.
   *   *Constraints: `first` has a maximum limit of 500*
   */
  vendorEvents?: Maybe<LeagueVendorEventsConnection>;
  /**
   * The games that are associated with the vendor.
   *   *Constraints: `first` has a maximum limit of 500*
   */
  vendorGames?: Maybe<LeagueVendorGamesConnection>;
  /**
   * year projection for sepecific year and only return active teams and markets by default
   *   when marketActiveFlag and teamActiveFlag are set to false, it returns all teams and markets
   */
  yearProjections?: Maybe<LeagueYearProjections>;
};


/**
 * Represents a sports league (e.g., NFL, NBA, MLB). This entity is federated
 * across multiple services, allowing you to query or mutate league data from
 * different subgraphs.
 */
export type LeagueBettingPlayerPropsProjectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<PlayerPropsProjectionFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Array<InputMaybe<PlayerPropsProjectionSortInput>>>;
};


/**
 * Represents a sports league (e.g., NFL, NBA, MLB). This entity is federated
 * across multiple services, allowing you to query or mutate league data from
 * different subgraphs.
 */
export type LeagueBettingTopFreePlayerPropsProjectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<PlayerPropsProjectionFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Array<InputMaybe<PlayerPropsProjectionSortInput>>>;
};


/**
 * Represents a sports league (e.g., NFL, NBA, MLB). This entity is federated
 * across multiple services, allowing you to query or mutate league data from
 * different subgraphs.
 */
export type LeagueEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  scheduledSince?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledUntil?: InputMaybe<Scalars['DateTime']['input']>;
};


/**
 * Represents a sports league (e.g., NFL, NBA, MLB). This entity is federated
 * across multiple services, allowing you to query or mutate league data from
 * different subgraphs.
 */
export type LeagueExpertPicksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ExpertPickFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Array<ExpertPickSortByInput>>;
};


/**
 * Represents a sports league (e.g., NFL, NBA, MLB). This entity is federated
 * across multiple services, allowing you to query or mutate league data from
 * different subgraphs.
 */
export type LeagueGamesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  scheduledSince?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledUntil?: InputMaybe<Scalars['DateTime']['input']>;
};


/**
 * Represents a sports league (e.g., NFL, NBA, MLB). This entity is federated
 * across multiple services, allowing you to query or mutate league data from
 * different subgraphs.
 */
export type LeagueHottestExpertsArgs = {
  year?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Represents a sports league (e.g., NFL, NBA, MLB). This entity is federated
 * across multiple services, allowing you to query or mutate league data from
 * different subgraphs.
 */
export type LeagueParlaysArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Array<InputMaybe<ParlaySortInput>>>;
};


/**
 * Represents a sports league (e.g., NFL, NBA, MLB). This entity is federated
 * across multiple services, allowing you to query or mutate league data from
 * different subgraphs.
 */
export type LeaguePlayerNewsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  createdSince?: InputMaybe<Scalars['DateTime']['input']>;
  createdUntil?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Array<InputMaybe<PlayerNewsSortInput>>>;
  team?: InputMaybe<Array<Scalars['ID']['input']>>;
};


/**
 * Represents a sports league (e.g., NFL, NBA, MLB). This entity is federated
 * across multiple services, allowing you to query or mutate league data from
 * different subgraphs.
 */
export type LeagueProjectionMarketsArgs = {
  categoryType: BettingCategoryType;
};


/**
 * Represents a sports league (e.g., NFL, NBA, MLB). This entity is federated
 * across multiple services, allowing you to query or mutate league data from
 * different subgraphs.
 */
export type LeagueTournamentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Represents a sports league (e.g., NFL, NBA, MLB). This entity is federated
 * across multiple services, allowing you to query or mutate league data from
 * different subgraphs.
 */
export type LeagueVendorEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  first: Scalars['Int']['input'];
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  vendorName: Scalars['String']['input'];
};


/**
 * Represents a sports league (e.g., NFL, NBA, MLB). This entity is federated
 * across multiple services, allowing you to query or mutate league data from
 * different subgraphs.
 */
export type LeagueVendorGamesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  first: Scalars['Int']['input'];
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  vendorName: Scalars['String']['input'];
};


/**
 * Represents a sports league (e.g., NFL, NBA, MLB). This entity is federated
 * across multiple services, allowing you to query or mutate league data from
 * different subgraphs.
 */
export type LeagueYearProjectionsArgs = {
  marketActiveFlag?: InputMaybe<Scalars['Boolean']['input']>;
  teamActiveFlag?: InputMaybe<Scalars['Boolean']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

/** Define a connection between a league and its list of tournaments. */
export type LeagueCompetitionConnection = {
  __typename?: 'LeagueCompetitionConnection';
  edges?: Maybe<Array<LeagueCompetitionEdge>>;
  nodes?: Maybe<Array<CompetitionParent>>;
  pageInfo: PageInfo;
};

export type LeagueCompetitionEdge = {
  __typename?: 'LeagueCompetitionEdge';
  cursor: Scalars['String']['output'];
  node: CompetitionParent;
};

export type LeagueConnection = {
  __typename?: 'LeagueConnection';
  /** A list of edges. */
  edges: Array<LeagueEdge>;
  /** A list of nodes. */
  nodes: Array<League>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total count. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type LeagueEdge = {
  __typename?: 'LeagueEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: League;
};

/** Edge wrapper for league events connection. */
export type LeagueEventEdge = {
  __typename?: 'LeagueEventEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<SportsEvent>;
};

/** Connection for league -> events (generic cross-sport events implementing SportsEvent). */
export type LeagueEventsConnection = {
  __typename?: 'LeagueEventsConnection';
  edges?: Maybe<Array<Maybe<LeagueEventEdge>>>;
  nodes?: Maybe<Array<Maybe<SportsEvent>>>;
  pageInfo: PageInfo;
};

/** Define an edge between league and a game */
export type LeagueGameEdge = {
  __typename?: 'LeagueGameEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<Game>;
};

/** Define a connection between league and games */
export type LeagueGamesConnection = {
  __typename?: 'LeagueGamesConnection';
  edges?: Maybe<Array<Maybe<LeagueGameEdge>>>;
  nodes?: Maybe<Array<Maybe<Game>>>;
  pageInfo: PageInfo;
};

/** Define a connection between a league and its list of parlays. */
export type LeagueParlayConnection = {
  __typename?: 'LeagueParlayConnection';
  edges?: Maybe<Array<Maybe<LeagueParlayEdge>>>;
  nodes?: Maybe<Array<Maybe<Parlay>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LeagueParlayEdge = {
  __typename?: 'LeagueParlayEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<Parlay>;
};

export type LeaguePayment = {
  __typename?: 'LeaguePayment';
  amountPaid?: Maybe<Scalars['Float']['output']>;
  amountRefunded?: Maybe<Scalars['Float']['output']>;
  custId?: Maybe<Scalars['Int']['output']>;
  invoiceNum?: Maybe<Scalars['String']['output']>;
  leagueId?: Maybe<Scalars['Int']['output']>;
  modelName?: Maybe<Scalars['String']['output']>;
  paymentMethod?: Maybe<Scalars['String']['output']>;
  paymentStatus?: Maybe<Scalars['String']['output']>;
  subId?: Maybe<Scalars['Int']['output']>;
  totalPaid?: Maybe<Scalars['Float']['output']>;
  validPayment?: Maybe<Scalars['Boolean']['output']>;
};

export type LeaguePaymentInput = {
  custId: Scalars['String']['input'];
  league: Scalars['String']['input'];
  mpid: Scalars['String']['input'];
};

export type LeaguePaymentResponse = {
  __typename?: 'LeaguePaymentResponse';
  orphanPaymentFound?: Maybe<Scalars['Boolean']['output']>;
  orphanPaymentList?: Maybe<Array<LeaguePayment>>;
  paymentFound?: Maybe<Scalars['Boolean']['output']>;
  paymentList?: Maybe<Array<LeaguePayment>>;
};

/** Define a connection between a league and its player news. */
export type LeaguePlayerNewsConnection = {
  __typename?: 'LeaguePlayerNewsConnection';
  edges?: Maybe<Array<Maybe<PlayerNewsEdge>>>;
  nodes?: Maybe<Array<Maybe<RotowirePlayerNews>>>;
  pageInfo: PageInfo;
};

/** Defines a connection between a league and its vendor events. */
export type LeagueVendorEventsConnection = {
  __typename?: 'LeagueVendorEventsConnection';
  edges: Array<Maybe<LeagueVendorEventsEdge>>;
  nodes: Array<Maybe<VendorEvent>>;
  pageInfo: PageInfo;
};

/** Defines an edge between a league and one of its vendor events. */
export type LeagueVendorEventsEdge = {
  __typename?: 'LeagueVendorEventsEdge';
  cursor: Scalars['String']['output'];
  node: VendorEvent;
};

/** Defines a connection between a league and its vendor games. */
export type LeagueVendorGamesConnection = {
  __typename?: 'LeagueVendorGamesConnection';
  edges: Array<Maybe<LeagueVendorGamesEdge>>;
  nodes: Array<Maybe<VendorGame>>;
  pageInfo: PageInfo;
};

/** Defines an edge between a league and one of its vendor games. */
export type LeagueVendorGamesEdge = {
  __typename?: 'LeagueVendorGamesEdge';
  cursor: Scalars['String']['output'];
  node: VendorGame;
};

/** The league future year projections type, refer to legaue_future_projections in mongo DB */
export type LeagueYearProjections = {
  __typename?: 'LeagueYearProjections';
  /** Current season id for the league */
  currentSeasonId?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier for the year projection. */
  league: Scalars['String']['output'];
  markets: Array<LeagueYearProjectionsMarket>;
  seasonYear: Scalars['Int']['output'];
};

/** market type definition in league year projection */
export type LeagueYearProjectionsMarket = {
  __typename?: 'LeagueYearProjectionsMarket';
  /** Current season id for the league */
  currentSeasonId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  /** market active flag */
  marketActive?: Maybe<Scalars['Boolean']['output']>;
  marketSorting: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  teams: Array<LeagueYearProjectionsTeamMarket>;
};

/** team market type definition in league year projection */
export type LeagueYearProjectionsTeamMarket = {
  __typename?: 'LeagueYearProjectionsTeamMarket';
  conference?: Maybe<Conference>;
  /** The current regular season standings for the team. */
  currentRegularStandings?: Maybe<TeamSeasonStanding>;
  /** Current season id for the league */
  currentSeasonId?: Maybe<Scalars['Int']['output']>;
  division?: Maybe<Division>;
  /** The projected number of draws for the soccer team. */
  draws?: Maybe<Scalars['Float']['output']>;
  /** The projected number of losses for the team. */
  losses?: Maybe<Scalars['Float']['output']>;
  /** The projected odds for the team. */
  projOdds?: Maybe<Scalars['String']['output']>;
  /** The projected probability for the team. */
  projProbability?: Maybe<Scalars['Float']['output']>;
  team: Team;
  /** team active flag */
  teamActive?: Maybe<Scalars['Boolean']['output']>;
  /** The projected number of wins for the team. */
  wins?: Maybe<Scalars['Float']['output']>;
};

/**
 * Represents a leg of a parlay. The Leg interface does not need scope to read.
 * The implementing types are gating the interface field permsissions.
 */
export type Leg = {
  /** The type of bet (player, game, team, or league) */
  betType: Scalars['String']['output'];
  /** The CBS book ID associated with the leg */
  cbsBookId: Scalars['Int']['output'];
  /** cbsMarketAbbrev */
  cbsMarketAbbrev?: Maybe<Scalars['String']['output']>;
  /** The CBS market ID associated with the leg */
  cbsMarketId?: Maybe<Scalars['Int']['output']>;
  /** The CBS market name associated with the leg */
  cbsMarketName?: Maybe<Scalars['String']['output']>;
  /** The edge or advantage the bettor has over the bookmaker for the leg */
  edge: Scalars['Float']['output'];
  /** The game associated with the leg */
  game: Game;
  /** The id of the Leg */
  id: Scalars['ID']['output'];
  /** Additional insight or commentary about the bet */
  insight?: Maybe<Scalars['String']['output']>;
  /**
   * The american odds for the bet in american format
   *   (e.g., -110, 110, -105, 105)
   */
  odds?: Maybe<Scalars['Float']['output']>;
  /** The side of the bet (Over, Under, Home, Away) */
  side?: Maybe<Scalars['String']['output']>;
};

export type LogoutMvpd = {
  __typename?: 'LogoutMVPD';
  actionName?: Maybe<Scalars['String']['output']>;
  actionType?: Maybe<Scalars['String']['output']>;
  mvpd?: Maybe<Scalars['String']['output']>;
};

export type LogoutMvpdResponse = {
  __typename?: 'LogoutMVPDResponse';
  logouts?: Maybe<Array<Maybe<LogoutMvpd>>>;
};

/** define mlb team standing type */
export type MlbTeamStanding = TeamSeasonStanding & {
  __typename?: 'MLBTeamStanding';
  /** league abbreviation */
  leagueAbbrev?: Maybe<Scalars['String']['output']>;
  /** Team's loss record */
  losses?: Maybe<Scalars['Int']['output']>;
  /** team season id */
  seasonId?: Maybe<Scalars['Int']['output']>;
  /** team CBS Id */
  teamId?: Maybe<Scalars['Int']['output']>;
  /** Team's tie record */
  ties?: Maybe<Scalars['Int']['output']>;
  /** The date and time the team was updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** winning percentage */
  winningPercentage?: Maybe<Scalars['String']['output']>;
  /** Team's win record */
  wins?: Maybe<Scalars['Int']['output']>;
};

/** Corner assignment (RED or BLUE) aligning with broadcast graphics and scoring forms. */
export enum MmaCorner {
  Blue = 'BLUE',
  Red = 'RED'
}

/**
 * Represents a UFC / Mixed Martial Arts event (fight night or numbered card).
 *
 * An event groups a set of scheduled fights (bouts) which may span multiple
 * card segments (e.g. Prelims vs Main Card). Some events provide only a
 * placeholder until the fight lineup is finalized.
 */
export type MmaEvent = SportsEvent & {
  __typename?: 'MMAEvent';
  /** Creation timestamp in persistence layer. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Paginated list of fights (bouts) associated with this event ordered by display order (main event first). */
  fights?: Maybe<MmaEventFightsConnection>;
  id: Scalars['ID']['output'];
  mainCardStartingAt?: Maybe<Scalars['DateTime']['output']>;
  /** Human readable marketing name supplied by vendor (e.g. UFC 320: Doe vs Smith). */
  name: Scalars['String']['output'];
  prelim1StartingAt?: Maybe<Scalars['DateTime']['output']>;
  prelim2StartingAt?: Maybe<Scalars['DateTime']['output']>;
  /** Scheduled start timestamp of the overall event. */
  scheduledTime?: Maybe<Scalars['DateTime']['output']>;
  /** High level lifecycle state of the event (scheduled, ongoing, completed, etc). */
  status?: Maybe<SportsEventStatus>;
  /** Last modification timestamp. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Venue object when location metadata is available; can be null before official assignment. */
  venue?: Maybe<Venue>;
};


/**
 * Represents a UFC / Mixed Martial Arts event (fight night or numbered card).
 *
 * An event groups a set of scheduled fights (bouts) which may span multiple
 * card segments (e.g. Prelims vs Main Card). Some events provide only a
 * placeholder until the fight lineup is finalized.
 */
export type MmaEventFightsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type MmaEventFightsConnection = {
  __typename?: 'MMAEventFightsConnection';
  edges: Array<Maybe<MmaEventFightsEdge>>;
  nodes: Array<Maybe<MmaFight>>;
  pageInfo: PageInfo;
};

export type MmaEventFightsEdge = {
  __typename?: 'MMAEventFightsEdge';
  cursor: Scalars['String']['output'];
  node: MmaFight;
};

/**
 * Represents a single fight (bout) between two competitors on an MMA event card.
 *
 * The ordering (`order`) is main-event-first (1 is the main event). For UI segment
 * controls, use `cardSegmentName` plus the segment start times from the parent event.
 *
 * Note: Some fights may be removed or replaced; clients should be resilient to
 * missing or null fields (e.g. venue or networks before confirmation).
 */
export type MmaFight = SportsMatch & {
  __typename?: 'MMAFight';
  /** Card segment name (e.g. Main, Prelim1, Prelim2). */
  cardSegmentName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** The MMA event that the fight will take place. */
  event: MmaEvent;
  /** Per fighter contextual details (corner, weigh-in, fighter reference, optional stats). */
  fighterDetails: Array<MmaMatchFighterDetails>;
  id: Scalars['ID']['output'];
  /** Indicates write-lock / administrative protection flag when true. */
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the fight is part of the main card. */
  isMainCard?: Maybe<Scalars['Boolean']['output']>;
  /** Owning league (e.g., UFC). */
  league: League;
  /** Display ordering where 1 = Main Event, 2 = Co-Main (if present), increasing. */
  order: Scalars['Int']['output'];
  /** Scheduled start time for the fight (aligns with card segment start time). */
  scheduledTime: Scalars['DateTime']['output'];
  /** Live / finalized scoring and time progression information. */
  scoreboard?: Maybe<MmaFightScoreboard>;
  /** Current primary status following generic MatchStatus taxonomy. */
  status: MatchStatus;
  /** Broadcast partners prioritized; ordering determined by backend (e.g., PAR+ then CBS). */
  tvNetworks?: Maybe<Array<TvNetwork>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  venue?: Maybe<Venue>;
  /** Weight class definition for this fight (normal, catchweight, etc). */
  weightClass: MmaWeightClass;
  /** List of winner players if resolved. */
  winnerPlayer?: Maybe<Array<Player>>;
};

export type MmaFightInput = {
  /** The segment of the fight card. Ex) Main, Prelims1, Prelims2, Prelims3 */
  cardType?: InputMaybe<Scalars['String']['input']>;
  /** The current round for the fight */
  currentRound?: InputMaybe<Scalars['Int']['input']>;
  /** The number of seconds elapsed in the current round */
  currentRoundSeconds?: InputMaybe<Scalars['Int']['input']>;
  /** The result of the fight */
  fightResult?: InputMaybe<MmaFightResultInput>;
  /** The match id associated with the mma match */
  matchId?: InputMaybe<DataEngIdentifier>;
  /** The order of the fight. Ex) The main event is match order = 1 */
  matchOrder?: InputMaybe<Scalars['Int']['input']>;
  /** The vendor unique identifier for the referee */
  refereeId?: InputMaybe<Scalars['Int']['input']>;
  /** The rule set description for the fight. Ex) 5 Rnd (5-5-5-5-5) */
  ruleSet?: InputMaybe<Scalars['String']['input']>;
  /** The weight class details for the fight. */
  weightClass?: InputMaybe<MmaWeightClassInput>;
};

export type MmaFightResultInput = {
  /** The note about the ending. Ex) 'Doctor Stoppage due to cut', 'Corner Stoppage', etc */
  endingNotes?: InputMaybe<Scalars['String']['input']>;
  /** The position at the end of the fight. Ex) At Distance, In Clinch, On Ground, From Guard, From Half Guard */
  endingPosition?: InputMaybe<Scalars['String']['input']>;
  /** The round in which the fight ended. */
  endingRound?: InputMaybe<Scalars['Int']['input']>;
  /** The strike that ended the fight. Ex) punch, elbow, knee, headbutt, etc */
  endingStrike?: InputMaybe<Scalars['String']['input']>;
  /** The submission that ended the fight. Ex) Armbar, Kimura, Keylock, Kneebar */
  endingSubmission?: InputMaybe<Scalars['String']['input']>;
  /** The target of the ending strike. Ex) Head, Body, Leg */
  endingTarget?: InputMaybe<Scalars['String']['input']>;
  /** The elapsed time in a 5-minute round, not the time remaining on the clock. */
  endingTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** Performance award at the discretion of UFC. Announced post-event. */
  fightOfTheNight?: InputMaybe<Scalars['Boolean']['input']>;
  /** The mma match id */
  matchId?: InputMaybe<DataEngIdentifier>;
  /** The method used at end of fight. Ex) KO/TKO, Submission, Decision, DQ */
  method?: InputMaybe<MmaResultMethod>;
};

/**
 * Represents the live and immediate post-fight scoreboard for an MMA bout, exposing evolving round-by-round data, in-fight statistics, and status/meta fields.
 * Population behavior:
 * - Live: Continuously updated in near real time while the fight is in progress.
 * - Post fight: Finalized shortly after conclusion with official results, then remains available for reference.
 * Caching note:
 * During a live match, this type is intentionally not aggressively cached (very low maxAge) to ensure clients can poll or refetch frequently for up-to-the-second updates.
 */
export type MmaFightScoreboard = {
  __typename?: 'MMAFightScoreboard';
  /** Number of the active or ending round. */
  currentRound?: Maybe<Scalars['Int']['output']>;
  /** Elapsed clock in the current round (formatted MM:SS). */
  elapsedTime?: Maybe<Scalars['String']['output']>;
  resultMethod?: Maybe<MmaResultMethod>;
  resultMethodDisplay?: Maybe<Scalars['String']['output']>;
  /** Per-round breakdown in chronological order. */
  rounds?: Maybe<Array<MmaRound>>;
  /** Remaining clock in the current round (formatted MM:SS), if available. This is calculated from the elapsed time by subtracting from standard 5 minute round time. */
  timeRemaining?: Maybe<Scalars['String']['output']>;
  /** Aggregate totals across all completed rounds for each fighter. */
  totalFighterStats?: Maybe<Array<MmaFighterStats>>;
};

export type MmaFighter = SportsPlayer & {
  __typename?: 'MMAFighter';
  /** Age, in years, is derived from DOB, when available. */
  age?: Maybe<Scalars['Int']['output']>;
  /** Country of birth (vendor string). */
  birthCountry?: Maybe<Scalars['String']['output']>;
  birthDate?: Maybe<Scalars['DateTime']['output']>;
  /** Declared 'fighting out of' location mapped to a Country when resolvable. */
  fightingOutOf?: Maybe<Country>;
  /** Localized or short given name where available. */
  firstName?: Maybe<Scalars['String']['output']>;
  fullFirstName?: Maybe<Scalars['String']['output']>;
  fullLastName?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['String']['output']>;
  homeTown?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  nationalityCountry?: Maybe<Scalars['String']['output']>;
  nationalityCountryCode?: Maybe<Scalars['String']['output']>;
  nickName?: Maybe<Scalars['String']['output']>;
  reach?: Maybe<Scalars['Int']['output']>;
  /** Career or current record snapshot (may change over time). */
  record?: Maybe<MmaFighterRecord>;
  /** Primary fighting stance or orientation (orthodox, southpaw, etc). */
  stance?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Int']['output']>;
};

export type MmaFighterRecord = {
  __typename?: 'MMAFighterRecord';
  /** Number of declared draws. */
  draws: Scalars['Int']['output'];
  /** Number of official losses. */
  losses: Scalars['Int']['output'];
  /** Number of no contest results. */
  noContests: Scalars['Int']['output'];
  /** Number of official wins including all decisions and finishes. */
  wins: Scalars['Int']['output'];
};

export type MmaFighterStats = {
  __typename?: 'MMAFighterStats';
  backControlTime?: Maybe<Scalars['String']['output']>;
  clinchControlTime?: Maybe<Scalars['String']['output']>;
  clinchTime?: Maybe<Scalars['String']['output']>;
  controlTime?: Maybe<Scalars['String']['output']>;
  distanceTime?: Maybe<Scalars['String']['output']>;
  /** Reference to the fighter whose stats these represent. */
  fighter: MmaFighter;
  groundControlTime?: Maybe<Scalars['String']['output']>;
  groundTime?: Maybe<Scalars['String']['output']>;
  guardControlTime?: Maybe<Scalars['String']['output']>;
  halfGuardControlTime?: Maybe<Scalars['String']['output']>;
  knockdowns?: Maybe<Scalars['Int']['output']>;
  miscGroundControlTime?: Maybe<Scalars['String']['output']>;
  mountControlTime?: Maybe<Scalars['String']['output']>;
  neutralTime?: Maybe<Scalars['String']['output']>;
  reversals?: Maybe<Scalars['Int']['output']>;
  sideControlTime?: Maybe<Scalars['String']['output']>;
  sigBodyStrikesAttempted?: Maybe<Scalars['Int']['output']>;
  sigBodyStrikesLanded?: Maybe<Scalars['Int']['output']>;
  sigClinchBodyStrikesAttempted?: Maybe<Scalars['Int']['output']>;
  sigClinchBodyStrikesLanded?: Maybe<Scalars['Int']['output']>;
  sigClinchHeadStrikesAttempted?: Maybe<Scalars['Int']['output']>;
  sigClinchHeadStrikesLanded?: Maybe<Scalars['Int']['output']>;
  sigClinchLegStrikesAttempted?: Maybe<Scalars['Int']['output']>;
  sigClinchLegStrikesLanded?: Maybe<Scalars['Int']['output']>;
  sigClinchStrikesAttempted?: Maybe<Scalars['Int']['output']>;
  sigClinchStrikesLanded?: Maybe<Scalars['Int']['output']>;
  sigDistanceBodyStrikesAttempted?: Maybe<Scalars['Int']['output']>;
  sigDistanceBodyStrikesLanded?: Maybe<Scalars['Int']['output']>;
  sigDistanceHeadStrikesAttempted?: Maybe<Scalars['Int']['output']>;
  sigDistanceHeadStrikesLanded?: Maybe<Scalars['Int']['output']>;
  sigDistanceLegStrikesAttempted?: Maybe<Scalars['Int']['output']>;
  sigDistanceLegStrikesLanded?: Maybe<Scalars['Int']['output']>;
  sigDistanceStrikesAttempted?: Maybe<Scalars['Int']['output']>;
  sigDistanceStrikesLanded?: Maybe<Scalars['Int']['output']>;
  sigGroundBodyStrikesAttempted?: Maybe<Scalars['Int']['output']>;
  sigGroundBodyStrikesLanded?: Maybe<Scalars['Int']['output']>;
  sigGroundHeadStrikesAttempted?: Maybe<Scalars['Int']['output']>;
  sigGroundHeadStrikesLanded?: Maybe<Scalars['Int']['output']>;
  sigGroundLegStrikesAttempted?: Maybe<Scalars['Int']['output']>;
  sigGroundLegStrikesLanded?: Maybe<Scalars['Int']['output']>;
  sigGroundStrikesAttempted?: Maybe<Scalars['Int']['output']>;
  sigGroundStrikesLanded?: Maybe<Scalars['Int']['output']>;
  sigHeadStrikesAttempted?: Maybe<Scalars['Int']['output']>;
  sigHeadStrikesLanded?: Maybe<Scalars['Int']['output']>;
  sigLegStrikesAttempted?: Maybe<Scalars['Int']['output']>;
  sigLegStrikesLanded?: Maybe<Scalars['Int']['output']>;
  sigStrikesAccuracy?: Maybe<Scalars['Float']['output']>;
  sigStrikesAttempted?: Maybe<Scalars['Int']['output']>;
  sigStrikesLanded?: Maybe<Scalars['Int']['output']>;
  standingTime?: Maybe<Scalars['String']['output']>;
  submissionsAttempted?: Maybe<Scalars['Int']['output']>;
  takedownsAccuracy?: Maybe<Scalars['Float']['output']>;
  takedownsAttempted?: Maybe<Scalars['Int']['output']>;
  takedownsLanded?: Maybe<Scalars['Int']['output']>;
  totalBodyStrikesAttempted?: Maybe<Scalars['Int']['output']>;
  totalBodyStrikesLanded?: Maybe<Scalars['Int']['output']>;
  totalClinchStrikesAttempted?: Maybe<Scalars['Int']['output']>;
  totalClinchStrikesLanded?: Maybe<Scalars['Int']['output']>;
  totalGroundStrikesAttempted?: Maybe<Scalars['Int']['output']>;
  totalGroundStrikesLanded?: Maybe<Scalars['Int']['output']>;
  totalHeadStrikesAttempted?: Maybe<Scalars['Int']['output']>;
  totalHeadStrikesLanded?: Maybe<Scalars['Int']['output']>;
  totalLegStrikesAttempted?: Maybe<Scalars['Int']['output']>;
  totalLegStrikesLanded?: Maybe<Scalars['Int']['output']>;
  totalStrikesAttempted?: Maybe<Scalars['Int']['output']>;
  totalStrikesLanded?: Maybe<Scalars['Int']['output']>;
};

export type MmaJudgeScoreInput = {
  /** The fighter id the judge's score is associated with */
  fighterId?: InputMaybe<DataEngIdentifier>;
  /** The first name of the judge for the fight */
  judgeFirstName?: InputMaybe<Scalars['String']['input']>;
  /** The last name of the judge for the fight */
  judgeLastName?: InputMaybe<Scalars['String']['input']>;
  /** The match id the judge's score is associated with */
  matchId?: InputMaybe<DataEngIdentifier>;
  /** The total score the judge gave the fighter for the fight */
  score?: InputMaybe<Scalars['Int']['input']>;
};

export type MmaMatchFighterDetails = {
  __typename?: 'MMAMatchFighterDetails';
  /** Corner color assignment; null if unassigned at early scheduling stage. */
  corner?: Maybe<MmaCorner>;
  /** Fighter entity reference. */
  fighter: MmaFighter;
  /** Aggregate stats for the fighter. */
  stats?: Maybe<MmaFighterStats>;
  /** Official weigh-in result in pounds (may be null before or if not recorded). */
  weighIn?: Maybe<Scalars['Float']['output']>;
};

/**
 * Method of victory for an MMA fight.
 * Draws are represented via fighter Outcome = "DRAW" with an appropriate decision method (e.g. DECISION_SPLIT).
 */
export enum MmaResultMethod {
  /** Could not continue (injury, corner stoppage, etc). */
  CouldNotContinue = 'COULD_NOT_CONTINUE',
  /** Generic decision (method not further classified). */
  Decision = 'DECISION',
  /** Decision - Majority. */
  DecisionMajority = 'DECISION_MAJORITY',
  /** Decision - Split. */
  DecisionSplit = 'DECISION_SPLIT',
  /** Decision - Unanimous. */
  DecisionUnanimous = 'DECISION_UNANIMOUS',
  /** Disqualification. */
  Dq = 'DQ',
  /** Knockout or technical knockout. */
  KoTko = 'KO_TKO',
  /** Other / unspecified method. */
  Other = 'OTHER',
  /** Result later overturned by commission. */
  Overturned = 'OVERTURNED',
  /** Submission (tap, verbal, technical). */
  Submission = 'SUBMISSION',
  /** Technical knockout via doctor's stoppage. */
  TkoDoctorsStoppage = 'TKO_DOCTORS_STOPPAGE'
}

export type MmaRound = {
  __typename?: 'MMARound';
  /** Per-fighter statistics for this specific round. */
  fighterStats: Array<MmaFighterStats>;
  /** Round sequence number starting at 1. */
  number: Scalars['Int']['output'];
};

/**
 * Weight class metadata. The `maxWeight` value represents the upper bound in pounds
 * for the contracted weight limit of the class (e.g., 155 for Lightweight).
 * Catchweight bouts may reference the nearest standard class while specifying
 * non-standard weigh-ins externally.
 */
export type MmaWeightClass = {
  __typename?: 'MMAWeightClass';
  id: Scalars['ID']['output'];
  maxWeight: Scalars['Float']['output'];
  name: Scalars['String']['output'];
};

export type MmaWeightClassInput = {
  /** The weight class id unique identifier */
  id?: InputMaybe<DataEngIdentifier>;
  /** The maximum weight in pounds for the weight class */
  maxWeightlbs?: InputMaybe<Scalars['Int']['input']>;
  /** The name of the weight class. Ex) Light Heavyweight, Middleweight, Heavyweight,etc */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type MvdpConfigurationResponse = {
  __typename?: 'MVDPConfigurationResponse';
  os?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<Scalars['String']['output']>;
  platformCategory?: Maybe<Scalars['String']['output']>;
  requestor?: Maybe<Requestor>;
};

export type MvpdProfilesInput = {
  mvpd: Scalars['String']['input'];
  serviceProvider?: InputMaybe<Scalars['String']['input']>;
};

/** market category type definition for player props projections, refer to market_category table */
export type MarketCategory = {
  __typename?: 'MarketCategory';
  category: BettingCategory;
  createdAt: Scalars['DateTime']['output'];
  league_id: Scalars['ID']['output'];
  market: BettingMarket;
  updatedAt: Scalars['DateTime']['output'];
};

export type MarketSeasonSplit = {
  __typename?: 'MarketSeasonSplit';
  /** The unique identifier for the market. */
  id: Scalars['ID']['output'];
  /**  The name of the market (e.g., Spread, Moneyline, Over/Under). */
  name: Scalars['String']['output'];
  /** The different splits (e.g., Location, Status, Head-to-Head) for this market. */
  splits: Array<SeasonSplit>;
};

/**
 * Represents performance data for a team in a specific situation.
 * Fields vary based on the type of market (e.g., Spread, Moneyline, Over/Under).
 */
export type MarketTeamSeasonRecord = {
  /** The specific situation this split represents (e.g., "At Home", "As Favorite"). */
  situation: Scalars['String']['output'];
  /** The team this split data belongs to. */
  team: Team;
};

export type MasterProduct = {
  __typename?: 'MasterProduct';
  appId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  disclosureList?: Maybe<Array<DisclosureList>>;
  fields?: Maybe<Array<MasterProductField>>;
  id?: Maybe<Scalars['Int']['output']>;
  leagueId?: Maybe<Scalars['Int']['output']>;
  modifiedAt?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nameAbbreviation?: Maybe<Scalars['String']['output']>;
  productLine?: Maybe<Scalars['Int']['output']>;
  serviceLevel?: Maybe<Scalars['Int']['output']>;
  serviceLevelName?: Maybe<Scalars['String']['output']>;
  spoeCategory?: Maybe<Scalars['String']['output']>;
  sport?: Maybe<SapiSport>;
  sportId?: Maybe<Scalars['Int']['output']>;
  typeId?: Maybe<Scalars['Int']['output']>;
  typeName?: Maybe<Scalars['String']['output']>;
  vendorId?: Maybe<Scalars['Int']['output']>;
  vendorName?: Maybe<Scalars['String']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

export type MasterProductField = {
  __typename?: 'MasterProductField';
  apiName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
};

export type MasterProductInput = {
  clientName?: InputMaybe<Scalars['String']['input']>;
  productId: Scalars['Int']['input'];
};

/** Represents a match in sports like tennis */
export type Match = SportsMatch & {
  __typename?: 'Match';
  /** The abbreviation for the match */
  abbrev: Scalars['String']['output'];
  /** The competition associated with this match */
  competition: Competition;
  /** The competitors involved in the match */
  competitors?: Maybe<MatchCompetitors>;
  /** The date and time the match was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** The extended status for the match */
  extendedStatus?: Maybe<MatchExtendedStatus>;
  /** The unique identifier of the match */
  id: Scalars['ID']['output'];
  /** The boolean flag if scheduled time is estimated */
  isEstimated?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the match is locked (1) or not (0) */
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  /** The league associated with this match */
  league: League;
  /** The round of the match */
  round?: Maybe<MatchRound>;
  /** The scheduled time for the match */
  scheduledTime: Scalars['DateTime']['output'];
  /** The scheduled time in seconds since the epoch (Unix time) */
  scheduledTimeEpoch: Scalars['Int']['output'];
  /** The scoreboard for the match */
  scores?: Maybe<TennisScoreboard>;
  /** The season associated with this match */
  season: CompetitionSeason;
  /** The status of the match */
  status: MatchStatus;
  /** The television broadcast information for the match */
  tvNetworks?: Maybe<Array<TvNetwork>>;
  /** The date and time the match was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The venue for the match */
  venue?: Maybe<Venue>;
  /** The winning player(s), if applicable */
  winnerPlayer?: Maybe<Array<Player>>;
};

/** The competitor's profile. */
export type MatchCompetitorProfile = {
  __typename?: 'MatchCompetitorProfile';
  /** The id of the competitor pair for a double's match. */
  pairId?: Maybe<Scalars['ID']['output']>;
  /** The competitor for the match. */
  player: Player;
  /** The competitor. */
  playerId: Scalars['ID']['output'];
  /** The competitor's seed in the tournament. */
  seed?: Maybe<Scalars['Int']['output']>;
};

/** The competitors involved in a match. */
export type MatchCompetitors = {
  __typename?: 'MatchCompetitors';
  /** The away competitor involved in the match. */
  away: Array<MatchCompetitorProfile>;
  /** The home competitor involved in the match. */
  home: Array<MatchCompetitorProfile>;
};

/** Input for competitors involved in a match */
export type MatchCompetitorsInput = {
  /** The away competitor(s) involved in the match */
  away: Array<TennisCompetitorProfileInput>;
  /** The home competitor(s) involved in the match */
  home: Array<TennisCompetitorProfileInput>;
};

/**
 * The extended status of a match, providing more detailed information about the match's current state.
 *
 * not_started – The match is scheduled to be played (SCHEDULED)
 * match_about_to_start – The match time has expired, awaiting play (SCHEDULED)
 * start_delayed – The match has been temporarily delayed and will be continued. Matches are manually moved to this status 15 minutes after the scheduled start time. (SCHEDULED)
 * started – The match has begun (IN_PROGRESS)
 * 1st_set – First set (IN_PROGRESS)
 * 2nd_set – Second set (IN_PROGRESS)
 * 3rd_set – Third set (IN_PROGRESS)
 * 4th_set – Fourth set (IN_PROGRESS)
 * 5th_set – Fifth set (IN_PROGRESS)
 * interrupted – The match began, but is stopped for a short time (IN_PROGRESS)
 * suspended – The match began, but has been suspended to a later time (SUSPENDED)
 * ended – The match is over (FINAL)
 * walkover – The match ended in a walkover (FINAL)
 * retired – The match is incomplete due to the retirement of one player (FINAL)
 * defaulted – The match has ended as a result of one player being disqualified (FINAL)
 * abandoned – The match has been abandoned (CANCELED)
 * cancelled – The match has been cancelled and will not be played (CANCELED)
 * postponed – The match has been postponed to a future date (POSTPONED)
 */
export enum MatchExtendedStatus {
  Abandoned = 'ABANDONED',
  Cancelled = 'CANCELLED',
  Defaulted = 'DEFAULTED',
  Ended = 'ENDED',
  FifthSet = 'FIFTH_SET',
  FirstSet = 'FIRST_SET',
  FourthSet = 'FOURTH_SET',
  Interrupted = 'INTERRUPTED',
  MatchAboutToStart = 'MATCH_ABOUT_TO_START',
  NotStarted = 'NOT_STARTED',
  Postponed = 'POSTPONED',
  Retired = 'RETIRED',
  SecondSet = 'SECOND_SET',
  Started = 'STARTED',
  StartDelayed = 'START_DELAYED',
  Suspended = 'SUSPENDED',
  ThirdSet = 'THIRD_SET',
  Walkover = 'WALKOVER'
}

/**
 * The round of a match
 *
 * qualification - General term for the qualification stage, where players compete for entry into the main draw
 * qualification_final - The final round of the qualification stage
 * qualification_round_1 - First round of the qualification stage
 * qualification_round_2 - Second round of the qualification stage
 * round_1 - First round match
 * round_2 - Second round match
 * round_3 - Third round match
 * round_of_256 - Round with 256 players/teams remaining (128 matches)
 * round_of_128 - Round with 128 players/teams remaining (64 matches)
 * round_of_64 - Round with 64 players/teams remaining (32 matches)
 * round_of_32 - Round with 32 players/teams remaining (16 matches)
 * round_of_16 - Round with 16 players/teams remaining (8 matches)
 * quarterfinal - Round with 8 players/teams remaining (4 matches)
 * semifinal - Round with 4 players/teams remaining (2 matches)
 * final - The championship match between the last 2 players/teams
 * 3rd_place_playoff - A match to determine third place
 * 3rd_place_final - Alternative naming for the third-place playoff
 * 5th_place_final - A match to determine who finishes in fifth place
 * 7th_place_final - A match to determine who finishes in seventh place
 */
export enum MatchRound {
  FifthPlaceFinal = 'FIFTH_PLACE_FINAL',
  Final = 'FINAL',
  Qualification = 'QUALIFICATION',
  QualificationFinal = 'QUALIFICATION_FINAL',
  QualificationRound_1 = 'QUALIFICATION_ROUND_1',
  QualificationRound_2 = 'QUALIFICATION_ROUND_2',
  Quarterfinal = 'QUARTERFINAL',
  Round_1 = 'ROUND_1',
  Round_2 = 'ROUND_2',
  Round_3 = 'ROUND_3',
  RoundOf_16 = 'ROUND_OF_16',
  RoundOf_32 = 'ROUND_OF_32',
  RoundOf_64 = 'ROUND_OF_64',
  RoundOf_128 = 'ROUND_OF_128',
  RoundOf_256 = 'ROUND_OF_256',
  Semifinal = 'SEMIFINAL',
  SeventhPlaceFinal = 'SEVENTH_PLACE_FINAL',
  ThirdPlaceFinal = 'THIRD_PLACE_FINAL',
  ThirdPlacePlayoff = 'THIRD_PLACE_PLAYOFF'
}

/** Fields available for sorting matches - status, scheduled_time, id */
export enum MatchSortField {
  Id = 'ID',
  ScheduledTime = 'SCHEDULED_TIME',
  Status = 'STATUS'
}

/**
 * Defines sorting options for matches. You can specify a field (e.g., status, scheduled_time, or id)
 * with an order (ascending or descending) or use a field (e.g status) with a prioritized list of match statuses for custom sorting.
 */
export type MatchSortInput = {
  field: MatchSortField;
  order?: InputMaybe<SortOrder>;
  value?: InputMaybe<Array<MatchStatus>>;
};

/** The status of a match */
export enum MatchStatus {
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Delayed = 'DELAYED',
  Final = 'FINAL',
  InProgress = 'IN_PROGRESS',
  Postponed = 'POSTPONED',
  Rescheduled = 'RESCHEDULED',
  Scheduled = 'SCHEDULED',
  Suspended = 'SUSPENDED',
  Tba = 'TBA'
}

export type MaxRating = {
  __typename?: 'MaxRating';
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Value>;
};

export type MetaData = {
  __typename?: 'MetaData';
  tpid?: Maybe<Scalars['String']['output']>;
};

/** Input type for creating or updating an MMA fighter/player */
export type MmaFighterInput = {
  /** Fighter's birth country */
  birthCountry?: InputMaybe<Scalars['String']['input']>;
  /** Fighter's birth date */
  birthDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Fighter's professional debut date */
  debutDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Total professional fight draws */
  draws?: InputMaybe<Scalars['Int']['input']>;
  /** Years of professional experience */
  experience?: InputMaybe<Scalars['Int']['input']>;
  /** Country name the fighter represents/fights out of (e.g., 'United States', 'Netherlands', 'Brazil') */
  fightingOutOfCountry?: InputMaybe<Scalars['String']['input']>;
  /** Fighter's first name (required if create) */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Fighter's full first name */
  fullFirstName?: InputMaybe<Scalars['String']['input']>;
  /** Fighter's full last name */
  fullLastName?: InputMaybe<Scalars['String']['input']>;
  /** Fighter's height in whole inches (e.g., '74') */
  height?: InputMaybe<Scalars['Int']['input']>;
  /** Fighter's hometown */
  homeTown?: InputMaybe<Scalars['String']['input']>;
  /** Player identifier - can use internal ID or vendor ID (required if update) */
  id?: InputMaybe<DataEngIdentifier>;
  /** Fighter's last name (required if create) */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Whether the fighter record is locked for updates */
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  /** Total professional fight losses */
  losses?: InputMaybe<Scalars['Int']['input']>;
  /** Fighter's nationality country */
  nationalityCountry?: InputMaybe<Scalars['String']['input']>;
  /** Fighter's nickname */
  nickName?: InputMaybe<Scalars['String']['input']>;
  /** Total professional no contest results */
  noContests?: InputMaybe<Scalars['Int']['input']>;
  /** Fighter's reach in inches */
  reach?: InputMaybe<Scalars['Float']['input']>;
  /** Fighter's training school/gym */
  school?: InputMaybe<Scalars['String']['input']>;
  /** Fighter's stance (Orthodox, Southpaw, Switch, etc.) */
  stance?: InputMaybe<Scalars['String']['input']>;
  /** Fighter's weight in pounds */
  weight?: InputMaybe<Scalars['Int']['input']>;
  /** Total professional fight wins */
  wins?: InputMaybe<Scalars['Int']['input']>;
};

/** Represent a moneyline game leg of a parlay where betType='game' and marketName='moneyline' */
export type MoneyLineGameLeg = GameLeg & Leg & {
  __typename?: 'MoneyLineGameLeg';
  /** The type of bet being placed. */
  betType: Scalars['String']['output'];
  /** The CBS book identifier. */
  cbsBookId: Scalars['Int']['output'];
  /** cbsMarketAbbrev */
  cbsMarketAbbrev?: Maybe<Scalars['String']['output']>;
  /** The CBS market identifier. */
  cbsMarketId?: Maybe<Scalars['Int']['output']>;
  /** The name of the CBS market. */
  cbsMarketName?: Maybe<Scalars['String']['output']>;
  /** The bettor's edge for the bet. */
  edge: Scalars['Float']['output'];
  /** Expert Picks for the same game, team, and market id */
  expertPicks?: Maybe<ExpertPicksConnection>;
  /** Represents a game in the parlay. */
  game: Game;
  /** The id of the Leg */
  id: Scalars['ID']['output'];
  /** Additional insight or information about the bet. */
  insight?: Maybe<Scalars['String']['output']>;
  /** The american odds for the bet. */
  odds?: Maybe<Scalars['Float']['output']>;
  /** The projected score used for the parlay */
  parlayProjectedScore?: Maybe<ParlayProjectedScore>;
  /** The side of the bet. */
  side?: Maybe<Scalars['String']['output']>;
  /** Represents the team picked in the moneyline bet. */
  team?: Maybe<Team>;
};


/** Represent a moneyline game leg of a parlay where betType='game' and marketName='moneyline' */
export type MoneyLineGameLegExpertPicksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ParlayLegExpertPickFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Array<ExpertPickSortByInput>>;
};

export type Mutation = {
  __typename?: 'Mutation';
  authenticatedPasswordChange?: Maybe<AuthenticationDetails>;
  cancelSubscription?: Maybe<RecurlySubscriptionResponse>;
  cmsPollCastVote: CmsPollVoteResult;
  cmsPollCastVotes: CmsPollVoteResult;
  cmsPollVoteAccessToken?: Maybe<CmsPollAccessToken>;
  cmsPollVotesAccessToken?: Maybe<CmsPollAccessToken>;
  createAuthenticationSession?: Maybe<AuthenticationSessionResponse>;
  createGraphic: Graphic;
  createGraphicExport: GraphicExport;
  createGraphicScheduleTask: GraphicScheduleTask;
  createGraphicTag: Scalars['Boolean']['output'];
  /** Create a Graphics Card. */
  createGraphicsCard?: Maybe<GraphicsCard>;
  createGraphicsUser: GraphicsUser;
  createMVPDUser?: Maybe<SapiUserMvpd>;
  createNewsletterSubscription: Array<Maybe<CbsSportsNewsletterSubscription>>;
  createOneTimePurchase?: Maybe<CreateOneTimePurchaseResponse>;
  createOpenWebUser: UpdateOpenWebUserResponse;
  /** @deprecated Use createPurchaseV2 */
  createPurchase?: Maybe<RecurlyInvoiceCollection>;
  createPurchaseV2?: Maybe<ProcessPaymentResponse>;
  createRecurlySubscription?: Maybe<RecurlySubscriptionResponse>;
  createRecurlySubscriptionChange?: Maybe<RecurlyPendingChange>;
  /** @deprecated Use createUserV2 */
  createUser?: Maybe<CreateUser>;
  createUserProfile?: Maybe<UserProfile>;
  createUserSubscription: UserSubscription;
  createUserV2?: Maybe<CreateUserResult>;
  /** Create an X Handle. */
  createXHandle?: Maybe<XHandle>;
  /** Create an X Tweet. */
  createXTweet?: Maybe<XTweet>;
  deleteGraphic: Scalars['Boolean']['output'];
  deleteGraphicExport: Scalars['Boolean']['output'];
  deleteGraphicScheduleTask: Scalars['Boolean']['output'];
  deleteGraphicScheduleTasks: Array<GraphicScheduleTaskDeleteManyResponse>;
  deleteGraphicTag: Scalars['Boolean']['output'];
  deleteGraphics: Array<GraphicDeleteManyResponse>;
  deleteGraphicsUser: Scalars['Boolean']['output'];
  deleteMVPDUser?: Maybe<SapiUserMvpd>;
  deleteNewsletterConfig: Scalars['Boolean']['output'];
  deleteOpenWebUser: DeleteOpenWebUserResponse;
  forgotPassword?: Maybe<ForgotPassword>;
  generateSportsEntityId: GenerateSportsEntityIdOutput;
  initiateMVPDLogout?: Maybe<LogoutMvpdResponse>;
  linkMVPDUser?: Maybe<SapiUserMvpd>;
  linkSocial?: Maybe<SocialDetails>;
  /** @deprecated Use userAuth instead */
  loginUser: AuthenticationDetails;
  oneTimePassword: OneTimePasswordResult;
  previewRecurlySubscriptionChange?: Maybe<RecurlyPendingChange>;
  previewSubscriptionPurchase?: Maybe<ProcessPaymentResponse>;
  reactivateSubscription?: Maybe<RecurlySubscriptionResponse>;
  recurlyDeactivateCouponCode?: Maybe<RecurlyUniqueCouponCode>;
  recurlyUpdateAccount?: Maybe<RecurlyUpdateAccountResponse>;
  registerOpenWebUser: RegisterOpenWebUserResponse;
  removeNewsletterSubscription: Array<Maybe<CbsSportsNewsletterSubscription>>;
  removeOpenWebUser: RegisterOpenWebUserResponse;
  removeTeamFromBracketology?: Maybe<RemoveTeamFromBracketologyResponse>;
  removeUserProductSignup?: Maybe<UserProductSignup>;
  /** @deprecated Use resetPasswordV2 */
  resetPassword?: Maybe<ResetPassword>;
  resetPasswordV2?: Maybe<ResetPasswordResult>;
  revokeOpenWebOptIn: RegisterOpenWebUserResponse;
  signupNewsletterSubscriptions: Array<CbsSportsNewsletterSubscription>;
  socialAuth: AuthenticationDetails;
  /** Adds a user to the guild using an authorization code. The authorization code will be retrieved from the Discord OAuth2 flow. */
  sportslineDiscordAddUserToGuild?: Maybe<SportslineDiscordGuildUser>;
  /** Update the rol of the current user logged in sportsline with the discord user and returns the user's discord guild url */
  sportslineDiscordUserSync?: Maybe<Scalars['String']['output']>;
  /** Sync the user role in discord with the user role in sapi by sapiUserId */
  sportslineDiscordUserSyncBySapiUserId?: Maybe<SportslineDiscordUserDb>;
  toggleGraphicScheduleTaskStatus: GraphicScheduleTask;
  unlinkMVPDUser?: Maybe<SapiUserMvpd>;
  unlinkSocial?: Maybe<SocialDetails>;
  updateBracketByTeamId?: Maybe<GetBracketologyDataByTeamIdResponse>;
  updateBracketologyData?: Maybe<GetBracketologyDataResponse>;
  updateBubblewatchByTeamId?: Maybe<GetBracketologyDataByTeamIdResponse>;
  updateGraphic: Graphic;
  updateGraphicExport: GraphicExport;
  updateGraphicScheduleTask: GraphicScheduleTask;
  updateGraphicTags: Scalars['Boolean']['output'];
  /** Update a Graphics Card. */
  updateGraphicsCard?: Maybe<GraphicsCard>;
  updateGraphicsUser: GraphicsUser;
  updateIterableUserEmail?: Maybe<UpdateIterableUserEmailResponse>;
  updateIterableUserSubscription: UpdateIterableUserSubscriptionResponse;
  updateIterableUserSubscriptions?: Maybe<UpdateIterableUserSubscriptionsResponse>;
  updateNewsletterConfig: NewsletterConfigs;
  updateNewsletterSiteDisplayOrder: Array<Scalars['Int']['output']>;
  updateNewsletterSubscriptions: Array<CbsSportsNewsletterSubscription>;
  updateOpenWebDetails: UpdateOpenWebUserResponse;
  updateSosByTeamId?: Maybe<GetBracketologyDataByTeamIdResponse>;
  updateSubscription?: Maybe<RecurlySubscriptionResponse>;
  updateTierWonLossMetadataByTeamId?: Maybe<GetBracketologyDataByTeamIdResponse>;
  updateTourneyLocations?: Maybe<UpdateTourneyLocationsResponse>;
  updateUser?: Maybe<UserDetails>;
  updateUserMVPD?: Maybe<SapiUserMvpd>;
  updateUserPreferences?: Maybe<UserPreferences>;
  updateUserTeamPreferences?: Maybe<UpdateUserTeamPreferences>;
  updateUserV2?: Maybe<UpdateUserDetails>;
  /** Update an X Handle. */
  updateXHandle?: Maybe<XHandle>;
  /** Update an X Tweet. */
  updateXTweet?: Maybe<XTweet>;
  upsertMMAFight: Array<UpsertMmaFightResult>;
  /** Creates or updates MMA fighters in batch (max 100) returning results with possible multiple inline errors per fighter (order aligns with inputs) */
  upsertMmaFighter: Array<UpsertMmaFighterResult>;
  /** Creates or updates a market */
  upsertPropsMarket: UpsertSidelinesMarketResult;
  /** Creates or updates multiple markets */
  upsertPropsMarketBatch: Array<UpsertSidelinesMarketResult>;
  /** Creates or updates a match */
  upsertTennisMatch: Match;
  /** Creates or updates matches (V2) in batch (max 100) returning results with possible multiple inline errors per match (order aligns with inputs) */
  upsertTennisMatchV2: Array<UpsertTennisMatchV2Result>;
  /** Creates or updates tournaments in batch (max 100) returning results with possible multiple inline errors per tournament (order aligns with inputs) */
  upsertTennisTournament: Array<UpsertTennisTournamentResult>;
  userAuth: AuthenticationResult;
  userProductSignup?: Maybe<UserProductSignup>;
};


export type MutationAuthenticatedPasswordChangeArgs = {
  input: AuthenticatedPasswordChangeInput;
};


export type MutationCancelSubscriptionArgs = {
  input: RecurlyCancelSubscriptionInput;
};


export type MutationCmsPollCastVoteArgs = {
  input: CmsPollCastVoteInput;
};


export type MutationCmsPollCastVotesArgs = {
  input: CmsPollCastVotesInput;
};


export type MutationCmsPollVoteAccessTokenArgs = {
  input: CmsPollVoteAccessTokenInput;
};


export type MutationCmsPollVotesAccessTokenArgs = {
  input: CmsPollVotesAccessTokenInput;
};


export type MutationCreateAuthenticationSessionArgs = {
  input?: InputMaybe<CreateAuthenticationSessionInput>;
};


export type MutationCreateGraphicArgs = {
  input: CreateGraphicInput;
};


export type MutationCreateGraphicExportArgs = {
  input: CreateGraphicExportInput;
};


export type MutationCreateGraphicScheduleTaskArgs = {
  input: CreateGraphicScheduleTaskInput;
};


export type MutationCreateGraphicTagArgs = {
  name: Scalars['String']['input'];
};


export type MutationCreateGraphicsCardArgs = {
  create: GraphicsCardCreate;
};


export type MutationCreateGraphicsUserArgs = {
  input: CreateGraphicsUserInput;
};


export type MutationCreateMvpdUserArgs = {
  input: SapiUserMvpdInput;
};


export type MutationCreateNewsletterSubscriptionArgs = {
  input: CreateSubscriptionInput;
};


export type MutationCreateOneTimePurchaseArgs = {
  input: CreateOneTimePurchaseInput;
};


export type MutationCreateOpenWebUserArgs = {
  input: CreateOpenWebUserInput;
};


export type MutationCreatePurchaseArgs = {
  input: CreatePurchaseInput;
};


export type MutationCreatePurchaseV2Args = {
  input: CreatePurchaseInput;
};


export type MutationCreateRecurlySubscriptionArgs = {
  input: CreateRecurlySubscriptionInput;
};


export type MutationCreateRecurlySubscriptionChangeArgs = {
  input: CreateRecurlySubscriptionChangeInput;
};


export type MutationCreateUserArgs = {
  input: UserCreateInput;
};


export type MutationCreateUserProfileArgs = {
  input: CreateUserProfileInput;
};


export type MutationCreateUserSubscriptionArgs = {
  input: CreateUserSubscriptionInput;
};


export type MutationCreateUserV2Args = {
  input: UserCreateInput;
};


export type MutationCreateXHandleArgs = {
  create: XHandleCreate;
};


export type MutationCreateXTweetArgs = {
  create: XTweetCreate;
};


export type MutationDeleteGraphicArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteGraphicExportArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteGraphicScheduleTaskArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteGraphicScheduleTasksArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteGraphicTagArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteGraphicsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteGraphicsUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteMvpdUserArgs = {
  input: SapiUserMvpdInput;
};


export type MutationDeleteNewsletterConfigArgs = {
  mpid: Scalars['Int']['input'];
};


export type MutationDeleteOpenWebUserArgs = {
  input: DeleteOpenWebUserInput;
};


export type MutationForgotPasswordArgs = {
  input: ForgotPasswordInput;
};


export type MutationGenerateSportsEntityIdArgs = {
  input: GenerateSportsEntityIdInput;
};


export type MutationInitiateMvpdLogoutArgs = {
  input?: InputMaybe<InitiateMvpdLogoutInput>;
};


export type MutationLinkMvpdUserArgs = {
  input: SapiUserMvpdInput;
};


export type MutationLinkSocialArgs = {
  input: SocialLinkInput;
};


export type MutationLoginUserArgs = {
  input: UserAuthenticationInput;
};


export type MutationOneTimePasswordArgs = {
  input: OneTimePasswordInput;
};


export type MutationPreviewRecurlySubscriptionChangeArgs = {
  input: CreateRecurlySubscriptionChangeInput;
};


export type MutationPreviewSubscriptionPurchaseArgs = {
  input: PreviewSubscriptionPurchaseInput;
};


export type MutationReactivateSubscriptionArgs = {
  subscriptionId: Scalars['String']['input'];
};


export type MutationRecurlyDeactivateCouponCodeArgs = {
  id: Scalars['String']['input'];
};


export type MutationRecurlyUpdateAccountArgs = {
  input: RecurlyUpdateAccountInput;
};


export type MutationRegisterOpenWebUserArgs = {
  input: RegisterOpenWebUserInput;
};


export type MutationRemoveNewsletterSubscriptionArgs = {
  input: RemoveSubscriptionInput;
};


export type MutationRemoveTeamFromBracketologyArgs = {
  teamId: Scalars['Int']['input'];
};


export type MutationRemoveUserProductSignupArgs = {
  input: RemoveUserProductSignupInput;
};


export type MutationResetPasswordArgs = {
  input: ResetPasswordInput;
};


export type MutationResetPasswordV2Args = {
  input: ResetPasswordInput;
};


export type MutationSignupNewsletterSubscriptionsArgs = {
  input: SignupNewslettersInput;
};


export type MutationSocialAuthArgs = {
  input: UserSocialAuthInput;
};


export type MutationSportslineDiscordAddUserToGuildArgs = {
  authCode: Scalars['ID']['input'];
};


export type MutationSportslineDiscordUserSyncBySapiUserIdArgs = {
  sapiUserId: Scalars['String']['input'];
};


export type MutationToggleGraphicScheduleTaskStatusArgs = {
  active: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};


export type MutationUnlinkMvpdUserArgs = {
  input: SapiUserMvpdInput;
};


export type MutationUnlinkSocialArgs = {
  input: SocialUnlinkInput;
};


export type MutationUpdateBracketByTeamIdArgs = {
  teamId: Scalars['Int']['input'];
  updateBracketInput: BracketTeamInput;
};


export type MutationUpdateBracketologyDataArgs = {
  input: BracketologyDataInput;
};


export type MutationUpdateBubblewatchByTeamIdArgs = {
  teamId: Scalars['Int']['input'];
  updateBubbleWatchInput: BubbleWatchInput;
};


export type MutationUpdateGraphicArgs = {
  id: Scalars['ID']['input'];
  input: UpdateGraphicInput;
};


export type MutationUpdateGraphicExportArgs = {
  id: Scalars['ID']['input'];
  input: UpdateGraphicExportInput;
};


export type MutationUpdateGraphicScheduleTaskArgs = {
  id: Scalars['ID']['input'];
  input: UpdateGraphicScheduleTaskInput;
};


export type MutationUpdateGraphicTagsArgs = {
  id: Scalars['ID']['input'];
  tags: Array<Scalars['String']['input']>;
};


export type MutationUpdateGraphicsCardArgs = {
  update: GraphicsCardUpdate;
};


export type MutationUpdateGraphicsUserArgs = {
  id: Scalars['ID']['input'];
  input: UpdateGraphicsUserInput;
};


export type MutationUpdateIterableUserEmailArgs = {
  input: UpdateIterableUserEmailInput;
};


export type MutationUpdateIterableUserSubscriptionArgs = {
  input: UpdateIterableUserSubscriptionInput;
};


export type MutationUpdateIterableUserSubscriptionsArgs = {
  input: UpdateIterableUserSubscriptionsInput;
};


export type MutationUpdateNewsletterConfigArgs = {
  input: NewsletterConfigsInput;
};


export type MutationUpdateNewsletterSiteDisplayOrderArgs = {
  input: NewsletterSiteDisplayOrderInput;
};


export type MutationUpdateNewsletterSubscriptionsArgs = {
  input: UpdateSubscriptionsInput;
};


export type MutationUpdateOpenWebDetailsArgs = {
  input: UpdateOpenWebUserInput;
};


export type MutationUpdateSosByTeamIdArgs = {
  teamId: Scalars['Int']['input'];
  updateStrengthOfScheduleInput: StrengthOfScheduleInput;
};


export type MutationUpdateSubscriptionArgs = {
  input: RecurlyUpdateSubscriptionInput;
};


export type MutationUpdateTierWonLossMetadataByTeamIdArgs = {
  teamId: Scalars['Int']['input'];
  updateTierWonLossInput: TierWonLossInput;
};


export type MutationUpdateTourneyLocationsArgs = {
  pods: Array<PodInput>;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationUpdateUserMvpdArgs = {
  input: SapiUserMvpdInput;
};


export type MutationUpdateUserPreferencesArgs = {
  input: UserPreferencesInput;
};


export type MutationUpdateUserTeamPreferencesArgs = {
  input: UpdateUserTeamPreferencesInput;
};


export type MutationUpdateUserV2Args = {
  input: UpdateUserInput;
};


export type MutationUpdateXHandleArgs = {
  update: XHandleUpdate;
};


export type MutationUpdateXTweetArgs = {
  update: XTweetUpdate;
};


export type MutationUpsertMmaFightArgs = {
  inputs: Array<MmaFightInput>;
};


export type MutationUpsertMmaFighterArgs = {
  inputs: Array<MmaFighterInput>;
};


export type MutationUpsertPropsMarketArgs = {
  input: SidelinesMarketInput;
};


export type MutationUpsertPropsMarketBatchArgs = {
  inputs: Array<SidelinesMarketInput>;
};


export type MutationUpsertTennisMatchArgs = {
  input: TennisMatchInput;
};


export type MutationUpsertTennisMatchV2Args = {
  inputs: Array<TennisMatchInput>;
};


export type MutationUpsertTennisTournamentArgs = {
  inputs: Array<TennisTournamentInput>;
};


export type MutationUserAuthArgs = {
  input: UserAuthenticationInput;
};


export type MutationUserProductSignupArgs = {
  input: UserProductSignupInput;
};

export type Mvpd = {
  __typename?: 'Mvpd';
  authPerAggregator?: Maybe<Scalars['Boolean']['output']>;
  authPerBrowserSession?: Maybe<Scalars['Boolean']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isProxy?: Maybe<Scalars['Boolean']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  passiveAuthnEnabled?: Maybe<Scalars['Boolean']['output']>;
};

/** define nba team standing type */
export type NbaTeamStanding = TeamSeasonStanding & {
  __typename?: 'NBATeamStanding';
  /** league abbreviation */
  leagueAbbrev?: Maybe<Scalars['String']['output']>;
  /** Team's loss record */
  losses?: Maybe<Scalars['Int']['output']>;
  /** team season id */
  seasonId?: Maybe<Scalars['Int']['output']>;
  /** team CBS Id */
  teamId?: Maybe<Scalars['Int']['output']>;
  /** Team's tie record */
  ties?: Maybe<Scalars['Int']['output']>;
  /** The date and time the team was updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** winning percentage */
  winningPercentage?: Maybe<Scalars['String']['output']>;
  /** Team's win record */
  wins?: Maybe<Scalars['Int']['output']>;
};

/** define ncaaf team standing type */
export type NcaabTeamStanding = TeamSeasonStanding & {
  __typename?: 'NCAABTeamStanding';
  /** league abbreviation */
  leagueAbbrev?: Maybe<Scalars['String']['output']>;
  /** Team's loss record */
  losses?: Maybe<Scalars['Int']['output']>;
  /** team season id */
  seasonId?: Maybe<Scalars['Int']['output']>;
  /** team CBS Id */
  teamId?: Maybe<Scalars['Int']['output']>;
  /** Team's tie record */
  ties?: Maybe<Scalars['Int']['output']>;
  /** The date and time the team was updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** winning percentage */
  winningPercentage?: Maybe<Scalars['String']['output']>;
  /** Team's win record */
  wins?: Maybe<Scalars['Int']['output']>;
};

/** define ncaaf team standing type */
export type NcaafTeamStanding = TeamSeasonStanding & {
  __typename?: 'NCAAFTeamStanding';
  /** league abbreviation */
  leagueAbbrev?: Maybe<Scalars['String']['output']>;
  /** Team's loss record */
  losses?: Maybe<Scalars['Int']['output']>;
  /** team season id */
  seasonId?: Maybe<Scalars['Int']['output']>;
  /** team CBS Id */
  teamId?: Maybe<Scalars['Int']['output']>;
  /** Team's tie record */
  ties?: Maybe<Scalars['Int']['output']>;
  /** The date and time the team was updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** winning percentage */
  winningPercentage?: Maybe<Scalars['String']['output']>;
  /** Team's win record */
  wins?: Maybe<Scalars['Int']['output']>;
};

/** define nfl team standing type */
export type NflTeamStanding = TeamSeasonStanding & {
  __typename?: 'NFLTeamStanding';
  /** league abbreviation */
  leagueAbbrev?: Maybe<Scalars['String']['output']>;
  /** Team's loss record */
  losses?: Maybe<Scalars['Int']['output']>;
  /** team season id */
  seasonId?: Maybe<Scalars['Int']['output']>;
  /** team CBS Id */
  teamId?: Maybe<Scalars['Int']['output']>;
  /** Team's tie record */
  ties?: Maybe<Scalars['Int']['output']>;
  /** The date and time the team was updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** winning percentage .667 */
  winningPercentage?: Maybe<Scalars['String']['output']>;
  /** Team's win record */
  wins?: Maybe<Scalars['Int']['output']>;
};

/** define nhl team standing type */
export type NhlTeamStanding = TeamSeasonStanding & {
  __typename?: 'NHLTeamStanding';
  /** league abbreviation */
  leagueAbbrev?: Maybe<Scalars['String']['output']>;
  /** Team's loss record */
  losses?: Maybe<Scalars['Int']['output']>;
  /** Team's overtime loss record */
  otLosses?: Maybe<Scalars['Int']['output']>;
  /** Team's overtime win record */
  otWins?: Maybe<Scalars['Int']['output']>;
  /** team season id */
  seasonId?: Maybe<Scalars['Int']['output']>;
  /** team CBS Id */
  teamId?: Maybe<Scalars['Int']['output']>;
  /** Team's tie record */
  ties?: Maybe<Scalars['Int']['output']>;
  /** The date and time the team was updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** winning percentage */
  winningPercentage?: Maybe<Scalars['String']['output']>;
  /** Team's win record */
  wins?: Maybe<Scalars['Int']['output']>;
};

export type NewsletterConfigs = {
  __typename?: 'NewsletterConfigs';
  description: Scalars['String']['output'];
  image: Scalars['String']['output'];
  mCode: Scalars['String']['output'];
  masterProductId: Scalars['Int']['output'];
  sites?: Maybe<Array<Maybe<NewsletterSite>>>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  title: Scalars['String']['output'];
};

export type NewsletterConfigsInput = {
  description: Scalars['String']['input'];
  image: Scalars['String']['input'];
  masterProductId: Scalars['Int']['input'];
  sites?: InputMaybe<Array<InputMaybe<NewsletterSiteInput>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title: Scalars['String']['input'];
};

export type NewsletterSite = {
  __typename?: 'NewsletterSite';
  displayOrder: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  site: Scalars['Int']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type NewsletterSiteDisplayOrderInput = {
  displayOrder: Array<Scalars['Int']['input']>;
  siteId: Scalars['Int']['input'];
};

export type NewsletterSiteInput = {
  displayOrder: Scalars['Int']['input'];
  isActive: Scalars['Boolean']['input'];
  site: Scalars['Int']['input'];
};

export type Newsletters = {
  __typename?: 'Newsletters';
  mCode: Scalars['String']['output'];
  masterProductId: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

/** Node interface used in Edges of Connections Types. */
export type Node = {
  id: Scalars['ID']['output'];
};

/** Represents the odds for a betting market */
export type OddsBettingMarket = {
  __typename?: 'OddsBettingMarket';
  /** Indicates if the sports book is active */
  active: Scalars['Boolean']['output'];
  /** CBS-specific identifier for the book */
  cbsBookId: Scalars['Int']['output'];
  /** CBS-specific name for the book */
  cbsBookName: Scalars['String']['output'];
  /** Unique identifier for the betting market */
  id: Scalars['ID']['output'];
  /** Represents selection for standard moneyline odds */
  selections: BookSelectionConnection;
};


/** Represents the odds for a betting market */
export type OddsBettingMarketSelectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type OneTimePasswordInput = {
  emailAddress: Scalars['String']['input'];
};

export type OneTimePasswordResult = SapiResponse & {
  __typename?: 'OneTimePasswordResult';
  code: Scalars['Int']['output'];
  data?: Maybe<AuthenticationDetails>;
  message?: Maybe<Scalars['String']['output']>;
  sapiStatusCode?: Maybe<Scalars['Int']['output']>;
  success: Scalars['Boolean']['output'];
};

export type OpenWebNoficationInput = {
  featured_message?: InputMaybe<Scalars['Boolean']['input']>;
  followee_activity?: InputMaybe<Scalars['Boolean']['input']>;
  liked_your_message?: InputMaybe<Scalars['Boolean']['input']>;
  message_approved?: InputMaybe<Scalars['Boolean']['input']>;
  message_rejected?: InputMaybe<Scalars['Boolean']['input']>;
  new_follower?: InputMaybe<Scalars['Boolean']['input']>;
  replied_to_message?: InputMaybe<Scalars['Boolean']['input']>;
  topic_notification?: InputMaybe<Scalars['Boolean']['input']>;
  user_mentioned?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OpenWebNoficationOptions = {
  __typename?: 'OpenWebNoficationOptions';
  featured_message: OpenWebNotificationOption;
  followee_activity: OpenWebNotificationOption;
  liked_your_message: OpenWebNotificationOption;
  message_approved: OpenWebNotificationOption;
  message_rejected: OpenWebNotificationOption;
  new_follower: OpenWebNotificationOption;
  replied_to_message: OpenWebNotificationOption;
  topic_notification: OpenWebNotificationOption;
  user_mentioned: OpenWebNotificationOption;
};

export enum OpenWebNotificationOption {
  Immediately = 'immediately',
  Never = 'never'
}

export type OpenWebNotifications = {
  __typename?: 'OpenWebNotifications';
  email: OpenWebNoficationOptions;
  in_app: OpenWebNoficationOptions;
};

export type OpenWebSettings = {
  __typename?: 'OpenWebSettings';
  notifications: OpenWebNotifications;
};

export type OpenWebUser = {
  __typename?: 'OpenWebUser';
  bio: Scalars['String']['output'];
  display_name: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  email_verified: Scalars['Boolean']['output'];
  image_url?: Maybe<Scalars['String']['output']>;
  is_blocked: Scalars['Boolean']['output'];
  livefyre_user_id?: Maybe<Scalars['String']['output']>;
  location: Scalars['String']['output'];
  primary_key: Scalars['String']['output'];
  private_profile: Scalars['Boolean']['output'];
  roles: Array<Scalars['String']['output']>;
  settings: OpenWebSettings;
  spotim_user_id: Scalars['String']['output'];
  user_name: Scalars['String']['output'];
};

export type OpenWebUserResponse = {
  __typename?: 'OpenWebUserResponse';
  success: Scalars['Boolean']['output'];
  user?: Maybe<OpenWebUser>;
};

/** Represents the sorting order by for results. */
export enum OrderByDir {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type OrderRowDataConnection = {
  __typename?: 'OrderRowDataConnection';
  /** The list of edges */
  edges?: Maybe<Array<OrderRowDataEdge>>;
  /** The page info */
  pageInfo: PageInfo;
};

export type OrderRowDataEdge = {
  __typename?: 'OrderRowDataEdge';
  /** The cursor for pagination */
  cursor: Scalars['String']['output'];
  /** The node (VideoMenuOrder) associated with this edge */
  node: VideoMenuRowInterface;
};

export type OverUnderTeamSeasonRecord = MarketTeamSeasonRecord & {
  __typename?: 'OverUnderTeamSeasonRecord';
  /** The underwins - number of games where the total score went under the set line, defaults to 0. */
  losses: Scalars['Int']['output'];
  /** The number of games that ended in a tie or push for the total score, defaults to 0. */
  pushes: Scalars['Int']['output'];
  /** The specific situation this split represents (e.g., "At Home", "As Favorite"). */
  situation: Scalars['String']['output'];
  /** The team this split data belongs to. */
  team: Team;
  /** The over win percentage - percentage of games where the total score went over the set line, defaults to 0. */
  winPercentage: Scalars['Float']['output'];
  /** The overwins - number of games where the total score went over the set line, defaults to 0. */
  wins: Scalars['Int']['output'];
};

/** Information about pagination results in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** Represents a parlay */
export type Parlay = {
  __typename?: 'Parlay';
  /** The id of the parlay */
  id: Scalars['ID']['output'];
  /**
   * The legs of the top parlay
   *   *Constraints:`first` has a maximum limit of 500*
   */
  legs: ParlayLegConnection;
  /** The edge or advantage the bettor has over the bookmaker for the parlay bet */
  parlayEdge: Scalars['Float']['output'];
  /** The combined odds for the parlay bet */
  parlayOdds?: Maybe<Scalars['Float']['output']>;
  /** The projected odds for the parlay bet */
  parlayProjectedOdds?: Maybe<Scalars['Float']['output']>;
  /** The rank of the parlay bet */
  parlayRank: Scalars['Int']['output'];
};


/** Represents a parlay */
export type ParlayLegsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

/** Define a connection between a parlay and its list of legs. */
export type ParlayLegConnection = {
  __typename?: 'ParlayLegConnection';
  /** The legs of the parlay */
  edges?: Maybe<Array<Maybe<ParlayLegEdge>>>;
  /** The legs of the parlay */
  nodes?: Maybe<Array<Maybe<Leg>>>;
  /** The page info for the parlay */
  pageInfo: PageInfo;
};

/** Define an edge between a parlay and a leg */
export type ParlayLegEdge = {
  __typename?: 'ParlayLegEdge';
  /** The cursor for the edge */
  cursor: Scalars['String']['output'];
  /** The leg for the edge */
  node?: Maybe<Leg>;
};

export type ParlayLegExpertPickFilterInput = {
  cbsExpertId?: InputMaybe<Array<Scalars['Int']['input']>>;
  expertId?: InputMaybe<Array<Scalars['String']['input']>>;
  resultStatus?: InputMaybe<Array<ExpertPickResultStatus>>;
  state?: InputMaybe<ExpertPickState>;
};

/** Represents the projected score for a parlay */
export type ParlayProjectedScore = {
  __typename?: 'ParlayProjectedScore';
  /** The projected score for the away team */
  away?: Maybe<TeamScore>;
  /** The projected score for the home team */
  home?: Maybe<TeamScore>;
};

/** Parlay sort field enum */
export enum ParlaySortField {
  Rank = 'RANK'
}

/** Input defintion for sorting parlays */
export type ParlaySortInput = {
  field?: InputMaybe<ParlaySortField>;
  order?: InputMaybe<ParlaySortOrder>;
};

/** sort order enum */
export enum ParlaySortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type PickSnippet = {
  __typename?: 'PickSnippet';
  game: Game;
  id: Scalars['ID']['output'];
  selection?: Maybe<PickSnippetSelection>;
};

export type PickSnippetInput = {
  /** CbsGameId is the unique identifier for the game in the CBS Sports system. */
  gameId: Scalars['ID']['input'];
  /**
   * The numerical threshold or handicap associated with specific market types.
   *   Only applicable for:
   *   - OVER_UNDER markets (e.g., total points: 42.5)
   *   - POINT_SPREAD markets (e.g., spread: -3.5)
   *
   *   For all other market types, this field will be null. Often includes
   *   a half-point (x.5) to prevent push outcomes.
   */
  line?: InputMaybe<Scalars['Float']['input']>;
  /**
   * Standard, Game Prop, Player Prop, Team Prop
   *   cbsMarketIds
   *   1: POINT_SPREAD
   *   2: MONEY_LINE (2way)
   *   3: MONEY_LINE (3way)
   *   4: OVER_UNDER
   */
  marketId: Scalars['Int']['input'];
  /**
   * A fallback display name for the market when marketTypeLabel is unavailable.
   *   Resolution priority:
   *   1. Internal mapping
   *   2. This marketName value
   *   3. Retrieved from Primpy API
   *
   *   This ensures consistent market naming across the application UI.
   */
  marketName?: InputMaybe<Scalars['String']['input']>;
  /**
   * standard
   *   • MONEY_LINE, OVER_UNDER, POINT_SPREAD
   *   Props:
   *   • player
   *   • team
   *   • game
   */
  marketType: Scalars['String']['input'];
  /** Should be and Interger and mandatory */
  odds: Scalars['Int']['input'];
  /**
   * The specific outcome or position being selected within the market context.
   *   Standardized values based on market type:
   *
   *   Market Type    | Valid Values
   *   ---------------|----------------
   *   OVER_UNDER     | "over", "under"
   *   POINT_SPREAD   | "home", "away"
   *   MONEY_LINE     | "home", "away", "draw"
   *   YES_NO         | "yes", "no"
   *
   *   This field is critical for bet validation and outcome determination.
   */
  pick: Scalars['String']['input'];
  /**
   * The unique identifier for the player associated with this selection.
   *   This field is only used for marketType:
   *   • player
   */
  playerId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * The unique identifier for the player associated with this selection.
   *   This field is only used for marketType and used as a fallback for label:
   *   • player
   */
  playerName?: InputMaybe<Scalars['String']['input']>;
  /**
   * The unique identifier for the player associated with this selection.
   *   This field is only used for marketType:
   *   • standard & game
   *   • moneyline
   *   • point spread
   *   • team
   */
  teamId?: InputMaybe<Scalars['ID']['input']>;
  /** The unique identifier for the vendor's game, used to track and manage */
  vendorGameId: Scalars['ID']['input'];
};

export type PickSnippetParlay = {
  __typename?: 'PickSnippetParlay';
  /** A unique identifier for the parlay based on the legs properties. */
  id: Scalars['ID']['output'];
  /** The different legs of the parlay, each representing a pick snippet. */
  legs: Array<PickSnippet>;
  /** Calculated odds for the parlay based on the individual legs odds in American format. For example 1190, -200. */
  odds: Scalars['Int']['output'];
};

export type PickSnippetSelection = {
  /**
   * The team associated with this selection,
   *   cbsMarketId is used to determine the market type.
   */
  cbsMarketId: Scalars['Int']['output'];
  /**
   * A unique identifier for the pick selection, used to create a GraphQL fragment
   *   and reference the selection in the Apollo cache. This ensures that updates
   *   are properly tracked and displayed in the user interface.
   */
  id: Scalars['ID']['output'];
  /**
   * A descriptive summary of the expert's selection. For example: "Baltimore -124".
   *
   *   - For non-subscribers (if the pick is still pending), this may display a
   *   promotional or upsell message (e.g., "Pick available to subscribers only")
   *   instead of the actual pick details.
   *   - Once the pick is no longer pending (e.g., the game has started or completed),
   *   the full description is revealed to everyone.
   */
  label: Scalars['String']['output'];
  /** The market of the expert pick snippet, which provides context about the type of bet. */
  market?: Maybe<BettingMarket>;
  /** A user friendly name for the market. */
  marketName?: Maybe<Scalars['String']['output']>;
  /**
   * The type of market this bet falls under. Examples:
   *   - MONEY_LINE, OVER_UNDER, POINT_SPREAD (for typical standard picks)
   *   - PROP (for player, team, or game prop bets)
   *
   *   This helps users quickly identify the bet's nature.
   */
  marketType?: Maybe<Scalars['String']['output']>;
  /**
   * A user-friendly label describing the market type. For example:
   *   - 'Money Line' for MONEY_LINE
   *   - 'Over/Under' for OVER_UNDER
   *   - 'Point Spread' for POINT_SPREAD
   *   - 'Prop' for PROP
   *
   *   If the pick is pending and the user is not subscribed, this may be null.
   *   Otherwise, it displays a descriptive value drawn from the dataset.
   */
  marketTypeLabel?: Maybe<Scalars['String']['output']>;
  /**
   * The odds (or payout indicator) assigned to this pick. These values may be in
   *   American (e.g., -110), decimal (e.g., 1.91), or fractional (e.g., 10/11) format,
   *   depending on your system. The odds reflect the potential return if the pick wins.
   */
  odds: Scalars['Float']['output'];
  /**
   * Indicates which side of the selection is being chosen. Examples:
   *   • HOME or AWAY for a game outcome
   *   • OVER or UNDER for a totals/points-based bet
   *   This field's meaning can vary based on the marketType.
   */
  side?: Maybe<Scalars['String']['output']>;
};


export type PickSnippetSelectionLabelArgs = {
  abbreviated?: InputMaybe<Scalars['Boolean']['input']>;
  formatOdds?: InputMaybe<Scalars['Boolean']['input']>;
  variant?: InputMaybe<ExpertPickSelectionLabelVariant>;
};

export type PickSnippetSelectionGameProp = PickSnippetSelection & {
  __typename?: 'PickSnippetSelectionGameProp';
  /**
   * The team associated with this selection,
   *   cbsMarketId is used to determine the market type.
   *   markets:
   *   1: POINT_SPREAD
   *   2: MONEY_LINE (2way)
   *   3: MONEY_LINE (3way)
   *   4: OVER_UNDER
   */
  cbsMarketId: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  market?: Maybe<BettingMarket>;
  marketName?: Maybe<Scalars['String']['output']>;
  /**
   * Market type for this game prop. Typically, one of the following:
   *   • MONEY_LINE
   *   • OVER_UNDER
   *   • POINT_SPREAD
   *   • UNKNOWN (for cbsMarketId not matching 1,2,3,4 & marketType=standard)
   */
  marketType?: Maybe<Scalars['String']['output']>;
  marketTypeLabel?: Maybe<Scalars['String']['output']>;
  odds: Scalars['Float']['output'];
  /**
   * Indicates which side of the selection is being chosen. Examples:
   *   • HOME or AWAY for a game outcome
   *   • OVER or UNDER for a totals/points-based bet
   *   This field's meaning can vary based on the marketType.
   */
  side?: Maybe<Scalars['String']['output']>;
  /**
   * Information about the team associated with this pick, if applicable.
   *   For markets that don't involve a specific team (e.g., certain
   *   Over/Under bets), this field may be null. Otherwise, it can
   *   represent the HOME or AWAY team for a given matchup.
   */
  team?: Maybe<Team>;
  value?: Maybe<Scalars['Float']['output']>;
};


export type PickSnippetSelectionGamePropLabelArgs = {
  abbreviated?: InputMaybe<Scalars['Boolean']['input']>;
  formatOdds?: InputMaybe<Scalars['Boolean']['input']>;
  variant?: InputMaybe<ExpertPickSelectionLabelVariant>;
};

export type PickSnippetSelectionPlayerProp = PickSnippetSelection & {
  __typename?: 'PickSnippetSelectionPlayerProp';
  cbsMarketId: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  market?: Maybe<BettingMarket>;
  marketName?: Maybe<Scalars['String']['output']>;
  marketType?: Maybe<Scalars['String']['output']>;
  marketTypeLabel?: Maybe<Scalars['String']['output']>;
  odds: Scalars['Float']['output'];
  /** Player associated with this selection. */
  player?: Maybe<Player>;
  side?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};


export type PickSnippetSelectionPlayerPropLabelArgs = {
  abbreviated?: InputMaybe<Scalars['Boolean']['input']>;
  formatOdds?: InputMaybe<Scalars['Boolean']['input']>;
  variant?: InputMaybe<ExpertPickSelectionLabelVariant>;
};

export type PickSnippetSelectionStandard = PickSnippetSelection & {
  __typename?: 'PickSnippetSelectionStandard';
  /**
   * The team associated with this selection,
   *   cbsMarketId is used to determine the market type.
   *   markets:
   *   1: POINT_SPREAD
   *   2: MONEY_LINE (2way)
   *   3: MONEY_LINE (3way)
   *   4: OVER_UNDER
   */
  cbsMarketId: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  market?: Maybe<BettingMarket>;
  marketName?: Maybe<Scalars['String']['output']>;
  /**
   * Market type for this game prop. Typically, one of the following:
   *   • MONEY_LINE
   *   • OVER_UNDER
   *   • POINT_SPREAD
   *   • UNKNOWN (for cbsMarketId not matching 1,2,3,4 & marketType=standard)
   */
  marketType?: Maybe<Scalars['String']['output']>;
  /**
   * A user-friendly label derived from marketType, often displayed in the UI.
   *   For example:
   *   • 'Money Line'
   *   • 'Over/Under'
   *   • 'Point Spread'
   *   Logging is recommended if this value is missing for diagnosis and
   *   data consistency purposes.
   */
  marketTypeLabel?: Maybe<Scalars['String']['output']>;
  odds: Scalars['Float']['output'];
  /**
   * Indicates which side of the selection is being chosen. Examples:
   *   • HOME or AWAY for a game outcome
   *   • OVER or UNDER for a totals/points-based bet
   *   This field's meaning can vary based on the marketType.
   */
  side?: Maybe<Scalars['String']['output']>;
  /**
   * Information about the team associated with this pick, if applicable.
   *   For markets that don't involve a specific team (e.g., certain
   *   Over/Under bets), this field may be null. Otherwise, it can
   *   represent the HOME or AWAY team for a given matchup.
   */
  team?: Maybe<Team>;
  value?: Maybe<Scalars['Float']['output']>;
};


export type PickSnippetSelectionStandardLabelArgs = {
  abbreviated?: InputMaybe<Scalars['Boolean']['input']>;
  formatOdds?: InputMaybe<Scalars['Boolean']['input']>;
  variant?: InputMaybe<ExpertPickSelectionLabelVariant>;
};

export type PickSnippetSelectionTeamProp = PickSnippetSelection & {
  __typename?: 'PickSnippetSelectionTeamProp';
  cbsMarketId: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  market?: Maybe<BettingMarket>;
  marketName?: Maybe<Scalars['String']['output']>;
  marketType?: Maybe<Scalars['String']['output']>;
  marketTypeLabel?: Maybe<Scalars['String']['output']>;
  odds: Scalars['Float']['output'];
  side?: Maybe<Scalars['String']['output']>;
  /** Team associated with this selection. */
  team?: Maybe<Team>;
  value?: Maybe<Scalars['Float']['output']>;
};


export type PickSnippetSelectionTeamPropLabelArgs = {
  abbreviated?: InputMaybe<Scalars['Boolean']['input']>;
  formatOdds?: InputMaybe<Scalars['Boolean']['input']>;
  variant?: InputMaybe<ExpertPickSelectionLabelVariant>;
};

export type Place = {
  __typename?: 'Place';
  /** The numerical portion of an address, such as a building number. */
  addressNumber?: Maybe<Scalars['String']['output']>;
  /**
   * A country/region specified using ISO 3166
   *   3-digit country/region code. For example, CAN.
   */
  country?: Maybe<Scalars['String']['output']>;
  /** Places uses a point geometry to specify a location or a Place. */
  geometry?: Maybe<PlaceGeometry>;
  /** The full name and address of the point of interest such as a city, region, or country. For example, 123 Any Street, Any Town, USA. */
  label?: Maybe<Scalars['String']['output']>;
  /** A name for a local area, such as a city or town name. For example, Toronto. */
  municipality?: Maybe<Scalars['String']['output']>;
  /** The name of a community district. For example, Downtown. */
  neighborhood?: Maybe<Scalars['String']['output']>;
  /** A group of numbers and letters in a country-specific format, which accompanies the address for the purpose of identifying a location. */
  postalCode?: Maybe<Scalars['String']['output']>;
  /** A name for an area or geographical division, such as a province or state name. For example, British Columbia. */
  region?: Maybe<Scalars['String']['output']>;
  /**
   * The relative confidence in the match for a result among the results returned.
   *   For example, if more fields for an address match (including house number, street, city, country/region, and postal code), the relevance score is closer to 1.
   *   Returned only when the partner selected is Esri or Grab.
   */
  relevance?: Maybe<Scalars['Int']['output']>;
  /** The name for a street or a road to identify a location. For example, Main Street. */
  street?: Maybe<Scalars['String']['output']>;
  /** A county, or an area that's part of a larger region. For example, Metro Vancouver. */
  subRegion?: Maybe<Scalars['String']['output']>;
  /** For addresses with multiple units, the unit identifier. Can include numbers and letters, for example 3B or Unit 123. */
  unitNumber?: Maybe<Scalars['String']['output']>;
  /** For addresses with a UnitNumber, the type of unit. For example, Apartment. */
  unitType?: Maybe<Scalars['String']['output']>;
};

export type PlaceGeometry = {
  __typename?: 'PlaceGeometry';
  /** The long and lat of the returned location */
  lat?: Maybe<Scalars['Float']['output']>;
  /** The long and lat of the returned location */
  long?: Maybe<Scalars['Float']['output']>;
};

/** player type definition */
export type Player = SportsPlayer & {
  __typename?: 'Player';
  /**
   * player props projections for this player
   *   *Constraints: `first` has a maximum limit of 500*
   */
  bettingPlayerPropsProjections?: Maybe<PlayerPropsProjectionConnection>;
  birthCountry?: Maybe<Scalars['String']['output']>;
  birthDate?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  debutDate?: Maybe<Scalars['DateTime']['output']>;
  experience?: Maybe<Scalars['Int']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullFirstName?: Maybe<Scalars['String']['output']>;
  fullLastName?: Maybe<Scalars['String']['output']>;
  headshotImage?: Maybe<CmsImage>;
  height?: Maybe<Scalars['String']['output']>;
  homeTown?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  marqueeImage?: Maybe<CmsImage>;
  nationalityCountry?: Maybe<Scalars['String']['output']>;
  nationalityCountryCode?: Maybe<Scalars['String']['output']>;
  /**
   * The news articles related to the player.
   *   *Constraints:`first` has a maximum limit of 500*
   */
  news?: Maybe<PlayerNewsConnection>;
  nickName?: Maybe<Scalars['String']['output']>;
  resolvedMarquee?: Maybe<Scalars['Boolean']['output']>;
  school?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The vendors that are associated with this player.
   *   *Constraints:`first` has a maximum limit of 500*
   */
  vendors?: Maybe<PlayerVendorConnection>;
  weight?: Maybe<Scalars['Int']['output']>;
};


/** player type definition */
export type PlayerBettingPlayerPropsProjectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Array<InputMaybe<PlayerPropsProjectionSortInput>>>;
};


/** player type definition */
export type PlayerNewsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  createdSince?: InputMaybe<Scalars['DateTime']['input']>;
  createdUntil?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


/** player type definition */
export type PlayerVendorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  vendorName?: InputMaybe<Scalars['String']['input']>;
};

export type PlayerConnection = {
  __typename?: 'PlayerConnection';
  /** A list of edges. */
  edges: Array<PlayerEdge>;
  /** A list of nodes. */
  nodes: Array<Player>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total count. */
  totalCount: Scalars['Int']['output'];
};

/**
 * The PlayerSalary type represents the salary information for a player in a DFS contest.
 * cacheControl(maxAge: 60)
 */
export type PlayerDfsSalary = DfsSalary & {
  __typename?: 'PlayerDfsSalary';
  /** Creation timestamp of the salary entry. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** DraftKings specific draftable ID. */
  draftKingsDraftableId?: Maybe<Scalars['Int']['output']>;
  /** DraftKings specific player ID. */
  draftKingsPlayerId?: Maybe<Scalars['Int']['output']>;
  /** FanDuel specific player ID. */
  fanDuelPlayerId?: Maybe<Scalars['Int']['output']>;
  /** FanDuel specific stats ID. */
  fanDuelStatsId?: Maybe<Scalars['Int']['output']>;
  /** The game associated with this salary. */
  game: Game;
  /** Type of DFS contest. */
  gameType?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the salary entry. */
  id: Scalars['ID']['output'];
  /** The player associated with this salary. */
  player: Player;
  /** Positions eligible for the salary. */
  positions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Provider of the salary information. */
  provider: Scalars['String']['output'];
  /** The salary amount. */
  salary: Scalars['Int']['output'];
  /** The date when the salary is applicable. */
  salaryDate?: Maybe<Scalars['Date']['output']>;
  /** End time of the slate. */
  slateEnd?: Maybe<Scalars['DateTime']['output']>;
  /** Unique identifier for the slate. */
  slateId: Scalars['Int']['output'];
  /** Start time of the slate. */
  slateStart?: Maybe<Scalars['DateTime']['output']>;
  /** Type of slate for the game(s). */
  slateType?: Maybe<Scalars['String']['output']>;
  /** Tier of the salary. */
  tier?: Maybe<Scalars['String']['output']>;
  /** Last update timestamp of the salary entry. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** An edge in a connection. */
export type PlayerEdge = {
  __typename?: 'PlayerEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Player;
};

/** Input for creating or referencing a player */
export type PlayerInput = {
  /** Player's birth country */
  birthCountry?: InputMaybe<Scalars['String']['input']>;
  /** Player's birth date */
  birthDate?: InputMaybe<Scalars['Date']['input']>;
  /** Player's debut date */
  debutDate?: InputMaybe<Scalars['Date']['input']>;
  /** Player's experience in years */
  experience?: InputMaybe<Scalars['Int']['input']>;
  /** First name */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Full first name */
  fullFirstName?: InputMaybe<Scalars['String']['input']>;
  /** Full last name */
  fullLastName?: InputMaybe<Scalars['String']['input']>;
  /** Player's height in cm */
  height?: InputMaybe<Scalars['Int']['input']>;
  /** Player's hometown */
  homeTown?: InputMaybe<Scalars['String']['input']>;
  /** Identifier for the player - can use internal ID or vendor ID */
  id?: InputMaybe<DataEngIdentifier>;
  /** Last name */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Player's nationality */
  nationalityCountry?: InputMaybe<Scalars['String']['input']>;
  /** Player's nickname */
  nickName?: InputMaybe<Scalars['String']['input']>;
  /** Player's school */
  school?: InputMaybe<Scalars['String']['input']>;
  /** Player's weight in kg */
  weight?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents a player leg of a parlay where betType='player' */
export type PlayerLeg = Leg & {
  __typename?: 'PlayerLeg';
  /** Represents the type of bet for the leg. This field is required. */
  betType: Scalars['String']['output'];
  /** Represents the CBS book ID associated with the leg. This field is required. */
  cbsBookId: Scalars['Int']['output'];
  /** cbsMarketAbbrev */
  cbsMarketAbbrev?: Maybe<Scalars['String']['output']>;
  /** Represents the CBS market ID associated with the leg. This field is required. */
  cbsMarketId?: Maybe<Scalars['Int']['output']>;
  /** Represents the name of the CBS market associated with the leg. This field is required. */
  cbsMarketName?: Maybe<Scalars['String']['output']>;
  /** Represents the bettor's edge value for the leg. This field is required. */
  edge: Scalars['Float']['output'];
  /** Expert Picks for the same game, player, and market id */
  expertPicks?: Maybe<ExpertPicksConnection>;
  /** Represents the game involved in the leg. This field is required. */
  game: Game;
  /** The id of the Leg */
  id: Scalars['ID']['output'];
  /** Represents the insight or analysis for the parlay. This field is required. */
  insight?: Maybe<Scalars['String']['output']>;
  /** Represents the line value for the leg. */
  line?: Maybe<Scalars['Float']['output']>;
  /** Represents the odds for the leg. This field is required. */
  odds?: Maybe<Scalars['Float']['output']>;
  /** Represents the player involved in the leg. */
  player: Player;
  /** Represents the projected value for the leg. */
  projection?: Maybe<Scalars['Float']['output']>;
  /** Represents the side of the bet for the leg. This field is required. */
  side?: Maybe<Scalars['String']['output']>;
  /** Represents the team the player is on. */
  team?: Maybe<Team>;
};


/** Represents a player leg of a parlay where betType='player' */
export type PlayerLegExpertPicksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ParlayLegExpertPickFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Array<ExpertPickSortByInput>>;
};

/** Define a connection between a player and its news. */
export type PlayerNewsConnection = {
  __typename?: 'PlayerNewsConnection';
  edges: Array<Maybe<PlayerNewsEdge>>;
  nodes: Array<Maybe<RotowirePlayerNews>>;
  pageInfo: PageInfo;
};

/** Edge for player news connection */
export type PlayerNewsEdge = {
  __typename?: 'PlayerNewsEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<RotowirePlayerNews>;
};

/** player news sort field enum */
export enum PlayerNewsSortField {
  Createdat = 'CREATEDAT',
  Priority = 'PRIORITY',
  Updatedat = 'UPDATEDAT'
}

/** input defintion for sorting player news */
export type PlayerNewsSortInput = {
  field: PlayerNewsSortField;
  order: SortOrder;
};

/**
 * GraphQL type definitions for player props projections, including queries and types for betting edges, projections, and connections.
 * refer to player_props_projection collection in MongoDB
 */
export type PlayerPropsProjection = BasePlayerPropsProjection & {
  __typename?: 'PlayerPropsProjection';
  /** betting active flag, true if the player prop projection is active */
  active: Scalars['Boolean']['output'];
  /** betting side for the player prop projection, always two sides, like 'Over' and 'Under' */
  bettingSides: Array<SimplePlayerPropsProjectionSide>;
  /** book state, like "NJ", "PA", etc. */
  bookState?: Maybe<Scalars['String']['output']>;
  /** cbs betting book id */
  cbsBookId: Scalars['ID']['output'];
  /** cbs betting market id, provide league id from _id to solve vendor market association */
  cbsMarket: BettingMarket;
  /** betting created at timestamp */
  createdAt: Scalars['DateTime']['output'];
  /** betting game */
  game: Game;
  /** composite id for player props projection, include cbsMarketId and leagueId */
  id: Scalars['ID']['output'];
  /** isSubscriber flag, true because the player prop projection is for subscribers only */
  isSubscriber?: Maybe<Scalars['Boolean']['output']>;
  /** player jersey number, like 12, 23, etc. */
  jerseyNumber?: Maybe<Scalars['String']['output']>;
  /** betting player league, change to ! later */
  league: League;
  /** betting line for the player prop projection, like 50.5 for 'Over/Under 50.5 Receiving Yards' */
  line?: Maybe<Scalars['Float']['output']>;
  /** betting matchup score, a float value representing the strength of the matchup */
  matchupScore: Scalars['Float']['output'];
  /** betting model name */
  model: Scalars['String']['output'];
  /** betting player */
  player: Player;
  /** betting team, change to ! later */
  playerTeam: Team;
  /** player position, like 'QB', 'RB', etc. */
  position?: Maybe<Scalars['String']['output']>;
  /** betting projection, a float value representing the projected value for the player prop */
  projection?: Maybe<Scalars['Float']['output']>;
  /** betting projection high, a float value representing the high end of the projection range */
  projectionHigh?: Maybe<Scalars['Float']['output']>;
  /** betting projection low, a float value representing the low end of the projection range */
  projectionLow?: Maybe<Scalars['Float']['output']>;
  /** betting rank, a float value representing the rank of the player prop projection */
  rank: Scalars['Float']['output'];
  /** Recommended betting side for Player Props Projection with recommendSide as true, like 'Over' or 'Under' */
  recommendedBettingSide?: Maybe<PlayerPropsProjectionSide>;
  /** betting source, like 'AI', 'CBS', 'SportsLine', etc. */
  src: Scalars['String']['output'];
  /** betting updated at timestamp */
  updatedAt: Scalars['DateTime']['output'];
};

/** Connection for player props projections */
export type PlayerPropsProjectionConnection = {
  __typename?: 'PlayerPropsProjectionConnection';
  edges: Array<PlayerPropsProjectionEdge>;
  nodes: Array<PlayerPropsProjection>;
  pageInfo: PageInfo;
};

/** edge for player props projection connection */
export type PlayerPropsProjectionEdge = {
  __typename?: 'PlayerPropsProjectionEdge';
  /** A cursor for pagination */
  cursor: Scalars['String']['output'];
  /** The player props projection at the end of the edge */
  node: PlayerPropsProjection;
};

/** Connection for player props projections */
export type PlayerPropsProjectionFpConnection = {
  __typename?: 'PlayerPropsProjectionFPConnection';
  edges: Array<PlayerPropsProjectionFpEdge>;
  nodes: Array<PlayerPropsProjectionFreePick>;
  pageInfo: PageInfo;
};

/** edge for player props projection connection */
export type PlayerPropsProjectionFpEdge = {
  __typename?: 'PlayerPropsProjectionFPEdge';
  /** A cursor for pagination */
  cursor: Scalars['String']['output'];
  /** The player props projection at the end of the edge */
  node: PlayerPropsProjectionFreePick;
};

/** filter input for player props projection */
export type PlayerPropsProjectionFilterInput = {
  cbsBookIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  cbsMarketIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  gameAbbreviations?: InputMaybe<Array<Scalars['String']['input']>>;
  gameIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  leagueAbbreviations?: InputMaybe<Array<Scalars['String']['input']>>;
  leagueIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** get rid of team abbreviation filter since it is not unique, use teamIds instead */
  playerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  teamIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * GraphQL type definitions for player props projections free version, including queries and types for betting edges, projections, and connections.
 * refer to player_props_projection collection in MongoDB
 */
export type PlayerPropsProjectionFreePick = BasePlayerPropsProjection & {
  __typename?: 'PlayerPropsProjectionFreePick';
  /** betting active flag, true if the player prop projection is active */
  active: Scalars['Boolean']['output'];
  /** betting side for the player prop projection, always two sides, like 'Over' and 'Under' */
  bettingSides: Array<SimplePlayerPropsProjectionSide>;
  /** book state, like "NJ", "PA", etc. */
  bookState?: Maybe<Scalars['String']['output']>;
  /** cbs betting book id */
  cbsBookId: Scalars['ID']['output'];
  /** cbs betting market id, provide league id from _id to solve vendor market association */
  cbsMarket: BettingMarket;
  /** betting created at timestamp */
  createdAt: Scalars['DateTime']['output'];
  /** betting game */
  game: Game;
  /** composite id for player props projection, include cbsMarketId and leagueId */
  id: Scalars['ID']['output'];
  /** isSubscriber flag, true because the player prop projection is for subscribers only */
  isSubscriber: Scalars['Boolean']['output'];
  /** player jersey number, like 12, 23, etc. */
  jerseyNumber?: Maybe<Scalars['String']['output']>;
  /** betting player league, change to ! later */
  league: League;
  /** betting line for the player prop projection, like 50.5 for 'Over/Under 50.5 Receiving Yards' */
  line?: Maybe<Scalars['Float']['output']>;
  /** betting matchup score, a float value representing the strength of the matchup */
  matchupScore: Scalars['Float']['output'];
  /** betting model name */
  model: Scalars['String']['output'];
  /** betting player */
  player: Player;
  /** betting team, change to ! later */
  playerTeam: Team;
  /** player position, like 'QB', 'RB', etc. */
  position?: Maybe<Scalars['String']['output']>;
  /** betting projection, a float value representing the projected value for the player prop */
  projection: Scalars['Float']['output'];
  /** betting projection high, a float value representing the high end of the projection range */
  projectionHigh: Scalars['Float']['output'];
  /** betting projection low, a float value representing the low end of the projection range */
  projectionLow: Scalars['Float']['output'];
  /** betting rank, a float value representing the rank of the player prop projection */
  rank: Scalars['Float']['output'];
  /** Recommended betting side for Player Props Projection, like 'Over' or 'Under' */
  recommendedBettingSide?: Maybe<PlayerPropsProjectionFreePickSide>;
  /** betting source, like 'AI', 'CBS', 'SportsLine', etc. */
  src: Scalars['String']['output'];
  /** betting updated at timestamp */
  updatedAt: Scalars['DateTime']['output'];
};

export type PlayerPropsProjectionFreePickSide = BasePlayerPropsProjectionSide & {
  __typename?: 'PlayerPropsProjectionFreePickSide';
  /** ai insights, a string value representing the AI insights for the player prop projection, come from player_insights table or betNarrative */
  aiInsights: Scalars['String']['output'];
  /** is insights ai insights, true if the player prop projection is AI generated */
  isAiInsights: Scalars['Boolean']['output'];
  /** betting odds, like -110 for 'Over -110' or 'Under -110' */
  odds: Scalars['String']['output'];
  /** pickDisplay flag, true if the player prop projection should be displayed in the betting picks */
  pickDisplay: Scalars['Boolean']['output'];
  /** betting probability, a int value representing the probability of the player prop projection */
  probInterval: Scalars['Int']['output'];
  /** betting projection, a float value representing the projected value for the player prop */
  probSigmoid?: Maybe<Scalars['Float']['output']>;
  /** rank of betting side, a float value representing the rank of the player prop projection */
  rank: Scalars['Float']['output'];
  /** betting rating star level, like 1 star, 2 stars, etc. */
  rating: Scalars['Float']['output'];
  /** betting recommended side, true if the player prop projection is recommended to bet on that side */
  recommendedSide: Scalars['Boolean']['output'];
  /** betting side, like 'Over' or 'Under' */
  side: Scalars['String']['output'];
  /** betting edge value */
  value: Scalars['Float']['output'];
};

/** betting side value for player props projection */
export type PlayerPropsProjectionSide = BasePlayerPropsProjectionSide & {
  __typename?: 'PlayerPropsProjectionSide';
  /** ai insights, a string value representing the AI insights for the player prop projection, come from player_insights table or betNarrative */
  aiInsights?: Maybe<Scalars['String']['output']>;
  /** is insights ai insights, true if the player prop projection is AI generated */
  isAiInsights?: Maybe<Scalars['Boolean']['output']>;
  /** betting odds, like -110 for 'Over -110' or 'Under -110' */
  odds?: Maybe<Scalars['String']['output']>;
  /** pickDisplay flag, true if the player prop projection should be displayed in the betting picks */
  pickDisplay?: Maybe<Scalars['Boolean']['output']>;
  /** betting probability, a int value representing the probability of the player prop projection */
  probInterval?: Maybe<Scalars['Int']['output']>;
  /** betting projection, a float value representing the projected value for the player prop */
  probSigmoid?: Maybe<Scalars['Float']['output']>;
  /** rank of betting side, a float value representing the rank of the player prop projection */
  rank?: Maybe<Scalars['Float']['output']>;
  /** betting rating star level, like 1 star, 2 stars, etc. */
  rating: Scalars['Float']['output'];
  /** betting recommended side, true if the player prop projection is recommended to bet on that side */
  recommendedSide?: Maybe<Scalars['Boolean']['output']>;
  /** betting side, like 'Over' or 'Under' */
  side?: Maybe<Scalars['String']['output']>;
  /** betting edge value */
  value?: Maybe<Scalars['Float']['output']>;
};

/** possible sort fields for player props projection */
export enum PlayerPropsProjectionSortField {
  AiRating = 'AI_RATING',
  Projection = 'PROJECTION',
  Rank = 'RANK'
}

/** input type for sorting player props projection */
export type PlayerPropsProjectionSortInput = {
  /** The field to sort by */
  field: PlayerPropsProjectionSortField;
  /** The order of the sort, either ascending or descending */
  order?: InputMaybe<SortOrder>;
};

/** interface for player stats */
export type PlayerStats = {
  /** The first name of the player. */
  firstName?: Maybe<Scalars['String']['output']>;
  /** initials for the player */
  initials?: Maybe<Scalars['String']['output']>;
  /** The jersey number of the player. */
  jerseyNumber?: Maybe<Scalars['String']['output']>;
  /** The last name of the player. */
  lastName?: Maybe<Scalars['String']['output']>;
  /** The unique identifier for the player is player id. */
  playerId: Scalars['ID']['output'];
  /** The position of the player. */
  position?: Maybe<Scalars['String']['output']>;
  /** The sport type for the player. */
  sport?: Maybe<Scalars['String']['output']>;
};

/** connection between player and vendors, refer to vendor_player_association table */
export type PlayerVendorConnection = {
  __typename?: 'PlayerVendorConnection';
  edges: Array<Maybe<PlayerVendorEdge>>;
  nodes?: Maybe<Array<Maybe<Vendor>>>;
  pageInfo: PageInfo;
};

/** Edge for player vendor connection */
export type PlayerVendorEdge = {
  __typename?: 'PlayerVendorEdge';
  cursor: Scalars['String']['output'];
  leagueId?: Maybe<Scalars['Int']['output']>;
  node?: Maybe<Vendor>;
  vendorPlayerId?: Maybe<Scalars['String']['output']>;
};

export type Pod = {
  __typename?: 'Pod';
  podIdInRegion?: Maybe<Scalars['String']['output']>;
  podLocation?: Maybe<Scalars['String']['output']>;
  regionName?: Maybe<Scalars['String']['output']>;
};

export type PodInput = {
  podIdInRegion: Scalars['String']['input'];
  podLocation: Scalars['String']['input'];
  regionName: Scalars['String']['input'];
};

export type PreviewSubscriptionPurchaseInput = {
  account: RecurlyPreviewSubscriptionPurchaseAccountInput;
  collectionMethod?: InputMaybe<Scalars['String']['input']>;
  couponCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  currency: Scalars['Currency']['input'];
  lineItems?: InputMaybe<Array<RecurlyPurchaseLineItemInput>>;
  subscriptions?: InputMaybe<Array<InputMaybe<SubscriptionPurchaseInput>>>;
};

/** Represents invalid / rejected user input during upsert mutations */
export type PrimpyBadUserInputError = {
  __typename?: 'PrimpyBadUserInputError';
  /** Optional field name related to the invalid input */
  field?: Maybe<Scalars['String']['output']>;
  /** Identifier (internal or vendor) if the invalid input referenced one */
  id?: Maybe<Scalars['ID']['output']>;
  /** Human-readable error message */
  message: Scalars['String']['output'];
};

/** Generic error codes for Primpy batch upsert operations */
export enum PrimpyErrorCode {
  BadInput = 'BAD_INPUT',
  NotFound = 'NOT_FOUND'
}

/** Represents a generic error encountered while processing batch upsert mutations (match V2 and future mutations). Consolidated shape for not found & bad input. */
export type PrimpyGenericError = {
  __typename?: 'PrimpyGenericError';
  code: PrimpyErrorCode;
  field?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type PrivacyToken = {
  __typename?: 'PrivacyToken';
  id: Scalars['String']['output'];
  jwt: Scalars['String']['output'];
};

export type PrivacyTokenInput = {
  brand: Scalars['String']['input'];
  pid: Scalars['String']['input'];
};

export type ProcessPaymentResponse = RecurlyInvoiceCollection | RecurlyPaymentError;

export type PromotedExpertPickFilterInput = {
  /** Filter promoted picks to only include certain leagues (e.g., 'NFL', 'NBA'). */
  leagues?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Types of Prop Bets */
export enum PropBetType {
  Game = 'GAME',
  Player = 'PLAYER',
  Team = 'TEAM'
}

export type ProviderProfile = {
  __typename?: 'ProviderProfile';
  attributes?: Maybe<Attributes>;
  issuer?: Maybe<Scalars['String']['output']>;
  notAfter?: Maybe<Scalars['Long']['output']>;
  notBefore?: Maybe<Scalars['Long']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** query for venue type */
export type Query = {
  __typename?: 'Query';
  activeGraphicScheduleTasks: Array<GraphicScheduleTask>;
  allCountries?: Maybe<Array<Maybe<Country>>>;
  /** Get a cbs market by its ID */
  bettingMarket?: Maybe<BettingMarket>;
  /**
   * Get player props projections by multiple player IDs, league id or team id or game id or game abbrev or cbs market id or cbs book id
   *   suggest pass in leagueId to get only future projections
   *   *Constraints: `first` has a maximum limit of 500*
   */
  bettingPlayerPropsProjections?: Maybe<PlayerPropsProjectionConnection>;
  category?: Maybe<BettingCategory>;
  cmsArticle?: Maybe<CmsArticle>;
  cmsAutocompleteEvent: EventConnection;
  cmsAutocompleteGame: GameConnection;
  cmsAutocompleteLeague: LeagueConnection;
  cmsAutocompletePlayer: PlayerConnection;
  cmsAutocompleteSport: SportConnection;
  cmsAutocompleteTeam: TeamConnection;
  cmsComponent?: Maybe<CmsComponentInterface>;
  cmsComponentBySlug?: Maybe<CmsComponentInterface>;
  cmsCustomConfig?: Maybe<CmsCustomConfigConfiguration>;
  cmsCustomConfigBySlug?: Maybe<CmsCustomConfigConfiguration>;
  cmsFeature?: Maybe<CmsFeature>;
  cmsFeatureBySlug?: Maybe<CmsFeature>;
  cmsLiveBlog?: Maybe<CmsLiveBlog>;
  cmsPoll?: Maybe<CmsPoll>;
  cmsPolls: CmsPollConnection;
  /** Fetch CMS recommended content by their IDs. */
  cmsRecommendedContent: Array<Maybe<CmsRecommendedContent>>;
  cmsVideo?: Maybe<CmsVideo>;
  /**
   * Get all requested competition seasons by their competition ID or season id
   *   *Constraints: `first` has a maximum limit of 500*
   */
  competitionSeasons?: Maybe<CompetitionSeasonsConnection>;
  complex?: Maybe<Complex>;
  country?: Maybe<Country>;
  countryByName?: Maybe<Country>;
  event?: Maybe<Event>;
  eventPlayer?: Maybe<EventPlayer>;
  /**
   * Retrieves a single ExpertPick by ID. Often used to view the details
   *   of a particular pick, such as the expert's commentary or the game details.
   */
  expertPick?: Maybe<ExpertPick>;
  /**
   * Retrieves a paginated list of expert picks. Allows filters by game ID, leagues,
   *   or pick states, as well as sorting options (e.g., FEATURED first).
   *   The query can be constrained with Relay-style arguments (first, after, last, before).
   */
  expertPicks?: Maybe<ExpertPicksConnection>;
  /**
   * Retrieves a single free ExpertPick by ID.
   *   This query returns detailed information for a free pick,
   *   fulfilling the requirements for the Free Pick of the Day feature.
   */
  freeExpertPick?: Maybe<ExpertPick>;
  /**
   * Retrieve only the free picks, useful for displaying free picks in a separate section.
   *   Will maintain all other filter and sorting options as passed.
   *
   *   The editorial team can designates and select a singular featured expert pick to
   *   showcase to users on a specific article page on CBS Sports Web. 
   */
  freeExpertPicks?: Maybe<ExpertPicksConnection>;
  /** Get a game by its ID */
  game?: Maybe<Game>;
  /** Get a game by its abbreviation */
  gameByAbbrev?: Maybe<Game>;
  /** Get all requested games by their IDs */
  games: Array<Maybe<Game>>;
  getAllBracketologyData?: Maybe<GetBracketologyDataResponse>;
  getAllBracketologyDataByTeamId?: Maybe<GetBracketologyDataByTeamIdResponse>;
  getBowlPredictionData?: Maybe<GetBowlPredictionDataResponse>;
  getCodeProfiles?: Maybe<CodeProfilesResponse>;
  getMVPDConfiguration?: Maybe<MvdpConfigurationResponse>;
  getMVPDProfiles?: Maybe<CodeProfilesResponse>;
  getUserMVPD?: Maybe<SapiUserMvpd>;
  getUserNewsletterSubscriptions: Array<Maybe<CbsSportsNewsletterSubscription>>;
  googleUserProfile?: Maybe<GoogleUserProfile>;
  graphic: Graphic;
  graphicApiIds: Array<Scalars['String']['output']>;
  graphicByName?: Maybe<Graphic>;
  graphicCount: Scalars['Int']['output'];
  graphicExport: GraphicExport;
  graphicExportCount: Scalars['Int']['output'];
  graphicExports: Array<GraphicExport>;
  graphicExportsByFilters: Array<GraphicExport>;
  graphicExportsByGraphicId: Array<GraphicExport>;
  graphicScheduleTask: GraphicScheduleTask;
  graphicScheduleTaskCount: Scalars['Int']['output'];
  graphicScheduleTasks: Array<GraphicScheduleTask>;
  graphicScheduleTasksByFilters: Array<GraphicScheduleTask>;
  graphicScheduleTasksByGraphicId: Array<GraphicScheduleTask>;
  graphicTags: Array<GraphicTag>;
  graphicTagsByGraphicId: Array<GraphicTag>;
  graphics: Array<Graphic>;
  graphicsByFilters: Array<Graphic>;
  graphicsByTags: Array<Graphic>;
  /** Fetch a Graphics Card. */
  graphicsCard?: Maybe<GraphicsCard>;
  /** Fetch Graphics Cards by filtering. */
  graphicsCards?: Maybe<GraphicsCardConnection>;
  graphicsUser?: Maybe<GraphicsUser>;
  graphicsUsers?: Maybe<Array<GraphicsUser>>;
  healthCheckSLDiscord?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Retrieves a list of the hottest experts, typically sorted by performance,
   *   for a given league and season year. The final league and season year may
   *   come from the input or default to configuration values set within
   *   SportsLine.
   *
   *   Parameters:
   *   - leagueAbbrev (String): Abbreviation of the league (e.g., 'NFL', 'NBA').
   *   - year (Int): The season year to filter experts for; defaults may apply
   *   if not provided.
   */
  hottestExperts?: Maybe<HottestExpertResponse>;
  isSportslineSubscriber?: Maybe<Scalars['Boolean']['output']>;
  iterableChannels?: Maybe<Array<IterableChannel>>;
  iterableMessageTypes?: Maybe<Array<IterableMessageType>>;
  iterableUser?: Maybe<IterableUserByEmailResponse>;
  /** Returns a league by its ID. */
  league?: Maybe<League>;
  /** Returns a league by its abbreviation. */
  leagueByAbbrev?: Maybe<League>;
  /**
   * Windowed slice of events around a reference date for a given league. Returns an ordered array of
   *   SportsEvent objects composed of (past N events, current/closest event if any, upcoming M events).
   *   The ordering is chronological (past ascending up to reference, then upcoming).
   */
  leagueEventsWindow?: Maybe<Array<Maybe<SportsEvent>>>;
  leaguePayment?: Maybe<LeaguePaymentResponse>;
  /** Returns all active leagues from a specific date range */
  leagues?: Maybe<Array<Maybe<League>>>;
  /** Get all requested leagues by their abbreviations. */
  leaguesByAbbrev: Array<Maybe<League>>;
  masterProduct?: Maybe<MasterProduct>;
  /** Get a match by its ID */
  match?: Maybe<Match>;
  /** Get matches with ids */
  matches: Array<Maybe<Match>>;
  newsletterConfig?: Maybe<NewsletterConfigs>;
  newsletters: Array<Newsletters>;
  newslettersBySite: Array<Newsletters>;
  openWebSSOHandshake: RegisterOpenWebUserResponse;
  /** Get a parlay by id */
  parlay?: Maybe<Parlay>;
  /**
   * A brief extract of an Expert Pick.
   *   Used to embed relevant pick information into other content, like articles or game summaries
   */
  pickSnippet?: Maybe<PickSnippet>;
  /** Pick Snippets in form of a parlay */
  pickSnippetParlay?: Maybe<PickSnippetParlay>;
  player?: Maybe<Player>;
  /** Get all requested players by their IDs */
  players: Array<Maybe<Player>>;
  privacyToken?: Maybe<PrivacyToken>;
  projectionMarkets?: Maybe<Array<MarketCategory>>;
  /**
   * Retrieves a list of promoted (free) expert picks based on the specified filter.
   *   The filter criteria can include one or more leagues (e.g., 'NFL', 'NBA').
   *   This query is designed to return a limited number of picks (default and maximum is 5)
   *   The results are ordered by the the creation date of the picks, from oldest to newest and
   *   then ordered by the scheduled date of the game, from newest to oldest.
   */
  promotedExpertPicks?: Maybe<ExpertPicksConnection>;
  recurlyAccountBillingInfo?: Maybe<RecurlyAccountBillingInfoResponse>;
  recurlyAccountSubscriptions?: Maybe<Array<RecurlySubscriptionResponse>>;
  recurlyCoupon?: Maybe<RecurlyCoupon>;
  recurlyCouponByCode?: Maybe<RecurlyCoupon>;
  recurlyCoupons?: Maybe<Array<Maybe<RecurlyCoupon>>>;
  recurlyInvoice?: Maybe<RecurlyInvoice>;
  recurlyPlan?: Maybe<RecurlyPlan>;
  recurlyPlans?: Maybe<Array<Maybe<RecurlyPlan>>>;
  recurlySubscription?: Maybe<RecurlySubscriptionResponse>;
  searchPlaces?: Maybe<Array<Place>>;
  season?: Maybe<Season>;
  /**
   * Get all requested seasons by their IDs or years or league ids
   *   *Constraints: `first` has a maximum limit of 500*
   */
  seasons?: Maybe<SeasonConnection>;
  /** Get a market by its ID */
  sidelinesMarket?: Maybe<SidelinesMarket>;
  siteNewsletterConfigs: Array<NewsletterConfigs>;
  siteNewsletterDisplayOrder: Array<Scalars['Int']['output']>;
  socialStatusByCustId?: Maybe<Array<Maybe<SocialDetails>>>;
  /** @deprecated Use socialUserDetailV2 */
  socialUserDetails?: Maybe<Array<Maybe<SocialDetails>>>;
  socialUserDetailsV2?: Maybe<SocialDetailsResult>;
  /** Get a sport by ID */
  sport?: Maybe<Sport>;
  sportsEvent?: Maybe<SportsEvent>;
  /** Fetch a single sports match by its unique identifier. */
  sportsMatch?: Maybe<SportsMatch>;
  /** Fetch multiple sports matches by their unique identifiers. Ordering of results matches input ids; missing ids may return null entries. */
  sportsMatches: Array<Maybe<SportsMatch>>;
  sportsPlayer?: Maybe<SportsPlayer>;
  /** Retrieves the guild information for the Sportsline Discord server. */
  sportslineDiscordGuild?: Maybe<SportslineDiscordGuild>;
  /** Retrieves the user information for a guild member in the Sportsline Discord server. The user id will be taken from the header(x-auth-user-id) */
  sportslineDiscordUser?: Maybe<SportslineDiscordGuildUser>;
  /** Retrieves the configuration for the Sportsline Discord widget. */
  sportslineDiscordWidgetConfig?: Maybe<SportslineDiscordWidgetConfig>;
  /**
   * Fetches a SportslineExpert object based on the provided CBS expert ID.
   *
   *   Arguments:
   *   id (Int!): The unique identifier of the CBS expert.
   *
   *   Returns:
   *   SportslineExpert: The SportslineExpert object associated with the given CBS expert ID.
   */
  sportslineExpertByCbsExpertId?: Maybe<SportslineExpert>;
  team?: Maybe<Team>;
  /** Get all requested teams by their IDs */
  teams: Array<Maybe<Team>>;
  /**
   * Get teams by league id
   *   *Constraints: `first` has a maximum limit of 500*
   */
  teamsByLeagueIds: TeamLeagueConnection;
  /** Get tennis tournaments with optional filtering */
  tennisTournaments?: Maybe<CompetitionParentConnection>;
  /** Get all requested Tennis vendor players by their player ID or vendor id or league id */
  tennisVendorPlayers?: Maybe<VendorPlayersConnection>;
  /** Fetch a competition by its unique identifier */
  tournament?: Maybe<CompetitionParent>;
  userDetails?: Maybe<UserDetails>;
  userDetailsByPid?: Maybe<UserDetails>;
  userPreferences?: Maybe<UserPreferences>;
  /**
   * Fetch user recommended content.
   *
   *   WIP: this is subject to change, DO NOT USE in production
   */
  userRecommendedContentInit?: Maybe<UserRecommendedContent>;
  /**
   * Fetch next user recommended content.
   *
   *   WIP: this is subject to change, DO NOT USE in production
   */
  userRecommendedContentNext?: Maybe<UserRecommendedContent>;
  userSubscriptionByCustId?: Maybe<Array<UserSubscription>>;
  validateUserFields?: Maybe<ValidateUserFields>;
  vendor?: Maybe<Vendor>;
  vendorByName?: Maybe<Vendor>;
  /**
   * Get all requested vendor competitions by their competition ID or vendor id
   *   *Constraints: `first` has a maximum limit of 500*
   */
  vendorCompetitions?: Maybe<VendorCompetitionsConnection>;
  /**
   * Get all requested vendor complex venues by their vendor ID or complex ID or venue ID
   *   *Constraints: `first` has a maximum limit of 500*
   */
  vendorComplexVenues?: Maybe<VendorComplexVenuesConnection>;
  vendorGame?: Maybe<VendorGame>;
  /**
   * Get all requested vendor games by their game ID or vendor id or league id
   *   *Constraints: `first` has a maximum limit of 500*
   */
  vendorGames?: Maybe<VendorGamesConnection>;
  /** Get vendor market by id */
  vendorMarket?: Maybe<VendorMarket>;
  /**
   * Get all requested vendor markets by their vendor id or market id or vendor market id
   *   *Constraints: `first` has a maximum limit of 500*
   */
  vendorMarkets?: Maybe<VendorMarketsConnection>;
  /**
   * Get all requested vendor matches by their match ID or vendor id or vendor match ID.
   *   *Constraints: `first` has a maximum limit of 500*
   */
  vendorMatches?: Maybe<VendorMatchConnection>;
  vendorPlayer?: Maybe<VendorPlayer>;
  /**
   * Get all requested vendor player pairs by their vendor ID or pair ID
   *   *Constraints: `first` has a maximum limit of 500*
   */
  vendorPlayerPairs?: Maybe<VendorPlayerPairsConnection>;
  /**
   * Get all requested vendor players by their player ID or vendor id or league id
   *   *Constraints: `first` has a maximum limit of 500*
   */
  vendorPlayers?: Maybe<VendorPlayersConnection>;
  /**
   * Get all requested vendor seasons by their vendor ID or season id or vendorSeasonId
   *   *Constraints: `first` has a maximum limit of 500*
   */
  vendorSeasons?: Maybe<VendorSeasonsConnection>;
  vendorTeam?: Maybe<VendorTeam>;
  /**
   * Get all requested vendor teams by their team ID or vendor id or league id
   *   *Constraints: `first` has a maximum limit of 500*
   */
  vendorTeams?: Maybe<VendorTeamsConnection>;
  venue?: Maybe<Venue>;
  /** Fetches VideoRows from Wayfinder */
  videoMenu?: Maybe<VideoMenuPage>;
  viewer?: Maybe<UserDetails>;
  /** Fetch an X Handle. */
  xHandle?: Maybe<XHandle>;
  /** Fetch X Handles by filtering. */
  xHandles?: Maybe<XHandleConnection>;
  /** Fetch an X Tweet. */
  xTweet?: Maybe<XTweet>;
  /** Fetch X Tweets by filtering. */
  xTweets?: Maybe<XTweetConnection>;
};


/** query for venue type */
export type QueryBettingMarketArgs = {
  id: Scalars['ID']['input'];
};


/** query for venue type */
export type QueryBettingPlayerPropsProjectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<PlayerPropsProjectionFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Array<PlayerPropsProjectionSortInput>>;
};


/** query for venue type */
export type QueryCategoryArgs = {
  id: Scalars['ID']['input'];
};


/** query for venue type */
export type QueryCmsArticleArgs = {
  id: Scalars['ID']['input'];
};


/** query for venue type */
export type QueryCmsAutocompleteEventArgs = {
  input?: CmsSportsObjectEventsInput;
};


/** query for venue type */
export type QueryCmsAutocompleteGameArgs = {
  input?: CmsSportsObjectGamesInput;
};


/** query for venue type */
export type QueryCmsAutocompleteLeagueArgs = {
  input?: CmsSportsObjectLeaguesInput;
};


/** query for venue type */
export type QueryCmsAutocompletePlayerArgs = {
  input?: CmsSportsObjectPlayersInput;
};


/** query for venue type */
export type QueryCmsAutocompleteSportArgs = {
  input?: CmsSportsObjectSportsInput;
};


/** query for venue type */
export type QueryCmsAutocompleteTeamArgs = {
  input?: CmsSportsObjectTeamsInput;
};


/** query for venue type */
export type QueryCmsComponentArgs = {
  input: CmsComponentInput;
};


/** query for venue type */
export type QueryCmsComponentBySlugArgs = {
  input: CmsComponentSlugInput;
};


/** query for venue type */
export type QueryCmsCustomConfigArgs = {
  input: CmsContentIdInput;
};


/** query for venue type */
export type QueryCmsCustomConfigBySlugArgs = {
  input: CmsContentSlugInput;
};


/** query for venue type */
export type QueryCmsFeatureArgs = {
  input: CmsContentIdEditionInput;
};


/** query for venue type */
export type QueryCmsFeatureBySlugArgs = {
  input: CmsContentSlugEditionInput;
};


/** query for venue type */
export type QueryCmsLiveBlogArgs = {
  id: Scalars['ID']['input'];
};


/** query for venue type */
export type QueryCmsPollArgs = {
  input: CmsPollInput;
};


/** query for venue type */
export type QueryCmsPollsArgs = {
  input: CmsPollsInput;
};


/** query for venue type */
export type QueryCmsRecommendedContentArgs = {
  ids: Array<CmsRecommendedContentIdInput>;
};


/** query for venue type */
export type QueryCmsVideoArgs = {
  id: Scalars['ID']['input'];
};


/** query for venue type */
export type QueryCompetitionSeasonsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  competitionId?: InputMaybe<Scalars['ID']['input']>;
  complexId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  seasonId?: InputMaybe<Scalars['ID']['input']>;
  surface?: InputMaybe<Scalars['String']['input']>;
};


/** query for venue type */
export type QueryComplexArgs = {
  id: Scalars['ID']['input'];
};


/** query for venue type */
export type QueryCountryArgs = {
  id: Scalars['ID']['input'];
};


/** query for venue type */
export type QueryCountryByNameArgs = {
  countryName: Scalars['String']['input'];
};


/** query for venue type */
export type QueryEventArgs = {
  id: Scalars['ID']['input'];
};


/** query for venue type */
export type QueryEventPlayerArgs = {
  id: Scalars['ID']['input'];
};


/** query for venue type */
export type QueryExpertPickArgs = {
  id: Scalars['ID']['input'];
};


/** query for venue type */
export type QueryExpertPicksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ExpertPickFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Array<ExpertPickSortByInput>>;
};


/** query for venue type */
export type QueryFreeExpertPickArgs = {
  id: Scalars['ID']['input'];
};


/** query for venue type */
export type QueryFreeExpertPicksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ExpertPickFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Array<ExpertPickSortByInput>>;
};


/** query for venue type */
export type QueryGameArgs = {
  id: Scalars['ID']['input'];
};


/** query for venue type */
export type QueryGameByAbbrevArgs = {
  abbrev: Scalars['String']['input'];
};


/** query for venue type */
export type QueryGamesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


/** query for venue type */
export type QueryGetAllBracketologyDataByTeamIdArgs = {
  teamId: Scalars['Int']['input'];
};


/** query for venue type */
export type QueryGetCodeProfilesArgs = {
  input: CodeProfilesInput;
};


/** query for venue type */
export type QueryGetMvpdConfigurationArgs = {
  serviceProvider?: InputMaybe<Scalars['String']['input']>;
};


/** query for venue type */
export type QueryGetMvpdProfilesArgs = {
  input: MvpdProfilesInput;
};


/** query for venue type */
export type QueryGetUserMvpdArgs = {
  input: SapiUserMvpdInput;
};


/** query for venue type */
export type QueryGetUserNewsletterSubscriptionsArgs = {
  input: GetUserNewslettersSubscriptionInput;
};


/** query for venue type */
export type QueryGoogleUserProfileArgs = {
  input: GoogleUserProfileInput;
};


/** query for venue type */
export type QueryGraphicArgs = {
  id: Scalars['ID']['input'];
};


/** query for venue type */
export type QueryGraphicByNameArgs = {
  name: Scalars['String']['input'];
};


/** query for venue type */
export type QueryGraphicCountArgs = {
  filters?: InputMaybe<GraphicFiltersInput>;
};


/** query for venue type */
export type QueryGraphicExportArgs = {
  id: Scalars['ID']['input'];
};


/** query for venue type */
export type QueryGraphicExportCountArgs = {
  filters?: InputMaybe<GraphicExportFiltersInput>;
};


/** query for venue type */
export type QueryGraphicExportsArgs = {
  filters?: InputMaybe<GraphicExportFilterInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


/** query for venue type */
export type QueryGraphicExportsByFiltersArgs = {
  filters: GraphicExportFiltersInput;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


/** query for venue type */
export type QueryGraphicExportsByGraphicIdArgs = {
  id: Scalars['ID']['input'];
};


/** query for venue type */
export type QueryGraphicScheduleTaskArgs = {
  id: Scalars['ID']['input'];
};


/** query for venue type */
export type QueryGraphicScheduleTaskCountArgs = {
  filters?: InputMaybe<GraphicScheduleTaskFiltersInput>;
};


/** query for venue type */
export type QueryGraphicScheduleTasksByFiltersArgs = {
  filters: GraphicScheduleTaskFiltersInput;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


/** query for venue type */
export type QueryGraphicScheduleTasksByGraphicIdArgs = {
  graphicId: Scalars['String']['input'];
};


/** query for venue type */
export type QueryGraphicTagsByGraphicIdArgs = {
  id: Scalars['ID']['input'];
};


/** query for venue type */
export type QueryGraphicsByFiltersArgs = {
  filters: GraphicFiltersInput;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


/** query for venue type */
export type QueryGraphicsByTagsArgs = {
  tags: Array<Scalars['String']['input']>;
};


/** query for venue type */
export type QueryGraphicsCardArgs = {
  id: Scalars['ID']['input'];
};


/** query for venue type */
export type QueryGraphicsCardsArgs = {
  input: GraphicsCardsInput;
};


/** query for venue type */
export type QueryGraphicsUserArgs = {
  id: Scalars['ID']['input'];
};


/** query for venue type */
export type QueryHottestExpertsArgs = {
  leagueAbbrev?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};


/** query for venue type */
export type QueryIterableUserArgs = {
  email: Scalars['String']['input'];
};


/** query for venue type */
export type QueryLeagueArgs = {
  id: Scalars['ID']['input'];
};


/** query for venue type */
export type QueryLeagueByAbbrevArgs = {
  abbrev: Scalars['String']['input'];
};


/** query for venue type */
export type QueryLeagueEventsWindowArgs = {
  leagueAbbrev: Scalars['String']['input'];
  pastEvents?: InputMaybe<Scalars['Int']['input']>;
  referenceDate: Scalars['Date']['input'];
  upcomingEvents?: InputMaybe<Scalars['Int']['input']>;
};


/** query for venue type */
export type QueryLeaguePaymentArgs = {
  input: LeaguePaymentInput;
};


/** query for venue type */
export type QueryLeaguesArgs = {
  seasonEnd?: InputMaybe<Scalars['Date']['input']>;
  seasonStart?: InputMaybe<Scalars['Date']['input']>;
};


/** query for venue type */
export type QueryLeaguesByAbbrevArgs = {
  abbrevs: Array<Scalars['String']['input']>;
};


/** query for venue type */
export type QueryMasterProductArgs = {
  input: MasterProductInput;
};


/** query for venue type */
export type QueryMatchArgs = {
  id: Scalars['ID']['input'];
};


/** query for venue type */
export type QueryMatchesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


/** query for venue type */
export type QueryNewsletterConfigArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  mpid: Scalars['Int']['input'];
};


/** query for venue type */
export type QueryNewslettersBySiteArgs = {
  siteId: Scalars['Int']['input'];
};


/** query for venue type */
export type QueryOpenWebSsoHandshakeArgs = {
  codeA: Scalars['String']['input'];
};


/** query for venue type */
export type QueryParlayArgs = {
  id: Scalars['ID']['input'];
};


/** query for venue type */
export type QueryPickSnippetArgs = {
  input: PickSnippetInput;
};


/** query for venue type */
export type QueryPickSnippetParlayArgs = {
  input: Array<PickSnippetInput>;
};


/** query for venue type */
export type QueryPlayerArgs = {
  id: Scalars['ID']['input'];
};


/** query for venue type */
export type QueryPlayersArgs = {
  ids: Array<Scalars['ID']['input']>;
};


/** query for venue type */
export type QueryPrivacyTokenArgs = {
  input: PrivacyTokenInput;
};


/** query for venue type */
export type QueryProjectionMarketsArgs = {
  categoryType: BettingCategoryType;
  leagueId: Scalars['ID']['input'];
};


/** query for venue type */
export type QueryPromotedExpertPicksArgs = {
  filter?: InputMaybe<PromotedExpertPickFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Array<ExpertPickSortByInput>>;
};


/** query for venue type */
export type QueryRecurlyAccountBillingInfoArgs = {
  custId: Scalars['Int']['input'];
};


/** query for venue type */
export type QueryRecurlyAccountSubscriptionsArgs = {
  input: RecurlyAccountSubscriptionsInput;
};


/** query for venue type */
export type QueryRecurlyCouponArgs = {
  id: Scalars['String']['input'];
};


/** query for venue type */
export type QueryRecurlyCouponByCodeArgs = {
  code: Scalars['String']['input'];
};


/** query for venue type */
export type QueryRecurlyCouponsArgs = {
  filter?: InputMaybe<RecurlyCouponsFilter>;
  input?: InputMaybe<RecurlyCouponsInput>;
};


/** query for venue type */
export type QueryRecurlyInvoiceArgs = {
  id: Scalars['String']['input'];
};


/** query for venue type */
export type QueryRecurlyPlanArgs = {
  id: Scalars['String']['input'];
};


/** query for venue type */
export type QueryRecurlyPlansArgs = {
  filter?: InputMaybe<RecurlyPlansFilter>;
  input?: InputMaybe<RecurlyPlansInput>;
};


/** query for venue type */
export type QueryRecurlySubscriptionArgs = {
  subscriptionId: Scalars['String']['input'];
};


/** query for venue type */
export type QuerySearchPlacesArgs = {
  value: Scalars['String']['input'];
};


/** query for venue type */
export type QuerySeasonArgs = {
  id: Scalars['ID']['input'];
};


/** query for venue type */
export type QuerySeasonsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  leagueIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  years?: InputMaybe<Array<Scalars['Int']['input']>>;
};


/** query for venue type */
export type QuerySidelinesMarketArgs = {
  id: Scalars['ID']['input'];
};


/** query for venue type */
export type QuerySiteNewsletterConfigsArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  siteId: Scalars['Int']['input'];
};


/** query for venue type */
export type QuerySiteNewsletterDisplayOrderArgs = {
  siteId: Scalars['Int']['input'];
};


/** query for venue type */
export type QuerySocialStatusByCustIdArgs = {
  input: SocialStatusByCustIdInput;
};


/** query for venue type */
export type QuerySocialUserDetailsArgs = {
  input: SocialDetailsInput;
};


/** query for venue type */
export type QuerySocialUserDetailsV2Args = {
  input: SocialDetailsInput;
};


/** query for venue type */
export type QuerySportArgs = {
  id: Scalars['ID']['input'];
};


/** query for venue type */
export type QuerySportsEventArgs = {
  id: Scalars['ID']['input'];
};


/** query for venue type */
export type QuerySportsMatchArgs = {
  id: Scalars['ID']['input'];
};


/** query for venue type */
export type QuerySportsMatchesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


/** query for venue type */
export type QuerySportsPlayerArgs = {
  id: Scalars['ID']['input'];
};


/** query for venue type */
export type QuerySportslineExpertByCbsExpertIdArgs = {
  id: Scalars['Int']['input'];
};


/** query for venue type */
export type QueryTeamArgs = {
  id: Scalars['ID']['input'];
};


/** query for venue type */
export type QueryTeamsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


/** query for venue type */
export type QueryTeamsByLeagueIdsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  leagueIds: Array<Scalars['ID']['input']>;
};


/** query for venue type */
export type QueryTennisTournamentsArgs = {
  activeSince?: InputMaybe<Scalars['Date']['input']>;
  activeUntil?: InputMaybe<Scalars['Date']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  leagueAbbrevs?: InputMaybe<Array<Scalars['String']['input']>>;
  levels?: InputMaybe<Array<CompetitionLevel>>;
  types?: InputMaybe<Array<CompetitionType>>;
};


/** query for venue type */
export type QueryTennisVendorPlayersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  leagueId?: InputMaybe<Scalars['ID']['input']>;
  playerId?: InputMaybe<Scalars['ID']['input']>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
  vendorPlayerId?: InputMaybe<Scalars['String']['input']>;
};


/** query for venue type */
export type QueryTournamentArgs = {
  id: Scalars['ID']['input'];
};


/** query for venue type */
export type QueryUserDetailsArgs = {
  input: UserDetailsInput;
};


/** query for venue type */
export type QueryUserDetailsByPidArgs = {
  input: UserDetailsByPidInput;
};


/** query for venue type */
export type QueryUserPreferencesArgs = {
  custId: Scalars['Int']['input'];
};


/** query for venue type */
export type QueryUserRecommendedContentInitArgs = {
  input: UserRecommendedContentInitInput;
};


/** query for venue type */
export type QueryUserRecommendedContentNextArgs = {
  input: UserRecommendedContentNextInput;
};


/** query for venue type */
export type QueryUserSubscriptionByCustIdArgs = {
  input: GetUserSubscriptionsInput;
};


/** query for venue type */
export type QueryValidateUserFieldsArgs = {
  input: ValidateUserFieldsInput;
};


/** query for venue type */
export type QueryVendorArgs = {
  id: Scalars['ID']['input'];
};


/** query for venue type */
export type QueryVendorByNameArgs = {
  name: Scalars['String']['input'];
};


/** query for venue type */
export type QueryVendorCompetitionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  competitionId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  vendorCompetitionId?: InputMaybe<Scalars['String']['input']>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};


/** query for venue type */
export type QueryVendorComplexVenuesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  complexId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  vendorComplexId?: InputMaybe<Scalars['String']['input']>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
  vendorVenueId?: InputMaybe<Scalars['String']['input']>;
  venueId?: InputMaybe<Scalars['ID']['input']>;
};


/** query for venue type */
export type QueryVendorGameArgs = {
  id: Scalars['ID']['input'];
};


/** query for venue type */
export type QueryVendorGamesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  gameId?: InputMaybe<Scalars['ID']['input']>;
  leagueId?: InputMaybe<Scalars['ID']['input']>;
  vendorGameId?: InputMaybe<Scalars['String']['input']>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};


/** query for venue type */
export type QueryVendorMarketArgs = {
  id: Scalars['ID']['input'];
};


/** query for venue type */
export type QueryVendorMarketsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  leagueId?: InputMaybe<Scalars['ID']['input']>;
  marketId?: InputMaybe<Scalars['ID']['input']>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
  vendorMarketId?: InputMaybe<Scalars['String']['input']>;
};


/** query for venue type */
export type QueryVendorMatchesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  matchId?: InputMaybe<Scalars['ID']['input']>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
  vendorMatchId?: InputMaybe<Scalars['String']['input']>;
};


/** query for venue type */
export type QueryVendorPlayerArgs = {
  id: Scalars['ID']['input'];
};


/** query for venue type */
export type QueryVendorPlayerPairsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  pairId?: InputMaybe<Scalars['ID']['input']>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
  vendorPairId?: InputMaybe<Scalars['String']['input']>;
};


/** query for venue type */
export type QueryVendorPlayersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  leagueId?: InputMaybe<Scalars['ID']['input']>;
  playerId?: InputMaybe<Scalars['ID']['input']>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
  vendorPlayerId?: InputMaybe<Scalars['String']['input']>;
};


/** query for venue type */
export type QueryVendorSeasonsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  seasonId?: InputMaybe<Scalars['ID']['input']>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
  vendorSeasonId?: InputMaybe<Scalars['String']['input']>;
};


/** query for venue type */
export type QueryVendorTeamArgs = {
  id: Scalars['ID']['input'];
};


/** query for venue type */
export type QueryVendorTeamsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  leagueId?: InputMaybe<Scalars['ID']['input']>;
  teamId?: InputMaybe<Scalars['ID']['input']>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
  vendorTeamId?: InputMaybe<Scalars['String']['input']>;
};


/** query for venue type */
export type QueryVenueArgs = {
  id: Scalars['ID']['input'];
};


/** query for venue type */
export type QueryVideoMenuArgs = {
  device: Scalars['String']['input'];
  dma?: InputMaybe<Scalars['String']['input']>;
  dmaDaiOptIn?: InputMaybe<Scalars['String']['input']>;
  dmaGroup?: InputMaybe<Scalars['String']['input']>;
  menuId: Scalars['Int']['input'];
  transform: Scalars['String']['input'];
};


/** query for venue type */
export type QueryXHandleArgs = {
  id: Scalars['ID']['input'];
};


/** query for venue type */
export type QueryXHandlesArgs = {
  input: XHandlesInput;
};


/** query for venue type */
export type QueryXTweetArgs = {
  id: Scalars['ID']['input'];
};


/** query for venue type */
export type QueryXTweetsArgs = {
  input: XTweetsInput;
};

export type RecurlyAccount = {
  __typename?: 'RecurlyAccount';
  billTo?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  dunningCampaignId?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  object?: Maybe<Scalars['String']['output']>;
  parentAccountId?: Maybe<Scalars['String']['output']>;
};

export type RecurlyAccountAddress = {
  __typename?: 'RecurlyAccountAddress';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  street1?: Maybe<Scalars['String']['output']>;
  street2?: Maybe<Scalars['String']['output']>;
};

export type RecurlyAccountBillingInfo = {
  __typename?: 'RecurlyAccountBillingInfo';
  accountId?: Maybe<Scalars['String']['output']>;
  address?: Maybe<RecurlyAccountAddress>;
  backupPaymentMethod?: Maybe<Scalars['Boolean']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fraud?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  object?: Maybe<Scalars['String']['output']>;
  paymentMethod?: Maybe<RecurlyAccountPaymentMethod>;
  primaryPaymentMethod?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<UpdatedBy>;
  valid?: Maybe<Scalars['Boolean']['output']>;
  vatNumber?: Maybe<Scalars['String']['output']>;
};

export type RecurlyAccountBillingInfoResponse = {
  __typename?: 'RecurlyAccountBillingInfoResponse';
  accountId?: Maybe<Scalars['String']['output']>;
  address?: Maybe<RecurlyAddress>;
  backupPaymentMethod?: Maybe<Scalars['Boolean']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fraud?: Maybe<RecurlyFraudInfo>;
  id?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  object?: Maybe<Scalars['String']['output']>;
  paymentMethod?: Maybe<RecurlyPaymentMethod>;
  primaryPaymentMethod?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<RecurlyUpdatedBy>;
  valid?: Maybe<Scalars['Boolean']['output']>;
  vatNumber?: Maybe<Scalars['String']['output']>;
};

export type RecurlyAccountPaymentMethod = {
  __typename?: 'RecurlyAccountPaymentMethod';
  cardNetworkPreference?: Maybe<Scalars['String']['output']>;
  cardType?: Maybe<Scalars['String']['output']>;
  ccBinCountry?: Maybe<Scalars['String']['output']>;
  expMonth?: Maybe<Scalars['Int']['output']>;
  expYear?: Maybe<Scalars['Int']['output']>;
  firstSix?: Maybe<Scalars['String']['output']>;
  lastFour?: Maybe<Scalars['String']['output']>;
  object?: Maybe<Scalars['String']['output']>;
};

export type RecurlyAccountSubscriptionsInput = {
  custId: Scalars['Int']['input'];
  filters?: InputMaybe<RecurlyAccountSubscriptionsInputParameters>;
};

export type RecurlyAccountSubscriptionsInputParameters = {
  beginTime?: InputMaybe<Scalars['DateTime']['input']>;
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<RecurlySortOrder>;
  sort?: InputMaybe<RecurlySortBy>;
  state?: InputMaybe<RecurlySubscriptionState>;
};

export type RecurlyAddOn = {
  __typename?: 'RecurlyAddOn';
  addOn?: Maybe<RecurlyAddOnDetails>;
  addOnSource?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  expiredAt?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  object?: Maybe<Scalars['String']['output']>;
  percentageTiers?: Maybe<Array<Maybe<RecurlyPercentageTier>>>;
  quantity?: Maybe<Scalars['Int']['output']>;
  revenueScheduleType?: Maybe<Scalars['String']['output']>;
  subscriptionId?: Maybe<Scalars['String']['output']>;
  tierType?: Maybe<Scalars['String']['output']>;
  tiers?: Maybe<Array<Maybe<RecurlyTier>>>;
  unitAmount?: Maybe<Scalars['Float']['output']>;
  unitAmountDecimal?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  usageCalculationType?: Maybe<Scalars['String']['output']>;
  usagePercentage?: Maybe<Scalars['Float']['output']>;
  usageTimeframe?: Maybe<Scalars['String']['output']>;
};

export type RecurlyAddOnDetails = {
  __typename?: 'RecurlyAddOnDetails';
  accountingCode?: Maybe<Scalars['String']['output']>;
  addOnType?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  externalSku?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  itemId?: Maybe<Scalars['String']['output']>;
  measuredUnitId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  object?: Maybe<Scalars['String']['output']>;
  usagePercentage?: Maybe<Scalars['Float']['output']>;
  usageType?: Maybe<Scalars['String']['output']>;
};

export type RecurlyAddress = {
  __typename?: 'RecurlyAddress';
  accountId?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  geoCode?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  object?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  street1?: Maybe<Scalars['String']['output']>;
  street2?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  vatNumber?: Maybe<Scalars['String']['output']>;
};

export type RecurlyBillingInfo = {
  __typename?: 'RecurlyBillingInfo';
  threeDSecureActionResultTokenId?: Maybe<Scalars['String']['output']>;
};

export type RecurlyCancelSubscriptionInput = {
  subscriptionId: Scalars['String']['input'];
  timeframe?: InputMaybe<Timeframe>;
};

export type RecurlyChargeInvoice = {
  __typename?: 'RecurlyChargeInvoice';
  account?: Maybe<RecurlyAccount>;
  address?: Maybe<RecurlyAddress>;
  balance?: Maybe<Scalars['Float']['output']>;
  billingInfoId?: Maybe<Scalars['String']['output']>;
  businessEntityId?: Maybe<Scalars['String']['output']>;
  closedAt?: Maybe<Scalars['String']['output']>;
  collectionMethod?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  creditPayments?: Maybe<Array<Maybe<RecurlyCreditPayment>>>;
  currency?: Maybe<Scalars['String']['output']>;
  customerNotes?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  dueAt?: Maybe<Scalars['String']['output']>;
  dunningCampaignId?: Maybe<Scalars['String']['output']>;
  dunningEventsSent?: Maybe<Scalars['Int']['output']>;
  finalDunningEvent?: Maybe<Scalars['Boolean']['output']>;
  hasMoreLineItems?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lineItems?: Maybe<Array<Maybe<RecurlyLineItem>>>;
  netTerms?: Maybe<Scalars['Int']['output']>;
  netTermsType?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  object?: Maybe<Scalars['String']['output']>;
  origin?: Maybe<Scalars['String']['output']>;
  paid?: Maybe<Scalars['Float']['output']>;
  poNumber?: Maybe<Scalars['String']['output']>;
  previousInvoiceId?: Maybe<Scalars['String']['output']>;
  refundableAmount?: Maybe<Scalars['Float']['output']>;
  shippingAddress?: Maybe<RecurlyAddress>;
  state?: Maybe<Scalars['String']['output']>;
  subscriptionIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  subtotal?: Maybe<Scalars['Float']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  taxInfo?: Maybe<RecurlyTaxInfo>;
  termsAndConditions?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
  transactions?: Maybe<Array<Maybe<RecurlyTransaction>>>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  usedTaxService?: Maybe<Scalars['Boolean']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
  vatNumber?: Maybe<Scalars['String']['output']>;
  vatReverseChargeNotes?: Maybe<Scalars['String']['output']>;
};

export type RecurlyCoupon = {
  __typename?: 'RecurlyCoupon';
  appliesToAllItems?: Maybe<Scalars['Boolean']['output']>;
  appliesToAllPlans?: Maybe<Scalars['Boolean']['output']>;
  appliesToNonPlanCharges?: Maybe<Scalars['Boolean']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  couponType?: Maybe<RecurlyCouponType>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  discount?: Maybe<RecurlyDiscount>;
  discountAmount?: Maybe<Scalars['Float']['output']>;
  duration?: Maybe<Scalars['String']['output']>;
  expiredAt?: Maybe<Scalars['DateTime']['output']>;
  freeTrialAmount?: Maybe<Scalars['Int']['output']>;
  freeTrialUnit?: Maybe<RecurlyFreeTrialUnit>;
  id?: Maybe<Scalars['String']['output']>;
  invoiceDescription?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<Maybe<RecurlyItems>>>;
  maxRedemptions?: Maybe<Scalars['Int']['output']>;
  maxRedemptionsPerAccount?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  object?: Maybe<Scalars['String']['output']>;
  plans?: Maybe<Array<Maybe<RecurlyPlan>>>;
  redeemBy?: Maybe<Scalars['DateTime']['output']>;
  redemptionResource?: Maybe<RecurlyCouponRedemptionResource>;
  state?: Maybe<RecurlyCouponState>;
  temporalAmount?: Maybe<Scalars['Int']['output']>;
  temporalUnit?: Maybe<RecurlyCouponTemporalUnit>;
  uniqueCouponCode?: Maybe<RecurlyUniqueCouponCode>;
  uniqueCouponCodes?: Maybe<Array<Maybe<RecurlyUniqueCouponCode>>>;
  uniqueCouponCodesCount?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type RecurlyCouponDiscountAmountArgs = {
  currency?: InputMaybe<Scalars['String']['input']>;
};

export enum RecurlyCouponDuration {
  Forever = 'forever',
  SingleUse = 'single_use',
  Temporal = 'temporal'
}

export enum RecurlyCouponFreeTrialUnit {
  Day = 'day',
  Month = 'month',
  Week = 'week'
}

export type RecurlyCouponRedemption = {
  __typename?: 'RecurlyCouponRedemption';
  coupon?: Maybe<RecurlyCoupon>;
  createdAt?: Maybe<Scalars['String']['output']>;
  discounted?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  object?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export enum RecurlyCouponRedemptionResource {
  Account = 'Account',
  Subscription = 'Subscription'
}

export enum RecurlyCouponState {
  Expired = 'expired',
  Inactive = 'inactive',
  MaxedOut = 'maxed_out',
  Redeemable = 'redeemable'
}

export enum RecurlyCouponTemporalUnit {
  Day = 'day',
  Month = 'month',
  Week = 'week',
  Year = 'year'
}

export enum RecurlyCouponType {
  Bulk = 'bulk',
  SingleCode = 'single_code'
}

export type RecurlyCouponsFilter = {
  state: RecurlyCouponState;
};

export type RecurlyCouponsInput = {
  beginTime?: InputMaybe<Scalars['DateTime']['input']>;
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<RecurlySortOrder>;
  sort?: InputMaybe<RecurlySortBy>;
};

export type RecurlyCreditInvoice = {
  __typename?: 'RecurlyCreditInvoice';
  account?: Maybe<RecurlyAccount>;
  address?: Maybe<RecurlyAddress>;
  balance?: Maybe<Scalars['Float']['output']>;
  billingInfoId?: Maybe<Scalars['String']['output']>;
  businessEntityId?: Maybe<Scalars['String']['output']>;
  closedAt?: Maybe<Scalars['String']['output']>;
  collectionMethod?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  creditPayments?: Maybe<Array<Maybe<RecurlyCreditPayment>>>;
  currency?: Maybe<Scalars['String']['output']>;
  customerNotes?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  dueAt?: Maybe<Scalars['String']['output']>;
  dunningCampaignId?: Maybe<Scalars['String']['output']>;
  dunningEventsSent?: Maybe<Scalars['Int']['output']>;
  finalDunningEvent?: Maybe<Scalars['Boolean']['output']>;
  hasMoreLineItems?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lineItems?: Maybe<Array<Maybe<RecurlyLineItem>>>;
  netTerms?: Maybe<Scalars['Int']['output']>;
  netTermsType?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  object?: Maybe<Scalars['String']['output']>;
  origin?: Maybe<Scalars['String']['output']>;
  paid?: Maybe<Scalars['Float']['output']>;
  poNumber?: Maybe<Scalars['String']['output']>;
  previousInvoiceId?: Maybe<Scalars['String']['output']>;
  refundableAmount?: Maybe<Scalars['Float']['output']>;
  shippingAddress?: Maybe<RecurlyAddress>;
  state?: Maybe<Scalars['String']['output']>;
  subscriptionIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  subtotal?: Maybe<Scalars['Float']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  taxInfo?: Maybe<RecurlyTaxInfo>;
  termsAndConditions?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
  transactions?: Maybe<Array<Maybe<RecurlyTransaction>>>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  usedTaxService?: Maybe<Scalars['Boolean']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
  vatNumber?: Maybe<Scalars['String']['output']>;
  vatReverseChargeNotes?: Maybe<Scalars['String']['output']>;
};

export type RecurlyCreditPayment = {
  __typename?: 'RecurlyCreditPayment';
  account?: Maybe<RecurlyAccount>;
  action?: Maybe<Scalars['String']['output']>;
  amount?: Maybe<Scalars['Int']['output']>;
  appliedToInvoice?: Maybe<RecurlyInvoice>;
  createdAt?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  object?: Maybe<Scalars['String']['output']>;
  originalCreditPaymentId?: Maybe<Scalars['String']['output']>;
  originalInvoice?: Maybe<RecurlyInvoice>;
  refundTransaction?: Maybe<RecurlyRefundTransaction>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
  voidedAt?: Maybe<Scalars['String']['output']>;
};

export type RecurlyCurrency = {
  __typename?: 'RecurlyCurrency';
  amount?: Maybe<Scalars['Float']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
};

export type RecurlyCustomField = {
  __typename?: 'RecurlyCustomField';
  name?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type RecurlyCustomFieldInput = {
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type RecurlyDiscount = {
  __typename?: 'RecurlyDiscount';
  currencies?: Maybe<Array<Maybe<RecurlyCurrency>>>;
  percent?: Maybe<Scalars['Int']['output']>;
  trial?: Maybe<RecurlyTrial>;
  type?: Maybe<RecurlyDiscountType>;
};

export enum RecurlyDiscountType {
  Fixed = 'fixed',
  FreeTrial = 'free_trial',
  Percent = 'percent'
}

export type RecurlyFraudInfo = {
  __typename?: 'RecurlyFraudInfo';
  decision?: Maybe<Scalars['String']['output']>;
  object?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  riskRulesTriggered?: Maybe<Scalars['JSON']['output']>;
  score?: Maybe<Scalars['Int']['output']>;
};

export enum RecurlyFreeTrialUnit {
  Day = 'day',
  Month = 'month',
  Week = 'week'
}

export type RecurlyGatewayAttributes = {
  __typename?: 'RecurlyGatewayAttributes';
  accountReference?: Maybe<Scalars['String']['output']>;
};

export type RecurlyGatewayResponseValue = {
  __typename?: 'RecurlyGatewayResponseValue';
  name?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type RecurlyInvoice = {
  __typename?: 'RecurlyInvoice';
  businessEntityId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  object?: Maybe<Scalars['String']['output']>;
  state?: Maybe<RecurlyInvoiceState>;
  total?: Maybe<Scalars['Float']['output']>;
  transactions?: Maybe<Array<Maybe<RecurlyInvoiceTransaction>>>;
  type?: Maybe<RecurlyInvoiceType>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type RecurlyInvoiceCollection = {
  __typename?: 'RecurlyInvoiceCollection';
  chargeInvoice?: Maybe<RecurlyChargeInvoice>;
  creditInvoices?: Maybe<Array<Maybe<RecurlyCreditInvoice>>>;
  object?: Maybe<Scalars['String']['output']>;
};

export enum RecurlyInvoiceState {
  Closed = 'closed',
  Failed = 'failed',
  Open = 'open',
  Paid = 'paid',
  PastDue = 'past_due',
  Pending = 'pending',
  Processing = 'processing',
  Voided = 'voided'
}

export type RecurlyInvoiceTransaction = {
  __typename?: 'RecurlyInvoiceTransaction';
  gatewayReference?: Maybe<Scalars['String']['output']>;
};

export enum RecurlyInvoiceType {
  Charge = 'charge',
  Credit = 'credit',
  Legacy = 'legacy'
}

export type RecurlyItems = {
  __typename?: 'RecurlyItems';
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  object?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type RecurlyLineItem = {
  __typename?: 'RecurlyLineItem';
  account?: Maybe<RecurlyAccount>;
  accountingCode?: Maybe<Scalars['String']['output']>;
  addOnCode?: Maybe<Scalars['String']['output']>;
  addOnId?: Maybe<Scalars['String']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  avalaraServiceType?: Maybe<Scalars['Int']['output']>;
  avalaraTransactionType?: Maybe<Scalars['Int']['output']>;
  billForAccountId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  creditApplied?: Maybe<Scalars['Int']['output']>;
  creditReasonCode?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  destinationTaxAddressSource?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Scalars['Int']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  externalSku?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  invoiceId?: Maybe<Scalars['String']['output']>;
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  itemCode?: Maybe<Scalars['String']['output']>;
  itemId?: Maybe<Scalars['String']['output']>;
  legacyCategory?: Maybe<Scalars['String']['output']>;
  liabilityGlAccountCode?: Maybe<Scalars['String']['output']>;
  object?: Maybe<Scalars['String']['output']>;
  origin?: Maybe<Scalars['String']['output']>;
  originTaxAddressSource?: Maybe<Scalars['String']['output']>;
  originalLineItemInvoiceId?: Maybe<Scalars['String']['output']>;
  performanceObligationId?: Maybe<Scalars['String']['output']>;
  planCode?: Maybe<Scalars['String']['output']>;
  planId?: Maybe<Scalars['String']['output']>;
  previousLineItemId?: Maybe<Scalars['String']['output']>;
  productCode?: Maybe<Scalars['String']['output']>;
  prorationRate?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  quantityDecimal?: Maybe<Scalars['String']['output']>;
  refund?: Maybe<Scalars['Boolean']['output']>;
  refundedQuantity?: Maybe<Scalars['Int']['output']>;
  refundedQuantityDecimal?: Maybe<Scalars['String']['output']>;
  revenueGlAccountCode?: Maybe<Scalars['String']['output']>;
  revenueScheduleType?: Maybe<Scalars['String']['output']>;
  shippingAddress?: Maybe<RecurlyAddress>;
  startDate?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  subscriptionId?: Maybe<Scalars['String']['output']>;
  subtotal?: Maybe<Scalars['Int']['output']>;
  tax?: Maybe<Scalars['Int']['output']>;
  taxCode?: Maybe<Scalars['String']['output']>;
  taxExempt?: Maybe<Scalars['Boolean']['output']>;
  taxInclusive?: Maybe<Scalars['Boolean']['output']>;
  taxInfo?: Maybe<RecurlyTaxInfo>;
  taxable?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  unitAmount?: Maybe<Scalars['Float']['output']>;
  unitAmountDecimal?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type RecurlyMethod = {
  __typename?: 'RecurlyMethod';
  code?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  object?: Maybe<Scalars['String']['output']>;
};

export type RecurlyPaymentError = {
  __typename?: 'RecurlyPaymentError';
  code?: Maybe<Scalars['String']['output']>;
  err?: Maybe<RecurlyTransactionError>;
};

export type RecurlyPaymentGateway = {
  __typename?: 'RecurlyPaymentGateway';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  object?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type RecurlyPaymentMethod = {
  __typename?: 'RecurlyPaymentMethod';
  accountType?: Maybe<Scalars['String']['output']>;
  billingAgreementId?: Maybe<Scalars['String']['output']>;
  cardNetworkPreference?: Maybe<Scalars['String']['output']>;
  cardType?: Maybe<Scalars['String']['output']>;
  ccBinCountry?: Maybe<Scalars['String']['output']>;
  expMonth?: Maybe<Scalars['Int']['output']>;
  expYear?: Maybe<Scalars['Int']['output']>;
  firstSix?: Maybe<Scalars['String']['output']>;
  gatewayAttributes?: Maybe<RecurlyGatewayAttributes>;
  gatewayCode?: Maybe<Scalars['String']['output']>;
  gatewayToken?: Maybe<Scalars['String']['output']>;
  lastFour?: Maybe<Scalars['String']['output']>;
  lastTwo?: Maybe<Scalars['String']['output']>;
  nameOnAccount?: Maybe<Scalars['String']['output']>;
  object?: Maybe<Scalars['String']['output']>;
  routingNumber?: Maybe<Scalars['String']['output']>;
  routingNumberBank?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type RecurlyPendingChange = {
  __typename?: 'RecurlyPendingChange';
  activateAt?: Maybe<Scalars['String']['output']>;
  activated?: Maybe<Scalars['Boolean']['output']>;
  addOns?: Maybe<Array<Maybe<RecurlyAddOn>>>;
  billingInfo?: Maybe<RecurlyBillingInfo>;
  createdAt?: Maybe<Scalars['String']['output']>;
  customFields?: Maybe<Array<Maybe<RecurlyCustomField>>>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  invoiceCollection?: Maybe<RecurlyInvoiceCollection>;
  object?: Maybe<Scalars['String']['output']>;
  plan?: Maybe<RecurlyPlan>;
  quantity?: Maybe<Scalars['Int']['output']>;
  rampIntervals?: Maybe<Array<Maybe<RecurlyRampInterval>>>;
  revenueScheduleType?: Maybe<Scalars['String']['output']>;
  shipping?: Maybe<RecurlyShipping>;
  subscriptionId?: Maybe<Scalars['String']['output']>;
  taxInclusive?: Maybe<Scalars['Boolean']['output']>;
  unitAmount?: Maybe<Scalars['Float']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type RecurlyPercentageTier = {
  __typename?: 'RecurlyPercentageTier';
  endingAmount?: Maybe<Scalars['Int']['output']>;
  usagePercentage?: Maybe<Scalars['String']['output']>;
};

export type RecurlyPlan = {
  __typename?: 'RecurlyPlan';
  autoRenew?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currencies?: Maybe<Array<Maybe<RecurlyPlanCurrency>>>;
  customFields?: Maybe<Array<Maybe<CustomFields>>>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  intervalLength?: Maybe<Scalars['Int']['output']>;
  intervalUnit?: Maybe<RecurlyPlanIntervalUnit>;
  name: Scalars['String']['output'];
  object?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  pricingModel?: Maybe<RecurlyPlanPricingModel>;
  state?: Maybe<RecurlyPlanState>;
  trialLength?: Maybe<Scalars['Int']['output']>;
  trialRequiresBillingInfo?: Maybe<Scalars['Boolean']['output']>;
  trialUnit?: Maybe<RecurlyPlanIntervalUnit>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type RecurlyPlanPriceArgs = {
  currency?: InputMaybe<Scalars['String']['input']>;
};

export type RecurlyPlanCurrency = {
  __typename?: 'RecurlyPlanCurrency';
  currency?: Maybe<Scalars['String']['output']>;
  setupFee?: Maybe<Scalars['Float']['output']>;
  unitAmount?: Maybe<Scalars['Float']['output']>;
};

export enum RecurlyPlanIntervalUnit {
  Days = 'days',
  Months = 'months'
}

export enum RecurlyPlanOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export enum RecurlyPlanPricingModel {
  Fixed = 'fixed',
  Ramp = 'ramp'
}

export enum RecurlyPlanRevenueScheduleType {
  AtRangeEnd = 'atRangeEnd',
  AtRangeStart = 'atRangeStart',
  Evenly = 'evenly',
  Never = 'never'
}

export enum RecurlyPlanSort {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

export enum RecurlyPlanState {
  Active = 'active',
  Inactive = 'inactive'
}

export type RecurlyPlansFilter = {
  state?: InputMaybe<RecurlyPlanState>;
};

export type RecurlyPlansInput = {
  beginTime?: InputMaybe<Scalars['DateTime']['input']>;
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<RecurlyPlanOrder>;
  sort?: InputMaybe<RecurlyPlanSort>;
};

export type RecurlyPreviewSubscriptionPurchaseAccountAddressInput = {
  country?: InputMaybe<Scalars['CountryCode']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
};

export type RecurlyPreviewSubscriptionPurchaseAccountInput = {
  address?: InputMaybe<RecurlyPreviewSubscriptionPurchaseAccountAddressInput>;
  code: Scalars['String']['input'];
};

export type RecurlyPurchaseAccountInput = {
  address?: InputMaybe<RecurlyPurchaseAddressInput>;
  billingInfo: RecurlyPurchaseBillingInfoInput;
  code: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  username?: InputMaybe<Scalars['String']['input']>;
};

export type RecurlyPurchaseAddressInput = {
  address1: Scalars['String']['input'];
  address2?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  country: Scalars['CountryCode']['input'];
  region?: InputMaybe<RecurlyPurchaseRegion>;
  state: Scalars['String']['input'];
  zip: Scalars['String']['input'];
};

export type RecurlyPurchaseBillingInfoInput = {
  currency: Scalars['Currency']['input'];
  tokenId?: InputMaybe<Scalars['String']['input']>;
};

export type RecurlyPurchaseLineItemInput = {
  accountingCode?: InputMaybe<Scalars['String']['input']>;
  currency: Scalars['Currency']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  unitAmount: Scalars['Float']['input'];
};

export enum RecurlyPurchaseRegion {
  Ca = 'CA',
  Us = 'US'
}

export type RecurlyRampInterval = {
  __typename?: 'RecurlyRampInterval';
  endingOn?: Maybe<Scalars['String']['output']>;
  remainingBillingCycles?: Maybe<Scalars['Int']['output']>;
  startingBillingCycle?: Maybe<Scalars['Int']['output']>;
  startingOn?: Maybe<Scalars['String']['output']>;
  unitAmount?: Maybe<Scalars['Float']['output']>;
};

export type RecurlyRefundTransaction = {
  __typename?: 'RecurlyRefundTransaction';
  account?: Maybe<RecurlyAccount>;
  actionResult?: Maybe<Scalars['String']['output']>;
  amount?: Maybe<Scalars['Int']['output']>;
  avsCheck?: Maybe<Scalars['String']['output']>;
  backupPaymentMethodUsed?: Maybe<Scalars['Boolean']['output']>;
  billingAddress?: Maybe<RecurlyAddress>;
  collectedAt?: Maybe<Scalars['String']['output']>;
  collectionMethod?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  customerMessage?: Maybe<Scalars['String']['output']>;
  customerMessageLocale?: Maybe<Scalars['String']['output']>;
  cvvCheck?: Maybe<Scalars['String']['output']>;
  fraudInfo?: Maybe<RecurlyFraudInfo>;
  gatewayApprovalCode?: Maybe<Scalars['String']['output']>;
  gatewayMessage?: Maybe<Scalars['String']['output']>;
  gatewayReference?: Maybe<Scalars['String']['output']>;
  gatewayResponseCode?: Maybe<Scalars['String']['output']>;
  gatewayResponseTime?: Maybe<Scalars['Int']['output']>;
  gatewayResponseValues?: Maybe<Array<Maybe<RecurlyGatewayResponseValue>>>;
  id?: Maybe<Scalars['String']['output']>;
  invoice?: Maybe<RecurlyInvoice>;
  ipAddressCountry?: Maybe<Scalars['String']['output']>;
  ipAddressV4?: Maybe<Scalars['String']['output']>;
  object?: Maybe<Scalars['String']['output']>;
  origin?: Maybe<Scalars['String']['output']>;
  originalTransactionId?: Maybe<Scalars['String']['output']>;
  paymentGateway?: Maybe<RecurlyPaymentGateway>;
  paymentMethod?: Maybe<RecurlyPaymentMethod>;
  refunded?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['String']['output']>;
  statusMessage?: Maybe<Scalars['String']['output']>;
  subscriptionIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  success?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
  vatNumber?: Maybe<Scalars['String']['output']>;
  voidedAt?: Maybe<Scalars['String']['output']>;
  voidedByInvoice?: Maybe<RecurlyInvoice>;
};

export type RecurlyResponse = {
  __typename?: 'RecurlyResponse';
  code: Scalars['Int']['output'];
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type RecurlyShipping = {
  __typename?: 'RecurlyShipping';
  address?: Maybe<RecurlyAddress>;
  amount?: Maybe<Scalars['Float']['output']>;
  method?: Maybe<RecurlyMethod>;
  object?: Maybe<Scalars['String']['output']>;
};

export enum RecurlySortBy {
  CreatedAt = 'createdAt',
  ExpiredAt = 'expiredAt',
  UpdatedAt = 'updatedAt'
}

export enum RecurlySortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export type RecurlySubscriptionChangeProrationSetting = {
  charge?: InputMaybe<RecurlySubscriptionChangeProrationSettingType>;
  credit?: InputMaybe<RecurlySubscriptionChangeProrationSettingType>;
};

export enum RecurlySubscriptionChangeProrationSettingType {
  FullAmount = 'full_amount',
  None = 'none',
  ProratedAmount = 'prorated_amount'
}

export enum RecurlySubscriptionChangeTimeframe {
  BillDate = 'bill_date',
  Now = 'now',
  Renewal = 'renewal',
  TermEnd = 'term_end'
}

export type RecurlySubscriptionResponse = {
  __typename?: 'RecurlySubscriptionResponse';
  account?: Maybe<RecurlyAccount>;
  activatedAt?: Maybe<Scalars['String']['output']>;
  activeInvoice?: Maybe<RecurlyInvoice>;
  activeInvoiceId?: Maybe<Scalars['String']['output']>;
  addOnsTotal?: Maybe<Scalars['Float']['output']>;
  autoRenew?: Maybe<Scalars['Boolean']['output']>;
  bankAccountAuthorizedAt?: Maybe<Scalars['String']['output']>;
  billingInfoId?: Maybe<Scalars['String']['output']>;
  canceledAt?: Maybe<Scalars['String']['output']>;
  collectionMethod?: Maybe<Scalars['String']['output']>;
  convertedAt?: Maybe<Scalars['String']['output']>;
  couponRedemptions?: Maybe<Array<Maybe<RecurlyCouponRedemption>>>;
  createdAt?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  currentPeriodEndsAt?: Maybe<Scalars['String']['output']>;
  currentPeriodStartedAt?: Maybe<Scalars['String']['output']>;
  currentTermEndsAt?: Maybe<Scalars['String']['output']>;
  currentTermStartedAt?: Maybe<Scalars['String']['output']>;
  customFields?: Maybe<Array<Maybe<RecurlyCustomField>>>;
  customerNotes?: Maybe<Scalars['String']['output']>;
  expirationReason?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['String']['output']>;
  gatewayCode?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  netTerms?: Maybe<Scalars['Int']['output']>;
  netTermsType?: Maybe<Scalars['String']['output']>;
  object?: Maybe<Scalars['String']['output']>;
  pausedAt?: Maybe<Scalars['String']['output']>;
  pendingChange?: Maybe<RecurlyPendingChange>;
  plan?: Maybe<RecurlyPlan>;
  poNumber?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  remainingBillingCycles?: Maybe<Scalars['Int']['output']>;
  remainingPauseCycles?: Maybe<Scalars['Int']['output']>;
  renewalBillingCycles?: Maybe<Scalars['Int']['output']>;
  revenueScheduleType?: Maybe<Scalars['String']['output']>;
  shipping?: Maybe<RecurlyShipping>;
  startedWithGift?: Maybe<Scalars['Boolean']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  subtotal?: Maybe<Scalars['Float']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  taxInclusive?: Maybe<Scalars['Boolean']['output']>;
  termsAndConditions?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
  totalBillingCycles?: Maybe<Scalars['Int']['output']>;
  trialEndsAt?: Maybe<Scalars['String']['output']>;
  trialStartedAt?: Maybe<Scalars['String']['output']>;
  unitAmount?: Maybe<Scalars['Float']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export enum RecurlySubscriptionState {
  Active = 'active',
  Canceled = 'canceled',
  Expired = 'expired',
  Future = 'future',
  InTrial = 'in_trial',
  Live = 'live'
}

export type RecurlyTaxDetail = {
  __typename?: 'RecurlyTaxDetail';
  billable?: Maybe<Scalars['Boolean']['output']>;
  level?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  rate?: Maybe<Scalars['Float']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type RecurlyTaxInfo = {
  __typename?: 'RecurlyTaxInfo';
  rate?: Maybe<Scalars['Float']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  taxDetails?: Maybe<Array<Maybe<RecurlyTaxDetail>>>;
  type?: Maybe<Scalars['String']['output']>;
};

export type RecurlyTier = {
  __typename?: 'RecurlyTier';
  endingQuantity?: Maybe<Scalars['Int']['output']>;
  unitAmount?: Maybe<Scalars['Int']['output']>;
  unitAmountDecimal?: Maybe<Scalars['String']['output']>;
  usagePercentage?: Maybe<Scalars['String']['output']>;
};

export type RecurlyTransaction = {
  __typename?: 'RecurlyTransaction';
  account?: Maybe<RecurlyAccount>;
  actionResult?: Maybe<Scalars['String']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  avsCheck?: Maybe<Scalars['String']['output']>;
  backupPaymentMethodUsed?: Maybe<Scalars['Boolean']['output']>;
  billingAddress?: Maybe<RecurlyAddress>;
  collectedAt?: Maybe<Scalars['String']['output']>;
  collectionMethod?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  customerMessage?: Maybe<Scalars['String']['output']>;
  customerMessageLocale?: Maybe<Scalars['String']['output']>;
  cvvCheck?: Maybe<Scalars['String']['output']>;
  fraudInfo?: Maybe<RecurlyFraudInfo>;
  gatewayApprovalCode?: Maybe<Scalars['String']['output']>;
  gatewayMessage?: Maybe<Scalars['String']['output']>;
  gatewayReference?: Maybe<Scalars['String']['output']>;
  gatewayResponseCode?: Maybe<Scalars['String']['output']>;
  gatewayResponseTime?: Maybe<Scalars['Int']['output']>;
  gatewayResponseValues?: Maybe<Array<Maybe<RecurlyGatewayResponseValue>>>;
  id?: Maybe<Scalars['String']['output']>;
  invoice?: Maybe<RecurlyInvoice>;
  ipAddressCountry?: Maybe<Scalars['String']['output']>;
  ipAddressV4?: Maybe<Scalars['String']['output']>;
  object?: Maybe<Scalars['String']['output']>;
  origin?: Maybe<Scalars['String']['output']>;
  originalTransactionId?: Maybe<Scalars['String']['output']>;
  paymentGateway?: Maybe<RecurlyPaymentGateway>;
  paymentMethod?: Maybe<RecurlyPaymentMethod>;
  refunded?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['String']['output']>;
  statusMessage?: Maybe<Scalars['String']['output']>;
  subscriptionIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  success?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
  vatNumber?: Maybe<Scalars['String']['output']>;
  voidedAt?: Maybe<Scalars['String']['output']>;
  voidedByInvoice?: Maybe<RecurlyInvoice>;
};

export type RecurlyTransactionError = {
  __typename?: 'RecurlyTransactionError';
  name?: Maybe<Scalars['String']['output']>;
  transactionError?: Maybe<TransactionErrorDetails>;
  type?: Maybe<Scalars['String']['output']>;
};

export type RecurlyTrial = {
  __typename?: 'RecurlyTrial';
  length?: Maybe<Scalars['Int']['output']>;
  unit?: Maybe<RecurlyFreeTrialUnit>;
};

export type RecurlyUniqueCouponCode = {
  __typename?: 'RecurlyUniqueCouponCode';
  bulkCouponCode?: Maybe<Scalars['String']['output']>;
  bulkCouponId?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  state?: Maybe<RecurlyCouponState>;
};

export type RecurlyUpdateAccountInput = {
  address?: InputMaybe<AddressInput>;
  billingInfo: BillingInfoInput;
  custId: Scalars['Int']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
};

export type RecurlyUpdateAccountResponse = {
  __typename?: 'RecurlyUpdateAccountResponse';
  address?: Maybe<RecurlyAccountAddress>;
  billTo?: Maybe<Scalars['String']['output']>;
  billingInfo?: Maybe<RecurlyAccountBillingInfo>;
  ccEmails?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  customFields?: Maybe<Array<Maybe<RecurlyCustomField>>>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  dunningCampaignId?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  exemptionCertificate?: Maybe<Scalars['String']['output']>;
  externalAccounts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  firstName?: Maybe<Scalars['String']['output']>;
  hasActiveSubscription?: Maybe<Scalars['Boolean']['output']>;
  hasCanceledSubscription?: Maybe<Scalars['Boolean']['output']>;
  hasFutureSubscription?: Maybe<Scalars['Boolean']['output']>;
  hasLiveSubscription?: Maybe<Scalars['Boolean']['output']>;
  hasPastDueInvoice?: Maybe<Scalars['Boolean']['output']>;
  hasPausedSubscription?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  invoiceTemplateId?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  object?: Maybe<Scalars['String']['output']>;
  overrideBusinessEntityId?: Maybe<Scalars['String']['output']>;
  parentAccountId?: Maybe<Scalars['String']['output']>;
  preferredLocale?: Maybe<Scalars['String']['output']>;
  preferredTimeZone?: Maybe<Scalars['String']['output']>;
  shippingAddresses?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  state?: Maybe<Scalars['String']['output']>;
  taxExempt?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
  vatNumber?: Maybe<Scalars['String']['output']>;
};

export type RecurlyUpdateSubscriptionInput = {
  customFields?: InputMaybe<Array<RecurlyCustomFieldInput>>;
  nextBillDate?: InputMaybe<Scalars['DateTime']['input']>;
  subscriptionId: Scalars['String']['input'];
};

export type RecurlyUpdatedBy = {
  __typename?: 'RecurlyUpdatedBy';
  country?: Maybe<Scalars['String']['output']>;
  ip?: Maybe<Scalars['String']['output']>;
};

export type RegisterOpenWebUserInput = {
  code_a: Scalars['String']['input'];
  primary_key: Scalars['String']['input'];
  user_name: Scalars['String']['input'];
};

export type RegisterOpenWebUserResponse = {
  __typename?: 'RegisterOpenWebUserResponse';
  action?: Maybe<Scalars['String']['output']>;
  codeB?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  resultCode: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type RemoveSubscriptionInput = {
  custId?: InputMaybe<Scalars['String']['input']>;
  emailAddress?: InputMaybe<Scalars['EmailAddress']['input']>;
  mCode: Array<Scalars['String']['input']>;
  masterProductId: Scalars['String']['input'];
  pid?: InputMaybe<Scalars['String']['input']>;
};

export type RemoveUserProductSignupInput = {
  custId: Scalars['Int']['input'];
  masterProductId: Scalars['Int']['input'];
};

export type Requestor = {
  __typename?: 'Requestor';
  domains?: Maybe<Array<Maybe<Domain>>>;
  id?: Maybe<Scalars['String']['output']>;
  mvpds?: Maybe<Array<Maybe<Mvpd>>>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ResetPassword = {
  __typename?: 'ResetPassword';
  cacheAt?: Maybe<Scalars['String']['output']>;
  lastUnlockAt?: Maybe<Scalars['Date']['output']>;
  modifiedAt?: Maybe<Scalars['Date']['output']>;
  passwordChangeAt?: Maybe<Scalars['Date']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ResetPasswordInput = {
  clientName?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type ResetPasswordResult = SapiResponse & {
  __typename?: 'ResetPasswordResult';
  code: Scalars['Int']['output'];
  data?: Maybe<ResetPassword>;
  message?: Maybe<Scalars['String']['output']>;
  sapiStatusCode?: Maybe<Scalars['Int']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Defintion for rotowire player news, refer to player_news in sqlDB */
export type RotowirePlayerNews = {
  __typename?: 'RotowirePlayerNews';
  analysis?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  headline: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isTransaction: Scalars['Int']['output'];
  league: League;
  notes?: Maybe<Scalars['String']['output']>;
  player: Player;
  priority: Scalars['String']['output'];
  team: Team;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  vendorCreatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SapiResponse = {
  /** The status code of the last HTTP response received for this operation. */
  code: Scalars['Int']['output'];
  /** The message returned from the operation */
  message?: Maybe<Scalars['String']['output']>;
  /** The status code of the last SAPI response received for this operation. */
  sapiStatusCode?: Maybe<Scalars['Int']['output']>;
  /** Was the operation successful */
  success: Scalars['Boolean']['output'];
};

export type SapiSport = {
  __typename?: 'SapiSport';
  createdAt?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  modifiedAt?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parentSport?: Maybe<Scalars['String']['output']>;
  sportSortOrder?: Maybe<Scalars['String']['output']>;
  teamSport?: Maybe<Scalars['String']['output']>;
};

export type SapiUserMvpd = {
  __typename?: 'SapiUserMVPD';
  created?: Maybe<Scalars['Long']['output']>;
  custId?: Maybe<Scalars['Int']['output']>;
  domainId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  modified?: Maybe<Scalars['Long']['output']>;
  providerId?: Maybe<Scalars['String']['output']>;
  providerUserId?: Maybe<Scalars['String']['output']>;
};

export type SapiUserMvpdInput = {
  custId?: InputMaybe<Scalars['Int']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  providerUserId?: InputMaybe<Scalars['String']['input']>;
};

/** schedule meta data type definition, refer to game_schedule_metadata in mogno DB */
export type ScheduleMetaData = {
  __typename?: 'ScheduleMetaData';
  /** aggregate partner game global code, used for aggregating game data across different partners for SOCCER */
  aggregatePartnerGameGlobalCode?: Maybe<Scalars['String']['output']>;
  /** aggregate partner game id, used for aggregating game data across different partners for SOCCER */
  aggregatePartnerGameId?: Maybe<Scalars['Int']['output']>;
  /** away team post season ranking data */
  away?: Maybe<TeamRankingData>;
  /** bowl id for post season game, NCAAF */
  bowlId?: Maybe<Scalars['Int']['output']>;
  /** bowl name for post season game, NCAAF */
  bowlName?: Maybe<Scalars['String']['output']>;
  /** cbs week number for the game, NCAAF, NFL */
  cbsWeekNumber?: Maybe<Scalars['Int']['output']>;
  /** coverage level for the game, such as 1, 2, 3 */
  coverageLevel?: Maybe<Scalars['String']['output']>;
  /** double header game, for MLB */
  doubleHeader?: Maybe<Scalars['Boolean']['output']>;
  /** double header game number, for MLB */
  doubleHeaderGameNumber?: Maybe<Scalars['Int']['output']>;
  /** post season game type, such as Second Round Playoffs, Postseason Tournament */
  gameType?: Maybe<Scalars['String']['output']>;
  /** game type details */
  gameTypeDetail?: Maybe<Scalars['String']['output']>;
  /** home team post season ranking data */
  home?: Maybe<TeamRankingData>;
  /** The neutral site for the game, if applicable */
  neutralSite?: Maybe<Scalars['String']['output']>;
  /** post season game if necessary, for NBA, WNBA, MLB, NHL */
  postSeasonGameIfNecessary?: Maybe<Scalars['Boolean']['output']>;
  /** post season game league, such as West, for NBA, WNBA, MLB, NHL */
  postSeasonGameLeague?: Maybe<Scalars['String']['output']>;
  /** post season game number, for NBA, WNBA, MLB, NHL */
  postSeasonGameNumber?: Maybe<Scalars['Int']['output']>;
  /** post season game round, for NBA, WNBA, NHL */
  postSeasonGameRound?: Maybe<Scalars['Int']['output']>;
  /** post season game type, such as Post Season, LCS, Second round, for NBA, WNBA, MLB, NHL */
  postSeasonGameType?: Maybe<Scalars['String']['output']>;
  /** stadium city for the game */
  stadiumCity?: Maybe<Scalars['String']['output']>;
  /** stadium name for the game */
  stadiumName?: Maybe<Scalars['String']['output']>;
  /** stadium state for the game */
  stadiumState?: Maybe<Scalars['String']['output']>;
  /** tournament id for post season game, NCAAB, NCAAW */
  tournamentId?: Maybe<Scalars['Int']['output']>;
  /** tournament name for post season game, NCAAB, NCAAW */
  tournamentName?: Maybe<Scalars['String']['output']>;
  /** tournament round for post season game, NCAAB, NCAAW */
  tournamentRound?: Maybe<Scalars['Int']['output']>;
  /** week number for the game, NCAAF, NFL */
  weekNumber?: Maybe<Scalars['Int']['output']>;
};

/** Represents the scoreboard with scores for home and away teams. */
export type Scoreboard = {
  __typename?: 'Scoreboard';
  /** The scores for the away team. */
  away?: Maybe<ScoreboardScores>;
  /** The scores for the home team. */
  home?: Maybe<ScoreboardScores>;
};

/** Represents the scores for a team on the scoreboard. */
export type ScoreboardScores = {
  __typename?: 'ScoreboardScores';
  /** The scores of the team for each period. */
  period?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** The total score of the team. */
  total?: Maybe<Scalars['Int']['output']>;
};

export type ScoreboardStatus = {
  __typename?: 'ScoreboardStatus';
  /** The indicator if who has the advantage in the match. */
  advantage?: Maybe<TennisCourtPosition>;
  /** The current game score in the match. */
  gameScore?: Maybe<GameScore>;
  /** The current server in the match. */
  serving?: Maybe<TennisCourtPosition>;
  /** The current set number in the match. */
  set?: Maybe<Scalars['Int']['output']>;
  /** The boolean flag indicating if the match is in a tie-break. */
  tieBreak?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Represents a specific season of a sports league (e.g., the 2025 NFL season).
 * This entity is federated across services, meaning its data can be composed
 * from multiple subgraphs. The resolvable: false directive indicates that
 * resolution for this type's fields primarily happens in another subgraph
 * rather than here.
 */
export type Season = {
  __typename?: 'Season';
  endDate: Scalars['DateTime']['output'];
  /**
   * The games that were played in this season - default is 50. Includes the scheduled since and until filters.
   *   *Constraints: `first` has a maximum limit of 500*
   */
  games?: Maybe<SeasonGamesConnection>;
  /**
   * A unique identifier for the season entity. This is shared across
   *   subgraphs for consistent referencing.
   */
  id: Scalars['ID']['output'];
  isCurrent?: Maybe<Scalars['Boolean']['output']>;
  league: League;
  seasonType: SeasonType;
  sport: Sport;
  startDate: Scalars['DateTime']['output'];
  /**
   * The teams that participated in this season - default is 50. Includes the team's status and college football subdivision filters.
   *   *Constraints: `first` has a maximum limit of 500*
   */
  teams?: Maybe<SeasonTeamsConnection>;
  /**
   * The calendar year in which this season primarily occurs (e.g., 2025).
   *   Marked as @external because it's defined in another subgraph.
   *   For many leagues, the season year matches the majority of games
   *   played in that calendar year, even if it overlaps with adjacent years.
   */
  year: Scalars['Int']['output'];
};


/**
 * Represents a specific season of a sports league (e.g., the 2025 NFL season).
 * This entity is federated across services, meaning its data can be composed
 * from multiple subgraphs. The resolvable: false directive indicates that
 * resolution for this type's fields primarily happens in another subgraph
 * rather than here.
 */
export type SeasonGamesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  scheduledSince?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledUntil?: InputMaybe<Scalars['DateTime']['input']>;
};


/**
 * Represents a specific season of a sports league (e.g., the 2025 NFL season).
 * This entity is federated across services, meaning its data can be composed
 * from multiple subgraphs. The resolvable: false directive indicates that
 * resolution for this type's fields primarily happens in another subgraph
 * rather than here.
 */
export type SeasonTeamsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<SeasonTeamStatus>;
  subdivision?: InputMaybe<CollegeFootballSubdivision>;
};

/** Represents season connection. */
export type SeasonConnection = {
  __typename?: 'SeasonConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SeasonConnectionEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Season>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** Represents season connection edge. */
export type SeasonConnectionEdge = {
  __typename?: 'SeasonConnectionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Season>;
};

/** Represents a edge between season and game. */
export type SeasonGameEdge = {
  __typename?: 'SeasonGameEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Game>;
};

/** Represents a connection between season and games. */
export type SeasonGamesConnection = {
  __typename?: 'SeasonGamesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SeasonGameEdge>>>;
  nodes?: Maybe<Array<Maybe<Game>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type SeasonSplit = {
  __typename?: 'SeasonSplit';
  /** The performance data for the away team in this split. */
  awayTeamSeasonRecord?: Maybe<MarketTeamSeasonRecord>;
  /** The performance data for the home team in this split. */
  homeTeamSeasonRecord?: Maybe<MarketTeamSeasonRecord>;
  /** The name of the market split (e.g., All, Location, Status, Location & Status, Head-to-Head). */
  name: Scalars['String']['output'];
};

export type SeasonStandings = {
  __typename?: 'SeasonStandings';
  seasonId?: Maybe<Scalars['Int']['output']>;
  standings?: Maybe<Standings>;
};

/** Represents an edge in a connection between Season => Team. */
export type SeasonTeamEdge = {
  __typename?: 'SeasonTeamEdge';
  /** The team's bye week for the season */
  byeWeek?: Maybe<Scalars['Int']['output']>;
  /** The team's conference for the season */
  conference?: Maybe<Conference>;
  /** The date and time the team was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The team's division for the season */
  division?: Maybe<Division>;
  /** The node of the edge. */
  node: Team;
  /** The team's standing for the season */
  standing?: Maybe<TeamSeasonStanding>;
  /** The team's sub-division id for the season */
  subDivisionId?: Maybe<Scalars['Int']['output']>;
  /** The team's status for the season */
  teamStatus?: Maybe<Scalars['String']['output']>;
  /** The date and time the team was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Represents a season team status enum value. */
export enum SeasonTeamStatus {
  /** Current Team */
  Current = 'CURRENT',
  /** Historical Team */
  Historical = 'HISTORICAL',
  /** Special Team */
  Special = 'SPECIAL'
}

/** Represents a connection between teams and seasons. */
export type SeasonTeamsConnection = {
  __typename?: 'SeasonTeamsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SeasonTeamEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** Represents a season type enum with possible values. */
export enum SeasonType {
  Post = 'POST',
  Pre = 'PRE',
  Regular = 'REGULAR'
}

export type SetScore = {
  __typename?: 'SetScore';
  /** The away score for the match. */
  away: Scalars['Int']['output'];
  /** The home score for the match. */
  home: Scalars['Int']['output'];
  /** The sets in the match. */
  sets: Array<TennisSet>;
};

/** The outcome of a shootout */
export enum ShootoutOutcome {
  Loss = 'LOSS',
  Win = 'WIN'
}

export type SidelinesEntityNotFoundError = {
  __typename?: 'SidelinesEntityNotFoundError';
  entity: UpsertSidelinesEntityType;
  id?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/**
 * A type representing a sidelines market.
 * **WIP**: Fields are still being adjusted.
 */
export type SidelinesMarket = {
  __typename?: 'SidelinesMarket';
  /** Sideline best bets indicator */
  bestBet?: Maybe<Scalars['Boolean']['output']>;
  /** State for betting. */
  bookState?: Maybe<Scalars['String']['output']>;
  /** CBS book ID for bookie. */
  cbsBookId: Scalars['Int']['output'];
  /** CBS market ID for type of bet. */
  cbsMarketId: Scalars['Int']['output'];
  /** Sidelines created date and time */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** The unique identifier of the game. */
  gameId: Scalars['Int']['output'];
  /** The unique identifier of the sidelines market */
  id: Scalars['ID']['output'];
  /** The league identifier. */
  leagueId: Scalars['Int']['output'];
  /** The line for the bet, e.g. 1.5 */
  line?: Maybe<Scalars['Float']['output']>;
  /** The type of line, consensus, opening, or offers */
  lineType: Scalars['String']['output'];
  /** The odds for the bet in American format, e.g. +150, -200 */
  oddsAmerican?: Maybe<Scalars['String']['output']>;
  /** The odds for the bet in decimal format, e.g. 1.90 */
  oddsDecimal?: Maybe<Scalars['Float']['output']>;
  /** Period of betting, e.g. pre-game, first half, second half. */
  period?: Maybe<Scalars['String']['output']>;
  /** CBS player ID for the player involved in the bet. */
  playerId?: Maybe<Scalars['Int']['output']>;
  /** The side of the bet, e.g. 'OVER', 'UNDER' */
  side?: Maybe<Scalars['String']['output']>;
  /** Sideline top bets indicator */
  sweetSpot?: Maybe<Scalars['Boolean']['output']>;
  /** CBS team ID for the team involved in the bet. */
  teamId?: Maybe<Scalars['Int']['output']>;
  /** The deep link to other id's, e.g. 'selectionId:50208,rampMarketId:504602101' */
  vendorDeepLink?: Maybe<Scalars['String']['output']>;
  /** Vendor entity type, e.g. 'GAME' */
  vendorEntityType?: Maybe<Scalars['String']['output']>;
  /** Vendor ID */
  vendorId: Scalars['Int']['output'];
  /** Vendor market type, e.g. 'MONEYLINE_FULL' */
  vendorMarketType?: Maybe<Scalars['String']['output']>;
  /** Vendor position type, e.g. 'GAME', 'PLAYER', 'TEAM' */
  vendorPositionType?: Maybe<Scalars['String']['output']>;
};

/**
 * Input type for creating or updating a sidelines market.
 * **WIP**: Fields are still being adjusted.
 */
export type SidelinesMarketInput = {
  /** Sideline best bets indicator. */
  bestBet?: InputMaybe<Scalars['Boolean']['input']>;
  /** book ID for bookie (required if create). */
  bookId?: InputMaybe<DataEngIdentifier>;
  /** State for betting */
  bookState?: InputMaybe<Scalars['ID']['input']>;
  /** Sidelines created date and time. */
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The unique identifier of the game (required if create). */
  gameId?: InputMaybe<DataEngIdentifier>;
  /** Sidelines Market identifier - can use internal ID or vendor ID (required if update). */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Sidelines Active Flag */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** The league identifier (required if create). */
  leagueId: Scalars['Int']['input'];
  /** The line for the bet, e.g. 1.5 */
  line?: InputMaybe<Scalars['Float']['input']>;
  /** The type of line, consensus, opening, or offers (required if create) */
  lineType?: InputMaybe<Scalars['ID']['input']>;
  /** market ID for type of bet (required if create). */
  marketId?: InputMaybe<DataEngIdentifier>;
  /** The odds for the bet in American format, e.g. +150, -200 */
  oddsAmerican?: InputMaybe<Scalars['String']['input']>;
  /** The odds for the bet in decimal format, e.g. 1.90 */
  oddsDecimal?: InputMaybe<Scalars['Float']['input']>;
  /** period of betting, e.g. pre-game, first half, second half */
  period?: InputMaybe<Scalars['String']['input']>;
  /** player ID for the player involved in the bet (required if create). */
  playerId?: InputMaybe<DataEngIdentifier>;
  /** The side of the bet, e.g. 'OVER', 'UNDER' */
  side?: InputMaybe<Scalars['ID']['input']>;
  /** Sideline top bets indicator. */
  sweetSpot?: InputMaybe<Scalars['Boolean']['input']>;
  /** vendor team abbr for the team involved in the bet, to then later map to teamId  (required if create). */
  teamAbbr?: InputMaybe<DataEngIdentifier>;
  /** The deep link to other id's, e.g. 'selectionId:50208,rampMarketId:504602101' */
  vendorDeepLink?: InputMaybe<Scalars['String']['input']>;
  /** Vendor entity type, e.g. 'GAME' */
  vendorEntityType?: InputMaybe<Scalars['String']['input']>;
  /** The vendorName to be mapped into a vendorId. */
  vendorName: Scalars['ID']['input'];
  /** Vendor position type, e.g. 'GAME', 'PLAYER', 'TEAM' */
  vendorPositionType?: InputMaybe<Scalars['String']['input']>;
};

export type SignupNewslettersInput = {
  custId: Scalars['Int']['input'];
  mCodes: Array<Scalars['String']['input']>;
};

/** simplified betting side value for player props projection free version */
export type SimplePlayerPropsProjectionSide = BaseSimplePlayerPropsProjectionSide & {
  __typename?: 'SimplePlayerPropsProjectionSide';
  /** betting odds, like -110 for 'Over -110' or 'Under -110' */
  odds: Scalars['String']['output'];
  /** betting side, like 'Over' or 'Under' */
  side: Scalars['String']['output'];
};

/** Represents the player stats for soccer. */
export type SoccerPlayerStats = PlayerStats & {
  __typename?: 'SoccerPlayerStats';
  /** The first name of the player. */
  firstName?: Maybe<Scalars['String']['output']>;
  /** The initials for the player. */
  initials?: Maybe<Scalars['String']['output']>;
  /** The jersey number of the player. */
  jerseyNumber?: Maybe<Scalars['String']['output']>;
  /** The last name of the player. */
  lastName?: Maybe<Scalars['String']['output']>;
  /** The unique identifier for the player. */
  playerId: Scalars['ID']['output'];
  /** The position of the player. */
  position?: Maybe<Scalars['String']['output']>;
  /** The sport type for the player. */
  sport?: Maybe<Scalars['String']['output']>;
  /** The soccer stats for the player. */
  stat?: Maybe<SoccerStats>;
};

/** Represents the statistics of a player in a soccer game. */
export type SoccerStats = {
  __typename?: 'SoccerStats';
  /** Number of assists made by the player. */
  assists?: Maybe<Scalars['Int']['output']>;
  /** Number of catches made by the player. */
  catches?: Maybe<Scalars['Int']['output']>;
  /** Number of fouls committed by the player. */
  fouls?: Maybe<Scalars['Int']['output']>;
  /** Number of fouls suffered by the player. */
  foulsSuffered?: Maybe<Scalars['Int']['output']>;
  /** Position of the player in the game. */
  gamePosition?: Maybe<Scalars['String']['output']>;
  /** Number of goals scored by the player. */
  goals?: Maybe<Scalars['Int']['output']>;
  /** Number of goals allowed by the player. */
  goalsAllowed?: Maybe<Scalars['Int']['output']>;
  /** Number of minutes played by the player. */
  minutes?: Maybe<Scalars['Int']['output']>;
  /** Number of offsides committed by the player. */
  offsides?: Maybe<Scalars['Int']['output']>;
  /** Number of own goals scored by the player. */
  ownGoals?: Maybe<Scalars['Int']['output']>;
  /** Number of penalty goals allowed by the player. */
  penaltyGoalsAllowed?: Maybe<Scalars['Int']['output']>;
  /** Number of penalty saves made by the player. */
  penaltySaves?: Maybe<Scalars['Int']['output']>;
  /** Number of penalty shots faced by the player. */
  penaltyShotsFaced?: Maybe<Scalars['Int']['output']>;
  /** Number of punches made by the player. */
  punches?: Maybe<Scalars['Int']['output']>;
  /** Number of red cards received by the player. */
  redCards?: Maybe<Scalars['Int']['output']>;
  /** Number of saves made by the player. */
  saves?: Maybe<Scalars['Int']['output']>;
  /** Number of shots taken by the player. */
  shots?: Maybe<Scalars['Int']['output']>;
  /** Number of shots faced by the player. */
  shotsFaced?: Maybe<Scalars['Int']['output']>;
  /** Number of shots on goal made by the player. */
  shotsOnGoal?: Maybe<Scalars['Int']['output']>;
  /** Number of shots on goal faced by the player. */
  shotsOnGoalFaced?: Maybe<Scalars['Int']['output']>;
  /** Number of yellow cards received by the player. */
  yellowCards?: Maybe<Scalars['Int']['output']>;
};

/** define soccer team standing type */
export type SoccerTeamStanding = TeamSeasonStanding & {
  __typename?: 'SoccerTeamStanding';
  /** league abbreviation */
  leagueAbbrev?: Maybe<Scalars['String']['output']>;
  /** Team's loss record */
  losses?: Maybe<Scalars['Int']['output']>;
  /** team season id */
  seasonId?: Maybe<Scalars['Int']['output']>;
  /** team CBS Id */
  teamId?: Maybe<Scalars['Int']['output']>;
  /** Team's tie record */
  ties?: Maybe<Scalars['Int']['output']>;
  /** The date and time the team was updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** winning percentage */
  winningPercentage?: Maybe<Scalars['String']['output']>;
  /** Team's win record */
  wins?: Maybe<Scalars['Int']['output']>;
};

export type SocialDetails = {
  __typename?: 'SocialDetails';
  accessToken?: Maybe<Scalars['String']['output']>;
  birthDate?: Maybe<Scalars['String']['output']>;
  custId?: Maybe<Scalars['Int']['output']>;
  deleted?: Maybe<Scalars['Int']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  domainId?: Maybe<Scalars['Int']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  expireTime?: Maybe<Scalars['Float']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  profileUrl?: Maybe<Scalars['String']['output']>;
  providerId?: Maybe<Scalars['String']['output']>;
  providerUserId?: Maybe<Scalars['String']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  refreshToken?: Maybe<Scalars['String']['output']>;
  registrationInd?: Maybe<Scalars['Int']['output']>;
  userLogin?: Maybe<Scalars['String']['output']>;
};

export type SocialDetailsInput = {
  clientName?: InputMaybe<Scalars['String']['input']>;
  custId?: InputMaybe<Scalars['Int']['input']>;
  emailAddress?: InputMaybe<Scalars['EmailAddress']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  providerUserId?: InputMaybe<Scalars['String']['input']>;
  uregGuid?: InputMaybe<Scalars['String']['input']>;
  userLogin?: InputMaybe<Scalars['String']['input']>;
};

export type SocialDetailsResult = SapiResponse & {
  __typename?: 'SocialDetailsResult';
  code: Scalars['Int']['output'];
  data?: Maybe<Array<Maybe<SocialDetails>>>;
  message?: Maybe<Scalars['String']['output']>;
  sapiStatusCode?: Maybe<Scalars['Int']['output']>;
  success: Scalars['Boolean']['output'];
};

export type SocialLinkInput = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  clientName?: InputMaybe<Scalars['String']['input']>;
  custId: Scalars['Int']['input'];
  providerId: Scalars['String']['input'];
  providerUserId?: InputMaybe<Scalars['String']['input']>;
};

export type SocialStatusByCustIdInput = {
  clientName?: InputMaybe<Scalars['String']['input']>;
  custId: Scalars['Int']['input'];
};

export type SocialUnlinkInput = {
  clientName?: InputMaybe<Scalars['String']['input']>;
  custId: Scalars['Int']['input'];
  providerId: Scalars['String']['input'];
};

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

/** sort order enum */
export enum SortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

/** The Sport type represents a sport that can be played, such as soccer, basketball, etc. */
export type Sport = {
  __typename?: 'Sport';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type SportConnection = {
  __typename?: 'SportConnection';
  /** A list of edges. */
  edges: Array<SportEdge>;
  /** A list of nodes. */
  nodes: Array<Sport>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total count. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SportEdge = {
  __typename?: 'SportEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Sport;
};

/** Interface for selection in a sports book */
export type SportsBookSelection = {
  /** Indicates if the selection is active */
  active: Scalars['Boolean']['output'];
  /** CBS-specific identifier for the market */
  cbsMarketId: Scalars['Int']['output'];
  /** CBS-specific name for the market */
  cbsMarketName: Scalars['String']['output'];
  /** Unique identifier for the selection */
  id: Scalars['ID']['output'];
  /** Odds for the selection */
  odds: Scalars['String']['output'];
  /** Opening odds for the selection */
  openingOdds: Scalars['String']['output'];
  /** Type of the selection */
  selectionType: Scalars['String']['output'];
  /** Vendor identifier */
  vendorId?: Maybe<Scalars['Int']['output']>;
  /** Vendor identifier for the market */
  vendorMarketId?: Maybe<Scalars['String']['output']>;
  /** Vendor name */
  vendorName?: Maybe<Scalars['String']['output']>;
};

/** An occurrence of a sports event, such as a MMA fight night or a golf tournament. */
export type SportsEvent = {
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  scheduledTime?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<SportsEventStatus>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** High level status values for sports events. */
export enum SportsEventStatus {
  /** Event canceled and will not occur. */
  Canceled = 'CANCELED',
  /** Event has concluded; results may still be unofficial. */
  Completed = 'COMPLETED',
  /** Event fully concluded with finalized results. */
  Final = 'FINAL',
  /** Event is currently in progress. */
  InProgress = 'IN_PROGRESS',
  /** Event postponed to a future date. */
  Postponed = 'POSTPONED',
  /** Event is scheduled and has not started. */
  Scheduled = 'SCHEDULED'
}

/**
 * Generic cross-sport abstraction for a scheduled competitive match. MMA fights
 * implement this via `MMAFight`, tennis via `Match` (legacy).
 */
export type SportsMatch = {
  /** The date and time the match was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** Whether the match is locked (1) or not (0) */
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  /** The league associated with this match */
  league: League;
  /** The scheduled time for the match */
  scheduledTime: Scalars['DateTime']['output'];
  /** The status of the match */
  status: MatchStatus;
  /** The television broadcast information for the match */
  tvNetworks?: Maybe<Array<TvNetwork>>;
  /** The date and time the match was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The venue for the match */
  venue?: Maybe<Venue>;
  /** The winning player(s), if applicable */
  winnerPlayer?: Maybe<Array<Player>>;
};

export type SportsPlayer = {
  /** Country of birth (vendor string). */
  birthCountry?: Maybe<Scalars['String']['output']>;
  birthDate?: Maybe<Scalars['DateTime']['output']>;
  /** Localized or short given name where available. */
  firstName?: Maybe<Scalars['String']['output']>;
  fullFirstName?: Maybe<Scalars['String']['output']>;
  fullLastName?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['String']['output']>;
  homeTown?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  nationalityCountry?: Maybe<Scalars['String']['output']>;
  nationalityCountryCode?: Maybe<Scalars['String']['output']>;
  nickName?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Int']['output']>;
};

/** SportslineDiscordGuild represents the guild model */
export type SportslineDiscordGuild = {
  __typename?: 'SportslineDiscordGuild';
  /** The approximate number of members in the guild. */
  approximateMemberCount?: Maybe<Scalars['Int']['output']>;
  /** The approximate number of online members in the guild. */
  approximatePresenceCount?: Maybe<Scalars['Int']['output']>;
  /** The icon hash of the guild. Can be used to retrieve the guild's icon image. */
  icon?: Maybe<Scalars['String']['output']>;
  /** The unique identifier for the guild. */
  id: Scalars['ID']['output'];
  /** The name of the guild. */
  name: Scalars['String']['output'];
};

/** SportslineDiscordGuildUser represents the user guild model */
export type SportslineDiscordGuildUser = {
  __typename?: 'SportslineDiscordGuildUser';
  /** The URL of the Discord guild. */
  discordGuildUrl?: Maybe<Scalars['String']['output']>;
  /** The timestamp when the user joined the guild. */
  joinedAt?: Maybe<Scalars['DateTime']['output']>;
  /** A message or status related to the user's presence in the guild. */
  message?: Maybe<Scalars['String']['output']>;
  /** An array of role IDs that the user has in the guild. */
  roles?: Maybe<Array<Scalars['ID']['output']>>;
  /** The user associated with the guild. */
  user?: Maybe<SportslineDiscordUser>;
};

/** SportslineDiscordUser represents the user model */
export type SportslineDiscordUser = {
  __typename?: 'SportslineDiscordUser';
  /** The user's avatar hash. */
  avatar?: Maybe<Scalars['String']['output']>;
  /** The user's display name, if it is set. For bots, this is the application name. */
  global_name: Scalars['String']['output'];
  /** The unique identifier for the user. */
  id: Scalars['ID']['output'];
  /** The preferred locale of the user, such as 'en-US'. */
  locale?: Maybe<Scalars['String']['output']>;
  /** The user's username, not unique across the platform. */
  username: Scalars['String']['output'];
};

/** SportslineDiscordUserDb represents the user model from the database */
export type SportslineDiscordUserDb = {
  __typename?: 'SportslineDiscordUserDb';
  /** The discord user avatar */
  discordAvatar?: Maybe<Scalars['String']['output']>;
  /** The discord user global name */
  discordGlobalName?: Maybe<Scalars['String']['output']>;
  /** The discord user roles */
  discordRoles?: Maybe<Array<Scalars['String']['output']>>;
  /** The discord user id */
  discordUserId?: Maybe<Scalars['String']['output']>;
  /** The discord user username */
  discordUsername?: Maybe<Scalars['String']['output']>;
  /** The unique identifier for the user. */
  id?: Maybe<Scalars['ID']['output']>;
  /** The user sapi subscription status */
  sapiSubscriptionStatus?: Maybe<SportslineDiscordUserSubscriptionStatus>;
};

/**
 * Represents whether a sportsline discord user is:
 * - SUBSCRIBER
 * - NON_SUBSCRIBER
 */
export enum SportslineDiscordUserSubscriptionStatus {
  /** Indicates the sportsline discord user is a non subscriber. */
  NonSubscriber = 'NON_SUBSCRIBER',
  /** Indicates the sportsline discord user is a registered user. */
  Registered = 'REGISTERED',
  /** Indicates the sportsline discord user is a subscriber. */
  Subscriber = 'SUBSCRIBER',
  /** Indicates the sportsline discord user has an unknown subscription status. */
  Unknown = 'UNKNOWN'
}

export type SportslineDiscordWidgetConfig = {
  __typename?: 'SportslineDiscordWidgetConfig';
  /** URL for user to subscribe to the guild */
  authorizationUrl: Scalars['String']['output'];
  /** The text displayed on the button of the widget. */
  buttonText?: Maybe<Scalars['String']['output']>;
  /** A description providing additional information about the widget. */
  description?: Maybe<Scalars['String']['output']>;
  /** A disclaimer message that is shown at the bottom of the widget. */
  disclaimerText?: Maybe<Scalars['String']['output']>;
  /** A URL for the "Learn More" link under the disclaimer text. */
  disclaimerUrl?: Maybe<Scalars['String']['output']>;
  /**
   * The minimum number of members required for to display the online/total
   *   members information in the widget.
   */
  minimumMembers?: Maybe<Scalars['Int']['output']>;
  /**
   * A list of promoted experts to be displayed in the widget. This Type
   *   is been resolved by the expert-picks subgraph.
   */
  promotedExperts?: Maybe<Array<SportslineExpert>>;
  /** The title of the widget. */
  title?: Maybe<Scalars['String']['output']>;
};

/**
 * An expert is a person who provides analysis and predictions on sports games.
 * Implements the SportslineExpertInterface, which defines core fields shared
 * by all sports experts in the system. This type may include additional
 * federation-specific decorators and behaviors.
 */
export type SportslineExpert = SportslineExpertInterface & {
  __typename?: 'SportslineExpert';
  /**
   * A textual biography or summary outlining the expert's background,
   *   expertise, track record, or any other relevant information that
   *   helps users understand the expert's credibility.
   */
  bio?: Maybe<Scalars['String']['output']>;
  /**
   * The expert's identifier used in CBS/Oracle systems for cross-referencing
   *   or integration with external data sources.
   */
  cbsExpertId?: Maybe<Scalars['Int']['output']>;
  /**
   * A URL pointing to a version of the expert's headshot image
   *   with a transparent or clear background, useful in layouts
   *   requiring a cutout-style image.
   */
  clearHeadshotUrl?: Maybe<Scalars['String']['output']>;
  /**
   * This field provides a link to the expert's profile on several platforms,
   *   allowing users to navigate directly to the expert's page for more information.
   *   The link may vary based on the platform or context in which it is used.
   */
  deepLink?: Maybe<DeepLink>;
  /**
   * The expert's first name, often displayed in picks, analyses, or
   *   any place where a full name is required.
   */
  firstName?: Maybe<Scalars['String']['output']>;
  /**
   * A URL pointing to the expert's standard headshot image, typically used
   *   in articles, pick cards, or anywhere a profile image is shown.
   */
  headshotUrl?: Maybe<Scalars['String']['output']>;
  /**
   * A unique, auto-generated identifier (UUID) for the expert.
   *   Used to reference and distinguish this expert across the system.
   */
  id: Scalars['String']['output'];
  /**
   * The expert's last name, often displayed in picks, analyses,
   *   or any place where a full name is required.
   */
  lastName?: Maybe<Scalars['String']['output']>;
  /** The streaks for all the leagues related to the expert */
  leaguesStreaks?: Maybe<Array<ExpertLeagueRecord>>;
  /**
   * An alternative name or moniker for the expert, which can appear in
   *   promotional content, pick cards, or areas where brevity or personality
   *   is desired (e.g., "Big Al," "The Professor").
   */
  nickName?: Maybe<Scalars['String']['output']>;
  /**
   * Contains links to the expert's social media profiles, allowing
   *   users to follow or engage with the expert’s content off-platform.
   */
  socialProfiles?: Maybe<SportslineExpertSocialProfiles>;
  /** The streaks releated to the expert */
  streaks?: Maybe<Array<ExpertStreak>>;
};


/**
 * An expert is a person who provides analysis and predictions on sports games.
 * Implements the SportslineExpertInterface, which defines core fields shared
 * by all sports experts in the system. This type may include additional
 * federation-specific decorators and behaviors.
 */
export type SportslineExpertStreaksArgs = {
  leagueAbbrev?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Represents a generic SportsLine expert who provides analysis and predictions
 * on various sports games. Experts typically create picks, share insights, and
 * may appear in hottest expert lists or rankings based on their performance.
 */
export type SportslineExpertInterface = {
  /**
   * A textual biography or summary outlining the expert's background,
   *   expertise, track record, or any other relevant information that
   *   helps users understand the expert's credibility.
   */
  bio?: Maybe<Scalars['String']['output']>;
  /**
   * The expert's identifier used in CBS/Oracle systems for cross-referencing
   *   or integration with external data sources.
   */
  cbsExpertId?: Maybe<Scalars['Int']['output']>;
  /**
   * A URL pointing to a version of the expert's headshot image
   *   with a transparent or clear background, useful in layouts
   *   requiring a cutout-style image.
   */
  clearHeadshotUrl?: Maybe<Scalars['String']['output']>;
  /**
   * The expert's first name, often displayed in picks, analyses, or
   *   any place where a full name is required.
   */
  firstName?: Maybe<Scalars['String']['output']>;
  /**
   * A URL pointing to the expert's standard headshot image, typically used
   *   in articles, pick cards, or anywhere a profile image is shown.
   */
  headshotUrl?: Maybe<Scalars['String']['output']>;
  /**
   * A unique, auto-generated identifier (UUID) for the expert.
   *   Used to reference and distinguish this expert across the system.
   */
  id: Scalars['String']['output'];
  /**
   * The expert's last name, often displayed in picks, analyses,
   *   or any place where a full name is required.
   */
  lastName?: Maybe<Scalars['String']['output']>;
  /**
   * An alternative name or moniker for the expert, which can appear in
   *   promotional content, pick cards, or areas where brevity or personality
   *   is desired (e.g., "Big Al," "The Professor").
   */
  nickName?: Maybe<Scalars['String']['output']>;
  /**
   * Contains links to the expert's social media profiles, allowing
   *   users to follow or engage with the expert’s content off-platform.
   */
  socialProfiles?: Maybe<SportslineExpertSocialProfiles>;
};

/**
 * Holds social media profiles for a given SportsLine expert, allowing users
 * to find and follow the expert’s content on external platforms.
 */
export type SportslineExpertSocialProfiles = {
  __typename?: 'SportslineExpertSocialProfiles';
  /**
   * The expert's Twitter handle (e.g., '@SportsExpert'). Could be used to
   *   build a link to the expert's Twitter profile or to display a direct follow button.
   */
  twitterHandle?: Maybe<Scalars['String']['output']>;
  /**
   * A direct URL to the expert's Twitter profile, enabling users to visit
   *   and engage with the expert's content on the Twitter platform.
   */
  twitterUrl?: Maybe<Scalars['String']['output']>;
};

/**
 * Represents an expert who is currently on a hot streak according to
 * SportsLine metrics. Implements the SportslineExpertInterface,
 * and includes fields relevant for displaying or ranking
 * the expert in 'hottest expert' lists.
 */
export type SportslineHottestExpert = SportslineExpertInterface & {
  __typename?: 'SportslineHottestExpert';
  /**
   * A short biography or background for the expert, highlighting
   *   experience, credentials, or areas of specialization.
   */
  bio?: Maybe<Scalars['String']['output']>;
  /**
   * An identifier used specifically by CBS to reference this expert
   *   in CBS systems or data feeds.
   */
  cbsExpertId?: Maybe<Scalars['Int']['output']>;
  /**
   * A clear or high-resolution version of the expert's avatar or
   *   headshot, used when the standard resolution might not suffice.
   */
  clearHeadshotUrl?: Maybe<Scalars['String']['output']>;
  /**
   * This field provides a link to the expert's profile on several platforms,
   *   allowing users to navigate directly to the expert's page for more information.
   *   The link may vary based on the platform or context in which it is used.
   */
  deepLink?: Maybe<DeepLink>;
  /** The expert's first name. */
  firstName?: Maybe<Scalars['String']['output']>;
  /**
   * The URL for the expert's headshot image, typically displayed
   *   alongside their name and stats.
   */
  headshotUrl?: Maybe<Scalars['String']['output']>;
  /**
   * A unique identifier for the expert, used to reference the expert
   *   across the system.
   */
  id: Scalars['String']['output'];
  /** The expert's last name. */
  lastName?: Maybe<Scalars['String']['output']>;
  /**
   * The league associated with this hot streak, allowing deeper
   *   context or filtering (e.g., 'NFL', 'NBA').
   */
  league?: Maybe<League>;
  /** The total number of picks classified as a LOSS for this expert's streak. */
  lost?: Maybe<Scalars['Int']['output']>;
  /**
   * A nickname or handle for the expert, if they commonly go by
   *   a name other than firstName/lastName (e.g., "The Professor").
   */
  nickName?: Maybe<Scalars['String']['output']>;
  /**
   * The total profit (or loss) for the current streak, typically
   *   measured in a standard currency unit or points.
   */
  profit?: Maybe<Scalars['Float']['output']>;
  /** The total number of picks classified as a PUSH (a tie or no-action scenario). */
  pushed?: Maybe<Scalars['Int']['output']>;
  /**
   * The rank of the hottest expert within a particular streak or
   *   leaderboard. This might be used to highlight the top experts
   *   on the SportsLine 'Hot Experts' board.
   */
  rank?: Maybe<Scalars['Int']['output']>;
  /**
   * Any associated social media profiles, such as Twitter or Instagram,
   *   stored in a consolidated object.
   */
  socialProfiles?: Maybe<SportslineExpertSocialProfiles>;
  /**
   * A direct link to the expert's SportsLine profile page,
   *   where users can find more picks, history, and analysis.
   */
  sportsLineExpertUrl?: Maybe<Scalars['String']['output']>;
  /**
   * Provides a descriptive summary of the expert's current streak,
   *   with two possible formats:
   *   • short: "Last 99 NFL ATS" (focusing on the number of picks,
   *   league, and market type)
   *   • long: "60-36-3 (63%) L99 ATS" (including win-loss-push,
   *   percentage, and total picks)
   *   The 'short' argument determines which format is returned.
   */
  streakLabel?: Maybe<Scalars['String']['output']>;
  /**
   * The expert's current winning percentage for this streak, calculated
   *   as (won / total picks) * 100.
   */
  winPercentage?: Maybe<Scalars['Float']['output']>;
  /** The total number of picks classified as a WIN for this expert's streak. */
  won?: Maybe<Scalars['Int']['output']>;
};


/**
 * Represents an expert who is currently on a hot streak according to
 * SportsLine metrics. Implements the SportslineExpertInterface,
 * and includes fields relevant for displaying or ranking
 * the expert in 'hottest expert' lists.
 */
export type SportslineHottestExpertStreakLabelArgs = {
  short?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Represent a spread game leg of a parlay where betType='game' and marketName='spread' */
export type SpreadGameLeg = GameLeg & Leg & {
  __typename?: 'SpreadGameLeg';
  /** Always game */
  betType: Scalars['String']['output'];
  /**
   * The CBS book identifier.
   *   In this case always 31 (consensus)
   */
  cbsBookId: Scalars['Int']['output'];
  /** cbsMarketAbbrev */
  cbsMarketAbbrev?: Maybe<Scalars['String']['output']>;
  /** The CBS market identifier. */
  cbsMarketId?: Maybe<Scalars['Int']['output']>;
  /** The name of the CBS market. */
  cbsMarketName?: Maybe<Scalars['String']['output']>;
  /** The bettor's edge for the bet. */
  edge: Scalars['Float']['output'];
  /** Expert Picks for the same game, team, and market id */
  expertPicks?: Maybe<ExpertPicksConnection>;
  /** Represents a game in the parlay. */
  game: Game;
  /** The id of the Leg */
  id: Scalars['ID']['output'];
  /** Additional insight or information about the bet. */
  insight?: Maybe<Scalars['String']['output']>;
  /** The spread value for the bet this is always the home team line. */
  line?: Maybe<Scalars['Float']['output']>;
  /** The american odds for the bet and book. */
  odds?: Maybe<Scalars['Float']['output']>;
  /** The projected score used for the parlay */
  parlayProjectedScore?: Maybe<ParlayProjectedScore>;
  /** The projected value for the spread. */
  projection?: Maybe<Scalars['Float']['output']>;
  /** The side of the bet. */
  side?: Maybe<Scalars['String']['output']>;
  /** Represents the team picked in the spread bet. */
  team?: Maybe<Team>;
};


/** Represent a spread game leg of a parlay where betType='game' and marketName='spread' */
export type SpreadGameLegExpertPicksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ParlayLegExpertPickFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Array<ExpertPickSortByInput>>;
};

export type SpreadOrMoneyLineTeamSeasonRecord = MarketTeamSeasonRecord & {
  __typename?: 'SpreadOrMoneyLineTeamSeasonRecord';
  /** The number of games the team lost in this situation, defaults to 0. */
  losses: Scalars['Int']['output'];
  /** The number of games that ended in a tie or push in this situation, defaults to 0. */
  pushes: Scalars['Int']['output'];
  /** The specific situation this split represents (e.g., "At Home", "As Favorite"). */
  situation: Scalars['String']['output'];
  /** The team this split data belongs to. */
  team: Team;
  /** The percentage of games the team won in this situation, defaults to 0. */
  winPercentage: Scalars['Float']['output'];
  /** The number of games the team won in this situation, defaults to 0. */
  wins: Scalars['Int']['output'];
};

/** Represents selection for standard moneyline odds */
export type StandardMoneylineOddsSelection = SportsBookSelection & {
  __typename?: 'StandardMoneylineOddsSelection';
  /** Indicates if the selection is active */
  active: Scalars['Boolean']['output'];
  /** CBS-specific identifier for the market */
  cbsMarketId: Scalars['Int']['output'];
  /** CBS-specific name for the market */
  cbsMarketName: Scalars['String']['output'];
  /** Unique identifier for the selection */
  id: Scalars['ID']['output'];
  /** Team associated with the selection */
  moneylineTeam?: Maybe<Team>;
  /** Odds for the selection */
  odds: Scalars['String']['output'];
  /** Opening odds for the selection */
  openingOdds: Scalars['String']['output'];
  /** Type of the selection */
  selectionType: Scalars['String']['output'];
  /** Vendor identifier */
  vendorId?: Maybe<Scalars['Int']['output']>;
  /** Vendor identifier for the market */
  vendorMarketId?: Maybe<Scalars['String']['output']>;
  /** Vendor name */
  vendorName?: Maybe<Scalars['String']['output']>;
};

/** Represents selection for standard spread odds */
export type StandardSpreadOddsSelection = SportsBookSelection & {
  __typename?: 'StandardSpreadOddsSelection';
  /** Indicates if the selection is active */
  active: Scalars['Boolean']['output'];
  /** CBS-specific identifier for the market */
  cbsMarketId: Scalars['Int']['output'];
  /** CBS-specific name for the market */
  cbsMarketName: Scalars['String']['output'];
  /** Unique identifier for the selection */
  id: Scalars['ID']['output'];
  /** Spread for the selection */
  line: Scalars['String']['output'];
  /** Odds for the selection */
  odds: Scalars['String']['output'];
  /** Opening spread for the selection */
  openingLine: Scalars['String']['output'];
  /** Opening odds for the selection */
  openingOdds: Scalars['String']['output'];
  /** Type of the selection */
  selectionType: Scalars['String']['output'];
  /** Team associated with the selection */
  spreadTeam: Team;
  /** Vendor identifier */
  vendorId?: Maybe<Scalars['Int']['output']>;
  /** Vendor identifier for the market */
  vendorMarketId?: Maybe<Scalars['String']['output']>;
  /** Vendor name */
  vendorName?: Maybe<Scalars['String']['output']>;
};

/** Represents selection for standard total odds */
export type StandardTotalOddsSelection = SportsBookSelection & {
  __typename?: 'StandardTotalOddsSelection';
  /** Indicates if the selection is active */
  active: Scalars['Boolean']['output'];
  /** CBS-specific identifier for the market */
  cbsMarketId: Scalars['Int']['output'];
  /** CBS-specific name for the market */
  cbsMarketName: Scalars['String']['output'];
  /** Unique identifier for the selection */
  id: Scalars['ID']['output'];
  /** Total for the selection */
  line: Scalars['String']['output'];
  /** Odds for the selection */
  odds: Scalars['String']['output'];
  /** Opening total for the selection */
  openingLine: Scalars['String']['output'];
  /** Opening odds for the selection */
  openingOdds: Scalars['String']['output'];
  /** Type of the selection */
  selectionType: Scalars['String']['output'];
  /** Vendor identifier */
  vendorId?: Maybe<Scalars['Int']['output']>;
  /** Vendor identifier for the market */
  vendorMarketId?: Maybe<Scalars['String']['output']>;
  /** Vendor name */
  vendorName?: Maybe<Scalars['String']['output']>;
};

export type Standings = {
  __typename?: 'Standings';
  losses?: Maybe<Scalars['Int']['output']>;
  wins?: Maybe<Scalars['Int']['output']>;
};

/** definition for streamInfo in gameMetaData mongoDB table */
export type StreamInfo = {
  __typename?: 'StreamInfo';
  country?: Maybe<Scalars['String']['output']>;
  network?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  widgetUrl?: Maybe<Scalars['String']['output']>;
};

export type StrengthOfSchedule = {
  __typename?: 'StrengthOfSchedule';
  createDate?: Maybe<Scalars['String']['output']>;
  createEpoch?: Maybe<Scalars['Int']['output']>;
  ncsos?: Maybe<Scalars['Float']['output']>;
  ncsosRank?: Maybe<Scalars['Int']['output']>;
  oppWinPercentage?: Maybe<Scalars['Float']['output']>;
  sos?: Maybe<Scalars['Float']['output']>;
  sosRank?: Maybe<Scalars['Int']['output']>;
};

export type StrengthOfScheduleInput = {
  ncsos?: InputMaybe<Scalars['Float']['input']>;
  ncsosRank?: InputMaybe<Scalars['Int']['input']>;
  oppWinPercentage?: InputMaybe<Scalars['Float']['input']>;
  sos?: InputMaybe<Scalars['Float']['input']>;
  sosRank?: InputMaybe<Scalars['Int']['input']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  /** Subscribes to updates for a specific game. This is a POC so event publishing is currently only enabled in Helios dev. */
  gameUpdated: Game;
  /** Subscribes to status and score updates for matches with given IDs. */
  matchScoreUpdated: Match;
};


export type SubscriptionGameUpdatedArgs = {
  gameId: Scalars['ID']['input'];
};


export type SubscriptionMatchScoreUpdatedArgs = {
  matchIds: Array<Scalars['ID']['input']>;
};

export type SubscriptionPurchaseInput = {
  addOns?: InputMaybe<Array<RecurlyPurchaseLineItemInput>>;
  currency?: InputMaybe<Scalars['Currency']['input']>;
  planCode: Scalars['String']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
  unitAmount?: InputMaybe<Scalars['Float']['input']>;
};

export type SuccessResult = {
  __typename?: 'SuccessResult';
  success: Scalars['Boolean']['output'];
};

export type TvNetwork = {
  __typename?: 'TVNetwork';
  /** The abbreviation for the TV network */
  abbrev?: Maybe<Scalars['String']['output']>;
  /** The country of the TV network */
  country?: Maybe<Country>;
  /** The created date and time of the TV network */
  createdAt: Scalars['DateTime']['output'];
  /** The unique identifier of the TV network */
  id: Scalars['ID']['output'];
  /** The name of the TV network */
  name: Scalars['String']['output'];
  /** The type of the TV network */
  type?: Maybe<TvNetworkType>;
  /** The updated date and time of the TV network */
  updatedAt: Scalars['DateTime']['output'];
};

export enum TvNetworkType {
  /** A TV network that broadcasts nationally */
  National = 'NATIONAL',
  /** A TV network that broadcasts regionally */
  Regional = 'REGIONAL',
  /** A TV network that is available for streaming */
  Streaming = 'STREAMING',
  /** A TV network that is available for streaming nationally */
  StreamingNational = 'STREAMING_NATIONAL',
  /** A TV network that is available for streaming regionally */
  StreamingRegional = 'STREAMING_REGIONAL'
}

/** The Team type represents a sports team. */
export type Team = TeamBase & {
  __typename?: 'Team';
  /** The abbreviated name of the team. */
  abbrev?: Maybe<Scalars['String']['output']>;
  /** The color of the team in hex format. */
  colorHexDex?: Maybe<Scalars['String']['output']>;
  /** The primary color of the team in hex format. */
  colorPrimaryHex?: Maybe<Scalars['String']['output']>;
  /** The secondary color of the team in hex format. */
  colorSecondaryHex?: Maybe<Scalars['String']['output']>;
  /** The date and time the team was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** The home venue of the team */
  homeVenue?: Maybe<Venue>;
  /** The unique identifier for the team. */
  id: Scalars['ID']['output'];
  image?: Maybe<CmsImage>;
  /** The location of the team */
  location?: Maybe<Scalars['String']['output']>;
  /** The medium name of the team */
  mediumName?: Maybe<Scalars['String']['output']>;
  /** The nickname of the team */
  nickname?: Maybe<Scalars['String']['output']>;
  /**
   * The players that are associated with this team.
   *   *Constraints: `first` has a maximum limit of 500*
   */
  players?: Maybe<TeamPlayerConnection>;
  /**
   * team season association has more seasons than standings metadata, the Team's standing will come from the team standing metadata
   *   *Constraints: `first` has a maximum limit of 500*
   */
  seasons?: Maybe<TeamSeasonConnection>;
  /** The short name of the team */
  shortName?: Maybe<Scalars['String']['output']>;
  /** The date and time the team was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The vendors that are associated with this team.
   *   *Constraints: `first` has a maximum limit of 500*
   */
  vendors?: Maybe<TeamVendorConnection>;
};


/** The Team type represents a sports team. */
export type TeamPlayersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


/** The Team type represents a sports team. */
export type TeamSeasonsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


/** The Team type represents a sports team. */
export type TeamVendorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  vendorName?: InputMaybe<Scalars['String']['input']>;
};

export type TeamBase = {
  /** The abbreviated name of the team. */
  abbrev?: Maybe<Scalars['String']['output']>;
  /** The color of the team in hex format. */
  colorHexDex?: Maybe<Scalars['String']['output']>;
  /** The primary color of the team in hex format. */
  colorPrimaryHex?: Maybe<Scalars['String']['output']>;
  /** The secondary color of the team in hex format. */
  colorSecondaryHex?: Maybe<Scalars['String']['output']>;
  /** The date and time the team was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** The home venue of the team */
  homeVenue?: Maybe<Venue>;
  /** The unique identifier for the team. */
  id: Scalars['ID']['output'];
  /** The location of the team */
  location?: Maybe<Scalars['String']['output']>;
  /** The medium name of the team */
  mediumName?: Maybe<Scalars['String']['output']>;
  /** The nickname of the team */
  nickname?: Maybe<Scalars['String']['output']>;
  /** The short name of the team */
  shortName?: Maybe<Scalars['String']['output']>;
  /** The date and time the team was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type TeamConnection = {
  __typename?: 'TeamConnection';
  /** A list of edges. */
  edges: Array<TeamEdge>;
  /** A list of nodes. */
  nodes: Array<Team>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total count. */
  totalCount: Scalars['Int']['output'];
};

/**
 * The TeamSalary type represents the salary information for a team in a DFS contest.
 * The cache control directive is used to set the max age of the cache to 60 seconds.
 */
export type TeamDfsSalary = DfsSalary & {
  __typename?: 'TeamDfsSalary';
  /** Creation timestamp of the salary entry. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** DraftKings specific draftable ID. */
  draftKingsDraftableId?: Maybe<Scalars['Int']['output']>;
  /** DraftKings specific player ID. */
  draftKingsPlayerId?: Maybe<Scalars['Int']['output']>;
  /** FanDuel specific player ID. */
  fanDuelPlayerId?: Maybe<Scalars['Int']['output']>;
  /** FanDuel specific stats ID. */
  fanDuelStatsId?: Maybe<Scalars['Int']['output']>;
  /** The game associated with this salary. */
  game: Game;
  /** Type of DFS contest. */
  gameType?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the salary entry. */
  id: Scalars['ID']['output'];
  /** Positions eligible for the salary. */
  positions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Provider of the salary information. */
  provider: Scalars['String']['output'];
  /** The salary amount. */
  salary: Scalars['Int']['output'];
  /** The date when the salary is applicable. */
  salaryDate?: Maybe<Scalars['Date']['output']>;
  /** End time of the slate. */
  slateEnd?: Maybe<Scalars['DateTime']['output']>;
  /** Unique identifier for the slate. */
  slateId: Scalars['Int']['output'];
  /** Start time of the slate. */
  slateStart?: Maybe<Scalars['DateTime']['output']>;
  /** Type of slate for the game(s). */
  slateType?: Maybe<Scalars['String']['output']>;
  /** The team associated with this salary. */
  team: Team;
  /** Tier of the salary. */
  tier?: Maybe<Scalars['String']['output']>;
  /** Last update timestamp of the salary entry. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** An edge in a connection. */
export type TeamEdge = {
  __typename?: 'TeamEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Team;
};

/** Team Connection for pagination */
export type TeamLeagueConnection = {
  __typename?: 'TeamLeagueConnection';
  edges: Array<Maybe<TeamLeagueEdge>>;
  nodes: Array<Maybe<Team>>;
  pageInfo: PageInfo;
};

/** Edge for team connection */
export type TeamLeagueEdge = {
  __typename?: 'TeamLeagueEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** node of the team edge */
  node: Team;
};

/** Defines a connection between a team and its players association. */
export type TeamPlayerConnection = {
  __typename?: 'TeamPlayerConnection';
  edges: Array<Maybe<TeamPlayerEdge>>;
  nodes: Array<Maybe<Player>>;
  pageInfo: PageInfo;
};

/** Defines an edge in a connection between a team and its players association. */
export type TeamPlayerEdge = {
  __typename?: 'TeamPlayerEdge';
  cursor: Scalars['String']['output'];
  jerseyNumber?: Maybe<Scalars['String']['output']>;
  node: Player;
  position?: Maybe<Scalars['String']['output']>;
  rosterStatus?: Maybe<Scalars['String']['output']>;
};

/** Represents the player stats for a team. */
export type TeamPlayerStats = {
  __typename?: 'TeamPlayerStats';
  /** The player stats for the team. */
  playerStats?: Maybe<Array<Maybe<PlayerStats>>>;
  /** The sport type for player stats for the team. */
  sport?: Maybe<Scalars['String']['output']>;
  /** The abbreviation for the team. */
  teamAbbrev?: Maybe<Scalars['String']['output']>;
  /** The unique identifier for the team player stats is team id. */
  teamId: Scalars['ID']['output'];
};

/** team ranking type definition in schedule meta data */
export type TeamRankingData = {
  __typename?: 'TeamRankingData';
  /** aggregate outcome for SOCCER */
  aggregateOutcome?: Maybe<Scalars['String']['output']>;
  /** aggregate outcome score for SOCCER */
  aggregateOutcomeScore?: Maybe<Scalars['String']['output']>;
  /** The seed of the team in post season for conference, NBA, WNBA, NFL */
  conferenceSeed?: Maybe<Scalars['Int']['output']>;
  /** The team id associated with this ranking data. */
  id?: Maybe<Scalars['Int']['output']>;
  /** Playoff ranking for the team in post season, NCAAF */
  playoffRanking?: Maybe<Scalars['Int']['output']>;
  /** playoff record for the team in post season, NBA, WNBA, NHL */
  playoffRecord?: Maybe<Scalars['String']['output']>;
  /** playoff seed for the team in post season, MLB */
  playoffSeed?: Maybe<Scalars['Int']['output']>;
  /** college team ranking in post season, NCAAB, NCAAF, NCAAW */
  ranking?: Maybe<Scalars['Int']['output']>;
  /** The seed of the college team in the ranking in post season, NCAAB, NCAAW */
  rankingSeed?: Maybe<Scalars['Int']['output']>;
  /** region name for the college team in post season, NCAAB, NCAAW */
  regionName?: Maybe<Scalars['String']['output']>;
  /** region number for the college team in post season, NCAAB, NCAAW */
  regionNumber?: Maybe<Scalars['Int']['output']>;
  /** Series record for the team in post season, NBA, WNBA, MLB, NHL */
  seriesRecord?: Maybe<Scalars['String']['output']>;
};

/** Represents the projected score for a team */
export type TeamScore = {
  __typename?: 'TeamScore';
  /** The projected score for the team */
  score?: Maybe<Scalars['Float']['output']>;
  /** The team id */
  teamId?: Maybe<Scalars['Int']['output']>;
};

/** Define a connection between a team and its seasons. */
export type TeamSeasonConnection = {
  __typename?: 'TeamSeasonConnection';
  edges: Array<Maybe<TeamSeasonEdge>>;
  nodes: Array<Maybe<Season>>;
  pageInfo: PageInfo;
};

/** Represents an edge in a connection between Team => Season. */
export type TeamSeasonEdge = {
  __typename?: 'TeamSeasonEdge';
  /** The team's bye week for the season */
  byeWeek?: Maybe<Scalars['Int']['output']>;
  /** The team's conference for the season */
  conference?: Maybe<Conference>;
  /** The date and time the team was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The team's division for the season */
  division?: Maybe<Division>;
  /** The node of the edge. */
  node: Season;
  /** The team's standing for the season */
  standing?: Maybe<TeamSeasonStanding>;
  /** The team's sub-division id for the season */
  subDivisionId?: Maybe<Scalars['Int']['output']>;
  /** The team's status for the season */
  teamStatus?: Maybe<Scalars['String']['output']>;
  /** The date and time the team was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** define interface for team season standing which is base for soccer, nfl, nba, mlb, nhl, ncaaf, ncaab */
export type TeamSeasonStanding = {
  /** league abbreviation */
  leagueAbbrev?: Maybe<Scalars['String']['output']>;
  /** Team's loss record */
  losses?: Maybe<Scalars['Int']['output']>;
  /** team season id */
  seasonId?: Maybe<Scalars['Int']['output']>;
  /** team CBS Id */
  teamId?: Maybe<Scalars['Int']['output']>;
  /** Team's tie record */
  ties?: Maybe<Scalars['Int']['output']>;
  /** The date and time the team was updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** winning percentage .667 */
  winningPercentage?: Maybe<Scalars['String']['output']>;
  /** Team's win record */
  wins?: Maybe<Scalars['Int']['output']>;
};

/** define team standing type, refer to team_standings_metadata in mongo db */
export type TeamStanding = {
  __typename?: 'TeamStanding';
  /** team cbs id */
  _id: Scalars['ID']['output'];
  /** The date and time the record was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** league abbreviation */
  leagueAbbrev?: Maybe<Scalars['String']['output']>;
  /** team season standings */
  standings?: Maybe<Array<Maybe<TeamSeasonStanding>>>;
  /** The date and time the record was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type TeamStandings = {
  __typename?: 'TeamStandings';
  season?: Maybe<Array<Maybe<SeasonStandings>>>;
};

/** Defines a connection between a team and its vendor teams association. */
export type TeamVendorConnection = {
  __typename?: 'TeamVendorConnection';
  edges: Array<Maybe<TeamVendorEdge>>;
  nodes: Array<Maybe<Vendor>>;
  pageInfo: PageInfo;
};

/** Represents an edge in a connection between Teams => Vendor. */
export type TeamVendorEdge = {
  __typename?: 'TeamVendorEdge';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The node of the edge. */
  node: Vendor;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  vendorTeamId?: Maybe<Scalars['String']['output']>;
};

/** Input for creating or referencing a competition */
export type TennisCompetitionInput = {
  /** The alternate name of the competition */
  alternateName?: InputMaybe<Scalars['String']['input']>;
  /** Gender of the competition */
  gender?: InputMaybe<CompetitionGender>;
  /** Identifier for the competition - can use internal ID or vendor ID */
  id?: InputMaybe<DataEngIdentifier>;
  /** The league identifier */
  leagueId?: InputMaybe<DataEngIdentifier>;
  /** The level of the competition */
  level?: InputMaybe<CompetitionLevel>;
  /** The name of the competition */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Parent competition identifier */
  parentId?: InputMaybe<DataEngIdentifier>;
  /** The type of the competition (e.g., singles, doubles) */
  type?: InputMaybe<CompetitionType>;
};

/** Input for creating or referencing a competition season */
export type TennisCompetitionSeasonInput = {
  /** Competition identifier */
  competitionId?: InputMaybe<DataEngIdentifier>;
  /** Complex information */
  complex?: InputMaybe<TennisComplexInput>;
  /** Season identifier */
  seasonId?: InputMaybe<DataEngIdentifier>;
  /** Surface type */
  surface?: InputMaybe<Scalars['String']['input']>;
  /** Tournament end date */
  tournamentEndDt?: InputMaybe<Scalars['Date']['input']>;
  /** Tournament start date */
  tournamentStartDt?: InputMaybe<Scalars['Date']['input']>;
  /** Tournament year */
  tournamentYear?: InputMaybe<Scalars['Int']['input']>;
};

/** Input for a competitor's profile */
export type TennisCompetitorProfileInput = {
  /** The ID of the competitor pair for a double's match */
  pairId?: InputMaybe<DataEngIdentifier>;
  /** The competitor's player ID (required if create) */
  playerId?: InputMaybe<DataEngIdentifier>;
  /** The competitor's seed in the tournament */
  seed?: InputMaybe<Scalars['Int']['input']>;
};

/** Input for creating or referencing a complex */
export type TennisComplexInput = {
  /** City where the complex is located */
  city?: InputMaybe<Scalars['String']['input']>;
  /** Country where the complex is located */
  countryName?: InputMaybe<Scalars['CountryName']['input']>;
  /** Identifier for the complex - can use internal ID or vendor ID */
  id?: InputMaybe<DataEngIdentifier>;
  /** Name of the complex (required if create) */
  name?: InputMaybe<Scalars['String']['input']>;
  /** State where the complex is located */
  state?: InputMaybe<Scalars['String']['input']>;
};

/** The tennis court position for the match. */
export enum TennisCourtPosition {
  /** The away side of the court. */
  Away = 'AWAY',
  /** The home side of the court. */
  Home = 'HOME'
}

/** Input for tennis game score */
export type TennisGameScoreInput = {
  /** The away score for the game */
  away: Scalars['Int']['input'];
  /** The home score for the game */
  home: Scalars['Int']['input'];
};

/** Input type for creating or updating a match */
export type TennisMatchInput = {
  /** The abbreviation for the match (required if create) */
  abbrev?: InputMaybe<Scalars['String']['input']>;
  /** The competition for the match - can provide identifier or full details (required if create) */
  competition?: InputMaybe<TennisCompetitionInput>;
  /** The competitors involved in the match */
  competitors?: InputMaybe<MatchCompetitorsInput>;
  /** The extended status for the match */
  extendedStatus?: InputMaybe<MatchExtendedStatus>;
  /** Match identifier - can use internal ID or vendor ID (required if update) */
  id?: InputMaybe<DataEngIdentifier>;
  /** Whether the scheduled time is estimated */
  isEstimated?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the match is locked or not */
  isLocked?: InputMaybe<Scalars['Boolean']['input']>;
  /** The league identifier (required if create) */
  leagueId?: InputMaybe<DataEngIdentifier>;
  /** The round of the match */
  round?: InputMaybe<MatchRound>;
  /** The scheduled time for the match (required if create) */
  scheduledTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** The scores for the match */
  scores?: InputMaybe<TennisScoreboardInput>;
  /** The season information (required if create) */
  season?: InputMaybe<TennisCompetitionSeasonInput>;
  /** The status of the match (required if create) */
  status?: InputMaybe<MatchStatus>;
  /** List of TV networks to associate with the match */
  tvNetworks?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The venue for the match */
  venue?: InputMaybe<TennisVenueInput>;
  /** The winner pair identifier */
  winnerPairId?: InputMaybe<DataEngIdentifier>;
  /** The winner player identifier */
  winnerPlayerId?: InputMaybe<DataEngIdentifier>;
};

/** Represents the scoreboard with scores for home and away teams. */
export type TennisScoreboard = {
  __typename?: 'TennisScoreboard';
  /** The extended status for the match. */
  currentStatus?: Maybe<ScoreboardStatus>;
  /** The current setScores in the match. */
  setScores?: Maybe<SetScore>;
  /** The date the scoreboard was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Input for tennis scoreboard */
export type TennisScoreboardInput = {
  /** The current status of the match */
  currentStatus?: InputMaybe<TennisScoreboardStatusInput>;
  /** The current set scores in the match */
  setScores?: InputMaybe<TennisSetScoreInput>;
};

/** Input for current tennis scoreboard status */
export type TennisScoreboardStatusInput = {
  /** The indicator of which player has the advantage */
  advantage?: InputMaybe<TennisCourtPosition>;
  /** The current game score in the match */
  gameScore?: InputMaybe<TennisGameScoreInput>;
  /** The current server in the match */
  serving?: InputMaybe<TennisCourtPosition>;
  /** The current set number in the match */
  set?: InputMaybe<Scalars['Int']['input']>;
  /** Whether the match is currently in a tie-break */
  tieBreak?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TennisSet = {
  __typename?: 'TennisSet';
  /** The away score for the set. */
  away: Scalars['Int']['output'];
  /** The away tie-break score for the set. */
  awayTieBreakScore?: Maybe<Scalars['Int']['output']>;
  /** The home score for the set. */
  home: Scalars['Int']['output'];
  /** The home tie-break score for the set. */
  homeTieBreakScore?: Maybe<Scalars['Int']['output']>;
  /** The set number. */
  number: Scalars['Int']['output'];
};

/** Input for a tennis set */
export type TennisSetInput = {
  /** The away score for the set */
  away: Scalars['Int']['input'];
  /** The away tie-break score for the set */
  awayTieBreakScore?: InputMaybe<Scalars['Int']['input']>;
  /** The home score for the set */
  home: Scalars['Int']['input'];
  /** The home tie-break score for the set */
  homeTieBreakScore?: InputMaybe<Scalars['Int']['input']>;
  /** The set number */
  number: Scalars['Int']['input'];
};

/** Input for set scores */
export type TennisSetScoreInput = {
  /** The away score for the match */
  away: Scalars['Int']['input'];
  /** The home score for the match */
  home: Scalars['Int']['input'];
  /** The sets in the match */
  sets: Array<TennisSetInput>;
};

/** Input for creating or updating a tennis tournament/competition and its related season/complex */
export type TennisTournamentInput = {
  /** Competition core attributes (name/type/level/gender/parent/league) */
  competition?: InputMaybe<TennisCompetitionInput>;
  /** Tournament identifier - can use internal ID or vendor ID (required if update) */
  id?: InputMaybe<DataEngIdentifier>;
  /** League identifier (redundant when supplied in competition, kept for convenience) */
  leagueId?: InputMaybe<DataEngIdentifier>;
  /** Parent competition identifier (if setting parent-child relationship) */
  parentCompetitionId?: InputMaybe<DataEngIdentifier>;
  /** Season details for the tournament */
  season?: InputMaybe<TennisCompetitionSeasonInput>;
  /** Venue for the tournament (mapped to venue_id) */
  venue?: InputMaybe<TennisVenueInput>;
};

/** Input for creating or referencing a venue */
export type TennisVenueInput = {
  /** Venue abbreviation */
  abbrev?: InputMaybe<Scalars['String']['input']>;
  /** City where venue is located */
  city?: InputMaybe<Scalars['String']['input']>;
  /** Country where venue is located */
  country?: InputMaybe<Scalars['String']['input']>;
  /** Identifier for the venue - can use internal ID or vendor ID */
  id?: InputMaybe<DataEngIdentifier>;
  /** Market ID for the venue */
  marketId?: InputMaybe<Scalars['String']['input']>;
  /** The name of the venue */
  name?: InputMaybe<Scalars['String']['input']>;
  /** State where venue is located */
  state?: InputMaybe<Scalars['String']['input']>;
  /** Surface type (e.g., 'grass', 'clay', 'hard') */
  surface?: InputMaybe<Scalars['String']['input']>;
  /** Time zone of the venue */
  timeZone?: InputMaybe<Scalars['String']['input']>;
  /** Venue type */
  type?: InputMaybe<Scalars['String']['input']>;
  /** Weather code for the venue */
  weatherCode?: InputMaybe<Scalars['String']['input']>;
  /** Postal code for the venue */
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type TierWonLoss = {
  __typename?: 'TierWonLoss';
  createDate?: Maybe<Scalars['String']['output']>;
  createEpoch?: Maybe<Scalars['Int']['output']>;
  netRanking?: Maybe<Scalars['Int']['output']>;
  tier1Losses?: Maybe<Scalars['Int']['output']>;
  tier1Wins?: Maybe<Scalars['Int']['output']>;
  tier2Losses?: Maybe<Scalars['Int']['output']>;
  tier2Wins?: Maybe<Scalars['Int']['output']>;
  tier3Losses?: Maybe<Scalars['Int']['output']>;
  tier3Wins?: Maybe<Scalars['Int']['output']>;
  tier4Losses?: Maybe<Scalars['Int']['output']>;
  tier4Wins?: Maybe<Scalars['Int']['output']>;
};

export type TierWonLossInput = {
  netRanking?: InputMaybe<Scalars['Int']['input']>;
  tier1Losses?: InputMaybe<Scalars['Int']['input']>;
  tier1Wins?: InputMaybe<Scalars['Int']['input']>;
  tier2Losses?: InputMaybe<Scalars['Int']['input']>;
  tier2Wins?: InputMaybe<Scalars['Int']['input']>;
  tier3Losses?: InputMaybe<Scalars['Int']['input']>;
  tier3Wins?: InputMaybe<Scalars['Int']['input']>;
  tier4Losses?: InputMaybe<Scalars['Int']['input']>;
  tier4Wins?: InputMaybe<Scalars['Int']['input']>;
};

export enum Timeframe {
  BillDate = 'bill_date',
  TermEnd = 'term_end'
}

/** Represent a total game leg of a parlay where betType='game' and marketName='total' */
export type TotalGameLeg = GameLeg & Leg & {
  __typename?: 'TotalGameLeg';
  /** The type of bet being placed. */
  betType: Scalars['String']['output'];
  /** The CBS book identifier. */
  cbsBookId: Scalars['Int']['output'];
  /** cbsMarketAbbrev */
  cbsMarketAbbrev?: Maybe<Scalars['String']['output']>;
  /** The CBS market identifier. */
  cbsMarketId?: Maybe<Scalars['Int']['output']>;
  /** The name of the CBS market. */
  cbsMarketName?: Maybe<Scalars['String']['output']>;
  /** The bettor's edge for the bet. */
  edge: Scalars['Float']['output'];
  /** Expert Picks for the same game, side (OVER or UNDER), and market id */
  expertPicks?: Maybe<ExpertPicksConnection>;
  /** Represents a game in the parlay. */
  game: Game;
  /** The id of the Leg */
  id: Scalars['ID']['output'];
  /** Additional insight or information about the bet. */
  insight?: Maybe<Scalars['String']['output']>;
  /** The line value for the bet. */
  line?: Maybe<Scalars['Float']['output']>;
  /** The american odds for the bet. */
  odds?: Maybe<Scalars['Float']['output']>;
  /** The projected score used for the parlay */
  parlayProjectedScore?: Maybe<ParlayProjectedScore>;
  /** The projected value for the bet. */
  projection?: Maybe<Scalars['Float']['output']>;
  /** The side of the bet. */
  side?: Maybe<Scalars['String']['output']>;
};


/** Represent a total game leg of a parlay where betType='game' and marketName='total' */
export type TotalGameLegExpertPicksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ParlayLegExpertPickFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Array<ExpertPickSortByInput>>;
};

export type TransactionErrorDetails = {
  __typename?: 'TransactionErrorDetails';
  category?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  declineCode?: Maybe<Scalars['String']['output']>;
  fraudInfo?: Maybe<Scalars['String']['output']>;
  merchantAdvice?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  object?: Maybe<Scalars['String']['output']>;
  threeDSecureActionTokenId?: Maybe<Scalars['String']['output']>;
  transactionId?: Maybe<Scalars['String']['output']>;
};

export type UpdateGraphicExportInput = {
  config?: InputMaybe<Scalars['JSON']['input']>;
  dataEndpoint?: InputMaybe<Scalars['String']['input']>;
  leagueAbbr?: InputMaybe<Scalars['String']['input']>;
  leagueId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  s3Bucket?: InputMaybe<Scalars['String']['input']>;
  s3Path?: InputMaybe<Scalars['String']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateGraphicInput = {
  cmsId?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  exports?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  s3Bucket?: InputMaybe<Scalars['String']['input']>;
  s3Path?: InputMaybe<Scalars['String']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateGraphicScheduleTaskInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nextRun?: InputMaybe<Scalars['DateTime']['input']>;
  schedule?: InputMaybe<Scalars['String']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateGraphicsUserInput = {
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateIterableUserEmailInput = {
  currentEmail: Scalars['String']['input'];
  newEmail: Scalars['String']['input'];
};

export type UpdateIterableUserEmailParams = {
  __typename?: 'UpdateIterableUserEmailParams';
  endpoint?: Maybe<Scalars['String']['output']>;
  ip: Scalars['String']['output'];
};

export type UpdateIterableUserEmailResponse = {
  __typename?: 'UpdateIterableUserEmailResponse';
  code: Scalars['String']['output'];
  msg: Scalars['String']['output'];
  params?: Maybe<UpdateIterableUserEmailParams>;
};

export type UpdateIterableUserSubscriptionInput = {
  /** Subscription group (i.e.: emailList, messageType, messageChannel) [Alphanumeric, case insensitive] */
  subscriptionGroup: Scalars['String']['input'];
  /** Subscription Group Id [Numeric]. Example: 123456 */
  subscriptionGroupId: Scalars['Int']['input'];
  /** Action to perform [subscribe, unsubscribe] */
  updateIterableUserSubscriptionAction: Scalars['String']['input'];
  userEmail: Scalars['String']['input'];
};

export type UpdateIterableUserSubscriptionParams = {
  __typename?: 'UpdateIterableUserSubscriptionParams';
  endpoint?: Maybe<Scalars['String']['output']>;
  ip: Scalars['String']['output'];
};

export type UpdateIterableUserSubscriptionResponse = {
  __typename?: 'UpdateIterableUserSubscriptionResponse';
  code: Scalars['String']['output'];
  msg: Scalars['String']['output'];
  params?: Maybe<UpdateIterableUserSubscriptionParams>;
};

export type UpdateIterableUserSubscriptionsInput = {
  campaignId?: InputMaybe<Scalars['Int']['input']>;
  email: Scalars['String']['input'];
  emailListIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Subscribed Iterable Message Type Id (NCIS, CBS Mornings, Ghosts, etc.) */
  subscribedMessageTypeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  templateId?: InputMaybe<Scalars['Int']['input']>;
  /** Iterable Channel Id (Marketing, Transactional) */
  unsubscribedChannelIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Unsubscribed Iterable Message Type Id (NCIS, CBS Mornings, Ghosts, etc.) */
  unsubscribedMessageTypeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type UpdateIterableUserSubscriptionsParams = {
  __typename?: 'UpdateIterableUserSubscriptionsParams';
  endpoint?: Maybe<Scalars['String']['output']>;
  ip: Scalars['String']['output'];
};

export type UpdateIterableUserSubscriptionsResponse = {
  __typename?: 'UpdateIterableUserSubscriptionsResponse';
  code: Scalars['String']['output'];
  msg: Scalars['String']['output'];
  params?: Maybe<UpdateIterableUserSubscriptionsParams>;
};

/** Input type for creating or updating a match */
export type UpdateMatchInput = {
  /** The abbreviation for the match */
  abbrev?: InputMaybe<Scalars['String']['input']>;
  /** The competition ID for the match */
  competitionId?: InputMaybe<Scalars['ID']['input']>;
  /** The extended status for the match */
  extendedStatus?: InputMaybe<MatchExtendedStatus>;
  /** The unique identifier of the match */
  id: Scalars['ID']['input'];
  /** The league ID for the match */
  leagueId?: InputMaybe<Scalars['ID']['input']>;
  /** Whether the match is locked (1) or not (0) */
  lockInd?: InputMaybe<Scalars['Int']['input']>;
  /** The scheduled time for the match */
  scheduledTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** The scheduled time epoch for the match */
  scheduledTimeEpoch?: InputMaybe<Scalars['Int']['input']>;
  /** The season ID for the match */
  seasonId?: InputMaybe<Scalars['ID']['input']>;
  /** The status of the match (e.g., 'scheduled', 'in_progress', 'completed') */
  status?: InputMaybe<MatchStatus>;
  /** The venue ID for the match */
  venueId?: InputMaybe<Scalars['ID']['input']>;
  /** The winner pair ID, if applicable */
  winnerPairId?: InputMaybe<Scalars['ID']['input']>;
  /** The winner player ID, if applicable */
  winnerPlayerId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateNewsletterInput = {
  optIn?: InputMaybe<Array<Scalars['String']['input']>>;
  optOut?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateOpenWebUserInput = {
  display_name?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<OpenWebNoficationInput>;
  primary_key: Scalars['String']['input'];
  user_name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOpenWebUserResponse = {
  __typename?: 'UpdateOpenWebUserResponse';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateSubscriptionsInput = {
  custId?: InputMaybe<Scalars['String']['input']>;
  disclosureIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  emailAddress?: InputMaybe<Scalars['EmailAddress']['input']>;
  masterProductId: Scalars['String']['input'];
  newsletters: UpdateNewsletterInput;
  pid?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTourneyLocationsResponse = {
  __typename?: 'UpdateTourneyLocationsResponse';
  code?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<BracketologyTeamData>;
};

export type UpdateUserDetails = SapiResponse & {
  __typename?: 'UpdateUserDetails';
  code: Scalars['Int']['output'];
  data?: Maybe<UserDetails>;
  message?: Maybe<Scalars['String']['output']>;
  sapiStatusCode?: Maybe<Scalars['Int']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateUserInput = {
  clientName?: InputMaybe<Scalars['String']['input']>;
  custId: Scalars['Int']['input'];
  updateFields: Scalars['String']['input'];
};

export type UpdateUserTeamPreferences = {
  __typename?: 'UpdateUserTeamPreferences';
  teamPreferencesById?: Maybe<Array<Scalars['Int']['output']>>;
  teams?: Maybe<FavoriteTeams>;
};

export type UpdateUserTeamPreferencesInput = {
  custId: Scalars['Int']['input'];
  teamPreferencesById?: InputMaybe<Array<Scalars['Int']['input']>>;
  teamPreferencesByIdEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  teams?: InputMaybe<FavoriteTeamsInput>;
};

export type UpdatedBy = {
  __typename?: 'UpdatedBy';
  country?: Maybe<Scalars['String']['output']>;
  ip?: Maybe<Scalars['String']['output']>;
};

export type UpsertMmaEventInput = {
  id?: InputMaybe<DataEngIdentifier>;
  /** League ID (required if create) */
  leagueId?: InputMaybe<DataEngIdentifier>;
  mainCardScheduledTime?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  prelims1CardScheduledTime?: InputMaybe<Scalars['DateTime']['input']>;
  prelims2CardScheduledTime?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledTime?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<SportsEventStatus>;
  /** Venue ID (required if create) */
  venueId?: InputMaybe<DataEngIdentifier>;
};

export type UpsertMmaFightResult = {
  __typename?: 'UpsertMMAFightResult';
  errors: Array<PrimpyGenericError>;
  fight?: Maybe<MmaFight>;
};

/** Result returned by upsertMmaFighter containing the fighter ID and a list of errors */
export type UpsertMmaFighterResult = {
  __typename?: 'UpsertMmaFighterResult';
  errors: Array<PrimpyGenericError>;
  fighter?: Maybe<MmaFighter>;
};

export enum UpsertSidelinesEntityType {
  Book = 'BOOK',
  Game = 'GAME',
  Market = 'MARKET',
  Player = 'PLAYER',
  Team = 'TEAM',
  Vendor = 'VENDOR'
}

export type UpsertSidelinesMarketError = PrimpyBadUserInputError | SidelinesEntityNotFoundError;

export type UpsertSidelinesMarketResult = {
  __typename?: 'UpsertSidelinesMarketResult';
  errors: Array<UpsertSidelinesMarketError>;
  market?: Maybe<SidelinesMarket>;
};

/** Result returned by upsertTennisMatchV2 containing the (possibly partially updated) match and a list of errors */
export type UpsertTennisMatchV2Result = {
  __typename?: 'UpsertTennisMatchV2Result';
  errors: Array<PrimpyGenericError>;
  match?: Maybe<Match>;
};

/** Result returned by upsertTennisTournament containing the (possibly partially updated) tournament and a list of errors */
export type UpsertTennisTournamentResult = {
  __typename?: 'UpsertTennisTournamentResult';
  errors: Array<PrimpyGenericError>;
  tournament?: Maybe<CompetitionParent>;
};

export type UserAuthenticationInput = {
  appId?: InputMaybe<Scalars['String']['input']>;
  /** The name that identifies the client platform that sends the request (e.g. 'cbssports' or 'sportsline') */
  clientName?: InputMaybe<Scalars['String']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  memberId?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  platform?: InputMaybe<Scalars['String']['input']>;
  refCode?: InputMaybe<Scalars['String']['input']>;
  refPage?: InputMaybe<Scalars['String']['input']>;
  userLogin?: InputMaybe<Scalars['String']['input']>;
};

export type UserCreateInput = {
  appId?: InputMaybe<Scalars['String']['input']>;
  clientName?: InputMaybe<Scalars['String']['input']>;
  emailAddress: Scalars['String']['input'];
  masterProductId: Scalars['Int']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
  refCode?: InputMaybe<Scalars['String']['input']>;
  refPage?: InputMaybe<Scalars['String']['input']>;
  userFields?: InputMaybe<Scalars['String']['input']>;
};

export type UserDetails = {
  __typename?: 'UserDetails';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  address3?: Maybe<Scalars['String']['output']>;
  age?: Maybe<Scalars['Int']['output']>;
  ageInd?: Maybe<Scalars['Int']['output']>;
  autoGenUserIdInd?: Maybe<Scalars['Int']['output']>;
  birthDate?: Maybe<Scalars['String']['output']>;
  bounceInd?: Maybe<Scalars['Int']['output']>;
  cacheAt?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  custId?: Maybe<Scalars['Int']['output']>;
  disclosures?: Maybe<UserDisclosuresResponse>;
  doNotBill?: Maybe<Scalars['Boolean']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  encryptedPid?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  groupId?: Maybe<Scalars['Int']['output']>;
  hasOpenWebAcct?: Maybe<Scalars['Boolean']['output']>;
  hasSportsProfile?: Maybe<Scalars['Boolean']['output']>;
  homePhoneNumber?: Maybe<Scalars['String']['output']>;
  isSportslineSubscriber: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  masterProductId?: Maybe<Scalars['Int']['output']>;
  mobileNumber?: Maybe<Scalars['String']['output']>;
  modelName?: Maybe<Scalars['String']['output']>;
  modifiedAt?: Maybe<Scalars['String']['output']>;
  newsletters?: Maybe<Array<Maybe<CbsSportsNewsletterSubscription>>>;
  occupationCd?: Maybe<Scalars['Int']['output']>;
  openWebInfo?: Maybe<OpenWebUserResponse>;
  password?: Maybe<Scalars['String']['output']>;
  password1?: Maybe<Scalars['String']['output']>;
  password2?: Maybe<Scalars['String']['output']>;
  preferences?: Maybe<UserPreferences>;
  productList?: Maybe<Array<MasterProduct>>;
  salt?: Maybe<Scalars['String']['output']>;
  screenName?: Maybe<Scalars['String']['output']>;
  socialDetails?: Maybe<Array<SocialDetails>>;
  state?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  statusCd?: Maybe<Scalars['Int']['output']>;
  strongPasswordIndicator?: Maybe<Scalars['Int']['output']>;
  subscriptions?: Maybe<Array<UserSubscription>>;
  timeZone?: Maybe<Scalars['String']['output']>;
  uregGuid?: Maybe<Scalars['String']['output']>;
  userLogin?: Maybe<Scalars['String']['output']>;
  validEmailInd?: Maybe<Scalars['Int']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type UserDetailsByPidInput = {
  pid: Scalars['String']['input'];
};

export type UserDetailsInput = {
  clientName?: InputMaybe<Scalars['String']['input']>;
  custId?: InputMaybe<Scalars['Int']['input']>;
  emailAddress?: InputMaybe<Scalars['EmailAddress']['input']>;
  encryptedPid?: InputMaybe<Scalars['String']['input']>;
  userLogin?: InputMaybe<Scalars['String']['input']>;
};

export type UserDisclosure = {
  __typename?: 'UserDisclosure';
  acceptedDate: Scalars['Int']['output'];
  acceptedDateDisplay: Scalars['String']['output'];
  custId: Scalars['Int']['output'];
  disclosureId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
};

export type UserDisclosuresObject = {
  __typename?: 'UserDisclosuresObject';
  custId: Scalars['Int']['output'];
  disclosureList?: Maybe<Array<UserDisclosure>>;
};

export type UserDisclosuresResponse = {
  __typename?: 'UserDisclosuresResponse';
  userDisclosures?: Maybe<UserDisclosuresObject>;
};

export type UserPlayerPreferences = {
  __typename?: 'UserPlayerPreferences';
  mlb?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  nba?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ncaab?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ncaaf?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  nfl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  nhl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type UserPreferences = {
  __typename?: 'UserPreferences';
  custId?: Maybe<Scalars['Int']['output']>;
  dateModified?: Maybe<Scalars['String']['output']>;
  players?: Maybe<UserPlayerPreferences>;
  sequence?: Maybe<Scalars['Int']['output']>;
  sessionId?: Maybe<Scalars['String']['output']>;
  sportOrder?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  teamPreferencesById?: Maybe<Array<Scalars['Int']['output']>>;
  teams?: Maybe<FavoriteTeams>;
};

export type UserPreferencesInput = {
  custId?: InputMaybe<Scalars['Int']['input']>;
  dateModified?: InputMaybe<Scalars['String']['input']>;
  players?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sequence?: InputMaybe<Scalars['Int']['input']>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
  sportOrder?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  teamPreferencesById?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type UserProductSignup = {
  __typename?: 'UserProductSignup';
  appId?: Maybe<Scalars['String']['output']>;
  custId?: Maybe<Scalars['Int']['output']>;
  dateFormat?: Maybe<Scalars['String']['output']>;
  masterProductId?: Maybe<Scalars['Int']['output']>;
  refCode?: Maybe<Scalars['String']['output']>;
  signupCode?: Maybe<Scalars['Int']['output']>;
  signupId?: Maybe<Scalars['Int']['output']>;
  signupStatus?: Maybe<Scalars['String']['output']>;
};

export type UserProductSignupInput = {
  appId?: InputMaybe<Scalars['String']['input']>;
  billingSourceId?: InputMaybe<Scalars['String']['input']>;
  custId: Scalars['Int']['input'];
  masterProductId: Scalars['Int']['input'];
  platform?: InputMaybe<Scalars['String']['input']>;
  refCode?: InputMaybe<Scalars['String']['input']>;
  signupStatus: Scalars['String']['input'];
  subId?: InputMaybe<Scalars['String']['input']>;
};

export type UserProfile = {
  __typename?: 'UserProfile';
  cacheDate?: Maybe<Scalars['String']['output']>;
  custId?: Maybe<Scalars['Int']['output']>;
  dateModified?: Maybe<Scalars['String']['output']>;
  profile?: Maybe<UserProfileProfile>;
  sequence?: Maybe<Scalars['Int']['output']>;
};

export type UserProfileProfile = {
  __typename?: 'UserProfileProfile';
  _VERSION?: Maybe<Scalars['Int']['output']>;
  fantasy_teams_updated: Scalars['Boolean']['output'];
  teamPreferencesById?: Maybe<Array<Scalars['Int']['output']>>;
};

export type UserRecommendedContent = {
  __typename?: 'UserRecommendedContent';
  composition?: Maybe<UserRecommendedContentComposition>;
  items?: Maybe<Array<UserRecommendedContentItem>>;
  page: UserRecommendedContentPage;
  recommenderRequestId: Scalars['String']['output'];
  slate: UserRecommendedContentSlate;
};

export type UserRecommendedContentComposition = {
  __typename?: 'UserRecommendedContentComposition';
  pinMode: Scalars['String']['output'];
  pinsApplied?: Maybe<Array<UserRecommendedContentPin>>;
  policyID: Scalars['ID']['output'];
  version: Scalars['String']['output'];
};

export type UserRecommendedContentExplicitUserPreferences = {
  teams: Array<Scalars['ID']['input']>;
};

export type UserRecommendedContentInitInput = {
  explicitUserPreferences: UserRecommendedContentExplicitUserPreferences;
  pageOverrides?: InputMaybe<UserRecommendedContentPageOverrides>;
  pageSize: Scalars['Int']['input'];
  userID: Scalars['ID']['input'];
};

export type UserRecommendedContentItem = {
  __typename?: 'UserRecommendedContentItem';
  contentId: Scalars['ID']['output'];
  contentType: CmsRecommendedContentType;
  origin: Scalars['String']['output'];
  pagePosition: Scalars['Int']['output'];
};

export type UserRecommendedContentNextInput = {
  pageToken?: InputMaybe<Scalars['String']['input']>;
  userID: Scalars['ID']['input'];
};

export type UserRecommendedContentPage = {
  __typename?: 'UserRecommendedContentPage';
  endOfFeed: Scalars['Boolean']['output'];
  index: Scalars['Int']['output'];
  nextToken: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

export type UserRecommendedContentPageOverrides = {
  pins?: InputMaybe<Array<UserRecommendedContentPinInput>>;
};

export type UserRecommendedContentPin = {
  __typename?: 'UserRecommendedContentPin';
  contentId: Scalars['ID']['output'];
  contentType: CmsRecommendedContentType;
  position: Scalars['Int']['output'];
  reason?: Maybe<Scalars['String']['output']>;
};

export type UserRecommendedContentPinInput = {
  contentId: Scalars['ID']['input'];
  contentType: CmsRecommendedContentType;
  position: Scalars['Int']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type UserRecommendedContentSlate = {
  __typename?: 'UserRecommendedContentSlate';
  createdAt: Scalars['DateTime']['output'];
  expiresAt: Scalars['DateTime']['output'];
};

export type UserSocialAuthInput = {
  accessToken: Scalars['String']['input'];
  appId?: InputMaybe<Scalars['String']['input']>;
  clientName?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
  providerId: Scalars['String']['input'];
  refCode?: InputMaybe<Scalars['String']['input']>;
  refPage?: InputMaybe<Scalars['String']['input']>;
};

export type UserSubscription = {
  __typename?: 'UserSubscription';
  accountCode?: Maybe<Scalars['String']['output']>;
  activatedAt?: Maybe<Scalars['String']['output']>;
  amount?: Maybe<Scalars['Int']['output']>;
  billTypeId?: Maybe<Scalars['Int']['output']>;
  canceledAt?: Maybe<Scalars['String']['output']>;
  curPeriodEndAt?: Maybe<Scalars['String']['output']>;
  curPeriodStartAt?: Maybe<Scalars['String']['output']>;
  custId?: Maybe<Scalars['Int']['output']>;
  dateFormat?: Maybe<Scalars['String']['output']>;
  discountAmount?: Maybe<Scalars['Int']['output']>;
  domainId?: Maybe<Scalars['Int']['output']>;
  expiresAt?: Maybe<Scalars['String']['output']>;
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  licenseKey?: Maybe<Scalars['String']['output']>;
  masterProductId?: Maybe<Scalars['Int']['output']>;
  masterProductName?: Maybe<Scalars['String']['output']>;
  modAt?: Maybe<Scalars['String']['output']>;
  paymentMethod?: Maybe<Scalars['String']['output']>;
  paymentPeriodType?: Maybe<Scalars['String']['output']>;
  paymentVendor?: Maybe<Scalars['String']['output']>;
  paymentVendorId?: Maybe<Scalars['Int']['output']>;
  paymentVendorName?: Maybe<Scalars['String']['output']>;
  planCode?: Maybe<Scalars['String']['output']>;
  planCodeName?: Maybe<Scalars['String']['output']>;
  planName?: Maybe<Scalars['String']['output']>;
  prodBillingType?: Maybe<Scalars['String']['output']>;
  prodPaymentId?: Maybe<Scalars['Int']['output']>;
  recurlySubStatus?: Maybe<Scalars['String']['output']>;
  statusId?: Maybe<Scalars['Int']['output']>;
  subId?: Maybe<Scalars['Int']['output']>;
  subStatus?: Maybe<Scalars['String']['output']>;
  subsDatesTimezone?: Maybe<Scalars['String']['output']>;
  subscriptionId?: Maybe<Scalars['Int']['output']>;
  taxAmount?: Maybe<Scalars['Int']['output']>;
  trialEndAt?: Maybe<Scalars['String']['output']>;
  trialStartAt?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type ValidateUserFields = {
  __typename?: 'ValidateUserFields';
  missing?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  valid: Scalars['Boolean']['output'];
};

export type ValidateUserFieldsInput = {
  clientName?: InputMaybe<Scalars['String']['input']>;
  custId: Scalars['Int']['input'];
  mpid: Scalars['Int']['input'];
};

export type Value = {
  __typename?: 'Value';
  MPAA?: Maybe<Scalars['String']['output']>;
  VCHIP?: Maybe<Scalars['String']['output']>;
};

/** define vendor type, refer to vendor table in sql db */
export type Vendor = {
  __typename?: 'Vendor';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  games?: Maybe<VendorGameAssociationsConnection>;
  id: Scalars['ID']['output'];
  lowerName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  players?: Maybe<VendorPlayerAssociationsConnection>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


/** define vendor type, refer to vendor table in sql db */
export type VendorGamesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  gameId?: InputMaybe<Scalars['ID']['input']>;
  leagueId?: InputMaybe<Scalars['ID']['input']>;
  vendorGameId?: InputMaybe<Scalars['String']['input']>;
};


/** define vendor type, refer to vendor table in sql db */
export type VendorPlayersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  leagueId?: InputMaybe<Scalars['ID']['input']>;
  playerId?: InputMaybe<Scalars['ID']['input']>;
  vendorPlayerId?: InputMaybe<Scalars['String']['input']>;
};

/** Association between vendor and CBS for competition, refer to vendor_competition_association table in SQL DB */
export type VendorCompetition = {
  __typename?: 'VendorCompetition';
  /** The unique identifier for the competition in the CBS system */
  competitionId?: Maybe<Scalars['ID']['output']>;
  /** The timestamp when the association was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** The timestamp when the association was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The unique identifier for the competition in the vendor's system */
  vendorCompetitionId?: Maybe<Scalars['String']['output']>;
  /** The unique identifier for the vendor */
  vendorId?: Maybe<Scalars['ID']['output']>;
};

/** Connection between vendor and competition */
export type VendorCompetitionsConnection = {
  __typename?: 'VendorCompetitionsConnection';
  /** A list of edges for the vendor competitions connection */
  edges: Array<Maybe<VendorCompetitionsEdge>>;
  /** A list of vendor competition nodes */
  nodes: Array<Maybe<VendorCompetition>>;
  /** Information about pagination for the connection */
  pageInfo: PageInfo;
};

/** Edge for vendor competition connection */
export type VendorCompetitionsEdge = {
  __typename?: 'VendorCompetitionsEdge';
  /** The cursor for pagination */
  cursor: Scalars['String']['output'];
  /** The vendor competition node associated with this edge */
  node: VendorCompetition;
};

/** Association between vendors and CBS for complex and venue, refer to vendor_complex_venue_association table */
export type VendorComplexVenue = {
  __typename?: 'VendorComplexVenue';
  /** The unique identifier for the complex in the CBS system */
  complexId: Scalars['ID']['output'];
  /** The timestamp when the association was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** The timestamp when the association was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The unique identifier for the complex in the vendor's system */
  vendorComplexId: Scalars['String']['output'];
  /** The unique identifier for the vendor */
  vendorId: Scalars['ID']['output'];
  /** The unique identifier for the venue in the vendor's system */
  vendorVenueId: Scalars['String']['output'];
  /** The unique identifier for the venue in the CBS system */
  venueId: Scalars['ID']['output'];
};

/** Connection between vendors and CBS for complex and venue */
export type VendorComplexVenuesConnection = {
  __typename?: 'VendorComplexVenuesConnection';
  /** A list of edges for the vendor complex venues connection */
  edges: Array<Maybe<VendorComplexVenuesEdge>>;
  /** A list of vendor complex venue nodes */
  nodes: Array<Maybe<VendorComplexVenue>>;
  /** Information about pagination for the connection */
  pageInfo: PageInfo;
};

/** Edge for vendor complex venue connection */
export type VendorComplexVenuesEdge = {
  __typename?: 'VendorComplexVenuesEdge';
  /** The cursor for pagination */
  cursor: Scalars['String']['output'];
  /** The vendor complex venue node associated with this edge */
  node: VendorComplexVenue;
};

/** define type for vendor event, refer to vendor_event_association table in sql db */
export type VendorEvent = {
  __typename?: 'VendorEvent';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  eventId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  league?: Maybe<League>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  vendor?: Maybe<Vendor>;
  vendorEventId?: Maybe<Scalars['String']['output']>;
};

/** define vendor game type, refer to vendor_game_association table in sql db */
export type VendorGame = {
  __typename?: 'VendorGame';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  gameId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  league?: Maybe<League>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  vendor?: Maybe<Vendor>;
  vendorGameId?: Maybe<Scalars['String']['output']>;
};

/** Edge for vendor -> game association exposing vendorGame metadata and the underlying CBS Game as node. */
export type VendorGameAssociationEdge = {
  __typename?: 'VendorGameAssociationEdge';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  cursor: Scalars['String']['output'];
  node: Game;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  vendorGameId?: Maybe<Scalars['String']['output']>;
};

/** Connection between a vendor and its games with vendorGame metadata on the edge and the Game as the node. */
export type VendorGameAssociationsConnection = {
  __typename?: 'VendorGameAssociationsConnection';
  edges: Array<VendorGameAssociationEdge>;
  nodes: Array<Game>;
  pageInfo: PageInfo;
};

/** connection between vendor and game, refer to vendor_game_association table */
export type VendorGamesConnection = {
  __typename?: 'VendorGamesConnection';
  edges: Array<Maybe<VendorGamesEdge>>;
  nodes: Array<Maybe<VendorGame>>;
  pageInfo: PageInfo;
};

/** Edge for vendor player connection */
export type VendorGamesEdge = {
  __typename?: 'VendorGamesEdge';
  cursor: Scalars['String']['output'];
  node: VendorGame;
};

/** type definition for vendor market, refer to vendor_market_association table in sql db */
export type VendorMarket = {
  __typename?: 'VendorMarket';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  league?: Maybe<League>;
  leagueId?: Maybe<Scalars['ID']['output']>;
  marketId?: Maybe<Scalars['ID']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  vendor?: Maybe<Vendor>;
  vendorId?: Maybe<Scalars['ID']['output']>;
  vendorMarketId?: Maybe<Scalars['String']['output']>;
};

/** Edge for vendor market connection */
export type VendorMarketEdge = {
  __typename?: 'VendorMarketEdge';
  cursor: Scalars['String']['output'];
  node: VendorMarket;
};

/** connection between vendor and market, refer to vendor_market_association table */
export type VendorMarketsConnection = {
  __typename?: 'VendorMarketsConnection';
  edges: Array<Maybe<VendorMarketEdge>>;
  nodes: Array<Maybe<VendorMarket>>;
  pageInfo: PageInfo;
};

/** Association between vendor and CBS for match, refer to vendor_match_association table in SQL DB */
export type VendorMatch = {
  __typename?: 'VendorMatch';
  /** The timestamp when the association was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** The unique identifier for the match in the CBS system */
  matchId: Scalars['ID']['output'];
  /** The timestamp when the association was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The unique identifier for the vendor */
  vendorId?: Maybe<Scalars['ID']['output']>;
  /** The unique identifier for the match in the vendor's system */
  vendorMatchId?: Maybe<Scalars['String']['output']>;
};

/** Connection between vendor and match */
export type VendorMatchConnection = {
  __typename?: 'VendorMatchConnection';
  /** A list of edges for the vendor match connection */
  edges: Array<VendorMatchEdge>;
  /** A list of vendor match nodes */
  nodes: Array<VendorMatch>;
  /** Information about pagination for the connection */
  pageInfo: PageInfo;
};

/** Edge for vendor match connection */
export type VendorMatchEdge = {
  __typename?: 'VendorMatchEdge';
  /** The cursor for pagination */
  cursor: Scalars['String']['output'];
  /** The vendor match node associated with this edge */
  node: VendorMatch;
};

/** deine vendor player type, refer to vendor_player_association table in sql db */
export type VendorPlayer = {
  __typename?: 'VendorPlayer';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  leagueId?: Maybe<Scalars['ID']['output']>;
  player?: Maybe<Player>;
  playerId?: Maybe<Scalars['ID']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  vendorId?: Maybe<Scalars['ID']['output']>;
  vendorPlayerId?: Maybe<Scalars['String']['output']>;
};

/** Edge for vendor -> player association exposing vendorPlayer metadata and the underlying CBS Player as node. */
export type VendorPlayerAssociationEdge = {
  __typename?: 'VendorPlayerAssociationEdge';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  cursor: Scalars['String']['output'];
  node: Player;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  vendorPlayerId?: Maybe<Scalars['String']['output']>;
};

/** Connection between a vendor and its players with vendorPlayer metadata on the edge and the Player as the node. */
export type VendorPlayerAssociationsConnection = {
  __typename?: 'VendorPlayerAssociationsConnection';
  edges: Array<VendorPlayerAssociationEdge>;
  nodes: Array<Player>;
  pageInfo: PageInfo;
};

/** Association between vendors and pair for vendor and pair, refer to vendor_player_pair_association table */
export type VendorPlayerPair = {
  __typename?: 'VendorPlayerPair';
  /** The timestamp when the association was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** The unique identifier for the pair in the CBS system */
  pairId: Scalars['ID']['output'];
  /** The timestamp when the association was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The unique identifier for the vendor */
  vendorId: Scalars['ID']['output'];
  /** The unique identifier for the pair in the vendor's system */
  vendorPairId: Scalars['String']['output'];
};

/** Connection between vendors and CBS for pair */
export type VendorPlayerPairsConnection = {
  __typename?: 'VendorPlayerPairsConnection';
  /** A list of edges for the vendor player pair connection */
  edges: Array<Maybe<VendorPlayerPairsEdge>>;
  /** A list of vendor player pair nodes */
  nodes: Array<Maybe<VendorPlayerPair>>;
  /** Information about pagination for the connection */
  pageInfo: PageInfo;
};

/** Edge for vendor player pair connection */
export type VendorPlayerPairsEdge = {
  __typename?: 'VendorPlayerPairsEdge';
  /** The cursor for pagination */
  cursor: Scalars['String']['output'];
  /** The vendor player pair node associated with this edge */
  node: VendorPlayerPair;
};

/** connection between vendor and player, refer to vendor_player_association table */
export type VendorPlayersConnection = {
  __typename?: 'VendorPlayersConnection';
  edges: Array<Maybe<VendorPlayersEdge>>;
  nodes: Array<Maybe<VendorPlayer>>;
  pageInfo: PageInfo;
};

/** Edge for vendor player connection */
export type VendorPlayersEdge = {
  __typename?: 'VendorPlayersEdge';
  cursor: Scalars['String']['output'];
  node: VendorPlayer;
};

/** define vendor season type, refer to vendor_season_association table in sql db */
export type VendorSeason = {
  __typename?: 'VendorSeason';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  season?: Maybe<Season>;
  seasonId: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  vendorId: Scalars['ID']['output'];
  vendorSeasonId: Scalars['String']['output'];
};

/** connection for vendor_season_association query result, refer to vendor_season_association table */
export type VendorSeasonsConnection = {
  __typename?: 'VendorSeasonsConnection';
  edges: Array<Maybe<VendorSeasonsEdge>>;
  nodes: Array<Maybe<VendorSeason>>;
  pageInfo: PageInfo;
};

/** Edge for vendor season connection */
export type VendorSeasonsEdge = {
  __typename?: 'VendorSeasonsEdge';
  cursor: Scalars['String']['output'];
  node: VendorSeason;
};

/** define vendor team type, refer to vendor_team_association table in sql db */
export type VendorTeam = {
  __typename?: 'VendorTeam';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  leagueId?: Maybe<Scalars['ID']['output']>;
  team?: Maybe<Team>;
  teamId?: Maybe<Scalars['ID']['output']>;
  ticketUrl?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  vendorId?: Maybe<Scalars['ID']['output']>;
  vendorTeamId?: Maybe<Scalars['String']['output']>;
};

/** connection for vendor_team_association query result, refer to vendor_team_association table */
export type VendorTeamsConnection = {
  __typename?: 'VendorTeamsConnection';
  edges: Array<Maybe<VendorTeamsEdge>>;
  nodes: Array<Maybe<VendorTeam>>;
  pageInfo: PageInfo;
};

/** Edge for vendor teams connection */
export type VendorTeamsEdge = {
  __typename?: 'VendorTeamsEdge';
  cursor: Scalars['String']['output'];
  node: VendorTeam;
};

/** define venue type, refer to venue table in sql db */
export type Venue = {
  __typename?: 'Venue';
  /** @deprecated Use 'abbrev' instead */
  abbr: Scalars['String']['output'];
  abbrev: Scalars['String']['output'];
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  marketId?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  state?: Maybe<Scalars['String']['output']>;
  surface?: Maybe<Scalars['String']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  weatherCode?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type Video = {
  __typename?: 'Video';
  /**
   * comments to trigger sche
   *   Contains information such as description, title, duration, etc.
   */
  about?: Maybe<VideoAbout>;
  /** Used for "daiAssetKey" */
  ads?: Maybe<VideoAds>;
  /**
   * An array of strings pertaining to the authentication of the video
   *   e.g. ["adobe"]
   */
  authentication?: Maybe<Array<Scalars['String']['output']>>;
  /** Designated market area (DMA) for the video */
  dma?: Maybe<Scalars['Int']['output']>;
  /** The group of the DMA for the video */
  dmaGroup?: Maybe<Scalars['Int']['output']>;
  /** Contains information about the event associated with the video */
  event?: Maybe<VideoEvent>;
  /** Contains information about the network associated with the video */
  flags?: Maybe<VideoFlags>;
  /** Contains information about the identifiers of the video such as guid, id, and slug */
  identifiers?: Maybe<VideoIdentifiers>;
  /** The network associated with the video */
  network?: Maybe<Scalars['String']['output']>;
  /** Network Info */
  networkInfo?: Maybe<VideoNetwork>;
  /** The order of the video in the row */
  order?: Maybe<Scalars['Int']['output']>;
  /** Details regarding the playback of the video (e.g. openHLS) */
  playback?: Maybe<Scalars['String']['output']>;
  /** Contains information such as isLive, league, type, etc. */
  properties?: Maybe<VideoProperties>;
  /** The unique identifier for the row in which the video is located */
  rowId?: Maybe<Scalars['Int']['output']>;
  /** Contains information about video scheduling */
  schedule?: Maybe<VideoSchedule>;
  /** Contains information about the URL sources of the video */
  sources?: Maybe<VideoSources>;
};

export type VideoAbout = {
  __typename?: 'VideoAbout';
  /** A detailed description of the video content. */
  description?: Maybe<Scalars['String']['output']>;
  /** The length of the video in seconds. */
  duration?: Maybe<Scalars['Int']['output']>;
  /** URL or path to the video thumbnail image. */
  images?: Maybe<VideoAboutImages>;
  /** A prefix identifier for the video. */
  prefix?: Maybe<Scalars['String']['output']>;
  /** Unix timestamp indicating when the video was published. */
  publishedOn?: Maybe<Scalars['Int']['output']>;
  /** The title of the video segment or chapter. */
  segmentTitle?: Maybe<Scalars['String']['output']>;
  /** Short title for the video */
  shortTitle?: Maybe<Scalars['String']['output']>;
  /** The user-friendly title shown in the interface. */
  title?: Maybe<Scalars['String']['output']>;
};

/** Collection of video about images in different aspect ratios */
export type VideoAboutImages = {
  __typename?: 'VideoAboutImages';
  /** Base image with aspect ratio 16:5 */
  baseImage16X5?: Maybe<Scalars['String']['output']>;
  /** Base image with aspect ratio 16:9 */
  baseImage16X9?: Maybe<Scalars['String']['output']>;
};

export type VideoAds = {
  __typename?: 'VideoAds';
  dai?: Maybe<VideoAdsDai>;
};

export type VideoAdsDai = {
  __typename?: 'VideoAdsDai';
  daiAssetKey?: Maybe<Scalars['String']['output']>;
};

export type VideoDeeplink = {
  __typename?: 'VideoDeeplink';
  /** Contains information such as description, title, duration, etc. */
  about?: Maybe<VideoAbout>;
  /** Used for "daiAssetKey" */
  flags?: Maybe<VideoFlags>;
  /** The order of the video in the row */
  order?: Maybe<Scalars['Int']['output']>;
  /** Contains details such as isLive, league, type, etc. */
  properties?: Maybe<VideoProperties>;
  /** Contains information about video scheduling */
  schedule?: Maybe<VideoSchedule>;
  /** Deeplink has just a URL field and not a "sources" field like Video */
  url?: Maybe<Scalars['String']['output']>;
};

/** Event representing video transition states and behavior */
export type VideoEvent = {
  __typename?: 'VideoEvent';
  /** How often the event occurs */
  frequency?: Maybe<Scalars['Int']['output']>;
  /** The event state after transition */
  postEvent?: Maybe<Scalars['String']['output']>;
  /** Post-game video event configuration */
  postGame?: Maybe<VideoEventPostGame>;
  /** The event state before transition */
  preEvent?: Maybe<Scalars['String']['output']>;
  /** Pre-game video event configuration */
  preGame?: Maybe<VideoEventPreGame>;
  /** Current status of the video event */
  status?: Maybe<Scalars['String']['output']>;
};

/** Configuration for post-game video events */
export type VideoEventPostGame = {
  __typename?: 'VideoEventPostGame';
  /** Video sources for post-game content */
  sources?: Maybe<VideoEventSources>;
  /** Preview image URL for post-game content */
  thumbnail?: Maybe<Scalars['String']['output']>;
};

/** Configuration for pre-game video events */
export type VideoEventPreGame = {
  __typename?: 'VideoEventPreGame';
  /** Video sources for pre-game content */
  sources?: Maybe<VideoEventSources>;
  /** Preview image URL for pre-game content */
  thumbnail?: Maybe<Scalars['String']['output']>;
};

/** DASH streaming source configuration */
export type VideoEventSourceDash = {
  __typename?: 'VideoEventSourceDash';
  /** DASH streaming URL with advertisements */
  url?: Maybe<Scalars['String']['output']>;
  /** DASH streaming URL without advertisements */
  urlnoAd?: Maybe<Scalars['String']['output']>;
};

/** HLS streaming source configuration */
export type VideoEventSourceHls = {
  __typename?: 'VideoEventSourceHls';
  /** Main HLS streaming URL */
  url?: Maybe<Scalars['String']['output']>;
  /** HLS streaming URL without advertisements */
  urlnoAd?: Maybe<Scalars['String']['output']>;
  /** Collection of HLS URLs by platform */
  urls?: Maybe<VideoEventSourceHlsUrls>;
  /** Collection of HLS URLs without advertisements by platform */
  urlsnoAd?: Maybe<VideoEventSourceHlsUrls>;
};

/** Platform-specific HLS streaming URLs */
export type VideoEventSourceHlsUrls = {
  __typename?: 'VideoEventSourceHlsUrls';
  /** HLS streaming URL optimized for desktop platforms */
  desktop?: Maybe<Scalars['String']['output']>;
};

/** Available video streaming sources */
export type VideoEventSources = {
  __typename?: 'VideoEventSources';
  /** DASH streaming configuration */
  dash?: Maybe<VideoEventSourceDash>;
  /** HLS streaming configuration */
  hls?: Maybe<VideoEventSourceHls>;
};

/** Flags controlling video delivery and ad behavior. */
export type VideoFlags = {
  __typename?: 'VideoFlags';
  /** When true, prevents advertisements from being shown with this video. */
  suppressPreroll?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates if Dynamic Ad Insertion is enabled for this video. */
  useDai?: Maybe<Scalars['Boolean']['output']>;
};

export type VideoIdentifiers = {
  __typename?: 'VideoIdentifiers';
  /** Unique identifier for the video, typically a GUID. */
  guid?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the video, separate from its GQL ID */
  id?: Maybe<Scalars['String']['output']>;
  /** Prism Topic */
  prismTopic?: Maybe<Scalars['String']['output']>;
  /** URL-friendly string identifier for the video */
  slug?: Maybe<Scalars['String']['output']>;
  /** Tracking ID */
  trackingId?: Maybe<Scalars['String']['output']>;
};

/** An array of video rows */
export type VideoMenuOrder = {
  __typename?: 'VideoMenuOrder';
  /** Detailed description of the video menu item */
  description?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the video menu order */
  id: Scalars['ID']['output'];
  /** Visual arrangement style for the menu item */
  layout?: Maybe<Scalars['String']['output']>;
  /**
   * An array of video rows that can either be a:
   *   - Video
   *   - Deeplink
   *   - Promo
   *
   *   This interface is used to encompass all of these types.
   */
  rowData?: Maybe<OrderRowDataConnection>;
  /** URL-friendly version of the title */
  slug?: Maybe<Scalars['String']['output']>;
  /** Display title of the video menu item */
  title?: Maybe<Scalars['String']['output']>;
  /** Authentication or access token for the video */
  token?: Maybe<Scalars['String']['output']>;
  /** Direct URL to the video content */
  url?: Maybe<Scalars['String']['output']>;
};


/** An array of video rows */
export type VideoMenuOrderRowDataArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type VideoMenuPage = {
  __typename?: 'VideoMenuPage';
  /** MD5 hash of the response */
  fullRefreshToken?: Maybe<Scalars['String']['output']>;
  /** An array of video rows */
  order: VideoMenuPageOrderConnection;
  /** Version of the response */
  version?: Maybe<Scalars['Int']['output']>;
};


export type VideoMenuPageOrderArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type VideoMenuPageOrderConnection = {
  __typename?: 'VideoMenuPageOrderConnection';
  /** The list of edges */
  edges?: Maybe<Array<VideoMenuPageOrderEdge>>;
  /** The page info */
  pageInfo: PageInfo;
};

export type VideoMenuPageOrderEdge = {
  __typename?: 'VideoMenuPageOrderEdge';
  /** The cursor for pagination */
  cursor: Scalars['String']['output'];
  /** The node (VideoMenuOrder) associated with this edge */
  node: VideoMenuOrder;
};

/** Default VideoMenuRow */
export type VideoMenuRow = VideoMenuRowInterface & {
  __typename?: 'VideoMenuRow';
  /** Indicates if this row is featured */
  featured?: Maybe<Scalars['Boolean']['output']>;
  /** GUID for the row */
  id: Scalars['ID']['output'];
  /** Numeric value determining the display sequence of this row relative to other rows */
  order?: Maybe<Scalars['Int']['output']>;
};

/** A single row is a container for videos, deeplinks, and/or promos. */
export type VideoMenuRowInterface = {
  /** Indicates if this row is featured */
  featured?: Maybe<Scalars['Boolean']['output']>;
  /** GUID for the row */
  id: Scalars['ID']['output'];
  /** Numeric value determining the display sequence of this row relative to other rows */
  order?: Maybe<Scalars['Int']['output']>;
};

/** Network information associated with a video */
export type VideoNetwork = {
  __typename?: 'VideoNetwork';
  /** URL path for the small-sized logo of the network */
  logoUrlSmall?: Maybe<Scalars['String']['output']>;
  /** Name of the network */
  name?: Maybe<Scalars['String']['output']>;
};

export type VideoPromo = {
  __typename?: 'VideoPromo';
  /** Description of the video content */
  description?: Maybe<Scalars['String']['output']>;
  /** Unix timestamp indicating when the video becomes ends */
  endDate?: Maybe<Scalars['Int']['output']>;
  /** Collection of related images for the video */
  images?: Maybe<VideoAboutImages>;
  /** Unix timestamp indicating when the video becomes starts */
  startDate?: Maybe<Scalars['Int']['output']>;
  /** Promotional tag associated with the video */
  tag?: Maybe<VideoPromoTag>;
  /** Title of the video */
  title?: Maybe<Scalars['String']['output']>;
};

/** Represents a promotional tag associated with a video content item */
export type VideoPromoTag = {
  __typename?: 'VideoPromoTag';
  /** Unique identifier for the promo tag */
  id: Scalars['ID']['output'];
  /** Flag indicating if the promo tag is currently active */
  isActive?: Maybe<Scalars['Boolean']['output']>;
  /** Unique key identifier for the promo tag */
  key?: Maybe<Scalars['String']['output']>;
  /** Display name of the promo tag */
  name?: Maybe<Scalars['String']['output']>;
  /** Related entity identifier associated with this promo tag */
  relatedId?: Maybe<Scalars['Int']['output']>;
  /** Type classification of the promotional tag */
  tag?: Maybe<VideoPromoTagType>;
};

/** Represents a promotional tag associated with video content. */
export type VideoPromoTagType = {
  __typename?: 'VideoPromoTagType';
  /** The league name to be displayed, using predefined Leagues enum. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** The division or category this tag belongs to. */
  division?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the promotional tag. */
  id: Scalars['ID']['output'];
  /** Indicates whether this tag is protected from modifications. */
  isProtected?: Maybe<Scalars['Boolean']['output']>;
  /** The name of the promotional tag. */
  name?: Maybe<Scalars['String']['output']>;
};

export type VideoProperties = {
  __typename?: 'VideoProperties';
  /** Used to determine if the video is live or not */
  eventType?: Maybe<Scalars['String']['output']>;
  /**
   * Reference to the associated game object. We'll eventually
   *   refactor this to utilize the Primpy subgraph
   */
  game?: Maybe<Game>;
  /** Game Id from Wayfinder */
  gameId?: Maybe<Scalars['Int']['output']>;
  /** The sports league associated with the video content */
  league?: Maybe<Scalars['String']['output']>;
  /** Sport associated with the video content */
  sport?: Maybe<Scalars['String']['output']>;
  /** Video tag slugs */
  tagSlugs?: Maybe<Array<Scalars['String']['output']>>;
  /** Video tags */
  tags?: Maybe<Array<Scalars['String']['output']>>;
  /** Live, live-linear */
  type?: Maybe<Scalars['String']['output']>;
};

/** Video row object where the deeplink field is populated */
export type VideoRowDeeplink = VideoMenuRowInterface & {
  __typename?: 'VideoRowDeeplink';
  /** The actual deeplink */
  deeplink?: Maybe<VideoDeeplink>;
  /** Indicates if this video row is featured */
  featured?: Maybe<Scalars['Boolean']['output']>;
  /** Unique identifier for the video row */
  id: Scalars['ID']['output'];
  /** Display order position of this row in the menu */
  order?: Maybe<Scalars['Int']['output']>;
};

/** Video row object where the promo field is populated */
export type VideoRowPromo = VideoMenuRowInterface & {
  __typename?: 'VideoRowPromo';
  /** Indicates if this video row is featured */
  featured?: Maybe<Scalars['Boolean']['output']>;
  /** Unique identifier for the video row */
  id: Scalars['ID']['output'];
  /** Sorting order of the video row in the menu */
  order?: Maybe<Scalars['Int']['output']>;
  /** Promo video */
  promo?: Maybe<VideoPromo>;
};

/** Video row object where the video field is populated */
export type VideoRowVideo = VideoMenuRowInterface & {
  __typename?: 'VideoRowVideo';
  /** Indicates if this video row is featured */
  featured?: Maybe<Scalars['Boolean']['output']>;
  /** Unique identifier for the video row */
  id: Scalars['ID']['output'];
  /** Position/sequence number of this row in the menu */
  order?: Maybe<Scalars['Int']['output']>;
  /** The video object associated with this row */
  video?: Maybe<Video>;
};

/** Schedule configuration for video availability period */
export type VideoSchedule = {
  __typename?: 'VideoSchedule';
  /** The date when the post-video period ends, represented as a Unix timestamp */
  postEndDate?: Maybe<Scalars['Int']['output']>;
  /** The date when the post-video period starts, represented as a Unix timestamp */
  postStartDate?: Maybe<Scalars['Int']['output']>;
  /** The date when the pre-video period ends, represented as a Unix timestamp */
  preEndDate?: Maybe<Scalars['Int']['output']>;
  /** The date when the pre-video period starts, represented as a Unix timestamp */
  preStartDate?: Maybe<Scalars['Int']['output']>;
  /** The date when the video viewing period ends, represented as a Unix timestamp */
  videoEndDate?: Maybe<Scalars['Int']['output']>;
  /** The date when the video becomes available for viewing, represented as a Unix timestamp */
  videoStartDate?: Maybe<Scalars['Int']['output']>;
};

/** A type representing DASH video source URLs */
export type VideoSourceDash = {
  __typename?: 'VideoSourceDash';
  /** The URL of the video source with advertisements */
  url?: Maybe<Scalars['String']['output']>;
  /** The URL of the video source without advertisements */
  urlNoAd?: Maybe<Scalars['String']['output']>;
};

export type VideoSourceHls = {
  __typename?: 'VideoSourceHls';
  /** URL for the HLS stream */
  url?: Maybe<Scalars['String']['output']>;
  urlNoAd?: Maybe<Scalars['String']['output']>;
};

export type VideoSources = {
  __typename?: 'VideoSources';
  /** DASH (Dynamic Adaptive Streaming over HTTP) source for the video */
  dash?: Maybe<VideoSourceDash>;
  /** HLS (HTTP Live Streaming) source for the video */
  hls?: Maybe<VideoSourceHls>;
};

/** Represents the available types of X Handle associations. */
export type XAssociation = Event | Game | League | Player | Sport | Team;

export type XAssociationInput = {
  id: Scalars['ID']['input'];
  type: XAssociationType;
};

export enum XAssociationType {
  Event = 'EVENT',
  Game = 'GAME',
  League = 'LEAGUE',
  Player = 'PLAYER',
  Sport = 'SPORT',
  Team = 'TEAM'
}

/** Represents an X Handle. */
export type XHandle = {
  __typename?: 'XHandle';
  associations?: Maybe<Array<XAssociation>>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  disabled: Scalars['Boolean']['output'];
  excludeFromTweetIngestion: Scalars['Boolean']['output'];
  /** Whether the handle exists already. */
  exists: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  internalCreatedAt: Scalars['DateTime']['output'];
  internalCreatedBy: CmsUser;
  internalUpdatedAt: Scalars['DateTime']['output'];
  internalUpdatedBy: CmsUser;
  location?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  profileImageURL?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  username: Scalars['String']['output'];
  verified?: Maybe<Scalars['Boolean']['output']>;
  verifiedType?: Maybe<XHandleVerifiedType>;
};

export type XHandleConnection = {
  __typename?: 'XHandleConnection';
  /** A list of edges. */
  edges: Array<XHandleEdge>;
  /** A list of nodes. */
  nodes: Array<XHandle>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total count. */
  totalCount: Scalars['Int']['output'];
};

/** Represents X Handle create. */
export type XHandleCreate = {
  associations?: InputMaybe<Array<XAssociationInput>>;
  createUserID: Scalars['ID']['input'];
  createdAt: Scalars['DateTime']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  excludeFromTweetIngestion?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  location?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  profileImageURL?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  username: Scalars['String']['input'];
  verified?: InputMaybe<Scalars['Boolean']['input']>;
  verifiedType?: InputMaybe<XHandleVerifiedType>;
};

export type XHandleEdge = {
  __typename?: 'XHandleEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: XHandle;
};

export type XHandleOrderBy = {
  createdAt?: InputMaybe<OrderByDir>;
  name?: InputMaybe<OrderByDir>;
  updatedAt?: InputMaybe<OrderByDir>;
  username?: InputMaybe<OrderByDir>;
};

/** Represents X Handle update. */
export type XHandleUpdate = {
  associations?: InputMaybe<Array<XAssociationInput>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  excludeFromTweetIngestion?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  location?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  profileImageURL?: InputMaybe<Scalars['String']['input']>;
  updateUserID: Scalars['ID']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
  verifiedType?: InputMaybe<XHandleVerifiedType>;
};

/** Represents an X Handle's verified type. */
export enum XHandleVerifiedType {
  Blue = 'BLUE',
  Business = 'BUSINESS',
  Government = 'GOVERNMENT',
  None = 'NONE'
}

export type XHandlesCondition = {
  associationsIn?: InputMaybe<Array<XAssociationInput>>;
  idsIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  keywordSearch?: InputMaybe<Scalars['String']['input']>;
  usernamesIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Represents the inputs for xHandles resolver. */
export type XHandlesInput = {
  /** Should be base64 encoded to support offset and ID-based pagination. */
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<XHandlesCondition>;
  /** Defines the number of results to return. */
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<XHandleOrderBy>>;
};

/** Represents an X Tweet. */
export type XTweet = {
  __typename?: 'XTweet';
  InReplyToHandle?: Maybe<XHandle>;
  associations?: Maybe<Array<XAssociation>>;
  contextAnnotations?: Maybe<Array<XTweetContextAnnotation>>;
  createdAt: Scalars['DateTime']['output'];
  disabled: Scalars['Boolean']['output'];
  entities?: Maybe<XTweetEntities>;
  handle: XHandle;
  id: Scalars['ID']['output'];
  includes?: Maybe<XTweetIncludes>;
  internalCreatedAt: Scalars['DateTime']['output'];
  internalCreatedBy: CmsUser;
  internalUpdatedAt: Scalars['DateTime']['output'];
  internalUpdatedBy: CmsUser;
  media?: Maybe<Array<XTweetMedia>>;
  referencedTweets?: Maybe<Array<XTweetReferencedTweet>>;
  text: Scalars['String']['output'];
};

export type XTweetAttachmentsInput = {
  mediaKeys?: InputMaybe<Array<Scalars['ID']['input']>>;
  pollIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type XTweetConnection = {
  __typename?: 'XTweetConnection';
  /** A list of edges. */
  edges: Array<XTweetEdge>;
  /** A list of nodes. */
  nodes: Array<XTweet>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total count. */
  totalCount: Scalars['Int']['output'];
};

export type XTweetContextAnnotation = {
  __typename?: 'XTweetContextAnnotation';
  domain: XTweetContextAnnotationItem;
  entity: XTweetContextAnnotationItem;
};

export type XTweetContextAnnotationInput = {
  domain: XTweetContextAnnotationItemInput;
  entity: XTweetContextAnnotationItemInput;
};

export type XTweetContextAnnotationItem = {
  __typename?: 'XTweetContextAnnotationItem';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type XTweetContextAnnotationItemInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type XTweetCreate = {
  associations?: InputMaybe<Array<XAssociationInput>>;
  attachments?: InputMaybe<XTweetAttachmentsInput>;
  contextAnnotations?: InputMaybe<Array<XTweetContextAnnotationInput>>;
  conversationID?: InputMaybe<Scalars['ID']['input']>;
  createUserID: Scalars['ID']['input'];
  createdAt: Scalars['DateTime']['input'];
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  entities?: InputMaybe<XTweetEntitiesInput>;
  handleID: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  inReplyToUserID?: InputMaybe<Scalars['ID']['input']>;
  includes?: InputMaybe<XTweetIncludesInput>;
  media?: InputMaybe<Array<XTweetMediaInput>>;
  referencedTweets?: InputMaybe<Array<XTweetReferencedTweetInput>>;
  text: Scalars['String']['input'];
};

export type XTweetEdge = {
  __typename?: 'XTweetEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: XTweet;
};

export type XTweetEntities = {
  __typename?: 'XTweetEntities';
  annotations?: Maybe<Array<XTweetEntityAnnotation>>;
  cashtags?: Maybe<Array<XTweetEntityHashtag>>;
  hashtags?: Maybe<Array<XTweetEntityHashtag>>;
  mentions?: Maybe<Array<XTweetEntityMention>>;
  urls?: Maybe<Array<XTweetEntityUrl>>;
};

export type XTweetEntitiesInput = {
  annotations?: InputMaybe<Array<XTweetEntityAnnotationInput>>;
  cashtags?: InputMaybe<Array<XTweetEntityHashtagInput>>;
  hashtags?: InputMaybe<Array<XTweetEntityHashtagInput>>;
  mentions?: InputMaybe<Array<XTweetEntityMentionInput>>;
  urls?: InputMaybe<Array<XTweetEntityUrlInput>>;
};

export type XTweetEntityAnnotation = {
  __typename?: 'XTweetEntityAnnotation';
  end: Scalars['Int']['output'];
  normalizedText: Scalars['String']['output'];
  probability: Scalars['Float']['output'];
  start: Scalars['Int']['output'];
  type: Scalars['String']['output'];
};

export type XTweetEntityAnnotationInput = {
  end: Scalars['Int']['input'];
  normalizedText: Scalars['String']['input'];
  probability: Scalars['Float']['input'];
  start: Scalars['Int']['input'];
  type: Scalars['String']['input'];
};

export type XTweetEntityHashtag = {
  __typename?: 'XTweetEntityHashtag';
  end: Scalars['Int']['output'];
  start: Scalars['Int']['output'];
  tag: Scalars['String']['output'];
};

export type XTweetEntityHashtagInput = {
  end: Scalars['Int']['input'];
  start: Scalars['Int']['input'];
  tag: Scalars['String']['input'];
};

export type XTweetEntityMention = {
  __typename?: 'XTweetEntityMention';
  end: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  start: Scalars['Int']['output'];
  username: Scalars['String']['output'];
};

export type XTweetEntityMentionInput = {
  end: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
  start: Scalars['Int']['input'];
  username: Scalars['String']['input'];
};

export type XTweetEntityUrl = {
  __typename?: 'XTweetEntityUrl';
  description?: Maybe<Scalars['String']['output']>;
  displayUrl: Scalars['String']['output'];
  end: Scalars['Int']['output'];
  expandedUrl: Scalars['String']['output'];
  images?: Maybe<Array<XTweetEntityUrlImage>>;
  mediaKey?: Maybe<Scalars['String']['output']>;
  start: Scalars['Int']['output'];
  status?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  unwoundUrl: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type XTweetEntityUrlImage = {
  __typename?: 'XTweetEntityUrlImage';
  height: Scalars['Int']['output'];
  url: Scalars['String']['output'];
  width: Scalars['Int']['output'];
};

export type XTweetEntityUrlImageInput = {
  height: Scalars['Int']['input'];
  url: Scalars['String']['input'];
  width: Scalars['Int']['input'];
};

export type XTweetEntityUrlInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayUrl: Scalars['String']['input'];
  end: Scalars['Int']['input'];
  expandedUrl: Scalars['String']['input'];
  images?: InputMaybe<Array<XTweetEntityUrlImageInput>>;
  mediaKey?: InputMaybe<Scalars['String']['input']>;
  start: Scalars['Int']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  unwoundUrl: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type XTweetIncludes = {
  __typename?: 'XTweetIncludes';
  media?: Maybe<Array<XTweetMedia>>;
  tweets?: Maybe<Array<XTweet>>;
  users?: Maybe<Array<XTweetIncludesUsers>>;
};

export type XTweetIncludesInput = {
  media?: InputMaybe<Array<XTweetIncludesMediaInput>>;
  tweets?: InputMaybe<Array<XTweetIncludesTweetInput>>;
  users?: InputMaybe<Array<XTweetIncludesUserInput>>;
};

export type XTweetIncludesMediaInput = {
  altText?: InputMaybe<Scalars['String']['input']>;
  durationMs?: InputMaybe<Scalars['Int']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  mediaKey: Scalars['String']['input'];
  previewImageUrl?: InputMaybe<Scalars['String']['input']>;
  type: XTweetMediaType;
  url?: InputMaybe<Scalars['String']['input']>;
  variants?: InputMaybe<Array<XTweetMediaVariantInput>>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type XTweetIncludesTweetInput = {
  attachments?: InputMaybe<XTweetAttachmentsInput>;
  contextAnnotations?: InputMaybe<Array<XTweetContextAnnotationInput>>;
  conversationID?: InputMaybe<Scalars['ID']['input']>;
  createdAt: Scalars['DateTime']['input'];
  entities?: InputMaybe<XTweetEntitiesInput>;
  handleID: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  inReplyToUserID?: InputMaybe<Scalars['ID']['input']>;
  includes?: InputMaybe<XTweetIncludesInput>;
  media?: InputMaybe<Array<XTweetMediaInput>>;
  referencedTweets?: InputMaybe<Array<XTweetReferencedTweetInput>>;
  text: Scalars['String']['input'];
};

export type XTweetIncludesUserInput = {
  id: Scalars['ID']['input'];
  name: Scalars['ID']['input'];
  profileImageURL?: InputMaybe<Scalars['String']['input']>;
  username: Scalars['String']['input'];
};

export type XTweetIncludesUsers = {
  __typename?: 'XTweetIncludesUsers';
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  location?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  profileImageURL?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  username: Scalars['String']['output'];
  verified?: Maybe<Scalars['Boolean']['output']>;
  verifiedType?: Maybe<XHandleVerifiedType>;
};

export type XTweetMedia = {
  __typename?: 'XTweetMedia';
  altText?: Maybe<Scalars['String']['output']>;
  durationMs?: Maybe<Scalars['Int']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  mediaKey: Scalars['String']['output'];
  previewImageURL?: Maybe<Scalars['String']['output']>;
  type: XTweetMediaType;
  url?: Maybe<Scalars['String']['output']>;
  /** Variants represents the different bitrate video files available for a VIDEO media type. */
  variants?: Maybe<Array<XTweetMediaVariant>>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type XTweetMediaInput = {
  altText?: InputMaybe<Scalars['String']['input']>;
  durationMs?: InputMaybe<Scalars['Int']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  mediaKey: Scalars['String']['input'];
  previewImageUrl?: InputMaybe<Scalars['String']['input']>;
  type: XTweetMediaType;
  url?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export enum XTweetMediaType {
  AnimatedGif = 'ANIMATED_GIF',
  Other = 'OTHER',
  Photo = 'PHOTO',
  Video = 'VIDEO'
}

export type XTweetMediaVariant = {
  __typename?: 'XTweetMediaVariant';
  bitRate: Scalars['Int64']['output'];
  contentType: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type XTweetMediaVariantInput = {
  bitRate: Scalars['Int64']['input'];
  contentType: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type XTweetOrderBy = {
  createdAt?: InputMaybe<OrderByDir>;
  id?: InputMaybe<OrderByDir>;
  updatedAt?: InputMaybe<OrderByDir>;
};

export type XTweetReferencedTweet = {
  __typename?: 'XTweetReferencedTweet';
  tweet: XTweet;
  type: XTweetReferencedTweetType;
};

export type XTweetReferencedTweetInput = {
  id: Scalars['ID']['input'];
  type: XTweetReferencedTweetType;
};

export enum XTweetReferencedTweetType {
  Quoted = 'QUOTED',
  RepliedTo = 'REPLIED_TO',
  Retweeted = 'RETWEETED'
}

export type XTweetUpdate = {
  associations?: InputMaybe<Array<XAssociationInput>>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  updateUserID: Scalars['ID']['input'];
};

export type XTweetsCondition = {
  associationsIn?: InputMaybe<Array<XAssociationInput>>;
  handlesIn?: InputMaybe<Array<Scalars['String']['input']>>;
  idsIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Represents the inputs for tweets resolver. */
export type XTweetsInput = {
  /** Should be base64 encoded to support offset and ID-based pagination. */
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<XTweetsCondition>;
  /** Defines the number of results to return. */
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<XTweetOrderBy>>;
};

export enum Link__Purpose {
  /** `EXECUTION` features provide metadata necessary for operation execution. */
  Execution = 'EXECUTION',
  /** `SECURITY` features provide metadata necessary to securely resolve fields. */
  Security = 'SECURITY'
}

export type Openfed__SubscriptionFieldCondition = {
  fieldPath: Scalars['String']['input'];
  values: Array<InputMaybe<Scalars['openfed__SubscriptionFilterValue']['input']>>;
};

export type Openfed__SubscriptionFilterCondition = {
  AND?: InputMaybe<Array<Openfed__SubscriptionFilterCondition>>;
  IN?: InputMaybe<Openfed__SubscriptionFieldCondition>;
  NOT?: InputMaybe<Openfed__SubscriptionFilterCondition>;
  OR?: InputMaybe<Array<Openfed__SubscriptionFilterCondition>>;
};

export type RemoveTeamFromBracketologyResponse = {
  __typename?: 'removeTeamFromBracketologyResponse';
  code?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<BracketologyTeamIdRemoved>;
};

export type FreeExpertPick_GameTeamFragment = { __typename?: 'GameTeam', id: string, abbrev?: string | null, nickname?: string | null, mediumName?: string | null, location?: string | null, colorHexDex?: string | null, colorSecondaryHex?: string | null };

export type FreeExpertPick_TeamFragment = { __typename?: 'Team', id: string, abbrev?: string | null, nickname?: string | null, mediumName?: string | null, location?: string | null, colorHexDex?: string | null, colorSecondaryHex?: string | null, vendors?: { __typename?: 'TeamVendorConnection', edges: Array<{ __typename?: 'TeamVendorEdge', vendorTeamId?: string | null } | null> } | null };

export type FreeExpertPick_MarketFragment = { __typename?: 'BettingMarket', id: string, name?: string | null, vendors?: { __typename?: 'BettingMarketVendorConnection', edges: Array<{ __typename?: 'BettingMarketVendorEdge', vendorMarketId: string, league?: { __typename?: 'League', id: string } | null }> } | null };

export type FreeExpertPick_ExpertPickFragment = { __typename?: 'ExpertPick', isSubscriber?: boolean | null, locked: boolean, resultStatus?: string | null, id: string, writeup?: string | null, createdAt: any, expertStreaks?: Array<{ __typename?: 'ExpertStreak', id: string, label?: string | null, hot?: boolean | null, rank?: number | null, profit?: number | null, won?: number | null, lost?: number | null, pushed?: number | null, winPercentage?: number | null, league?: { __typename?: 'League', id: string, abbrev: string } | null }> | null, expert?: { __typename?: 'SportslineExpert', cbsExpertId?: number | null, clearHeadshotUrl?: string | null, firstName?: string | null, lastName?: string | null } | null, league?: { __typename?: 'League', id: string } | null, game?: { __typename?: 'Game', id: string, scheduledTime?: any | null, isNeutral?: boolean | null, abbrev?: string | null, league: { __typename?: 'League', abbrev: string }, awayTeam?: { __typename?: 'GameTeam', id: string, abbrev?: string | null, nickname?: string | null, mediumName?: string | null, location?: string | null, colorHexDex?: string | null, colorSecondaryHex?: string | null } | null, homeTeam?: { __typename?: 'GameTeam', id: string, abbrev?: string | null, nickname?: string | null, mediumName?: string | null, location?: string | null, colorHexDex?: string | null, colorSecondaryHex?: string | null } | null, vendors?: { __typename?: 'GameVendorConnection', edges: Array<{ __typename?: 'GameVendorEdge', vendorGameId?: string | null }> } | null } | null, selection: { __typename: 'ExpertPickSelectionGameProps', marketType?: string | null, label: string, subLabel: string, odds?: number | null, side?: string | null, value?: number | null, unit?: number | null, labelLong: string, team?: { __typename?: 'Team', id: string, abbrev?: string | null, nickname?: string | null, mediumName?: string | null, location?: string | null, colorHexDex?: string | null, colorSecondaryHex?: string | null, vendors?: { __typename?: 'TeamVendorConnection', edges: Array<{ __typename?: 'TeamVendorEdge', vendorTeamId?: string | null } | null> } | null } | null, market?: { __typename?: 'BettingMarket', id: string, name?: string | null, vendors?: { __typename?: 'BettingMarketVendorConnection', edges: Array<{ __typename?: 'BettingMarketVendorEdge', vendorMarketId: string, league?: { __typename?: 'League', id: string } | null }> } | null } | null } | { __typename: 'ExpertPickSelectionPlayerProps', marketType?: string | null, label: string, subLabel: string, odds?: number | null, side?: string | null, value?: number | null, unit?: number | null, labelLong: string, player?: { __typename?: 'Player', id: string, firstName?: string | null, lastName?: string | null, vendors?: { __typename?: 'PlayerVendorConnection', edges: Array<{ __typename?: 'PlayerVendorEdge', vendorPlayerId?: string | null } | null> } | null } | null, playerTeam?: { __typename?: 'Team', id: string, abbrev?: string | null, nickname?: string | null, mediumName?: string | null, location?: string | null, colorHexDex?: string | null, colorSecondaryHex?: string | null, vendors?: { __typename?: 'TeamVendorConnection', edges: Array<{ __typename?: 'TeamVendorEdge', vendorTeamId?: string | null } | null> } | null } | null, market?: { __typename?: 'BettingMarket', id: string, name?: string | null, vendors?: { __typename?: 'BettingMarketVendorConnection', edges: Array<{ __typename?: 'BettingMarketVendorEdge', vendorMarketId: string, league?: { __typename?: 'League', id: string } | null }> } | null } | null } | { __typename: 'ExpertPickSelectionStandard', marketType?: string | null, label: string, subLabel: string, odds?: number | null, side?: string | null, value?: number | null, unit?: number | null, labelLong: string, team?: { __typename?: 'Team', id: string, abbrev?: string | null, nickname?: string | null, mediumName?: string | null, location?: string | null, colorHexDex?: string | null, colorSecondaryHex?: string | null, vendors?: { __typename?: 'TeamVendorConnection', edges: Array<{ __typename?: 'TeamVendorEdge', vendorTeamId?: string | null } | null> } | null } | null, market?: { __typename?: 'BettingMarket', id: string, name?: string | null, vendors?: { __typename?: 'BettingMarketVendorConnection', edges: Array<{ __typename?: 'BettingMarketVendorEdge', vendorMarketId: string, league?: { __typename?: 'League', id: string } | null }> } | null } | null } | { __typename: 'ExpertPickSelectionTeamProps', marketType?: string | null, label: string, subLabel: string, odds?: number | null, side?: string | null, value?: number | null, unit?: number | null, labelLong: string, team?: { __typename?: 'Team', id: string, abbrev?: string | null, nickname?: string | null, mediumName?: string | null, location?: string | null, colorHexDex?: string | null, colorSecondaryHex?: string | null, vendors?: { __typename?: 'TeamVendorConnection', edges: Array<{ __typename?: 'TeamVendorEdge', vendorTeamId?: string | null } | null> } | null } | null, market?: { __typename?: 'BettingMarket', id: string, name?: string | null, vendors?: { __typename?: 'BettingMarketVendorConnection', edges: Array<{ __typename?: 'BettingMarketVendorEdge', vendorMarketId: string, league?: { __typename?: 'League', id: string } | null }> } | null } | null } };

export type SportslineWebComponent_FreeExpertPickQueryVariables = Exact<{
  expertPickId: Scalars['ID']['input'];
  vendorName?: InputMaybe<Scalars['String']['input']>;
  marketVendorName?: InputMaybe<Scalars['String']['input']>;
}>;


export type SportslineWebComponent_FreeExpertPickQuery = { __typename?: 'Query', freeExpertPick?: { __typename?: 'ExpertPick', isSubscriber?: boolean | null, locked: boolean, resultStatus?: string | null, id: string, writeup?: string | null, createdAt: any, expertStreaks?: Array<{ __typename?: 'ExpertStreak', id: string, label?: string | null, hot?: boolean | null, rank?: number | null, profit?: number | null, won?: number | null, lost?: number | null, pushed?: number | null, winPercentage?: number | null, league?: { __typename?: 'League', id: string, abbrev: string } | null }> | null, expert?: { __typename?: 'SportslineExpert', cbsExpertId?: number | null, clearHeadshotUrl?: string | null, firstName?: string | null, lastName?: string | null } | null, league?: { __typename?: 'League', id: string } | null, game?: { __typename?: 'Game', id: string, scheduledTime?: any | null, isNeutral?: boolean | null, abbrev?: string | null, league: { __typename?: 'League', abbrev: string }, awayTeam?: { __typename?: 'GameTeam', id: string, abbrev?: string | null, nickname?: string | null, mediumName?: string | null, location?: string | null, colorHexDex?: string | null, colorSecondaryHex?: string | null } | null, homeTeam?: { __typename?: 'GameTeam', id: string, abbrev?: string | null, nickname?: string | null, mediumName?: string | null, location?: string | null, colorHexDex?: string | null, colorSecondaryHex?: string | null } | null, vendors?: { __typename?: 'GameVendorConnection', edges: Array<{ __typename?: 'GameVendorEdge', vendorGameId?: string | null }> } | null } | null, selection: { __typename: 'ExpertPickSelectionGameProps', marketType?: string | null, label: string, subLabel: string, odds?: number | null, side?: string | null, value?: number | null, unit?: number | null, labelLong: string, team?: { __typename?: 'Team', id: string, abbrev?: string | null, nickname?: string | null, mediumName?: string | null, location?: string | null, colorHexDex?: string | null, colorSecondaryHex?: string | null, vendors?: { __typename?: 'TeamVendorConnection', edges: Array<{ __typename?: 'TeamVendorEdge', vendorTeamId?: string | null } | null> } | null } | null, market?: { __typename?: 'BettingMarket', id: string, name?: string | null, vendors?: { __typename?: 'BettingMarketVendorConnection', edges: Array<{ __typename?: 'BettingMarketVendorEdge', vendorMarketId: string, league?: { __typename?: 'League', id: string } | null }> } | null } | null } | { __typename: 'ExpertPickSelectionPlayerProps', marketType?: string | null, label: string, subLabel: string, odds?: number | null, side?: string | null, value?: number | null, unit?: number | null, labelLong: string, player?: { __typename?: 'Player', id: string, firstName?: string | null, lastName?: string | null, vendors?: { __typename?: 'PlayerVendorConnection', edges: Array<{ __typename?: 'PlayerVendorEdge', vendorPlayerId?: string | null } | null> } | null } | null, playerTeam?: { __typename?: 'Team', id: string, abbrev?: string | null, nickname?: string | null, mediumName?: string | null, location?: string | null, colorHexDex?: string | null, colorSecondaryHex?: string | null, vendors?: { __typename?: 'TeamVendorConnection', edges: Array<{ __typename?: 'TeamVendorEdge', vendorTeamId?: string | null } | null> } | null } | null, market?: { __typename?: 'BettingMarket', id: string, name?: string | null, vendors?: { __typename?: 'BettingMarketVendorConnection', edges: Array<{ __typename?: 'BettingMarketVendorEdge', vendorMarketId: string, league?: { __typename?: 'League', id: string } | null }> } | null } | null } | { __typename: 'ExpertPickSelectionStandard', marketType?: string | null, label: string, subLabel: string, odds?: number | null, side?: string | null, value?: number | null, unit?: number | null, labelLong: string, team?: { __typename?: 'Team', id: string, abbrev?: string | null, nickname?: string | null, mediumName?: string | null, location?: string | null, colorHexDex?: string | null, colorSecondaryHex?: string | null, vendors?: { __typename?: 'TeamVendorConnection', edges: Array<{ __typename?: 'TeamVendorEdge', vendorTeamId?: string | null } | null> } | null } | null, market?: { __typename?: 'BettingMarket', id: string, name?: string | null, vendors?: { __typename?: 'BettingMarketVendorConnection', edges: Array<{ __typename?: 'BettingMarketVendorEdge', vendorMarketId: string, league?: { __typename?: 'League', id: string } | null }> } | null } | null } | { __typename: 'ExpertPickSelectionTeamProps', marketType?: string | null, label: string, subLabel: string, odds?: number | null, side?: string | null, value?: number | null, unit?: number | null, labelLong: string, team?: { __typename?: 'Team', id: string, abbrev?: string | null, nickname?: string | null, mediumName?: string | null, location?: string | null, colorHexDex?: string | null, colorSecondaryHex?: string | null, vendors?: { __typename?: 'TeamVendorConnection', edges: Array<{ __typename?: 'TeamVendorEdge', vendorTeamId?: string | null } | null> } | null } | null, market?: { __typename?: 'BettingMarket', id: string, name?: string | null, vendors?: { __typename?: 'BettingMarketVendorConnection', edges: Array<{ __typename?: 'BettingMarketVendorEdge', vendorMarketId: string, league?: { __typename?: 'League', id: string } | null }> } | null } | null } } | null };

export type SportslineWebComponent_FreeExpertPicksQueryVariables = Exact<{
  filter?: InputMaybe<ExpertPickFilterInput>;
  sortBy?: InputMaybe<Array<ExpertPickSortByInput> | ExpertPickSortByInput>;
  vendorName?: InputMaybe<Scalars['String']['input']>;
  marketVendorName?: InputMaybe<Scalars['String']['input']>;
}>;


export type SportslineWebComponent_FreeExpertPicksQuery = { __typename?: 'Query', freeExpertPicks?: { __typename?: 'ExpertPicksConnection', edges?: Array<{ __typename?: 'ExpertPicksEdge', node: { __typename?: 'ExpertPick', isSubscriber?: boolean | null, locked: boolean, resultStatus?: string | null, id: string, writeup?: string | null, createdAt: any, expertStreaks?: Array<{ __typename?: 'ExpertStreak', id: string, label?: string | null, hot?: boolean | null, rank?: number | null, profit?: number | null, won?: number | null, lost?: number | null, pushed?: number | null, winPercentage?: number | null, league?: { __typename?: 'League', id: string, abbrev: string } | null }> | null, expert?: { __typename?: 'SportslineExpert', cbsExpertId?: number | null, clearHeadshotUrl?: string | null, firstName?: string | null, lastName?: string | null } | null, league?: { __typename?: 'League', id: string } | null, game?: { __typename?: 'Game', id: string, scheduledTime?: any | null, isNeutral?: boolean | null, abbrev?: string | null, league: { __typename?: 'League', abbrev: string }, awayTeam?: { __typename?: 'GameTeam', id: string, abbrev?: string | null, nickname?: string | null, mediumName?: string | null, location?: string | null, colorHexDex?: string | null, colorSecondaryHex?: string | null } | null, homeTeam?: { __typename?: 'GameTeam', id: string, abbrev?: string | null, nickname?: string | null, mediumName?: string | null, location?: string | null, colorHexDex?: string | null, colorSecondaryHex?: string | null } | null, vendors?: { __typename?: 'GameVendorConnection', edges: Array<{ __typename?: 'GameVendorEdge', vendorGameId?: string | null }> } | null } | null, selection: { __typename: 'ExpertPickSelectionGameProps', marketType?: string | null, label: string, subLabel: string, odds?: number | null, side?: string | null, value?: number | null, unit?: number | null, labelLong: string, team?: { __typename?: 'Team', id: string, abbrev?: string | null, nickname?: string | null, mediumName?: string | null, location?: string | null, colorHexDex?: string | null, colorSecondaryHex?: string | null, vendors?: { __typename?: 'TeamVendorConnection', edges: Array<{ __typename?: 'TeamVendorEdge', vendorTeamId?: string | null } | null> } | null } | null, market?: { __typename?: 'BettingMarket', id: string, name?: string | null, vendors?: { __typename?: 'BettingMarketVendorConnection', edges: Array<{ __typename?: 'BettingMarketVendorEdge', vendorMarketId: string, league?: { __typename?: 'League', id: string } | null }> } | null } | null } | { __typename: 'ExpertPickSelectionPlayerProps', marketType?: string | null, label: string, subLabel: string, odds?: number | null, side?: string | null, value?: number | null, unit?: number | null, labelLong: string, player?: { __typename?: 'Player', id: string, firstName?: string | null, lastName?: string | null, vendors?: { __typename?: 'PlayerVendorConnection', edges: Array<{ __typename?: 'PlayerVendorEdge', vendorPlayerId?: string | null } | null> } | null } | null, playerTeam?: { __typename?: 'Team', id: string, abbrev?: string | null, nickname?: string | null, mediumName?: string | null, location?: string | null, colorHexDex?: string | null, colorSecondaryHex?: string | null, vendors?: { __typename?: 'TeamVendorConnection', edges: Array<{ __typename?: 'TeamVendorEdge', vendorTeamId?: string | null } | null> } | null } | null, market?: { __typename?: 'BettingMarket', id: string, name?: string | null, vendors?: { __typename?: 'BettingMarketVendorConnection', edges: Array<{ __typename?: 'BettingMarketVendorEdge', vendorMarketId: string, league?: { __typename?: 'League', id: string } | null }> } | null } | null } | { __typename: 'ExpertPickSelectionStandard', marketType?: string | null, label: string, subLabel: string, odds?: number | null, side?: string | null, value?: number | null, unit?: number | null, labelLong: string, team?: { __typename?: 'Team', id: string, abbrev?: string | null, nickname?: string | null, mediumName?: string | null, location?: string | null, colorHexDex?: string | null, colorSecondaryHex?: string | null, vendors?: { __typename?: 'TeamVendorConnection', edges: Array<{ __typename?: 'TeamVendorEdge', vendorTeamId?: string | null } | null> } | null } | null, market?: { __typename?: 'BettingMarket', id: string, name?: string | null, vendors?: { __typename?: 'BettingMarketVendorConnection', edges: Array<{ __typename?: 'BettingMarketVendorEdge', vendorMarketId: string, league?: { __typename?: 'League', id: string } | null }> } | null } | null } | { __typename: 'ExpertPickSelectionTeamProps', marketType?: string | null, label: string, subLabel: string, odds?: number | null, side?: string | null, value?: number | null, unit?: number | null, labelLong: string, team?: { __typename?: 'Team', id: string, abbrev?: string | null, nickname?: string | null, mediumName?: string | null, location?: string | null, colorHexDex?: string | null, colorSecondaryHex?: string | null, vendors?: { __typename?: 'TeamVendorConnection', edges: Array<{ __typename?: 'TeamVendorEdge', vendorTeamId?: string | null } | null> } | null } | null, market?: { __typename?: 'BettingMarket', id: string, name?: string | null, vendors?: { __typename?: 'BettingMarketVendorConnection', edges: Array<{ __typename?: 'BettingMarketVendorEdge', vendorMarketId: string, league?: { __typename?: 'League', id: string } | null }> } | null } | null } } }> | null } | null };

export type PickSnippet_ExpertPickFragment = { __typename?: 'ExpertPick', id: string, game?: { __typename?: 'Game', id: string, abbrev?: string | null, scheduledTime?: any | null, status?: GameStatus | null, isNeutral?: boolean | null, awayTeam?: { __typename?: 'GameTeam', abbrev?: string | null, id: string, colorHexDex?: string | null } | null, homeTeam?: { __typename?: 'GameTeam', abbrev?: string | null, id: string, colorHexDex?: string | null } | null } | null, selection: { __typename: 'ExpertPickSelectionGameProps', cbsMarketId?: number | null, label: string, value?: number | null, side?: string | null, subLabel: string, odds?: number | null, team?: { __typename?: 'Team', id: string } | null } | { __typename: 'ExpertPickSelectionPlayerProps', cbsMarketId?: number | null, label: string, value?: number | null, side?: string | null, subLabel: string, odds?: number | null, player?: { __typename?: 'Player', id: string, firstName?: string | null, lastName?: string | null } | null, playerTeam?: { __typename?: 'Team', id: string } | null } | { __typename: 'ExpertPickSelectionStandard', label: string, value?: number | null, side?: string | null, odds?: number | null, subLabel: string, team?: { __typename?: 'Team', id: string } | null } | { __typename: 'ExpertPickSelectionTeamProps', cbsMarketId?: number | null, label: string, side?: string | null, value?: number | null, subLabel: string, odds?: number | null, team?: { __typename?: 'Team', id: string } | null } };

export type SportslineWebComponent_PicksSnippetQueryVariables = Exact<{
  filter?: InputMaybe<ExpertPickFilterInput>;
  sortBy?: InputMaybe<Array<ExpertPickSortByInput> | ExpertPickSortByInput>;
}>;


export type SportslineWebComponent_PicksSnippetQuery = { __typename?: 'Query', freeExpertPicks?: { __typename?: 'ExpertPicksConnection', edges?: Array<{ __typename?: 'ExpertPicksEdge', node: { __typename?: 'ExpertPick', id: string, game?: { __typename?: 'Game', id: string, abbrev?: string | null, scheduledTime?: any | null, status?: GameStatus | null, isNeutral?: boolean | null, awayTeam?: { __typename?: 'GameTeam', abbrev?: string | null, id: string, colorHexDex?: string | null } | null, homeTeam?: { __typename?: 'GameTeam', abbrev?: string | null, id: string, colorHexDex?: string | null } | null } | null, selection: { __typename: 'ExpertPickSelectionGameProps', cbsMarketId?: number | null, label: string, value?: number | null, side?: string | null, subLabel: string, odds?: number | null, team?: { __typename?: 'Team', id: string } | null } | { __typename: 'ExpertPickSelectionPlayerProps', cbsMarketId?: number | null, label: string, value?: number | null, side?: string | null, subLabel: string, odds?: number | null, player?: { __typename?: 'Player', id: string, firstName?: string | null, lastName?: string | null } | null, playerTeam?: { __typename?: 'Team', id: string } | null } | { __typename: 'ExpertPickSelectionStandard', label: string, value?: number | null, side?: string | null, odds?: number | null, subLabel: string, team?: { __typename?: 'Team', id: string } | null } | { __typename: 'ExpertPickSelectionTeamProps', cbsMarketId?: number | null, label: string, side?: string | null, value?: number | null, subLabel: string, odds?: number | null, team?: { __typename?: 'Team', id: string } | null } } }> | null } | null };

export type SportslineWebComponent_PromotedExpertPicksQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<PromotedExpertPickFilterInput>;
  vendorName?: InputMaybe<Scalars['String']['input']>;
  marketVendorName?: InputMaybe<Scalars['String']['input']>;
}>;


export type SportslineWebComponent_PromotedExpertPicksQuery = { __typename?: 'Query', promotedExpertPicks?: { __typename?: 'ExpertPicksConnection', edges?: Array<{ __typename?: 'ExpertPicksEdge', node: { __typename?: 'ExpertPick', isSubscriber?: boolean | null, locked: boolean, resultStatus?: string | null, id: string, writeup?: string | null, createdAt: any, expertStreaks?: Array<{ __typename?: 'ExpertStreak', id: string, label?: string | null, hot?: boolean | null, rank?: number | null, profit?: number | null, won?: number | null, lost?: number | null, pushed?: number | null, winPercentage?: number | null, league?: { __typename?: 'League', id: string, abbrev: string } | null }> | null, expert?: { __typename?: 'SportslineExpert', cbsExpertId?: number | null, clearHeadshotUrl?: string | null, firstName?: string | null, lastName?: string | null } | null, league?: { __typename?: 'League', id: string } | null, game?: { __typename?: 'Game', id: string, scheduledTime?: any | null, isNeutral?: boolean | null, abbrev?: string | null, league: { __typename?: 'League', abbrev: string }, awayTeam?: { __typename?: 'GameTeam', id: string, abbrev?: string | null, nickname?: string | null, mediumName?: string | null, location?: string | null, colorHexDex?: string | null, colorSecondaryHex?: string | null } | null, homeTeam?: { __typename?: 'GameTeam', id: string, abbrev?: string | null, nickname?: string | null, mediumName?: string | null, location?: string | null, colorHexDex?: string | null, colorSecondaryHex?: string | null } | null, vendors?: { __typename?: 'GameVendorConnection', edges: Array<{ __typename?: 'GameVendorEdge', vendorGameId?: string | null }> } | null } | null, selection: { __typename: 'ExpertPickSelectionGameProps', marketType?: string | null, label: string, subLabel: string, odds?: number | null, side?: string | null, value?: number | null, unit?: number | null, labelLong: string, team?: { __typename?: 'Team', id: string, abbrev?: string | null, nickname?: string | null, mediumName?: string | null, location?: string | null, colorHexDex?: string | null, colorSecondaryHex?: string | null, vendors?: { __typename?: 'TeamVendorConnection', edges: Array<{ __typename?: 'TeamVendorEdge', vendorTeamId?: string | null } | null> } | null } | null, market?: { __typename?: 'BettingMarket', id: string, name?: string | null, vendors?: { __typename?: 'BettingMarketVendorConnection', edges: Array<{ __typename?: 'BettingMarketVendorEdge', vendorMarketId: string, league?: { __typename?: 'League', id: string } | null }> } | null } | null } | { __typename: 'ExpertPickSelectionPlayerProps', marketType?: string | null, label: string, subLabel: string, odds?: number | null, side?: string | null, value?: number | null, unit?: number | null, labelLong: string, player?: { __typename?: 'Player', id: string, firstName?: string | null, lastName?: string | null, vendors?: { __typename?: 'PlayerVendorConnection', edges: Array<{ __typename?: 'PlayerVendorEdge', vendorPlayerId?: string | null } | null> } | null } | null, playerTeam?: { __typename?: 'Team', id: string, abbrev?: string | null, nickname?: string | null, mediumName?: string | null, location?: string | null, colorHexDex?: string | null, colorSecondaryHex?: string | null, vendors?: { __typename?: 'TeamVendorConnection', edges: Array<{ __typename?: 'TeamVendorEdge', vendorTeamId?: string | null } | null> } | null } | null, market?: { __typename?: 'BettingMarket', id: string, name?: string | null, vendors?: { __typename?: 'BettingMarketVendorConnection', edges: Array<{ __typename?: 'BettingMarketVendorEdge', vendorMarketId: string, league?: { __typename?: 'League', id: string } | null }> } | null } | null } | { __typename: 'ExpertPickSelectionStandard', marketType?: string | null, label: string, subLabel: string, odds?: number | null, side?: string | null, value?: number | null, unit?: number | null, labelLong: string, team?: { __typename?: 'Team', id: string, abbrev?: string | null, nickname?: string | null, mediumName?: string | null, location?: string | null, colorHexDex?: string | null, colorSecondaryHex?: string | null, vendors?: { __typename?: 'TeamVendorConnection', edges: Array<{ __typename?: 'TeamVendorEdge', vendorTeamId?: string | null } | null> } | null } | null, market?: { __typename?: 'BettingMarket', id: string, name?: string | null, vendors?: { __typename?: 'BettingMarketVendorConnection', edges: Array<{ __typename?: 'BettingMarketVendorEdge', vendorMarketId: string, league?: { __typename?: 'League', id: string } | null }> } | null } | null } | { __typename: 'ExpertPickSelectionTeamProps', marketType?: string | null, label: string, subLabel: string, odds?: number | null, side?: string | null, value?: number | null, unit?: number | null, labelLong: string, team?: { __typename?: 'Team', id: string, abbrev?: string | null, nickname?: string | null, mediumName?: string | null, location?: string | null, colorHexDex?: string | null, colorSecondaryHex?: string | null, vendors?: { __typename?: 'TeamVendorConnection', edges: Array<{ __typename?: 'TeamVendorEdge', vendorTeamId?: string | null } | null> } | null } | null, market?: { __typename?: 'BettingMarket', id: string, name?: string | null, vendors?: { __typename?: 'BettingMarketVendorConnection', edges: Array<{ __typename?: 'BettingMarketVendorEdge', vendorMarketId: string, league?: { __typename?: 'League', id: string } | null }> } | null } | null } } }> | null } | null };

export type SportslineWebComponent_PickSnippet_GameTeamFragment = { __typename?: 'GameTeam', id: string, abbrev?: string | null, colorHexDex?: string | null, nickname?: string | null, shortName?: string | null, mediumName?: string | null, vendors?: { __typename?: 'TeamVendorConnection', edges: Array<{ __typename?: 'TeamVendorEdge', vendorTeamId?: string | null } | null> } | null };

export type SportslineWebComponent_PickSnippet_TeamFragment = { __typename?: 'Team', id: string };

export type SportslineWebComponent_PickSnippetFragment = { __typename?: 'PickSnippet', id: string, game: { __typename?: 'Game', id: string, abbrev?: string | null, scheduledTime?: any | null, status?: GameStatus | null, isNeutral?: boolean | null, league: { __typename?: 'League', id: string, abbrev: string }, vendors?: { __typename?: 'GameVendorConnection', edges: Array<{ __typename?: 'GameVendorEdge', vendorGameId?: string | null }> } | null, awayTeam?: { __typename?: 'GameTeam', id: string, abbrev?: string | null, colorHexDex?: string | null, nickname?: string | null, shortName?: string | null, mediumName?: string | null, vendors?: { __typename?: 'TeamVendorConnection', edges: Array<{ __typename?: 'TeamVendorEdge', vendorTeamId?: string | null } | null> } | null } | null, homeTeam?: { __typename?: 'GameTeam', id: string, abbrev?: string | null, colorHexDex?: string | null, nickname?: string | null, shortName?: string | null, mediumName?: string | null, vendors?: { __typename?: 'TeamVendorConnection', edges: Array<{ __typename?: 'TeamVendorEdge', vendorTeamId?: string | null } | null> } | null } | null }, selection?: { __typename: 'PickSnippetSelectionGameProp', odds: number, side?: string | null, marketTypeLabel?: string | null, marketName?: string | null, label: string, labelLong: string, team?: { __typename?: 'Team', id: string } | null } | { __typename: 'PickSnippetSelectionPlayerProp', odds: number, side?: string | null, marketTypeLabel?: string | null, marketName?: string | null, label: string, labelLong: string, player?: { __typename?: 'Player', id: string, firstName?: string | null, lastName?: string | null, vendors?: { __typename?: 'PlayerVendorConnection', edges: Array<{ __typename?: 'PlayerVendorEdge', vendorPlayerId?: string | null, leagueId?: number | null } | null> } | null } | null } | { __typename: 'PickSnippetSelectionStandard', odds: number, side?: string | null, marketTypeLabel?: string | null, marketName?: string | null, label: string, labelLong: string, team?: { __typename?: 'Team', id: string } | null } | { __typename: 'PickSnippetSelectionTeamProp', odds: number, side?: string | null, marketTypeLabel?: string | null, marketName?: string | null, label: string, labelLong: string, team?: { __typename?: 'Team', id: string } | null } | null };

export type SportslineWebComponent_PickSnippetQueryVariables = Exact<{
  input: PickSnippetInput;
  vendorName?: Scalars['String']['input'];
}>;


export type SportslineWebComponent_PickSnippetQuery = { __typename?: 'Query', pickSnippet?: { __typename?: 'PickSnippet', id: string, game: { __typename?: 'Game', id: string, abbrev?: string | null, scheduledTime?: any | null, status?: GameStatus | null, isNeutral?: boolean | null, league: { __typename?: 'League', id: string, abbrev: string }, vendors?: { __typename?: 'GameVendorConnection', edges: Array<{ __typename?: 'GameVendorEdge', vendorGameId?: string | null }> } | null, awayTeam?: { __typename?: 'GameTeam', id: string, abbrev?: string | null, colorHexDex?: string | null, nickname?: string | null, shortName?: string | null, mediumName?: string | null, vendors?: { __typename?: 'TeamVendorConnection', edges: Array<{ __typename?: 'TeamVendorEdge', vendorTeamId?: string | null } | null> } | null } | null, homeTeam?: { __typename?: 'GameTeam', id: string, abbrev?: string | null, colorHexDex?: string | null, nickname?: string | null, shortName?: string | null, mediumName?: string | null, vendors?: { __typename?: 'TeamVendorConnection', edges: Array<{ __typename?: 'TeamVendorEdge', vendorTeamId?: string | null } | null> } | null } | null }, selection?: { __typename: 'PickSnippetSelectionGameProp', odds: number, side?: string | null, marketTypeLabel?: string | null, marketName?: string | null, label: string, labelLong: string, team?: { __typename?: 'Team', id: string } | null } | { __typename: 'PickSnippetSelectionPlayerProp', odds: number, side?: string | null, marketTypeLabel?: string | null, marketName?: string | null, label: string, labelLong: string, player?: { __typename?: 'Player', id: string, firstName?: string | null, lastName?: string | null, vendors?: { __typename?: 'PlayerVendorConnection', edges: Array<{ __typename?: 'PlayerVendorEdge', vendorPlayerId?: string | null, leagueId?: number | null } | null> } | null } | null } | { __typename: 'PickSnippetSelectionStandard', odds: number, side?: string | null, marketTypeLabel?: string | null, marketName?: string | null, label: string, labelLong: string, team?: { __typename?: 'Team', id: string } | null } | { __typename: 'PickSnippetSelectionTeamProp', odds: number, side?: string | null, marketTypeLabel?: string | null, marketName?: string | null, label: string, labelLong: string, team?: { __typename?: 'Team', id: string } | null } | null } | null };

export type SportslineWebComponent_PickSnippetParlayQueryVariables = Exact<{
  input: Array<PickSnippetInput> | PickSnippetInput;
  vendorName?: Scalars['String']['input'];
}>;


export type SportslineWebComponent_PickSnippetParlayQuery = { __typename?: 'Query', pickSnippetParlay?: { __typename?: 'PickSnippetParlay', id: string, odds: number, legs: Array<{ __typename?: 'PickSnippet', id: string, game: { __typename?: 'Game', id: string, abbrev?: string | null, scheduledTime?: any | null, status?: GameStatus | null, isNeutral?: boolean | null, league: { __typename?: 'League', id: string, abbrev: string }, vendors?: { __typename?: 'GameVendorConnection', edges: Array<{ __typename?: 'GameVendorEdge', vendorGameId?: string | null }> } | null, awayTeam?: { __typename?: 'GameTeam', id: string, abbrev?: string | null, colorHexDex?: string | null, nickname?: string | null, shortName?: string | null, mediumName?: string | null, vendors?: { __typename?: 'TeamVendorConnection', edges: Array<{ __typename?: 'TeamVendorEdge', vendorTeamId?: string | null } | null> } | null } | null, homeTeam?: { __typename?: 'GameTeam', id: string, abbrev?: string | null, colorHexDex?: string | null, nickname?: string | null, shortName?: string | null, mediumName?: string | null, vendors?: { __typename?: 'TeamVendorConnection', edges: Array<{ __typename?: 'TeamVendorEdge', vendorTeamId?: string | null } | null> } | null } | null }, selection?: { __typename: 'PickSnippetSelectionGameProp', odds: number, side?: string | null, marketTypeLabel?: string | null, marketName?: string | null, label: string, labelLong: string, team?: { __typename?: 'Team', id: string } | null } | { __typename: 'PickSnippetSelectionPlayerProp', odds: number, side?: string | null, marketTypeLabel?: string | null, marketName?: string | null, label: string, labelLong: string, player?: { __typename?: 'Player', id: string, firstName?: string | null, lastName?: string | null, vendors?: { __typename?: 'PlayerVendorConnection', edges: Array<{ __typename?: 'PlayerVendorEdge', vendorPlayerId?: string | null, leagueId?: number | null } | null> } | null } | null } | { __typename: 'PickSnippetSelectionStandard', odds: number, side?: string | null, marketTypeLabel?: string | null, marketName?: string | null, label: string, labelLong: string, team?: { __typename?: 'Team', id: string } | null } | { __typename: 'PickSnippetSelectionTeamProp', odds: number, side?: string | null, marketTypeLabel?: string | null, marketName?: string | null, label: string, labelLong: string, team?: { __typename?: 'Team', id: string } | null } | null }> } | null };

export const FreeExpertPick_GameTeamFragmentDoc = gql`
    fragment FreeExpertPick_GameTeam on GameTeam {
  id
  abbrev
  nickname
  mediumName
  location
  colorHexDex
  colorSecondaryHex
}
    `;
export const FreeExpertPick_MarketFragmentDoc = gql`
    fragment FreeExpertPick_Market on BettingMarket {
  id
  name
  vendors(vendorName: $marketVendorName) {
    edges {
      league {
        id
      }
      vendorMarketId
    }
  }
}
    `;
export const FreeExpertPick_TeamFragmentDoc = gql`
    fragment FreeExpertPick_Team on Team {
  id
  abbrev
  nickname
  mediumName
  location
  colorHexDex
  colorSecondaryHex
  vendors(vendorName: $vendorName) {
    edges {
      vendorTeamId
    }
  }
}
    `;
export const FreeExpertPick_ExpertPickFragmentDoc = gql`
    fragment FreeExpertPick_ExpertPick on ExpertPick {
  isSubscriber
  locked
  resultStatus
  id
  writeup
  createdAt
  expertStreaks {
    id
    label(short: true)
    hot
    rank
    profit
    won
    lost
    pushed
    winPercentage
    league {
      id
      abbrev
    }
  }
  expert {
    cbsExpertId
    clearHeadshotUrl
    firstName
    lastName
  }
  league {
    id
  }
  game {
    league {
      abbrev
    }
    id
    scheduledTime
    isNeutral
    abbrev
    awayTeam {
      ...FreeExpertPick_GameTeam
    }
    homeTeam {
      ...FreeExpertPick_GameTeam
    }
    vendors(vendorName: $vendorName) {
      edges {
        vendorGameId
      }
    }
  }
  selection {
    market {
      ...FreeExpertPick_Market
    }
    ... on ExpertPickSelectionPlayerProps {
      labelLong: label(variant: LONG)
      __typename
      marketType
      label(variant: SHORT)
      subLabel
      odds
      side
      value
      unit
      player {
        id
        firstName
        lastName
        vendors(vendorName: $vendorName) {
          edges {
            vendorPlayerId
          }
        }
      }
      playerTeam {
        ...FreeExpertPick_Team
      }
    }
    ... on ExpertPickSelectionTeamProps {
      labelLong: label(variant: LONG)
      __typename
      marketType
      label(variant: MEDIUM)
      subLabel
      odds
      side
      value
      unit
      team {
        ...FreeExpertPick_Team
      }
    }
    ... on ExpertPickSelectionGameProps {
      labelLong: label(variant: LONG)
      __typename
      marketType
      label(variant: MEDIUM)
      subLabel
      odds
      side
      value
      unit
      team {
        ...FreeExpertPick_Team
      }
    }
    ... on ExpertPickSelectionStandard {
      labelLong: label(variant: LONG)
      __typename
      marketType
      label(variant: MEDIUM)
      subLabel
      odds
      side
      value
      unit
      team {
        ...FreeExpertPick_Team
      }
    }
  }
}
    ${FreeExpertPick_GameTeamFragmentDoc}
${FreeExpertPick_MarketFragmentDoc}
${FreeExpertPick_TeamFragmentDoc}`;
export const PickSnippet_ExpertPickFragmentDoc = gql`
    fragment PickSnippet_ExpertPick on ExpertPick {
  id
  game {
    id
    abbrev
    scheduledTime
    status
    isNeutral
    awayTeam {
      abbrev
      id
      colorHexDex
    }
    homeTeam {
      abbrev
      id
      colorHexDex
    }
  }
  selection {
    __typename
    subLabel
    odds
    ... on ExpertPickSelectionStandard {
      label(variant: MEDIUM)
      value
      side
      odds
      team {
        id
      }
    }
    ... on ExpertPickSelectionPlayerProps {
      cbsMarketId
      label(variant: MEDIUM)
      value
      side
      player {
        id
        firstName
        lastName
      }
      playerTeam {
        id
      }
    }
    ... on ExpertPickSelectionGameProps {
      cbsMarketId
      label(variant: MEDIUM)
      value
      side
      team {
        id
      }
    }
    ... on ExpertPickSelectionTeamProps {
      cbsMarketId
      label(variant: MEDIUM)
      side
      value
      team {
        id
      }
    }
  }
}
    `;
export const SportslineWebComponent_PickSnippet_GameTeamFragmentDoc = gql`
    fragment SportslineWebComponent_PickSnippet_GameTeam on GameTeam {
  id
  abbrev
  colorHexDex
  nickname
  shortName
  mediumName
  vendors(vendorName: $vendorName) {
    edges {
      vendorTeamId
    }
  }
}
    `;
export const SportslineWebComponent_PickSnippet_TeamFragmentDoc = gql`
    fragment SportslineWebComponent_PickSnippet_Team on Team {
  id
}
    `;
export const SportslineWebComponent_PickSnippetFragmentDoc = gql`
    fragment SportslineWebComponent_PickSnippet on PickSnippet {
  id
  game {
    id
    league {
      id
      abbrev
    }
    abbrev
    scheduledTime
    status
    isNeutral
    vendors(vendorName: $vendorName, first: 1) {
      edges {
        vendorGameId
      }
    }
    awayTeam {
      ...SportslineWebComponent_PickSnippet_GameTeam
    }
    homeTeam {
      ...SportslineWebComponent_PickSnippet_GameTeam
    }
  }
  selection {
    __typename
    odds
    side
    marketTypeLabel
    marketName
    label(variant: MEDIUM)
    ... on PickSnippetSelectionStandard {
      labelLong: label
      team {
        ...SportslineWebComponent_PickSnippet_Team
      }
    }
    ... on PickSnippetSelectionGameProp {
      labelLong: label
      team {
        ...SportslineWebComponent_PickSnippet_Team
      }
    }
    ... on PickSnippetSelectionPlayerProp {
      labelLong: label
      player {
        id
        firstName
        lastName
        vendors(vendorName: $vendorName) {
          edges {
            vendorPlayerId
            leagueId
          }
        }
      }
    }
    ... on PickSnippetSelectionTeamProp {
      labelLong: label
      team {
        ...SportslineWebComponent_PickSnippet_Team
      }
    }
  }
}
    ${SportslineWebComponent_PickSnippet_GameTeamFragmentDoc}
${SportslineWebComponent_PickSnippet_TeamFragmentDoc}`;
export const SportslineWebComponent_FreeExpertPickDocument = gql`
    query SportslineWebComponent_FreeExpertPick($expertPickId: ID!, $vendorName: String = "SRADAR", $marketVendorName: String = "SRADAR_MATCH") {
  freeExpertPick(id: $expertPickId) {
    ...FreeExpertPick_ExpertPick
  }
}
    ${FreeExpertPick_ExpertPickFragmentDoc}`;
export const SportslineWebComponent_FreeExpertPicksDocument = gql`
    query SportslineWebComponent_FreeExpertPicks($filter: ExpertPickFilterInput, $sortBy: [ExpertPickSortByInput!], $vendorName: String = "SRADAR", $marketVendorName: String = "SRADAR_MATCH") {
  freeExpertPicks(filter: $filter, sortBy: $sortBy) {
    edges {
      node {
        ...FreeExpertPick_ExpertPick
      }
    }
  }
}
    ${FreeExpertPick_ExpertPickFragmentDoc}`;
export const SportslineWebComponent_PicksSnippetDocument = gql`
    query SportslineWebComponent_PicksSnippet($filter: ExpertPickFilterInput, $sortBy: [ExpertPickSortByInput!]) {
  freeExpertPicks(filter: $filter, sortBy: $sortBy) {
    edges {
      node {
        ...PickSnippet_ExpertPick
      }
    }
  }
}
    ${PickSnippet_ExpertPickFragmentDoc}`;
export const SportslineWebComponent_PromotedExpertPicksDocument = gql`
    query SportslineWebComponent_PromotedExpertPicks($first: Int = 5, $filter: PromotedExpertPickFilterInput, $vendorName: String = "SRADAR", $marketVendorName: String = "SRADAR_MATCH") {
  promotedExpertPicks(first: $first, filter: $filter) {
    edges {
      node {
        ...FreeExpertPick_ExpertPick
      }
    }
  }
}
    ${FreeExpertPick_ExpertPickFragmentDoc}`;
export const SportslineWebComponent_PickSnippetDocument = gql`
    query SportslineWebComponent_PickSnippet($input: PickSnippetInput!, $vendorName: String! = "SRADAR") {
  pickSnippet(input: $input) {
    ...SportslineWebComponent_PickSnippet
  }
}
    ${SportslineWebComponent_PickSnippetFragmentDoc}`;
export const SportslineWebComponent_PickSnippetParlayDocument = gql`
    query SportslineWebComponent_PickSnippetParlay($input: [PickSnippetInput!]!, $vendorName: String! = "SRADAR") {
  pickSnippetParlay(input: $input) {
    id
    odds
    legs {
      ...SportslineWebComponent_PickSnippet
    }
  }
}
    ${SportslineWebComponent_PickSnippetFragmentDoc}`;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string, variables?: any) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType, _variables) => action();
const SportslineWebComponent_FreeExpertPickDocumentString = print(SportslineWebComponent_FreeExpertPickDocument);
const SportslineWebComponent_FreeExpertPicksDocumentString = print(SportslineWebComponent_FreeExpertPicksDocument);
const SportslineWebComponent_PicksSnippetDocumentString = print(SportslineWebComponent_PicksSnippetDocument);
const SportslineWebComponent_PromotedExpertPicksDocumentString = print(SportslineWebComponent_PromotedExpertPicksDocument);
const SportslineWebComponent_PickSnippetDocumentString = print(SportslineWebComponent_PickSnippetDocument);
const SportslineWebComponent_PickSnippetParlayDocumentString = print(SportslineWebComponent_PickSnippetParlayDocument);
export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    SportslineWebComponent_FreeExpertPick(variables: SportslineWebComponent_FreeExpertPickQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<{ data: SportslineWebComponent_FreeExpertPickQuery; errors?: GraphQLError[]; extensions?: any; headers: Headers; status: number; }> {
        return withWrapper((wrappedRequestHeaders) => client.rawRequest<SportslineWebComponent_FreeExpertPickQuery>(SportslineWebComponent_FreeExpertPickDocumentString, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SportslineWebComponent_FreeExpertPick', 'query', variables);
    },
    SportslineWebComponent_FreeExpertPicks(variables?: SportslineWebComponent_FreeExpertPicksQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<{ data: SportslineWebComponent_FreeExpertPicksQuery; errors?: GraphQLError[]; extensions?: any; headers: Headers; status: number; }> {
        return withWrapper((wrappedRequestHeaders) => client.rawRequest<SportslineWebComponent_FreeExpertPicksQuery>(SportslineWebComponent_FreeExpertPicksDocumentString, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SportslineWebComponent_FreeExpertPicks', 'query', variables);
    },
    SportslineWebComponent_PicksSnippet(variables?: SportslineWebComponent_PicksSnippetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<{ data: SportslineWebComponent_PicksSnippetQuery; errors?: GraphQLError[]; extensions?: any; headers: Headers; status: number; }> {
        return withWrapper((wrappedRequestHeaders) => client.rawRequest<SportslineWebComponent_PicksSnippetQuery>(SportslineWebComponent_PicksSnippetDocumentString, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SportslineWebComponent_PicksSnippet', 'query', variables);
    },
    SportslineWebComponent_PromotedExpertPicks(variables?: SportslineWebComponent_PromotedExpertPicksQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<{ data: SportslineWebComponent_PromotedExpertPicksQuery; errors?: GraphQLError[]; extensions?: any; headers: Headers; status: number; }> {
        return withWrapper((wrappedRequestHeaders) => client.rawRequest<SportslineWebComponent_PromotedExpertPicksQuery>(SportslineWebComponent_PromotedExpertPicksDocumentString, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SportslineWebComponent_PromotedExpertPicks', 'query', variables);
    },
    SportslineWebComponent_PickSnippet(variables: SportslineWebComponent_PickSnippetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<{ data: SportslineWebComponent_PickSnippetQuery; errors?: GraphQLError[]; extensions?: any; headers: Headers; status: number; }> {
        return withWrapper((wrappedRequestHeaders) => client.rawRequest<SportslineWebComponent_PickSnippetQuery>(SportslineWebComponent_PickSnippetDocumentString, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SportslineWebComponent_PickSnippet', 'query', variables);
    },
    SportslineWebComponent_PickSnippetParlay(variables: SportslineWebComponent_PickSnippetParlayQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<{ data: SportslineWebComponent_PickSnippetParlayQuery; errors?: GraphQLError[]; extensions?: any; headers: Headers; status: number; }> {
        return withWrapper((wrappedRequestHeaders) => client.rawRequest<SportslineWebComponent_PickSnippetParlayQuery>(SportslineWebComponent_PickSnippetParlayDocumentString, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SportslineWebComponent_PickSnippetParlay', 'query', variables);
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;